(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire164e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire164e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iD4WH", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jIgWH"));

});
parcelRegister("jIgWH", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $e59f457751cca0bb$export$ffb0004e005737fa; }, function (v) { return $e59f457751cca0bb$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $e59f457751cca0bb$export$34b9dba7ce09269b; }, function (v) { return $e59f457751cca0bb$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $e59f457751cca0bb$export$25062201e9e25d76; }, function (v) { return $e59f457751cca0bb$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e59f457751cca0bb$export$ffb0004e005737fa;
var $e59f457751cca0bb$export$34b9dba7ce09269b;
var $e59f457751cca0bb$export$25062201e9e25d76;
'use strict';

var $dQFEZ = parcelRequire("dQFEZ");
var $e59f457751cca0bb$var$k = Symbol.for("react.element"), $e59f457751cca0bb$var$l = Symbol.for("react.fragment"), $e59f457751cca0bb$var$m = Object.prototype.hasOwnProperty, $e59f457751cca0bb$var$n = $dQFEZ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $e59f457751cca0bb$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $e59f457751cca0bb$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$e59f457751cca0bb$var$m.call(a, b) && !$e59f457751cca0bb$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $e59f457751cca0bb$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $e59f457751cca0bb$var$n.current
    };
}
$e59f457751cca0bb$export$ffb0004e005737fa = $e59f457751cca0bb$var$l;
$e59f457751cca0bb$export$34b9dba7ce09269b = $e59f457751cca0bb$var$q;
$e59f457751cca0bb$export$25062201e9e25d76 = $e59f457751cca0bb$var$q;

});
parcelRegister("dQFEZ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4SjaJ"));

});
parcelRegister("4SjaJ", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $38cb13c5a0250553$export$dca3b0875bd9a954; }, function (v) { return $38cb13c5a0250553$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $38cb13c5a0250553$export$16fa2f45be04daa8; }, function (v) { return $38cb13c5a0250553$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $38cb13c5a0250553$export$ffb0004e005737fa; }, function (v) { return $38cb13c5a0250553$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $38cb13c5a0250553$export$e2c29f18771995cb; }, function (v) { return $38cb13c5a0250553$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $38cb13c5a0250553$export$221d75b3f55bb0bd; }, function (v) { return $38cb13c5a0250553$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $38cb13c5a0250553$export$5f8d39834fd61797; }, function (v) { return $38cb13c5a0250553$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $38cb13c5a0250553$export$74bf444e3cd11ea5; }, function (v) { return $38cb13c5a0250553$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $38cb13c5a0250553$export$ae55be85d98224ed; }, function (v) { return $38cb13c5a0250553$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $38cb13c5a0250553$export$3ba232387fd5d6dd; }, function (v) { return $38cb13c5a0250553$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $38cb13c5a0250553$export$e530037191fcd5d7; }, function (v) { return $38cb13c5a0250553$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $38cb13c5a0250553$export$fd42f52fd3ae1109; }, function (v) { return $38cb13c5a0250553$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $38cb13c5a0250553$export$c8a8987d4410bf2d; }, function (v) { return $38cb13c5a0250553$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $38cb13c5a0250553$export$d38cd72104c1f0e9; }, function (v) { return $38cb13c5a0250553$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $38cb13c5a0250553$export$7d1e3a5e95ceca43; }, function (v) { return $38cb13c5a0250553$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $38cb13c5a0250553$export$257a8862b851cb5b; }, function (v) { return $38cb13c5a0250553$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $38cb13c5a0250553$export$a8257692ac88316c; }, function (v) { return $38cb13c5a0250553$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $38cb13c5a0250553$export$488013bae63b21da; }, function (v) { return $38cb13c5a0250553$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $38cb13c5a0250553$export$7c73462e0d25e514; }, function (v) { return $38cb13c5a0250553$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $38cb13c5a0250553$export$7568632d0d33d16d; }, function (v) { return $38cb13c5a0250553$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $38cb13c5a0250553$export$88948ce120ea2619; }, function (v) { return $38cb13c5a0250553$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $38cb13c5a0250553$export$35808ee640e87ca7; }, function (v) { return $38cb13c5a0250553$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $38cb13c5a0250553$export$fae74005e78b1a27; }, function (v) { return $38cb13c5a0250553$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $38cb13c5a0250553$export$dc8fbce3eb94dc1e; }, function (v) { return $38cb13c5a0250553$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $38cb13c5a0250553$export$6a7bc4e911dc01cf; }, function (v) { return $38cb13c5a0250553$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $38cb13c5a0250553$export$6d9c69b0de29b591; }, function (v) { return $38cb13c5a0250553$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $38cb13c5a0250553$export$f680877a34711e37; }, function (v) { return $38cb13c5a0250553$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $38cb13c5a0250553$export$d5a552a76deda3c2; }, function (v) { return $38cb13c5a0250553$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $38cb13c5a0250553$export$aaabe4eda9ed9969; }, function (v) { return $38cb13c5a0250553$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $38cb13c5a0250553$export$e5c5a5f917a5871c; }, function (v) { return $38cb13c5a0250553$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $38cb13c5a0250553$export$1538c33de8887b59; }, function (v) { return $38cb13c5a0250553$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $38cb13c5a0250553$export$13e3392192263954; }, function (v) { return $38cb13c5a0250553$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $38cb13c5a0250553$export$b8f5890fc79d6aca; }, function (v) { return $38cb13c5a0250553$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $38cb13c5a0250553$export$60241385465d0a34; }, function (v) { return $38cb13c5a0250553$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $38cb13c5a0250553$export$306c0aa65ff9ec16; }, function (v) { return $38cb13c5a0250553$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $38cb13c5a0250553$export$7b286972b8d8ccbf; }, function (v) { return $38cb13c5a0250553$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $38cb13c5a0250553$export$83d89fbfd8236492; }, function (v) { return $38cb13c5a0250553$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $bJtXW = parcelRequire("bJtXW");
var $38cb13c5a0250553$export$dca3b0875bd9a954;
var $38cb13c5a0250553$export$16fa2f45be04daa8;
var $38cb13c5a0250553$export$ffb0004e005737fa;
var $38cb13c5a0250553$export$e2c29f18771995cb;
var $38cb13c5a0250553$export$221d75b3f55bb0bd;
var $38cb13c5a0250553$export$5f8d39834fd61797;
var $38cb13c5a0250553$export$74bf444e3cd11ea5;
var $38cb13c5a0250553$export$ae55be85d98224ed;
var $38cb13c5a0250553$export$3ba232387fd5d6dd;
var $38cb13c5a0250553$export$e530037191fcd5d7;
var $38cb13c5a0250553$export$fd42f52fd3ae1109;
var $38cb13c5a0250553$export$c8a8987d4410bf2d;
var $38cb13c5a0250553$export$d38cd72104c1f0e9;
var $38cb13c5a0250553$export$7d1e3a5e95ceca43;
var $38cb13c5a0250553$export$257a8862b851cb5b;
var $38cb13c5a0250553$export$a8257692ac88316c;
var $38cb13c5a0250553$export$488013bae63b21da;
var $38cb13c5a0250553$export$7c73462e0d25e514;
var $38cb13c5a0250553$export$7568632d0d33d16d;
var $38cb13c5a0250553$export$88948ce120ea2619;
var $38cb13c5a0250553$export$35808ee640e87ca7;
var $38cb13c5a0250553$export$fae74005e78b1a27;
var $38cb13c5a0250553$export$dc8fbce3eb94dc1e;
var $38cb13c5a0250553$export$6a7bc4e911dc01cf;
var $38cb13c5a0250553$export$6d9c69b0de29b591;
var $38cb13c5a0250553$export$f680877a34711e37;
var $38cb13c5a0250553$export$d5a552a76deda3c2;
var $38cb13c5a0250553$export$aaabe4eda9ed9969;
var $38cb13c5a0250553$export$e5c5a5f917a5871c;
var $38cb13c5a0250553$export$1538c33de8887b59;
var $38cb13c5a0250553$export$13e3392192263954;
var $38cb13c5a0250553$export$b8f5890fc79d6aca;
var $38cb13c5a0250553$export$60241385465d0a34;
var $38cb13c5a0250553$export$306c0aa65ff9ec16;
var $38cb13c5a0250553$export$7b286972b8d8ccbf;
var $38cb13c5a0250553$export$83d89fbfd8236492;
'use strict';
var $38cb13c5a0250553$var$l = Symbol.for("react.element"), $38cb13c5a0250553$var$n = Symbol.for("react.portal"), $38cb13c5a0250553$var$p = Symbol.for("react.fragment"), $38cb13c5a0250553$var$q = Symbol.for("react.strict_mode"), $38cb13c5a0250553$var$r = Symbol.for("react.profiler"), $38cb13c5a0250553$var$t = Symbol.for("react.provider"), $38cb13c5a0250553$var$u = Symbol.for("react.context"), $38cb13c5a0250553$var$v = Symbol.for("react.forward_ref"), $38cb13c5a0250553$var$w = Symbol.for("react.suspense"), $38cb13c5a0250553$var$x = Symbol.for("react.memo"), $38cb13c5a0250553$var$y = Symbol.for("react.lazy"), $38cb13c5a0250553$var$z = Symbol.iterator;
function $38cb13c5a0250553$var$A(a) {
    if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a))) return null;
    a = $38cb13c5a0250553$var$z && a[$38cb13c5a0250553$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $38cb13c5a0250553$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $38cb13c5a0250553$var$C = Object.assign, $38cb13c5a0250553$var$D = {};
function $38cb13c5a0250553$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $38cb13c5a0250553$var$D;
    this.updater = e || $38cb13c5a0250553$var$B;
}
$38cb13c5a0250553$var$E.prototype.isReactComponent = {};
$38cb13c5a0250553$var$E.prototype.setState = function(a, b) {
    if ("object" !== (typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a)) && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$38cb13c5a0250553$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $38cb13c5a0250553$var$F() {}
$38cb13c5a0250553$var$F.prototype = $38cb13c5a0250553$var$E.prototype;
function $38cb13c5a0250553$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $38cb13c5a0250553$var$D;
    this.updater = e || $38cb13c5a0250553$var$B;
}
var $38cb13c5a0250553$var$H = $38cb13c5a0250553$var$G.prototype = new $38cb13c5a0250553$var$F;
$38cb13c5a0250553$var$H.constructor = $38cb13c5a0250553$var$G;
$38cb13c5a0250553$var$C($38cb13c5a0250553$var$H, $38cb13c5a0250553$var$E.prototype);
$38cb13c5a0250553$var$H.isPureReactComponent = !0;
var $38cb13c5a0250553$var$I = Array.isArray, $38cb13c5a0250553$var$J = Object.prototype.hasOwnProperty, $38cb13c5a0250553$var$K = {
    current: null
}, $38cb13c5a0250553$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $38cb13c5a0250553$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$38cb13c5a0250553$var$J.call(b, d) && !$38cb13c5a0250553$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $38cb13c5a0250553$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $38cb13c5a0250553$var$K.current
    };
}
function $38cb13c5a0250553$var$N(a, b) {
    return {
        $$typeof: $38cb13c5a0250553$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $38cb13c5a0250553$var$O(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a)) && null !== a && a.$$typeof === $38cb13c5a0250553$var$l;
}
function $38cb13c5a0250553$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $38cb13c5a0250553$var$P = /\/+/g;
function $38cb13c5a0250553$var$Q(a, b) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a)) && null !== a && null != a.key ? $38cb13c5a0250553$var$escape("" + a.key) : b.toString(36);
}
function $38cb13c5a0250553$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $38cb13c5a0250553$var$l:
                case $38cb13c5a0250553$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $38cb13c5a0250553$var$Q(h, 0) : d, $38cb13c5a0250553$var$I(c) ? (e = "", null != a && (e = a.replace($38cb13c5a0250553$var$P, "$&/") + "/"), $38cb13c5a0250553$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($38cb13c5a0250553$var$O(c) && (c = $38cb13c5a0250553$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($38cb13c5a0250553$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($38cb13c5a0250553$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $38cb13c5a0250553$var$Q(k, g);
        h += $38cb13c5a0250553$var$R(k, b, e, f, c);
    }
    else if (f = $38cb13c5a0250553$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $38cb13c5a0250553$var$Q(k, g++), h += $38cb13c5a0250553$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $38cb13c5a0250553$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $38cb13c5a0250553$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $38cb13c5a0250553$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $38cb13c5a0250553$var$U = {
    current: null
}, $38cb13c5a0250553$var$V = {
    transition: null
}, $38cb13c5a0250553$var$W = {
    ReactCurrentDispatcher: $38cb13c5a0250553$var$U,
    ReactCurrentBatchConfig: $38cb13c5a0250553$var$V,
    ReactCurrentOwner: $38cb13c5a0250553$var$K
};
function $38cb13c5a0250553$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$38cb13c5a0250553$export$dca3b0875bd9a954 = {
    map: $38cb13c5a0250553$var$S,
    forEach: function forEach(a, b, e) {
        $38cb13c5a0250553$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $38cb13c5a0250553$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $38cb13c5a0250553$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$38cb13c5a0250553$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$38cb13c5a0250553$export$16fa2f45be04daa8 = $38cb13c5a0250553$var$E;
$38cb13c5a0250553$export$ffb0004e005737fa = $38cb13c5a0250553$var$p;
$38cb13c5a0250553$export$e2c29f18771995cb = $38cb13c5a0250553$var$r;
$38cb13c5a0250553$export$221d75b3f55bb0bd = $38cb13c5a0250553$var$G;
$38cb13c5a0250553$export$5f8d39834fd61797 = $38cb13c5a0250553$var$q;
$38cb13c5a0250553$export$74bf444e3cd11ea5 = $38cb13c5a0250553$var$w;
$38cb13c5a0250553$export$ae55be85d98224ed = $38cb13c5a0250553$var$W;
$38cb13c5a0250553$export$3ba232387fd5d6dd = $38cb13c5a0250553$var$X;
$38cb13c5a0250553$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $38cb13c5a0250553$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $38cb13c5a0250553$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$38cb13c5a0250553$var$J.call(b, f) && !$38cb13c5a0250553$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $38cb13c5a0250553$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$38cb13c5a0250553$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $38cb13c5a0250553$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $38cb13c5a0250553$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$38cb13c5a0250553$export$c8a8987d4410bf2d = $38cb13c5a0250553$var$M;
$38cb13c5a0250553$export$d38cd72104c1f0e9 = function(a) {
    var b = $38cb13c5a0250553$var$M.bind(null, a);
    b.type = a;
    return b;
};
$38cb13c5a0250553$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$38cb13c5a0250553$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $38cb13c5a0250553$var$v,
        render: a
    };
};
$38cb13c5a0250553$export$a8257692ac88316c = $38cb13c5a0250553$var$O;
$38cb13c5a0250553$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $38cb13c5a0250553$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $38cb13c5a0250553$var$T
    };
};
$38cb13c5a0250553$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $38cb13c5a0250553$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$38cb13c5a0250553$export$7568632d0d33d16d = function(a) {
    var b = $38cb13c5a0250553$var$V.transition;
    $38cb13c5a0250553$var$V.transition = {};
    try {
        a();
    } finally{
        $38cb13c5a0250553$var$V.transition = b;
    }
};
$38cb13c5a0250553$export$88948ce120ea2619 = $38cb13c5a0250553$var$X;
$38cb13c5a0250553$export$35808ee640e87ca7 = function(a, b) {
    return $38cb13c5a0250553$var$U.current.useCallback(a, b);
};
$38cb13c5a0250553$export$fae74005e78b1a27 = function(a) {
    return $38cb13c5a0250553$var$U.current.useContext(a);
};
$38cb13c5a0250553$export$dc8fbce3eb94dc1e = function() {};
$38cb13c5a0250553$export$6a7bc4e911dc01cf = function(a) {
    return $38cb13c5a0250553$var$U.current.useDeferredValue(a);
};
$38cb13c5a0250553$export$6d9c69b0de29b591 = function(a, b) {
    return $38cb13c5a0250553$var$U.current.useEffect(a, b);
};
$38cb13c5a0250553$export$f680877a34711e37 = function() {
    return $38cb13c5a0250553$var$U.current.useId();
};
$38cb13c5a0250553$export$d5a552a76deda3c2 = function(a, b, e) {
    return $38cb13c5a0250553$var$U.current.useImperativeHandle(a, b, e);
};
$38cb13c5a0250553$export$aaabe4eda9ed9969 = function(a, b) {
    return $38cb13c5a0250553$var$U.current.useInsertionEffect(a, b);
};
$38cb13c5a0250553$export$e5c5a5f917a5871c = function(a, b) {
    return $38cb13c5a0250553$var$U.current.useLayoutEffect(a, b);
};
$38cb13c5a0250553$export$1538c33de8887b59 = function(a, b) {
    return $38cb13c5a0250553$var$U.current.useMemo(a, b);
};
$38cb13c5a0250553$export$13e3392192263954 = function(a, b, e) {
    return $38cb13c5a0250553$var$U.current.useReducer(a, b, e);
};
$38cb13c5a0250553$export$b8f5890fc79d6aca = function(a) {
    return $38cb13c5a0250553$var$U.current.useRef(a);
};
$38cb13c5a0250553$export$60241385465d0a34 = function(a) {
    return $38cb13c5a0250553$var$U.current.useState(a);
};
$38cb13c5a0250553$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $38cb13c5a0250553$var$U.current.useSyncExternalStore(a, b, e);
};
$38cb13c5a0250553$export$7b286972b8d8ccbf = function() {
    return $38cb13c5a0250553$var$U.current.useTransition();
};
$38cb13c5a0250553$export$83d89fbfd8236492 = "18.3.1";

});
parcelRegister("bJtXW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $88ab244363eded38$export$71511d61b312f219; });
function $88ab244363eded38$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});





parcelRegister("gZreO", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $0331271bace68e97$export$ae55be85d98224ed; }, function (v) { return $0331271bace68e97$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $0331271bace68e97$export$d39a5bbd09211389; }, function (v) { return $0331271bace68e97$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $0331271bace68e97$export$882461b6382ed46c; }, function (v) { return $0331271bace68e97$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $0331271bace68e97$export$466bfc07425424d5; }, function (v) { return $0331271bace68e97$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $0331271bace68e97$export$cd75ccfd720a3cd4; }, function (v) { return $0331271bace68e97$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $0331271bace68e97$export$fa8d919ba61d84db; }, function (v) { return $0331271bace68e97$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $0331271bace68e97$export$757ceba2d55c277e; }, function (v) { return $0331271bace68e97$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $0331271bace68e97$export$b3890eb0ae9dca99; }, function (v) { return $0331271bace68e97$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $0331271bace68e97$export$502457920280e6be; }, function (v) { return $0331271bace68e97$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $0331271bace68e97$export$c78a37762a8d58e1; }, function (v) { return $0331271bace68e97$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $0331271bace68e97$export$dc54d992c10e8a18; }, function (v) { return $0331271bace68e97$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $0331271bace68e97$export$83d89fbfd8236492; }, function (v) { return $0331271bace68e97$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $bJtXW = parcelRequire("bJtXW");
var $0331271bace68e97$export$ae55be85d98224ed;
var $0331271bace68e97$export$d39a5bbd09211389;
var $0331271bace68e97$export$882461b6382ed46c;
var $0331271bace68e97$export$466bfc07425424d5;
var $0331271bace68e97$export$cd75ccfd720a3cd4;
var $0331271bace68e97$export$fa8d919ba61d84db;
var $0331271bace68e97$export$757ceba2d55c277e;
var $0331271bace68e97$export$b3890eb0ae9dca99;
var $0331271bace68e97$export$502457920280e6be;
var $0331271bace68e97$export$c78a37762a8d58e1;
var $0331271bace68e97$export$dc54d992c10e8a18;
var $0331271bace68e97$export$83d89fbfd8236492;
'use strict';

var $dQFEZ = parcelRequire("dQFEZ");

var $1iyD5 = parcelRequire("1iyD5");
function $0331271bace68e97$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0331271bace68e97$var$da = new Set, $0331271bace68e97$var$ea = {};
function $0331271bace68e97$var$fa(a, b) {
    $0331271bace68e97$var$ha(a, b);
    $0331271bace68e97$var$ha(a + "Capture", b);
}
function $0331271bace68e97$var$ha(a, b) {
    $0331271bace68e97$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0331271bace68e97$var$da.add(b[a]);
}
var $0331271bace68e97$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0331271bace68e97$var$ja = Object.prototype.hasOwnProperty, $0331271bace68e97$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0331271bace68e97$var$la = {}, $0331271bace68e97$var$ma = {};
function $0331271bace68e97$var$oa(a) {
    if ($0331271bace68e97$var$ja.call($0331271bace68e97$var$ma, a)) return !0;
    if ($0331271bace68e97$var$ja.call($0331271bace68e97$var$la, a)) return !1;
    if ($0331271bace68e97$var$ka.test(a)) return $0331271bace68e97$var$ma[a] = !0;
    $0331271bace68e97$var$la[a] = !0;
    return !1;
}
function $0331271bace68e97$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $bJtXW._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0331271bace68e97$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0331271bace68e97$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0331271bace68e97$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0331271bace68e97$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0331271bace68e97$var$z[b] = new $0331271bace68e97$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0331271bace68e97$var$ra = /[\-:]([a-z])/g;
function $0331271bace68e97$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0331271bace68e97$var$ra, $0331271bace68e97$var$sa);
    $0331271bace68e97$var$z[b] = new $0331271bace68e97$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0331271bace68e97$var$ra, $0331271bace68e97$var$sa);
    $0331271bace68e97$var$z[b] = new $0331271bace68e97$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0331271bace68e97$var$ra, $0331271bace68e97$var$sa);
    $0331271bace68e97$var$z[b] = new $0331271bace68e97$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0331271bace68e97$var$z.xlinkHref = new $0331271bace68e97$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0331271bace68e97$var$z[a] = new $0331271bace68e97$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0331271bace68e97$var$ta(a, b, c, d) {
    var e = $0331271bace68e97$var$z.hasOwnProperty(b) ? $0331271bace68e97$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0331271bace68e97$var$qa(b, c, e, d) && (c = null), d || null === e ? $0331271bace68e97$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0331271bace68e97$var$ua = $dQFEZ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0331271bace68e97$var$va = Symbol.for("react.element"), $0331271bace68e97$var$wa = Symbol.for("react.portal"), $0331271bace68e97$var$ya = Symbol.for("react.fragment"), $0331271bace68e97$var$za = Symbol.for("react.strict_mode"), $0331271bace68e97$var$Aa = Symbol.for("react.profiler"), $0331271bace68e97$var$Ba = Symbol.for("react.provider"), $0331271bace68e97$var$Ca = Symbol.for("react.context"), $0331271bace68e97$var$Da = Symbol.for("react.forward_ref"), $0331271bace68e97$var$Ea = Symbol.for("react.suspense"), $0331271bace68e97$var$Fa = Symbol.for("react.suspense_list"), $0331271bace68e97$var$Ga = Symbol.for("react.memo"), $0331271bace68e97$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0331271bace68e97$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0331271bace68e97$var$Ja = Symbol.iterator;
function $0331271bace68e97$var$Ka(a) {
    if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a))) return null;
    a = $0331271bace68e97$var$Ja && a[$0331271bace68e97$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0331271bace68e97$var$A = Object.assign, $0331271bace68e97$var$La;
function $0331271bace68e97$var$Ma(a) {
    if (void 0 === $0331271bace68e97$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0331271bace68e97$var$La = b && b[1] || "";
    }
    return "\n" + $0331271bace68e97$var$La + a;
}
var $0331271bace68e97$var$Na = !1;
function $0331271bace68e97$var$Oa(a, b) {
    if (!a || $0331271bace68e97$var$Na) return "";
    $0331271bace68e97$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === (typeof Reflect === "undefined" ? "undefined" : (0, $bJtXW._)(Reflect)) && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0331271bace68e97$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0331271bace68e97$var$Ma(a) : "";
}
function $0331271bace68e97$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0331271bace68e97$var$Ma(a.type);
        case 16:
            return $0331271bace68e97$var$Ma("Lazy");
        case 13:
            return $0331271bace68e97$var$Ma("Suspense");
        case 19:
            return $0331271bace68e97$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0331271bace68e97$var$Oa(a.type, !1), a;
        case 11:
            return a = $0331271bace68e97$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0331271bace68e97$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0331271bace68e97$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0331271bace68e97$var$ya:
            return "Fragment";
        case $0331271bace68e97$var$wa:
            return "Portal";
        case $0331271bace68e97$var$Aa:
            return "Profiler";
        case $0331271bace68e97$var$za:
            return "StrictMode";
        case $0331271bace68e97$var$Ea:
            return "Suspense";
        case $0331271bace68e97$var$Fa:
            return "SuspenseList";
    }
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a))) switch(a.$$typeof){
        case $0331271bace68e97$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0331271bace68e97$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0331271bace68e97$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0331271bace68e97$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0331271bace68e97$var$Qa(a.type) || "Memo";
        case $0331271bace68e97$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0331271bace68e97$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0331271bace68e97$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0331271bace68e97$var$Qa(b);
        case 8:
            return b === $0331271bace68e97$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0331271bace68e97$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0331271bace68e97$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0331271bace68e97$var$Ua(a) {
    var b = $0331271bace68e97$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0331271bace68e97$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0331271bace68e97$var$Ua(a));
}
function $0331271bace68e97$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0331271bace68e97$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0331271bace68e97$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0331271bace68e97$var$Ya(a, b) {
    var c = b.checked;
    return $0331271bace68e97$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0331271bace68e97$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0331271bace68e97$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0331271bace68e97$var$ab(a, b) {
    b = b.checked;
    null != b && $0331271bace68e97$var$ta(a, "checked", b, !1);
}
function $0331271bace68e97$var$bb(a, b) {
    $0331271bace68e97$var$ab(a, b);
    var c = $0331271bace68e97$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0331271bace68e97$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0331271bace68e97$var$cb(a, b.type, $0331271bace68e97$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0331271bace68e97$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0331271bace68e97$var$cb(a, b, c) {
    if ("number" !== b || $0331271bace68e97$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0331271bace68e97$var$eb = Array.isArray;
function $0331271bace68e97$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0331271bace68e97$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0331271bace68e97$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0331271bace68e97$var$p(91));
    return $0331271bace68e97$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0331271bace68e97$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0331271bace68e97$var$p(92));
            if ($0331271bace68e97$var$eb(c)) {
                if (1 < c.length) throw Error($0331271bace68e97$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0331271bace68e97$var$Sa(c)
    };
}
function $0331271bace68e97$var$ib(a, b) {
    var c = $0331271bace68e97$var$Sa(b.value), d = $0331271bace68e97$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0331271bace68e97$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0331271bace68e97$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0331271bace68e97$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0331271bace68e97$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0331271bace68e97$var$mb, $0331271bace68e97$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0331271bace68e97$var$mb = $0331271bace68e97$var$mb || document.createElement("div");
        $0331271bace68e97$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0331271bace68e97$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0331271bace68e97$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0331271bace68e97$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0331271bace68e97$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0331271bace68e97$var$pb).forEach(function(a) {
    $0331271bace68e97$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0331271bace68e97$var$pb[b] = $0331271bace68e97$var$pb[a];
    });
});
function $0331271bace68e97$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0331271bace68e97$var$pb.hasOwnProperty(a) && $0331271bace68e97$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0331271bace68e97$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0331271bace68e97$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0331271bace68e97$var$tb = $0331271bace68e97$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0331271bace68e97$var$ub(a, b) {
    if (b) {
        if ($0331271bace68e97$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0331271bace68e97$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0331271bace68e97$var$p(60));
            if ("object" !== (0, $bJtXW._)(b.dangerouslySetInnerHTML) || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0331271bace68e97$var$p(61));
        }
        if (null != b.style && "object" !== (0, $bJtXW._)(b.style)) throw Error($0331271bace68e97$var$p(62));
    }
}
function $0331271bace68e97$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0331271bace68e97$var$wb = null;
function $0331271bace68e97$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0331271bace68e97$var$yb = null, $0331271bace68e97$var$zb = null, $0331271bace68e97$var$Ab = null;
function $0331271bace68e97$var$Bb(a) {
    if (a = $0331271bace68e97$var$Cb(a)) {
        if ("function" !== typeof $0331271bace68e97$var$yb) throw Error($0331271bace68e97$var$p(280));
        var b = a.stateNode;
        b && (b = $0331271bace68e97$var$Db(b), $0331271bace68e97$var$yb(a.stateNode, a.type, b));
    }
}
function $0331271bace68e97$var$Eb(a) {
    $0331271bace68e97$var$zb ? $0331271bace68e97$var$Ab ? $0331271bace68e97$var$Ab.push(a) : $0331271bace68e97$var$Ab = [
        a
    ] : $0331271bace68e97$var$zb = a;
}
function $0331271bace68e97$var$Fb() {
    if ($0331271bace68e97$var$zb) {
        var a = $0331271bace68e97$var$zb, b = $0331271bace68e97$var$Ab;
        $0331271bace68e97$var$Ab = $0331271bace68e97$var$zb = null;
        $0331271bace68e97$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0331271bace68e97$var$Bb(b[a]);
    }
}
function $0331271bace68e97$var$Gb(a, b) {
    return a(b);
}
function $0331271bace68e97$var$Hb() {}
var $0331271bace68e97$var$Ib = !1;
function $0331271bace68e97$var$Jb(a, b, c) {
    if ($0331271bace68e97$var$Ib) return a(b, c);
    $0331271bace68e97$var$Ib = !0;
    try {
        return $0331271bace68e97$var$Gb(a, b, c);
    } finally{
        if ($0331271bace68e97$var$Ib = !1, null !== $0331271bace68e97$var$zb || null !== $0331271bace68e97$var$Ab) $0331271bace68e97$var$Hb(), $0331271bace68e97$var$Fb();
    }
}
function $0331271bace68e97$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0331271bace68e97$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0331271bace68e97$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $bJtXW._)(c)));
    return c;
}
var $0331271bace68e97$var$Lb = !1;
if ($0331271bace68e97$var$ia) try {
    var $0331271bace68e97$var$Mb = {};
    Object.defineProperty($0331271bace68e97$var$Mb, "passive", {
        get: function get() {
            $0331271bace68e97$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0331271bace68e97$var$Mb, $0331271bace68e97$var$Mb);
    window.removeEventListener("test", $0331271bace68e97$var$Mb, $0331271bace68e97$var$Mb);
} catch (a) {
    $0331271bace68e97$var$Lb = !1;
}
function $0331271bace68e97$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0331271bace68e97$var$Ob = !1, $0331271bace68e97$var$Pb = null, $0331271bace68e97$var$Qb = !1, $0331271bace68e97$var$Rb = null, $0331271bace68e97$var$Sb = {
    onError: function onError(a) {
        $0331271bace68e97$var$Ob = !0;
        $0331271bace68e97$var$Pb = a;
    }
};
function $0331271bace68e97$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0331271bace68e97$var$Ob = !1;
    $0331271bace68e97$var$Pb = null;
    $0331271bace68e97$var$Nb.apply($0331271bace68e97$var$Sb, arguments);
}
function $0331271bace68e97$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0331271bace68e97$var$Tb.apply(this, arguments);
    if ($0331271bace68e97$var$Ob) {
        if ($0331271bace68e97$var$Ob) {
            var l = $0331271bace68e97$var$Pb;
            $0331271bace68e97$var$Ob = !1;
            $0331271bace68e97$var$Pb = null;
        } else throw Error($0331271bace68e97$var$p(198));
        $0331271bace68e97$var$Qb || ($0331271bace68e97$var$Qb = !0, $0331271bace68e97$var$Rb = l);
    }
}
function $0331271bace68e97$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0331271bace68e97$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0331271bace68e97$var$Xb(a) {
    if ($0331271bace68e97$var$Vb(a) !== a) throw Error($0331271bace68e97$var$p(188));
}
function $0331271bace68e97$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0331271bace68e97$var$Vb(a);
        if (null === b) throw Error($0331271bace68e97$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0331271bace68e97$var$Xb(e), a;
                if (f === d) return $0331271bace68e97$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0331271bace68e97$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0331271bace68e97$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0331271bace68e97$var$p(190));
    }
    if (3 !== c.tag) throw Error($0331271bace68e97$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0331271bace68e97$var$Zb(a) {
    a = $0331271bace68e97$var$Yb(a);
    return null !== a ? $0331271bace68e97$var$$b(a) : null;
}
function $0331271bace68e97$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0331271bace68e97$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0331271bace68e97$var$ac = $1iyD5.unstable_scheduleCallback, $0331271bace68e97$var$bc = $1iyD5.unstable_cancelCallback, $0331271bace68e97$var$cc = $1iyD5.unstable_shouldYield, $0331271bace68e97$var$dc = $1iyD5.unstable_requestPaint, $0331271bace68e97$var$B = $1iyD5.unstable_now, $0331271bace68e97$var$ec = $1iyD5.unstable_getCurrentPriorityLevel, $0331271bace68e97$var$fc = $1iyD5.unstable_ImmediatePriority, $0331271bace68e97$var$gc = $1iyD5.unstable_UserBlockingPriority, $0331271bace68e97$var$hc = $1iyD5.unstable_NormalPriority, $0331271bace68e97$var$ic = $1iyD5.unstable_LowPriority, $0331271bace68e97$var$jc = $1iyD5.unstable_IdlePriority, $0331271bace68e97$var$kc = null, $0331271bace68e97$var$lc = null;
function $0331271bace68e97$var$mc(a) {
    if ($0331271bace68e97$var$lc && "function" === typeof $0331271bace68e97$var$lc.onCommitFiberRoot) try {
        $0331271bace68e97$var$lc.onCommitFiberRoot($0331271bace68e97$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0331271bace68e97$var$oc = Math.clz32 ? Math.clz32 : $0331271bace68e97$var$nc, $0331271bace68e97$var$pc = Math.log, $0331271bace68e97$var$qc = Math.LN2;
function $0331271bace68e97$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0331271bace68e97$var$pc(a) / $0331271bace68e97$var$qc | 0) | 0;
}
var $0331271bace68e97$var$rc = 64, $0331271bace68e97$var$sc = 4194304;
function $0331271bace68e97$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0331271bace68e97$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0331271bace68e97$var$tc(h) : (f &= g, 0 !== f && (d = $0331271bace68e97$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0331271bace68e97$var$tc(g) : 0 !== f && (d = $0331271bace68e97$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0331271bace68e97$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0331271bace68e97$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0331271bace68e97$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0331271bace68e97$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0331271bace68e97$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0331271bace68e97$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0331271bace68e97$var$yc() {
    var a = $0331271bace68e97$var$rc;
    $0331271bace68e97$var$rc <<= 1;
    0 === ($0331271bace68e97$var$rc & 4194240) && ($0331271bace68e97$var$rc = 64);
    return a;
}
function $0331271bace68e97$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0331271bace68e97$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0331271bace68e97$var$oc(b);
    a[b] = c;
}
function $0331271bace68e97$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0331271bace68e97$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0331271bace68e97$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0331271bace68e97$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0331271bace68e97$var$C = 0;
function $0331271bace68e97$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0331271bace68e97$var$Ec, $0331271bace68e97$var$Fc, $0331271bace68e97$var$Gc, $0331271bace68e97$var$Hc, $0331271bace68e97$var$Ic, $0331271bace68e97$var$Jc = !1, $0331271bace68e97$var$Kc = [], $0331271bace68e97$var$Lc = null, $0331271bace68e97$var$Mc = null, $0331271bace68e97$var$Nc = null, $0331271bace68e97$var$Oc = new Map, $0331271bace68e97$var$Pc = new Map, $0331271bace68e97$var$Qc = [], $0331271bace68e97$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0331271bace68e97$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0331271bace68e97$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0331271bace68e97$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0331271bace68e97$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0331271bace68e97$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0331271bace68e97$var$Pc.delete(b.pointerId);
    }
}
function $0331271bace68e97$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0331271bace68e97$var$Cb(b), null !== b && $0331271bace68e97$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0331271bace68e97$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0331271bace68e97$var$Lc = $0331271bace68e97$var$Tc($0331271bace68e97$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0331271bace68e97$var$Mc = $0331271bace68e97$var$Tc($0331271bace68e97$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0331271bace68e97$var$Nc = $0331271bace68e97$var$Tc($0331271bace68e97$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0331271bace68e97$var$Oc.set(f, $0331271bace68e97$var$Tc($0331271bace68e97$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0331271bace68e97$var$Pc.set(f, $0331271bace68e97$var$Tc($0331271bace68e97$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0331271bace68e97$var$Vc(a) {
    var b = $0331271bace68e97$var$Wc(a.target);
    if (null !== b) {
        var c = $0331271bace68e97$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0331271bace68e97$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0331271bace68e97$var$Ic(a.priority, function() {
                        $0331271bace68e97$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0331271bace68e97$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0331271bace68e97$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0331271bace68e97$var$wb = d;
            c.target.dispatchEvent(d);
            $0331271bace68e97$var$wb = null;
        } else return b = $0331271bace68e97$var$Cb(c), null !== b && $0331271bace68e97$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0331271bace68e97$var$Zc(a, b, c) {
    $0331271bace68e97$var$Xc(a) && c.delete(b);
}
function $0331271bace68e97$var$$c() {
    $0331271bace68e97$var$Jc = !1;
    null !== $0331271bace68e97$var$Lc && $0331271bace68e97$var$Xc($0331271bace68e97$var$Lc) && ($0331271bace68e97$var$Lc = null);
    null !== $0331271bace68e97$var$Mc && $0331271bace68e97$var$Xc($0331271bace68e97$var$Mc) && ($0331271bace68e97$var$Mc = null);
    null !== $0331271bace68e97$var$Nc && $0331271bace68e97$var$Xc($0331271bace68e97$var$Nc) && ($0331271bace68e97$var$Nc = null);
    $0331271bace68e97$var$Oc.forEach($0331271bace68e97$var$Zc);
    $0331271bace68e97$var$Pc.forEach($0331271bace68e97$var$Zc);
}
function $0331271bace68e97$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0331271bace68e97$var$Jc || ($0331271bace68e97$var$Jc = !0, $1iyD5.unstable_scheduleCallback($1iyD5.unstable_NormalPriority, $0331271bace68e97$var$$c)));
}
function $0331271bace68e97$var$bd(a) {
    function b(b) {
        return $0331271bace68e97$var$ad(b, a);
    }
    if (0 < $0331271bace68e97$var$Kc.length) {
        $0331271bace68e97$var$ad($0331271bace68e97$var$Kc[0], a);
        for(var c = 1; c < $0331271bace68e97$var$Kc.length; c++){
            var d = $0331271bace68e97$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0331271bace68e97$var$Lc && $0331271bace68e97$var$ad($0331271bace68e97$var$Lc, a);
    null !== $0331271bace68e97$var$Mc && $0331271bace68e97$var$ad($0331271bace68e97$var$Mc, a);
    null !== $0331271bace68e97$var$Nc && $0331271bace68e97$var$ad($0331271bace68e97$var$Nc, a);
    $0331271bace68e97$var$Oc.forEach(b);
    $0331271bace68e97$var$Pc.forEach(b);
    for(c = 0; c < $0331271bace68e97$var$Qc.length; c++)d = $0331271bace68e97$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0331271bace68e97$var$Qc.length && (c = $0331271bace68e97$var$Qc[0], null === c.blockedOn);)$0331271bace68e97$var$Vc(c), null === c.blockedOn && $0331271bace68e97$var$Qc.shift();
}
var $0331271bace68e97$var$cd = $0331271bace68e97$var$ua.ReactCurrentBatchConfig, $0331271bace68e97$var$dd = !0;
function $0331271bace68e97$var$ed(a, b, c, d) {
    var e = $0331271bace68e97$var$C, f = $0331271bace68e97$var$cd.transition;
    $0331271bace68e97$var$cd.transition = null;
    try {
        $0331271bace68e97$var$C = 1, $0331271bace68e97$var$fd(a, b, c, d);
    } finally{
        $0331271bace68e97$var$C = e, $0331271bace68e97$var$cd.transition = f;
    }
}
function $0331271bace68e97$var$gd(a, b, c, d) {
    var e = $0331271bace68e97$var$C, f = $0331271bace68e97$var$cd.transition;
    $0331271bace68e97$var$cd.transition = null;
    try {
        $0331271bace68e97$var$C = 4, $0331271bace68e97$var$fd(a, b, c, d);
    } finally{
        $0331271bace68e97$var$C = e, $0331271bace68e97$var$cd.transition = f;
    }
}
function $0331271bace68e97$var$fd(a, b, c, d) {
    if ($0331271bace68e97$var$dd) {
        var e = $0331271bace68e97$var$Yc(a, b, c, d);
        if (null === e) $0331271bace68e97$var$hd(a, b, d, $0331271bace68e97$var$id, c), $0331271bace68e97$var$Sc(a, d);
        else if ($0331271bace68e97$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0331271bace68e97$var$Sc(a, d), b & 4 && -1 < $0331271bace68e97$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0331271bace68e97$var$Cb(e);
                null !== f && $0331271bace68e97$var$Ec(f);
                f = $0331271bace68e97$var$Yc(a, b, c, d);
                null === f && $0331271bace68e97$var$hd(a, b, d, $0331271bace68e97$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0331271bace68e97$var$hd(a, b, d, null, c);
    }
}
var $0331271bace68e97$var$id = null;
function $0331271bace68e97$var$Yc(a, b, c, d) {
    $0331271bace68e97$var$id = null;
    a = $0331271bace68e97$var$xb(d);
    a = $0331271bace68e97$var$Wc(a);
    if (null !== a) {
        if (b = $0331271bace68e97$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0331271bace68e97$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0331271bace68e97$var$id = a;
    return null;
}
function $0331271bace68e97$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0331271bace68e97$var$ec()){
                case $0331271bace68e97$var$fc:
                    return 1;
                case $0331271bace68e97$var$gc:
                    return 4;
                case $0331271bace68e97$var$hc:
                case $0331271bace68e97$var$ic:
                    return 16;
                case $0331271bace68e97$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0331271bace68e97$var$kd = null, $0331271bace68e97$var$ld = null, $0331271bace68e97$var$md = null;
function $0331271bace68e97$var$nd() {
    if ($0331271bace68e97$var$md) return $0331271bace68e97$var$md;
    var a, b = $0331271bace68e97$var$ld, c = b.length, d, e = "value" in $0331271bace68e97$var$kd ? $0331271bace68e97$var$kd.value : $0331271bace68e97$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0331271bace68e97$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0331271bace68e97$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0331271bace68e97$var$pd() {
    return !0;
}
function $0331271bace68e97$var$qd() {
    return !1;
}
function $0331271bace68e97$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0331271bace68e97$var$pd : $0331271bace68e97$var$qd;
        this.isPropagationStopped = $0331271bace68e97$var$qd;
        return this;
    }
    $0331271bace68e97$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $bJtXW._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $0331271bace68e97$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $bJtXW._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $0331271bace68e97$var$pd);
        },
        persist: function persist() {},
        isPersistent: $0331271bace68e97$var$pd
    });
    return b;
}
var $0331271bace68e97$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0331271bace68e97$var$td = $0331271bace68e97$var$rd($0331271bace68e97$var$sd), $0331271bace68e97$var$ud = $0331271bace68e97$var$A({}, $0331271bace68e97$var$sd, {
    view: 0,
    detail: 0
}), $0331271bace68e97$var$vd = $0331271bace68e97$var$rd($0331271bace68e97$var$ud), $0331271bace68e97$var$wd, $0331271bace68e97$var$xd, $0331271bace68e97$var$yd, $0331271bace68e97$var$Ad = $0331271bace68e97$var$A({}, $0331271bace68e97$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0331271bace68e97$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0331271bace68e97$var$yd && ($0331271bace68e97$var$yd && "mousemove" === a.type ? ($0331271bace68e97$var$wd = a.screenX - $0331271bace68e97$var$yd.screenX, $0331271bace68e97$var$xd = a.screenY - $0331271bace68e97$var$yd.screenY) : $0331271bace68e97$var$xd = $0331271bace68e97$var$wd = 0, $0331271bace68e97$var$yd = a);
        return $0331271bace68e97$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $0331271bace68e97$var$xd;
    }
}), $0331271bace68e97$var$Bd = $0331271bace68e97$var$rd($0331271bace68e97$var$Ad), $0331271bace68e97$var$Cd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$Ad, {
    dataTransfer: 0
}), $0331271bace68e97$var$Dd = $0331271bace68e97$var$rd($0331271bace68e97$var$Cd), $0331271bace68e97$var$Ed = $0331271bace68e97$var$A({}, $0331271bace68e97$var$ud, {
    relatedTarget: 0
}), $0331271bace68e97$var$Fd = $0331271bace68e97$var$rd($0331271bace68e97$var$Ed), $0331271bace68e97$var$Gd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0331271bace68e97$var$Hd = $0331271bace68e97$var$rd($0331271bace68e97$var$Gd), $0331271bace68e97$var$Id = $0331271bace68e97$var$A({}, $0331271bace68e97$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0331271bace68e97$var$Jd = $0331271bace68e97$var$rd($0331271bace68e97$var$Id), $0331271bace68e97$var$Kd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$sd, {
    data: 0
}), $0331271bace68e97$var$Ld = $0331271bace68e97$var$rd($0331271bace68e97$var$Kd), $0331271bace68e97$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0331271bace68e97$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0331271bace68e97$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0331271bace68e97$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0331271bace68e97$var$Od[a]) ? !!b[a] : !1;
}
function $0331271bace68e97$var$zd() {
    return $0331271bace68e97$var$Pd;
}
var $0331271bace68e97$var$Qd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $0331271bace68e97$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0331271bace68e97$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0331271bace68e97$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0331271bace68e97$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $0331271bace68e97$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $0331271bace68e97$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0331271bace68e97$var$Rd = $0331271bace68e97$var$rd($0331271bace68e97$var$Qd), $0331271bace68e97$var$Sd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0331271bace68e97$var$Td = $0331271bace68e97$var$rd($0331271bace68e97$var$Sd), $0331271bace68e97$var$Ud = $0331271bace68e97$var$A({}, $0331271bace68e97$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0331271bace68e97$var$zd
}), $0331271bace68e97$var$Vd = $0331271bace68e97$var$rd($0331271bace68e97$var$Ud), $0331271bace68e97$var$Wd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0331271bace68e97$var$Xd = $0331271bace68e97$var$rd($0331271bace68e97$var$Wd), $0331271bace68e97$var$Yd = $0331271bace68e97$var$A({}, $0331271bace68e97$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0331271bace68e97$var$Zd = $0331271bace68e97$var$rd($0331271bace68e97$var$Yd), $0331271bace68e97$var$$d = [
    9,
    13,
    27,
    32
], $0331271bace68e97$var$ae = $0331271bace68e97$var$ia && "CompositionEvent" in window, $0331271bace68e97$var$be = null;
$0331271bace68e97$var$ia && "documentMode" in document && ($0331271bace68e97$var$be = document.documentMode);
var $0331271bace68e97$var$ce = $0331271bace68e97$var$ia && "TextEvent" in window && !$0331271bace68e97$var$be, $0331271bace68e97$var$de = $0331271bace68e97$var$ia && (!$0331271bace68e97$var$ae || $0331271bace68e97$var$be && 8 < $0331271bace68e97$var$be && 11 >= $0331271bace68e97$var$be), $0331271bace68e97$var$ee = String.fromCharCode(32), $0331271bace68e97$var$fe = !1;
function $0331271bace68e97$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0331271bace68e97$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0331271bace68e97$var$he(a) {
    a = a.detail;
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a)) && "data" in a ? a.data : null;
}
var $0331271bace68e97$var$ie = !1;
function $0331271bace68e97$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0331271bace68e97$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0331271bace68e97$var$fe = !0;
            return $0331271bace68e97$var$ee;
        case "textInput":
            return a = b.data, a === $0331271bace68e97$var$ee && $0331271bace68e97$var$fe ? null : a;
        default:
            return null;
    }
}
function $0331271bace68e97$var$ke(a, b) {
    if ($0331271bace68e97$var$ie) return "compositionend" === a || !$0331271bace68e97$var$ae && $0331271bace68e97$var$ge(a, b) ? (a = $0331271bace68e97$var$nd(), $0331271bace68e97$var$md = $0331271bace68e97$var$ld = $0331271bace68e97$var$kd = null, $0331271bace68e97$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0331271bace68e97$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0331271bace68e97$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0331271bace68e97$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0331271bace68e97$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0331271bace68e97$var$ne(a, b, c, d) {
    $0331271bace68e97$var$Eb(d);
    b = $0331271bace68e97$var$oe(b, "onChange");
    0 < b.length && (c = new $0331271bace68e97$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0331271bace68e97$var$pe = null, $0331271bace68e97$var$qe = null;
function $0331271bace68e97$var$re(a) {
    $0331271bace68e97$var$se(a, 0);
}
function $0331271bace68e97$var$te(a) {
    var b = $0331271bace68e97$var$ue(a);
    if ($0331271bace68e97$var$Wa(b)) return a;
}
function $0331271bace68e97$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0331271bace68e97$var$we = !1;
if ($0331271bace68e97$var$ia) {
    var $0331271bace68e97$var$xe;
    if ($0331271bace68e97$var$ia) {
        var $0331271bace68e97$var$ye = "oninput" in document;
        if (!$0331271bace68e97$var$ye) {
            var $0331271bace68e97$var$ze = document.createElement("div");
            $0331271bace68e97$var$ze.setAttribute("oninput", "return;");
            $0331271bace68e97$var$ye = "function" === typeof $0331271bace68e97$var$ze.oninput;
        }
        $0331271bace68e97$var$xe = $0331271bace68e97$var$ye;
    } else $0331271bace68e97$var$xe = !1;
    $0331271bace68e97$var$we = $0331271bace68e97$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0331271bace68e97$var$Ae() {
    $0331271bace68e97$var$pe && ($0331271bace68e97$var$pe.detachEvent("onpropertychange", $0331271bace68e97$var$Be), $0331271bace68e97$var$qe = $0331271bace68e97$var$pe = null);
}
function $0331271bace68e97$var$Be(a) {
    if ("value" === a.propertyName && $0331271bace68e97$var$te($0331271bace68e97$var$qe)) {
        var b = [];
        $0331271bace68e97$var$ne(b, $0331271bace68e97$var$qe, a, $0331271bace68e97$var$xb(a));
        $0331271bace68e97$var$Jb($0331271bace68e97$var$re, b);
    }
}
function $0331271bace68e97$var$Ce(a, b, c) {
    "focusin" === a ? ($0331271bace68e97$var$Ae(), $0331271bace68e97$var$pe = b, $0331271bace68e97$var$qe = c, $0331271bace68e97$var$pe.attachEvent("onpropertychange", $0331271bace68e97$var$Be)) : "focusout" === a && $0331271bace68e97$var$Ae();
}
function $0331271bace68e97$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0331271bace68e97$var$te($0331271bace68e97$var$qe);
}
function $0331271bace68e97$var$Ee(a, b) {
    if ("click" === a) return $0331271bace68e97$var$te(b);
}
function $0331271bace68e97$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0331271bace68e97$var$te(b);
}
function $0331271bace68e97$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0331271bace68e97$var$He = "function" === typeof Object.is ? Object.is : $0331271bace68e97$var$Ge;
function $0331271bace68e97$var$Ie(a, b) {
    if ($0331271bace68e97$var$He(a, b)) return !0;
    if ("object" !== (typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a)) || null === a || "object" !== (typeof b === "undefined" ? "undefined" : (0, $bJtXW._)(b)) || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0331271bace68e97$var$ja.call(b, e) || !$0331271bace68e97$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0331271bace68e97$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0331271bace68e97$var$Ke(a, b) {
    var c = $0331271bace68e97$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0331271bace68e97$var$Je(c);
    }
}
function $0331271bace68e97$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0331271bace68e97$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0331271bace68e97$var$Me() {
    for(var a = window, b = $0331271bace68e97$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0331271bace68e97$var$Xa(a.document);
    }
    return b;
}
function $0331271bace68e97$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0331271bace68e97$var$Oe(a) {
    var b = $0331271bace68e97$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0331271bace68e97$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0331271bace68e97$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0331271bace68e97$var$Ke(c, f);
                var g = $0331271bace68e97$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0331271bace68e97$var$Pe = $0331271bace68e97$var$ia && "documentMode" in document && 11 >= document.documentMode, $0331271bace68e97$var$Qe = null, $0331271bace68e97$var$Re = null, $0331271bace68e97$var$Se = null, $0331271bace68e97$var$Te = !1;
function $0331271bace68e97$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0331271bace68e97$var$Te || null == $0331271bace68e97$var$Qe || $0331271bace68e97$var$Qe !== $0331271bace68e97$var$Xa(d) || (d = $0331271bace68e97$var$Qe, "selectionStart" in d && $0331271bace68e97$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0331271bace68e97$var$Se && $0331271bace68e97$var$Ie($0331271bace68e97$var$Se, d) || ($0331271bace68e97$var$Se = d, d = $0331271bace68e97$var$oe($0331271bace68e97$var$Re, "onSelect"), 0 < d.length && (b = new $0331271bace68e97$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0331271bace68e97$var$Qe)));
}
function $0331271bace68e97$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0331271bace68e97$var$We = {
    animationend: $0331271bace68e97$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0331271bace68e97$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0331271bace68e97$var$Ve("Animation", "AnimationStart"),
    transitionend: $0331271bace68e97$var$Ve("Transition", "TransitionEnd")
}, $0331271bace68e97$var$Xe = {}, $0331271bace68e97$var$Ye = {};
$0331271bace68e97$var$ia && ($0331271bace68e97$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0331271bace68e97$var$We.animationend.animation, delete $0331271bace68e97$var$We.animationiteration.animation, delete $0331271bace68e97$var$We.animationstart.animation), "TransitionEvent" in window || delete $0331271bace68e97$var$We.transitionend.transition);
function $0331271bace68e97$var$Ze(a) {
    if ($0331271bace68e97$var$Xe[a]) return $0331271bace68e97$var$Xe[a];
    if (!$0331271bace68e97$var$We[a]) return a;
    var b = $0331271bace68e97$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0331271bace68e97$var$Ye) return $0331271bace68e97$var$Xe[a] = b[c];
    return a;
}
var $0331271bace68e97$var$$e = $0331271bace68e97$var$Ze("animationend"), $0331271bace68e97$var$af = $0331271bace68e97$var$Ze("animationiteration"), $0331271bace68e97$var$bf = $0331271bace68e97$var$Ze("animationstart"), $0331271bace68e97$var$cf = $0331271bace68e97$var$Ze("transitionend"), $0331271bace68e97$var$df = new Map, $0331271bace68e97$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0331271bace68e97$var$ff(a, b) {
    $0331271bace68e97$var$df.set(a, b);
    $0331271bace68e97$var$fa(b, [
        a
    ]);
}
for(var $0331271bace68e97$var$gf = 0; $0331271bace68e97$var$gf < $0331271bace68e97$var$ef.length; $0331271bace68e97$var$gf++){
    var $0331271bace68e97$var$hf = $0331271bace68e97$var$ef[$0331271bace68e97$var$gf], $0331271bace68e97$var$jf = $0331271bace68e97$var$hf.toLowerCase(), $0331271bace68e97$var$kf = $0331271bace68e97$var$hf[0].toUpperCase() + $0331271bace68e97$var$hf.slice(1);
    $0331271bace68e97$var$ff($0331271bace68e97$var$jf, "on" + $0331271bace68e97$var$kf);
}
$0331271bace68e97$var$ff($0331271bace68e97$var$$e, "onAnimationEnd");
$0331271bace68e97$var$ff($0331271bace68e97$var$af, "onAnimationIteration");
$0331271bace68e97$var$ff($0331271bace68e97$var$bf, "onAnimationStart");
$0331271bace68e97$var$ff("dblclick", "onDoubleClick");
$0331271bace68e97$var$ff("focusin", "onFocus");
$0331271bace68e97$var$ff("focusout", "onBlur");
$0331271bace68e97$var$ff($0331271bace68e97$var$cf, "onTransitionEnd");
$0331271bace68e97$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0331271bace68e97$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0331271bace68e97$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0331271bace68e97$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0331271bace68e97$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0331271bace68e97$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0331271bace68e97$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0331271bace68e97$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0331271bace68e97$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0331271bace68e97$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0331271bace68e97$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0331271bace68e97$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0331271bace68e97$var$lf));
function $0331271bace68e97$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0331271bace68e97$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0331271bace68e97$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0331271bace68e97$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0331271bace68e97$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0331271bace68e97$var$Qb) throw a = $0331271bace68e97$var$Rb, $0331271bace68e97$var$Qb = !1, $0331271bace68e97$var$Rb = null, a;
}
function $0331271bace68e97$var$D(a, b) {
    var c = b[$0331271bace68e97$var$of];
    void 0 === c && (c = b[$0331271bace68e97$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0331271bace68e97$var$pf(b, a, 2, !1), c.add(d));
}
function $0331271bace68e97$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0331271bace68e97$var$pf(c, a, d, b);
}
var $0331271bace68e97$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0331271bace68e97$var$sf(a) {
    if (!a[$0331271bace68e97$var$rf]) {
        a[$0331271bace68e97$var$rf] = !0;
        $0331271bace68e97$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0331271bace68e97$var$mf.has(b) || $0331271bace68e97$var$qf(b, !1, a), $0331271bace68e97$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0331271bace68e97$var$rf] || (b[$0331271bace68e97$var$rf] = !0, $0331271bace68e97$var$qf("selectionchange", !1, b));
    }
}
function $0331271bace68e97$var$pf(a, b, c, d) {
    switch($0331271bace68e97$var$jd(b)){
        case 1:
            var e = $0331271bace68e97$var$ed;
            break;
        case 4:
            e = $0331271bace68e97$var$gd;
            break;
        default:
            e = $0331271bace68e97$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0331271bace68e97$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0331271bace68e97$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0331271bace68e97$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0331271bace68e97$var$Jb(function() {
        var _$d = f, _$e = $0331271bace68e97$var$xb(c), g = [];
        a: {
            var h = $0331271bace68e97$var$df.get(a);
            if (void 0 !== h) {
                var k = $0331271bace68e97$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0331271bace68e97$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0331271bace68e97$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0331271bace68e97$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0331271bace68e97$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0331271bace68e97$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0331271bace68e97$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0331271bace68e97$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0331271bace68e97$var$Vd;
                        break;
                    case $0331271bace68e97$var$$e:
                    case $0331271bace68e97$var$af:
                    case $0331271bace68e97$var$bf:
                        k = $0331271bace68e97$var$Hd;
                        break;
                    case $0331271bace68e97$var$cf:
                        k = $0331271bace68e97$var$Xd;
                        break;
                    case "scroll":
                        k = $0331271bace68e97$var$vd;
                        break;
                    case "wheel":
                        k = $0331271bace68e97$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0331271bace68e97$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0331271bace68e97$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0331271bace68e97$var$Kb(w, x), null != F && t.push($0331271bace68e97$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0331271bace68e97$var$wb && (n = c.relatedTarget || c.fromElement) && ($0331271bace68e97$var$Wc(n) || n[$0331271bace68e97$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $0331271bace68e97$var$Wc(n) : null, null !== n && (J = $0331271bace68e97$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $0331271bace68e97$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0331271bace68e97$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0331271bace68e97$var$ue(k);
                        u = null == n ? h : $0331271bace68e97$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0331271bace68e97$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0331271bace68e97$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0331271bace68e97$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0331271bace68e97$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0331271bace68e97$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0331271bace68e97$var$vf(t);
                                x = $0331271bace68e97$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0331271bace68e97$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0331271bace68e97$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $0331271bace68e97$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0331271bace68e97$var$ve;
                else if ($0331271bace68e97$var$me(h)) {
                    if ($0331271bace68e97$var$we) na = $0331271bace68e97$var$Fe;
                    else {
                        na = $0331271bace68e97$var$De;
                        var xa = $0331271bace68e97$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0331271bace68e97$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $0331271bace68e97$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0331271bace68e97$var$cb(h, "number", h.value);
            }
            xa = _$d ? $0331271bace68e97$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($0331271bace68e97$var$me(xa) || "true" === xa.contentEditable) $0331271bace68e97$var$Qe = xa, $0331271bace68e97$var$Re = _$d, $0331271bace68e97$var$Se = null;
                    break;
                case "focusout":
                    $0331271bace68e97$var$Se = $0331271bace68e97$var$Re = $0331271bace68e97$var$Qe = null;
                    break;
                case "mousedown":
                    $0331271bace68e97$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0331271bace68e97$var$Te = !1;
                    $0331271bace68e97$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($0331271bace68e97$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0331271bace68e97$var$Ue(g, c, _$e);
            }
            var $a;
            if ($0331271bace68e97$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0331271bace68e97$var$ie ? $0331271bace68e97$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0331271bace68e97$var$de && "ko" !== c.locale && ($0331271bace68e97$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0331271bace68e97$var$ie && ($a = $0331271bace68e97$var$nd()) : ($0331271bace68e97$var$kd = _$e, $0331271bace68e97$var$ld = "value" in $0331271bace68e97$var$kd ? $0331271bace68e97$var$kd.value : $0331271bace68e97$var$kd.textContent, $0331271bace68e97$var$ie = !0)), xa = $0331271bace68e97$var$oe(_$d, ba), 0 < xa.length && (ba = new $0331271bace68e97$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0331271bace68e97$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0331271bace68e97$var$ce ? $0331271bace68e97$var$je(a, c) : $0331271bace68e97$var$ke(a, c)) _$d = $0331271bace68e97$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $0331271bace68e97$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $0331271bace68e97$var$se(g, b);
    });
}
function $0331271bace68e97$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0331271bace68e97$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0331271bace68e97$var$Kb(a, c), null != f && d.unshift($0331271bace68e97$var$tf(a, f, e)), f = $0331271bace68e97$var$Kb(a, b), null != f && d.push($0331271bace68e97$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0331271bace68e97$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0331271bace68e97$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0331271bace68e97$var$Kb(c, f), null != k && g.unshift($0331271bace68e97$var$tf(c, k, h))) : e || (k = $0331271bace68e97$var$Kb(c, f), null != k && g.push($0331271bace68e97$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0331271bace68e97$var$xf = /\r\n?/g, $0331271bace68e97$var$yf = /\u0000|\uFFFD/g;
function $0331271bace68e97$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0331271bace68e97$var$xf, "\n").replace($0331271bace68e97$var$yf, "");
}
function $0331271bace68e97$var$Af(a, b, c) {
    b = $0331271bace68e97$var$zf(b);
    if ($0331271bace68e97$var$zf(a) !== b && c) throw Error($0331271bace68e97$var$p(425));
}
function $0331271bace68e97$var$Bf() {}
var $0331271bace68e97$var$Cf = null, $0331271bace68e97$var$Df = null;
function $0331271bace68e97$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === (0, $bJtXW._)(b.dangerouslySetInnerHTML) && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0331271bace68e97$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0331271bace68e97$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0331271bace68e97$var$Hf = "function" === typeof Promise ? Promise : void 0, $0331271bace68e97$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0331271bace68e97$var$Hf ? function Jf(a) {
    return $0331271bace68e97$var$Hf.resolve(null).then(a).catch($0331271bace68e97$var$If);
} : $0331271bace68e97$var$Ff;
function $0331271bace68e97$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0331271bace68e97$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0331271bace68e97$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0331271bace68e97$var$bd(b);
}
function $0331271bace68e97$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0331271bace68e97$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0331271bace68e97$var$Nf = Math.random().toString(36).slice(2), $0331271bace68e97$var$Of = "__reactFiber$" + $0331271bace68e97$var$Nf, $0331271bace68e97$var$Pf = "__reactProps$" + $0331271bace68e97$var$Nf, $0331271bace68e97$var$uf = "__reactContainer$" + $0331271bace68e97$var$Nf, $0331271bace68e97$var$of = "__reactEvents$" + $0331271bace68e97$var$Nf, $0331271bace68e97$var$Qf = "__reactListeners$" + $0331271bace68e97$var$Nf, $0331271bace68e97$var$Rf = "__reactHandles$" + $0331271bace68e97$var$Nf;
function $0331271bace68e97$var$Wc(a) {
    var b = a[$0331271bace68e97$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0331271bace68e97$var$uf] || c[$0331271bace68e97$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0331271bace68e97$var$Mf(a); null !== a;){
                if (c = a[$0331271bace68e97$var$Of]) return c;
                a = $0331271bace68e97$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0331271bace68e97$var$Cb(a) {
    a = a[$0331271bace68e97$var$Of] || a[$0331271bace68e97$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0331271bace68e97$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0331271bace68e97$var$p(33));
}
function $0331271bace68e97$var$Db(a) {
    return a[$0331271bace68e97$var$Pf] || null;
}
var $0331271bace68e97$var$Sf = [], $0331271bace68e97$var$Tf = -1;
function $0331271bace68e97$var$Uf(a) {
    return {
        current: a
    };
}
function $0331271bace68e97$var$E(a) {
    0 > $0331271bace68e97$var$Tf || (a.current = $0331271bace68e97$var$Sf[$0331271bace68e97$var$Tf], $0331271bace68e97$var$Sf[$0331271bace68e97$var$Tf] = null, $0331271bace68e97$var$Tf--);
}
function $0331271bace68e97$var$G(a, b) {
    $0331271bace68e97$var$Tf++;
    $0331271bace68e97$var$Sf[$0331271bace68e97$var$Tf] = a.current;
    a.current = b;
}
var $0331271bace68e97$var$Vf = {}, $0331271bace68e97$var$H = $0331271bace68e97$var$Uf($0331271bace68e97$var$Vf), $0331271bace68e97$var$Wf = $0331271bace68e97$var$Uf(!1), $0331271bace68e97$var$Xf = $0331271bace68e97$var$Vf;
function $0331271bace68e97$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0331271bace68e97$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0331271bace68e97$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0331271bace68e97$var$$f() {
    $0331271bace68e97$var$E($0331271bace68e97$var$Wf);
    $0331271bace68e97$var$E($0331271bace68e97$var$H);
}
function $0331271bace68e97$var$ag(a, b, c) {
    if ($0331271bace68e97$var$H.current !== $0331271bace68e97$var$Vf) throw Error($0331271bace68e97$var$p(168));
    $0331271bace68e97$var$G($0331271bace68e97$var$H, b);
    $0331271bace68e97$var$G($0331271bace68e97$var$Wf, c);
}
function $0331271bace68e97$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0331271bace68e97$var$p(108, $0331271bace68e97$var$Ra(a) || "Unknown", e));
    return $0331271bace68e97$var$A({}, c, d);
}
function $0331271bace68e97$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0331271bace68e97$var$Vf;
    $0331271bace68e97$var$Xf = $0331271bace68e97$var$H.current;
    $0331271bace68e97$var$G($0331271bace68e97$var$H, a);
    $0331271bace68e97$var$G($0331271bace68e97$var$Wf, $0331271bace68e97$var$Wf.current);
    return !0;
}
function $0331271bace68e97$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0331271bace68e97$var$p(169));
    c ? (a = $0331271bace68e97$var$bg(a, b, $0331271bace68e97$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0331271bace68e97$var$E($0331271bace68e97$var$Wf), $0331271bace68e97$var$E($0331271bace68e97$var$H), $0331271bace68e97$var$G($0331271bace68e97$var$H, a)) : $0331271bace68e97$var$E($0331271bace68e97$var$Wf);
    $0331271bace68e97$var$G($0331271bace68e97$var$Wf, c);
}
var $0331271bace68e97$var$eg = null, $0331271bace68e97$var$fg = !1, $0331271bace68e97$var$gg = !1;
function $0331271bace68e97$var$hg(a) {
    null === $0331271bace68e97$var$eg ? $0331271bace68e97$var$eg = [
        a
    ] : $0331271bace68e97$var$eg.push(a);
}
function $0331271bace68e97$var$ig(a) {
    $0331271bace68e97$var$fg = !0;
    $0331271bace68e97$var$hg(a);
}
function $0331271bace68e97$var$jg() {
    if (!$0331271bace68e97$var$gg && null !== $0331271bace68e97$var$eg) {
        $0331271bace68e97$var$gg = !0;
        var a = 0, b = $0331271bace68e97$var$C;
        try {
            var c = $0331271bace68e97$var$eg;
            for($0331271bace68e97$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0331271bace68e97$var$eg = null;
            $0331271bace68e97$var$fg = !1;
        } catch (e) {
            throw null !== $0331271bace68e97$var$eg && ($0331271bace68e97$var$eg = $0331271bace68e97$var$eg.slice(a + 1)), $0331271bace68e97$var$ac($0331271bace68e97$var$fc, $0331271bace68e97$var$jg), e;
        } finally{
            $0331271bace68e97$var$C = b, $0331271bace68e97$var$gg = !1;
        }
    }
    return null;
}
var $0331271bace68e97$var$kg = [], $0331271bace68e97$var$lg = 0, $0331271bace68e97$var$mg = null, $0331271bace68e97$var$ng = 0, $0331271bace68e97$var$og = [], $0331271bace68e97$var$pg = 0, $0331271bace68e97$var$qg = null, $0331271bace68e97$var$rg = 1, $0331271bace68e97$var$sg = "";
function $0331271bace68e97$var$tg(a, b) {
    $0331271bace68e97$var$kg[$0331271bace68e97$var$lg++] = $0331271bace68e97$var$ng;
    $0331271bace68e97$var$kg[$0331271bace68e97$var$lg++] = $0331271bace68e97$var$mg;
    $0331271bace68e97$var$mg = a;
    $0331271bace68e97$var$ng = b;
}
function $0331271bace68e97$var$ug(a, b, c) {
    $0331271bace68e97$var$og[$0331271bace68e97$var$pg++] = $0331271bace68e97$var$rg;
    $0331271bace68e97$var$og[$0331271bace68e97$var$pg++] = $0331271bace68e97$var$sg;
    $0331271bace68e97$var$og[$0331271bace68e97$var$pg++] = $0331271bace68e97$var$qg;
    $0331271bace68e97$var$qg = a;
    var d = $0331271bace68e97$var$rg;
    a = $0331271bace68e97$var$sg;
    var e = 32 - $0331271bace68e97$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0331271bace68e97$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0331271bace68e97$var$rg = 1 << 32 - $0331271bace68e97$var$oc(b) + e | c << e | d;
        $0331271bace68e97$var$sg = f + a;
    } else $0331271bace68e97$var$rg = 1 << f | c << e | d, $0331271bace68e97$var$sg = a;
}
function $0331271bace68e97$var$vg(a) {
    null !== a.return && ($0331271bace68e97$var$tg(a, 1), $0331271bace68e97$var$ug(a, 1, 0));
}
function $0331271bace68e97$var$wg(a) {
    for(; a === $0331271bace68e97$var$mg;)$0331271bace68e97$var$mg = $0331271bace68e97$var$kg[--$0331271bace68e97$var$lg], $0331271bace68e97$var$kg[$0331271bace68e97$var$lg] = null, $0331271bace68e97$var$ng = $0331271bace68e97$var$kg[--$0331271bace68e97$var$lg], $0331271bace68e97$var$kg[$0331271bace68e97$var$lg] = null;
    for(; a === $0331271bace68e97$var$qg;)$0331271bace68e97$var$qg = $0331271bace68e97$var$og[--$0331271bace68e97$var$pg], $0331271bace68e97$var$og[$0331271bace68e97$var$pg] = null, $0331271bace68e97$var$sg = $0331271bace68e97$var$og[--$0331271bace68e97$var$pg], $0331271bace68e97$var$og[$0331271bace68e97$var$pg] = null, $0331271bace68e97$var$rg = $0331271bace68e97$var$og[--$0331271bace68e97$var$pg], $0331271bace68e97$var$og[$0331271bace68e97$var$pg] = null;
}
var $0331271bace68e97$var$xg = null, $0331271bace68e97$var$yg = null, $0331271bace68e97$var$I = !1, $0331271bace68e97$var$zg = null;
function $0331271bace68e97$var$Ag(a, b) {
    var c = $0331271bace68e97$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0331271bace68e97$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0331271bace68e97$var$xg = a, $0331271bace68e97$var$yg = $0331271bace68e97$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0331271bace68e97$var$xg = a, $0331271bace68e97$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0331271bace68e97$var$qg ? {
                id: $0331271bace68e97$var$rg,
                overflow: $0331271bace68e97$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0331271bace68e97$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0331271bace68e97$var$xg = a, $0331271bace68e97$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0331271bace68e97$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0331271bace68e97$var$Eg(a) {
    if ($0331271bace68e97$var$I) {
        var b = $0331271bace68e97$var$yg;
        if (b) {
            var c = b;
            if (!$0331271bace68e97$var$Cg(a, b)) {
                if ($0331271bace68e97$var$Dg(a)) throw Error($0331271bace68e97$var$p(418));
                b = $0331271bace68e97$var$Lf(c.nextSibling);
                var d = $0331271bace68e97$var$xg;
                b && $0331271bace68e97$var$Cg(a, b) ? $0331271bace68e97$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0331271bace68e97$var$I = !1, $0331271bace68e97$var$xg = a);
            }
        } else {
            if ($0331271bace68e97$var$Dg(a)) throw Error($0331271bace68e97$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0331271bace68e97$var$I = !1;
            $0331271bace68e97$var$xg = a;
        }
    }
}
function $0331271bace68e97$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0331271bace68e97$var$xg = a;
}
function $0331271bace68e97$var$Gg(a) {
    if (a !== $0331271bace68e97$var$xg) return !1;
    if (!$0331271bace68e97$var$I) return $0331271bace68e97$var$Fg(a), $0331271bace68e97$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0331271bace68e97$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0331271bace68e97$var$yg)) {
        if ($0331271bace68e97$var$Dg(a)) throw $0331271bace68e97$var$Hg(), Error($0331271bace68e97$var$p(418));
        for(; b;)$0331271bace68e97$var$Ag(a, b), b = $0331271bace68e97$var$Lf(b.nextSibling);
    }
    $0331271bace68e97$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0331271bace68e97$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0331271bace68e97$var$yg = $0331271bace68e97$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0331271bace68e97$var$yg = null;
        }
    } else $0331271bace68e97$var$yg = $0331271bace68e97$var$xg ? $0331271bace68e97$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0331271bace68e97$var$Hg() {
    for(var a = $0331271bace68e97$var$yg; a;)a = $0331271bace68e97$var$Lf(a.nextSibling);
}
function $0331271bace68e97$var$Ig() {
    $0331271bace68e97$var$yg = $0331271bace68e97$var$xg = null;
    $0331271bace68e97$var$I = !1;
}
function $0331271bace68e97$var$Jg(a) {
    null === $0331271bace68e97$var$zg ? $0331271bace68e97$var$zg = [
        a
    ] : $0331271bace68e97$var$zg.push(a);
}
var $0331271bace68e97$var$Kg = $0331271bace68e97$var$ua.ReactCurrentBatchConfig;
function $0331271bace68e97$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== (typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a))) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0331271bace68e97$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0331271bace68e97$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0331271bace68e97$var$p(284));
        if (!c._owner) throw Error($0331271bace68e97$var$p(290, a));
    }
    return a;
}
function $0331271bace68e97$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0331271bace68e97$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0331271bace68e97$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0331271bace68e97$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0331271bace68e97$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0331271bace68e97$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0331271bace68e97$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === (typeof f === "undefined" ? "undefined" : (0, $bJtXW._)(f)) && null !== f && f.$$typeof === $0331271bace68e97$var$Ha && $0331271bace68e97$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0331271bace68e97$var$Lg(a, b, c), d.return = a, d;
        d = $0331271bace68e97$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0331271bace68e97$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0331271bace68e97$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0331271bace68e97$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0331271bace68e97$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === (typeof b === "undefined" ? "undefined" : (0, $bJtXW._)(b)) && null !== b) {
            switch(b.$$typeof){
                case $0331271bace68e97$var$va:
                    return c = $0331271bace68e97$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0331271bace68e97$var$Lg(a, null, b), c.return = a, c;
                case $0331271bace68e97$var$wa:
                    return b = $0331271bace68e97$var$Sg(b, a.mode, c), b.return = a, b;
                case $0331271bace68e97$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0331271bace68e97$var$eb(b) || $0331271bace68e97$var$Ka(b)) return b = $0331271bace68e97$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0331271bace68e97$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === (typeof c === "undefined" ? "undefined" : (0, $bJtXW._)(c)) && null !== c) {
            switch(c.$$typeof){
                case $0331271bace68e97$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0331271bace68e97$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0331271bace68e97$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0331271bace68e97$var$eb(c) || $0331271bace68e97$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0331271bace68e97$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === (typeof d === "undefined" ? "undefined" : (0, $bJtXW._)(d)) && null !== d) {
            switch(d.$$typeof){
                case $0331271bace68e97$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0331271bace68e97$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0331271bace68e97$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0331271bace68e97$var$eb(d) || $0331271bace68e97$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0331271bace68e97$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0331271bace68e97$var$I && $0331271bace68e97$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0331271bace68e97$var$I && $0331271bace68e97$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0331271bace68e97$var$I && $0331271bace68e97$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0331271bace68e97$var$Ka(h);
        if ("function" !== typeof l) throw Error($0331271bace68e97$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0331271bace68e97$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0331271bace68e97$var$I && $0331271bace68e97$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0331271bace68e97$var$I && $0331271bace68e97$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0331271bace68e97$var$I && $0331271bace68e97$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === (typeof f === "undefined" ? "undefined" : (0, $bJtXW._)(f)) && null !== f && f.type === $0331271bace68e97$var$ya && null === f.key && (f = f.props.children);
        if ("object" === (typeof f === "undefined" ? "undefined" : (0, $bJtXW._)(f)) && null !== f) {
            switch(f.$$typeof){
                case $0331271bace68e97$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0331271bace68e97$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === (typeof k === "undefined" ? "undefined" : (0, $bJtXW._)(k)) && null !== k && k.$$typeof === $0331271bace68e97$var$Ha && $0331271bace68e97$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0331271bace68e97$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0331271bace68e97$var$ya ? (d = $0331271bace68e97$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0331271bace68e97$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0331271bace68e97$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0331271bace68e97$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0331271bace68e97$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0331271bace68e97$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0331271bace68e97$var$eb(f)) return n(a, d, f, h);
            if ($0331271bace68e97$var$Ka(f)) return t(a, d, f, h);
            $0331271bace68e97$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0331271bace68e97$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0331271bace68e97$var$Ug = $0331271bace68e97$var$Og(!0), $0331271bace68e97$var$Vg = $0331271bace68e97$var$Og(!1), $0331271bace68e97$var$Wg = $0331271bace68e97$var$Uf(null), $0331271bace68e97$var$Xg = null, $0331271bace68e97$var$Yg = null, $0331271bace68e97$var$Zg = null;
function $0331271bace68e97$var$$g() {
    $0331271bace68e97$var$Zg = $0331271bace68e97$var$Yg = $0331271bace68e97$var$Xg = null;
}
function $0331271bace68e97$var$ah(a) {
    var b = $0331271bace68e97$var$Wg.current;
    $0331271bace68e97$var$E($0331271bace68e97$var$Wg);
    a._currentValue = b;
}
function $0331271bace68e97$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0331271bace68e97$var$ch(a, b) {
    $0331271bace68e97$var$Xg = a;
    $0331271bace68e97$var$Zg = $0331271bace68e97$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0331271bace68e97$var$dh = !0), a.firstContext = null);
}
function $0331271bace68e97$var$eh(a) {
    var b = a._currentValue;
    if ($0331271bace68e97$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0331271bace68e97$var$Yg) {
            if (null === $0331271bace68e97$var$Xg) throw Error($0331271bace68e97$var$p(308));
            $0331271bace68e97$var$Yg = a;
            $0331271bace68e97$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0331271bace68e97$var$Yg = $0331271bace68e97$var$Yg.next = a;
    }
    return b;
}
var $0331271bace68e97$var$fh = null;
function $0331271bace68e97$var$gh(a) {
    null === $0331271bace68e97$var$fh ? $0331271bace68e97$var$fh = [
        a
    ] : $0331271bace68e97$var$fh.push(a);
}
function $0331271bace68e97$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0331271bace68e97$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0331271bace68e97$var$ih(a, d);
}
function $0331271bace68e97$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0331271bace68e97$var$jh = !1;
function $0331271bace68e97$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0331271bace68e97$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0331271bace68e97$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0331271bace68e97$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0331271bace68e97$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0331271bace68e97$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0331271bace68e97$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0331271bace68e97$var$ih(a, c);
}
function $0331271bace68e97$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0331271bace68e97$var$Cc(a, c);
    }
}
function $0331271bace68e97$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0331271bace68e97$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0331271bace68e97$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0331271bace68e97$var$A({}, q, r);
                            break a;
                        case 2:
                            $0331271bace68e97$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0331271bace68e97$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0331271bace68e97$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0331271bace68e97$var$p(191, e));
            e.call(d);
        }
    }
}
var $0331271bace68e97$var$th = {}, $0331271bace68e97$var$uh = $0331271bace68e97$var$Uf($0331271bace68e97$var$th), $0331271bace68e97$var$vh = $0331271bace68e97$var$Uf($0331271bace68e97$var$th), $0331271bace68e97$var$wh = $0331271bace68e97$var$Uf($0331271bace68e97$var$th);
function $0331271bace68e97$var$xh(a) {
    if (a === $0331271bace68e97$var$th) throw Error($0331271bace68e97$var$p(174));
    return a;
}
function $0331271bace68e97$var$yh(a, b) {
    $0331271bace68e97$var$G($0331271bace68e97$var$wh, b);
    $0331271bace68e97$var$G($0331271bace68e97$var$vh, a);
    $0331271bace68e97$var$G($0331271bace68e97$var$uh, $0331271bace68e97$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0331271bace68e97$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0331271bace68e97$var$lb(b, a);
    }
    $0331271bace68e97$var$E($0331271bace68e97$var$uh);
    $0331271bace68e97$var$G($0331271bace68e97$var$uh, b);
}
function $0331271bace68e97$var$zh() {
    $0331271bace68e97$var$E($0331271bace68e97$var$uh);
    $0331271bace68e97$var$E($0331271bace68e97$var$vh);
    $0331271bace68e97$var$E($0331271bace68e97$var$wh);
}
function $0331271bace68e97$var$Ah(a) {
    $0331271bace68e97$var$xh($0331271bace68e97$var$wh.current);
    var b = $0331271bace68e97$var$xh($0331271bace68e97$var$uh.current);
    var c = $0331271bace68e97$var$lb(b, a.type);
    b !== c && ($0331271bace68e97$var$G($0331271bace68e97$var$vh, a), $0331271bace68e97$var$G($0331271bace68e97$var$uh, c));
}
function $0331271bace68e97$var$Bh(a) {
    $0331271bace68e97$var$vh.current === a && ($0331271bace68e97$var$E($0331271bace68e97$var$uh), $0331271bace68e97$var$E($0331271bace68e97$var$vh));
}
var $0331271bace68e97$var$L = $0331271bace68e97$var$Uf(0);
function $0331271bace68e97$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0331271bace68e97$var$Dh = [];
function $0331271bace68e97$var$Eh() {
    for(var a = 0; a < $0331271bace68e97$var$Dh.length; a++)$0331271bace68e97$var$Dh[a]._workInProgressVersionPrimary = null;
    $0331271bace68e97$var$Dh.length = 0;
}
var $0331271bace68e97$var$Fh = $0331271bace68e97$var$ua.ReactCurrentDispatcher, $0331271bace68e97$var$Gh = $0331271bace68e97$var$ua.ReactCurrentBatchConfig, $0331271bace68e97$var$Hh = 0, $0331271bace68e97$var$M = null, $0331271bace68e97$var$N = null, $0331271bace68e97$var$O = null, $0331271bace68e97$var$Ih = !1, $0331271bace68e97$var$Jh = !1, $0331271bace68e97$var$Kh = 0, $0331271bace68e97$var$Lh = 0;
function $0331271bace68e97$var$P() {
    throw Error($0331271bace68e97$var$p(321));
}
function $0331271bace68e97$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0331271bace68e97$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0331271bace68e97$var$Nh(a, b, c, d, e, f) {
    $0331271bace68e97$var$Hh = f;
    $0331271bace68e97$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0331271bace68e97$var$Fh.current = null === a || null === a.memoizedState ? $0331271bace68e97$var$Oh : $0331271bace68e97$var$Ph;
    a = c(d, e);
    if ($0331271bace68e97$var$Jh) {
        f = 0;
        do {
            $0331271bace68e97$var$Jh = !1;
            $0331271bace68e97$var$Kh = 0;
            if (25 <= f) throw Error($0331271bace68e97$var$p(301));
            f += 1;
            $0331271bace68e97$var$O = $0331271bace68e97$var$N = null;
            b.updateQueue = null;
            $0331271bace68e97$var$Fh.current = $0331271bace68e97$var$Qh;
            a = c(d, e);
        }while ($0331271bace68e97$var$Jh);
    }
    $0331271bace68e97$var$Fh.current = $0331271bace68e97$var$Rh;
    b = null !== $0331271bace68e97$var$N && null !== $0331271bace68e97$var$N.next;
    $0331271bace68e97$var$Hh = 0;
    $0331271bace68e97$var$O = $0331271bace68e97$var$N = $0331271bace68e97$var$M = null;
    $0331271bace68e97$var$Ih = !1;
    if (b) throw Error($0331271bace68e97$var$p(300));
    return a;
}
function $0331271bace68e97$var$Sh() {
    var a = 0 !== $0331271bace68e97$var$Kh;
    $0331271bace68e97$var$Kh = 0;
    return a;
}
function $0331271bace68e97$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0331271bace68e97$var$O ? $0331271bace68e97$var$M.memoizedState = $0331271bace68e97$var$O = a : $0331271bace68e97$var$O = $0331271bace68e97$var$O.next = a;
    return $0331271bace68e97$var$O;
}
function $0331271bace68e97$var$Uh() {
    if (null === $0331271bace68e97$var$N) {
        var a = $0331271bace68e97$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0331271bace68e97$var$N.next;
    var b = null === $0331271bace68e97$var$O ? $0331271bace68e97$var$M.memoizedState : $0331271bace68e97$var$O.next;
    if (null !== b) $0331271bace68e97$var$O = b, $0331271bace68e97$var$N = a;
    else {
        if (null === a) throw Error($0331271bace68e97$var$p(310));
        $0331271bace68e97$var$N = a;
        a = {
            memoizedState: $0331271bace68e97$var$N.memoizedState,
            baseState: $0331271bace68e97$var$N.baseState,
            baseQueue: $0331271bace68e97$var$N.baseQueue,
            queue: $0331271bace68e97$var$N.queue,
            next: null
        };
        null === $0331271bace68e97$var$O ? $0331271bace68e97$var$M.memoizedState = $0331271bace68e97$var$O = a : $0331271bace68e97$var$O = $0331271bace68e97$var$O.next = a;
    }
    return $0331271bace68e97$var$O;
}
function $0331271bace68e97$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0331271bace68e97$var$Wh(a) {
    var b = $0331271bace68e97$var$Uh(), c = b.queue;
    if (null === c) throw Error($0331271bace68e97$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0331271bace68e97$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0331271bace68e97$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0331271bace68e97$var$M.lanes |= m;
                $0331271bace68e97$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0331271bace68e97$var$He(d, b.memoizedState) || ($0331271bace68e97$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0331271bace68e97$var$M.lanes |= f, $0331271bace68e97$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0331271bace68e97$var$Xh(a) {
    var b = $0331271bace68e97$var$Uh(), c = b.queue;
    if (null === c) throw Error($0331271bace68e97$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0331271bace68e97$var$He(f, b.memoizedState) || ($0331271bace68e97$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0331271bace68e97$var$Yh() {}
function $0331271bace68e97$var$Zh(a, b) {
    var c = $0331271bace68e97$var$M, d = $0331271bace68e97$var$Uh(), e = b(), f = !$0331271bace68e97$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0331271bace68e97$var$dh = !0);
    d = d.queue;
    $0331271bace68e97$var$$h($0331271bace68e97$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0331271bace68e97$var$O && $0331271bace68e97$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0331271bace68e97$var$bi(9, $0331271bace68e97$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0331271bace68e97$var$Q) throw Error($0331271bace68e97$var$p(349));
        0 !== ($0331271bace68e97$var$Hh & 30) || $0331271bace68e97$var$di(c, b, e);
    }
    return e;
}
function $0331271bace68e97$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0331271bace68e97$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0331271bace68e97$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0331271bace68e97$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0331271bace68e97$var$ei(b) && $0331271bace68e97$var$fi(a);
}
function $0331271bace68e97$var$ai(a, b, c) {
    return c(function() {
        $0331271bace68e97$var$ei(b) && $0331271bace68e97$var$fi(a);
    });
}
function $0331271bace68e97$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0331271bace68e97$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0331271bace68e97$var$fi(a) {
    var b = $0331271bace68e97$var$ih(a, 1);
    null !== b && $0331271bace68e97$var$gi(b, a, 1, -1);
}
function $0331271bace68e97$var$hi(a) {
    var b = $0331271bace68e97$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0331271bace68e97$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0331271bace68e97$var$ii.bind(null, $0331271bace68e97$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0331271bace68e97$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0331271bace68e97$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0331271bace68e97$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0331271bace68e97$var$ji() {
    return $0331271bace68e97$var$Uh().memoizedState;
}
function $0331271bace68e97$var$ki(a, b, c, d) {
    var e = $0331271bace68e97$var$Th();
    $0331271bace68e97$var$M.flags |= a;
    e.memoizedState = $0331271bace68e97$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0331271bace68e97$var$li(a, b, c, d) {
    var e = $0331271bace68e97$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0331271bace68e97$var$N) {
        var g = $0331271bace68e97$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0331271bace68e97$var$Mh(d, g.deps)) {
            e.memoizedState = $0331271bace68e97$var$bi(b, c, f, d);
            return;
        }
    }
    $0331271bace68e97$var$M.flags |= a;
    e.memoizedState = $0331271bace68e97$var$bi(1 | b, c, f, d);
}
function $0331271bace68e97$var$mi(a, b) {
    return $0331271bace68e97$var$ki(8390656, 8, a, b);
}
function $0331271bace68e97$var$$h(a, b) {
    return $0331271bace68e97$var$li(2048, 8, a, b);
}
function $0331271bace68e97$var$ni(a, b) {
    return $0331271bace68e97$var$li(4, 2, a, b);
}
function $0331271bace68e97$var$oi(a, b) {
    return $0331271bace68e97$var$li(4, 4, a, b);
}
function $0331271bace68e97$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0331271bace68e97$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0331271bace68e97$var$li(4, 4, $0331271bace68e97$var$pi.bind(null, b, a), c);
}
function $0331271bace68e97$var$ri() {}
function $0331271bace68e97$var$si(a, b) {
    var c = $0331271bace68e97$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0331271bace68e97$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0331271bace68e97$var$ti(a, b) {
    var c = $0331271bace68e97$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0331271bace68e97$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0331271bace68e97$var$ui(a, b, c) {
    if (0 === ($0331271bace68e97$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0331271bace68e97$var$dh = !0), a.memoizedState = c;
    $0331271bace68e97$var$He(c, b) || (c = $0331271bace68e97$var$yc(), $0331271bace68e97$var$M.lanes |= c, $0331271bace68e97$var$rh |= c, a.baseState = !0);
    return b;
}
function $0331271bace68e97$var$vi(a, b) {
    var c = $0331271bace68e97$var$C;
    $0331271bace68e97$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0331271bace68e97$var$Gh.transition;
    $0331271bace68e97$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0331271bace68e97$var$C = c, $0331271bace68e97$var$Gh.transition = d;
    }
}
function $0331271bace68e97$var$wi() {
    return $0331271bace68e97$var$Uh().memoizedState;
}
function $0331271bace68e97$var$xi(a, b, c) {
    var d = $0331271bace68e97$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0331271bace68e97$var$zi(a)) $0331271bace68e97$var$Ai(b, c);
    else if (c = $0331271bace68e97$var$hh(a, b, c, d), null !== c) {
        var e = $0331271bace68e97$var$R();
        $0331271bace68e97$var$gi(c, a, d, e);
        $0331271bace68e97$var$Bi(c, b, d);
    }
}
function $0331271bace68e97$var$ii(a, b, c) {
    var d = $0331271bace68e97$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0331271bace68e97$var$zi(a)) $0331271bace68e97$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0331271bace68e97$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0331271bace68e97$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0331271bace68e97$var$hh(a, b, e, d);
        null !== c && (e = $0331271bace68e97$var$R(), $0331271bace68e97$var$gi(c, a, d, e), $0331271bace68e97$var$Bi(c, b, d));
    }
}
function $0331271bace68e97$var$zi(a) {
    var b = a.alternate;
    return a === $0331271bace68e97$var$M || null !== b && b === $0331271bace68e97$var$M;
}
function $0331271bace68e97$var$Ai(a, b) {
    $0331271bace68e97$var$Jh = $0331271bace68e97$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0331271bace68e97$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0331271bace68e97$var$Cc(a, c);
    }
}
var $0331271bace68e97$var$Rh = {
    readContext: $0331271bace68e97$var$eh,
    useCallback: $0331271bace68e97$var$P,
    useContext: $0331271bace68e97$var$P,
    useEffect: $0331271bace68e97$var$P,
    useImperativeHandle: $0331271bace68e97$var$P,
    useInsertionEffect: $0331271bace68e97$var$P,
    useLayoutEffect: $0331271bace68e97$var$P,
    useMemo: $0331271bace68e97$var$P,
    useReducer: $0331271bace68e97$var$P,
    useRef: $0331271bace68e97$var$P,
    useState: $0331271bace68e97$var$P,
    useDebugValue: $0331271bace68e97$var$P,
    useDeferredValue: $0331271bace68e97$var$P,
    useTransition: $0331271bace68e97$var$P,
    useMutableSource: $0331271bace68e97$var$P,
    useSyncExternalStore: $0331271bace68e97$var$P,
    useId: $0331271bace68e97$var$P,
    unstable_isNewReconciler: !1
}, $0331271bace68e97$var$Oh = {
    readContext: $0331271bace68e97$var$eh,
    useCallback: function useCallback(a, b) {
        $0331271bace68e97$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0331271bace68e97$var$eh,
    useEffect: $0331271bace68e97$var$mi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0331271bace68e97$var$ki(4194308, 4, $0331271bace68e97$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $0331271bace68e97$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $0331271bace68e97$var$ki(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $0331271bace68e97$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $0331271bace68e97$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0331271bace68e97$var$xi.bind(null, $0331271bace68e97$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $0331271bace68e97$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0331271bace68e97$var$hi,
    useDebugValue: $0331271bace68e97$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        return $0331271bace68e97$var$Th().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $0331271bace68e97$var$hi(!1), b = a[0];
        a = $0331271bace68e97$var$vi.bind(null, a[1]);
        $0331271bace68e97$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $0331271bace68e97$var$M, e = $0331271bace68e97$var$Th();
        if ($0331271bace68e97$var$I) {
            if (void 0 === c) throw Error($0331271bace68e97$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0331271bace68e97$var$Q) throw Error($0331271bace68e97$var$p(349));
            0 !== ($0331271bace68e97$var$Hh & 30) || $0331271bace68e97$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0331271bace68e97$var$mi($0331271bace68e97$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0331271bace68e97$var$bi(9, $0331271bace68e97$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $0331271bace68e97$var$Th(), b = $0331271bace68e97$var$Q.identifierPrefix;
        if ($0331271bace68e97$var$I) {
            var c = $0331271bace68e97$var$sg;
            var d = $0331271bace68e97$var$rg;
            c = (d & ~(1 << 32 - $0331271bace68e97$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0331271bace68e97$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0331271bace68e97$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0331271bace68e97$var$Ph = {
    readContext: $0331271bace68e97$var$eh,
    useCallback: $0331271bace68e97$var$si,
    useContext: $0331271bace68e97$var$eh,
    useEffect: $0331271bace68e97$var$$h,
    useImperativeHandle: $0331271bace68e97$var$qi,
    useInsertionEffect: $0331271bace68e97$var$ni,
    useLayoutEffect: $0331271bace68e97$var$oi,
    useMemo: $0331271bace68e97$var$ti,
    useReducer: $0331271bace68e97$var$Wh,
    useRef: $0331271bace68e97$var$ji,
    useState: function useState() {
        return $0331271bace68e97$var$Wh($0331271bace68e97$var$Vh);
    },
    useDebugValue: $0331271bace68e97$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $0331271bace68e97$var$Uh();
        return $0331271bace68e97$var$ui(b, $0331271bace68e97$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $0331271bace68e97$var$Wh($0331271bace68e97$var$Vh)[0], b = $0331271bace68e97$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0331271bace68e97$var$Yh,
    useSyncExternalStore: $0331271bace68e97$var$Zh,
    useId: $0331271bace68e97$var$wi,
    unstable_isNewReconciler: !1
}, $0331271bace68e97$var$Qh = {
    readContext: $0331271bace68e97$var$eh,
    useCallback: $0331271bace68e97$var$si,
    useContext: $0331271bace68e97$var$eh,
    useEffect: $0331271bace68e97$var$$h,
    useImperativeHandle: $0331271bace68e97$var$qi,
    useInsertionEffect: $0331271bace68e97$var$ni,
    useLayoutEffect: $0331271bace68e97$var$oi,
    useMemo: $0331271bace68e97$var$ti,
    useReducer: $0331271bace68e97$var$Xh,
    useRef: $0331271bace68e97$var$ji,
    useState: function useState() {
        return $0331271bace68e97$var$Xh($0331271bace68e97$var$Vh);
    },
    useDebugValue: $0331271bace68e97$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $0331271bace68e97$var$Uh();
        return null === $0331271bace68e97$var$N ? b.memoizedState = a : $0331271bace68e97$var$ui(b, $0331271bace68e97$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $0331271bace68e97$var$Xh($0331271bace68e97$var$Vh)[0], b = $0331271bace68e97$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0331271bace68e97$var$Yh,
    useSyncExternalStore: $0331271bace68e97$var$Zh,
    useId: $0331271bace68e97$var$wi,
    unstable_isNewReconciler: !1
};
function $0331271bace68e97$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0331271bace68e97$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0331271bace68e97$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0331271bace68e97$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0331271bace68e97$var$Ei = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $0331271bace68e97$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $0331271bace68e97$var$R(), e = $0331271bace68e97$var$yi(a), f = $0331271bace68e97$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0331271bace68e97$var$nh(a, f, e);
        null !== b && ($0331271bace68e97$var$gi(b, a, e, d), $0331271bace68e97$var$oh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $0331271bace68e97$var$R(), e = $0331271bace68e97$var$yi(a), f = $0331271bace68e97$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0331271bace68e97$var$nh(a, f, e);
        null !== b && ($0331271bace68e97$var$gi(b, a, e, d), $0331271bace68e97$var$oh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $0331271bace68e97$var$R(), d = $0331271bace68e97$var$yi(a), e = $0331271bace68e97$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0331271bace68e97$var$nh(a, e, d);
        null !== b && ($0331271bace68e97$var$gi(b, a, d, c), $0331271bace68e97$var$oh(b, a, d));
    }
};
function $0331271bace68e97$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0331271bace68e97$var$Ie(c, d) || !$0331271bace68e97$var$Ie(e, f) : !0;
}
function $0331271bace68e97$var$Gi(a, b, c) {
    var d = !1, e = $0331271bace68e97$var$Vf;
    var f = b.contextType;
    "object" === (typeof f === "undefined" ? "undefined" : (0, $bJtXW._)(f)) && null !== f ? f = $0331271bace68e97$var$eh(f) : (e = $0331271bace68e97$var$Zf(b) ? $0331271bace68e97$var$Xf : $0331271bace68e97$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0331271bace68e97$var$Yf(a, e) : $0331271bace68e97$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0331271bace68e97$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0331271bace68e97$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0331271bace68e97$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0331271bace68e97$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0331271bace68e97$var$kh(a);
    var f = b.contextType;
    "object" === (typeof f === "undefined" ? "undefined" : (0, $bJtXW._)(f)) && null !== f ? e.context = $0331271bace68e97$var$eh(f) : (f = $0331271bace68e97$var$Zf(b) ? $0331271bace68e97$var$Xf : $0331271bace68e97$var$H.current, e.context = $0331271bace68e97$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0331271bace68e97$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0331271bace68e97$var$Ei.enqueueReplaceState(e, e.state, null), $0331271bace68e97$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0331271bace68e97$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0331271bace68e97$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0331271bace68e97$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0331271bace68e97$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0331271bace68e97$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0331271bace68e97$var$Ni(a, b, c) {
    c = $0331271bace68e97$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0331271bace68e97$var$Oi || ($0331271bace68e97$var$Oi = !0, $0331271bace68e97$var$Pi = d);
        $0331271bace68e97$var$Li(a, b);
    };
    return c;
}
function $0331271bace68e97$var$Qi(a, b, c) {
    c = $0331271bace68e97$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0331271bace68e97$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0331271bace68e97$var$Li(a, b);
        "function" !== typeof d && (null === $0331271bace68e97$var$Ri ? $0331271bace68e97$var$Ri = new Set([
            this
        ]) : $0331271bace68e97$var$Ri.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $0331271bace68e97$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0331271bace68e97$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0331271bace68e97$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0331271bace68e97$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0331271bace68e97$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0331271bace68e97$var$mh(-1, 1), b.tag = 2, $0331271bace68e97$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0331271bace68e97$var$Wi = $0331271bace68e97$var$ua.ReactCurrentOwner, $0331271bace68e97$var$dh = !1;
function $0331271bace68e97$var$Xi(a, b, c, d) {
    b.child = null === a ? $0331271bace68e97$var$Vg(b, null, c, d) : $0331271bace68e97$var$Ug(b, a.child, c, d);
}
function $0331271bace68e97$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0331271bace68e97$var$ch(b, e);
    d = $0331271bace68e97$var$Nh(a, b, c, d, f, e);
    c = $0331271bace68e97$var$Sh();
    if (null !== a && !$0331271bace68e97$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0331271bace68e97$var$Zi(a, b, e);
    $0331271bace68e97$var$I && c && $0331271bace68e97$var$vg(b);
    b.flags |= 1;
    $0331271bace68e97$var$Xi(a, b, d, e);
    return b.child;
}
function $0331271bace68e97$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0331271bace68e97$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0331271bace68e97$var$bj(a, b, f, d, e);
        a = $0331271bace68e97$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0331271bace68e97$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0331271bace68e97$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0331271bace68e97$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0331271bace68e97$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0331271bace68e97$var$Ie(f, d) && a.ref === b.ref) {
            if ($0331271bace68e97$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0331271bace68e97$var$dh = !0);
            else return b.lanes = a.lanes, $0331271bace68e97$var$Zi(a, b, e);
        }
    }
    return $0331271bace68e97$var$cj(a, b, c, d, e);
}
function $0331271bace68e97$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0331271bace68e97$var$G($0331271bace68e97$var$ej, $0331271bace68e97$var$fj), $0331271bace68e97$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0331271bace68e97$var$G($0331271bace68e97$var$ej, $0331271bace68e97$var$fj), $0331271bace68e97$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0331271bace68e97$var$G($0331271bace68e97$var$ej, $0331271bace68e97$var$fj);
            $0331271bace68e97$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0331271bace68e97$var$G($0331271bace68e97$var$ej, $0331271bace68e97$var$fj), $0331271bace68e97$var$fj |= d;
    $0331271bace68e97$var$Xi(a, b, e, c);
    return b.child;
}
function $0331271bace68e97$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0331271bace68e97$var$cj(a, b, c, d, e) {
    var f = $0331271bace68e97$var$Zf(c) ? $0331271bace68e97$var$Xf : $0331271bace68e97$var$H.current;
    f = $0331271bace68e97$var$Yf(b, f);
    $0331271bace68e97$var$ch(b, e);
    c = $0331271bace68e97$var$Nh(a, b, c, d, f, e);
    d = $0331271bace68e97$var$Sh();
    if (null !== a && !$0331271bace68e97$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0331271bace68e97$var$Zi(a, b, e);
    $0331271bace68e97$var$I && d && $0331271bace68e97$var$vg(b);
    b.flags |= 1;
    $0331271bace68e97$var$Xi(a, b, c, e);
    return b.child;
}
function $0331271bace68e97$var$hj(a, b, c, d, e) {
    if ($0331271bace68e97$var$Zf(c)) {
        var f = !0;
        $0331271bace68e97$var$cg(b);
    } else f = !1;
    $0331271bace68e97$var$ch(b, e);
    if (null === b.stateNode) $0331271bace68e97$var$ij(a, b), $0331271bace68e97$var$Gi(b, c, d), $0331271bace68e97$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === (typeof l === "undefined" ? "undefined" : (0, $bJtXW._)(l)) && null !== l ? l = $0331271bace68e97$var$eh(l) : (l = $0331271bace68e97$var$Zf(c) ? $0331271bace68e97$var$Xf : $0331271bace68e97$var$H.current, l = $0331271bace68e97$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0331271bace68e97$var$Hi(b, g, d, l);
        $0331271bace68e97$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0331271bace68e97$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0331271bace68e97$var$Wf.current || $0331271bace68e97$var$jh ? ("function" === typeof m && ($0331271bace68e97$var$Di(b, c, m, d), k = b.memoizedState), (h = $0331271bace68e97$var$jh || $0331271bace68e97$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0331271bace68e97$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0331271bace68e97$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === (typeof k === "undefined" ? "undefined" : (0, $bJtXW._)(k)) && null !== k ? k = $0331271bace68e97$var$eh(k) : (k = $0331271bace68e97$var$Zf(c) ? $0331271bace68e97$var$Xf : $0331271bace68e97$var$H.current, k = $0331271bace68e97$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0331271bace68e97$var$Hi(b, g, d, k);
        $0331271bace68e97$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0331271bace68e97$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0331271bace68e97$var$Wf.current || $0331271bace68e97$var$jh ? ("function" === typeof y && ($0331271bace68e97$var$Di(b, c, y, d), n = b.memoizedState), (l = $0331271bace68e97$var$jh || $0331271bace68e97$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0331271bace68e97$var$jj(a, b, c, d, f, e);
}
function $0331271bace68e97$var$jj(a, b, c, d, e, f) {
    $0331271bace68e97$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0331271bace68e97$var$dg(b, c, !1), $0331271bace68e97$var$Zi(a, b, f);
    d = b.stateNode;
    $0331271bace68e97$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0331271bace68e97$var$Ug(b, a.child, null, f), b.child = $0331271bace68e97$var$Ug(b, null, h, f)) : $0331271bace68e97$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0331271bace68e97$var$dg(b, c, !0);
    return b.child;
}
function $0331271bace68e97$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0331271bace68e97$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0331271bace68e97$var$ag(a, b.context, !1);
    $0331271bace68e97$var$yh(a, b.containerInfo);
}
function $0331271bace68e97$var$lj(a, b, c, d, e) {
    $0331271bace68e97$var$Ig();
    $0331271bace68e97$var$Jg(e);
    b.flags |= 256;
    $0331271bace68e97$var$Xi(a, b, c, d);
    return b.child;
}
var $0331271bace68e97$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0331271bace68e97$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0331271bace68e97$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0331271bace68e97$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0331271bace68e97$var$G($0331271bace68e97$var$L, e & 1);
    if (null === a) {
        $0331271bace68e97$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0331271bace68e97$var$pj(g, d, 0, null), a = $0331271bace68e97$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0331271bace68e97$var$nj(c), b.memoizedState = $0331271bace68e97$var$mj, a) : $0331271bace68e97$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0331271bace68e97$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0331271bace68e97$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0331271bace68e97$var$Pg(h, f) : (f = $0331271bace68e97$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0331271bace68e97$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0331271bace68e97$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0331271bace68e97$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0331271bace68e97$var$qj(a, b) {
    b = $0331271bace68e97$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0331271bace68e97$var$sj(a, b, c, d) {
    null !== d && $0331271bace68e97$var$Jg(d);
    $0331271bace68e97$var$Ug(b, a.child, null, c);
    a = $0331271bace68e97$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0331271bace68e97$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0331271bace68e97$var$Ki(Error($0331271bace68e97$var$p(422))), $0331271bace68e97$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0331271bace68e97$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0331271bace68e97$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0331271bace68e97$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0331271bace68e97$var$nj(g);
        b.memoizedState = $0331271bace68e97$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0331271bace68e97$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0331271bace68e97$var$p(419));
        d = $0331271bace68e97$var$Ki(f, d, void 0);
        return $0331271bace68e97$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0331271bace68e97$var$dh || h) {
        d = $0331271bace68e97$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0331271bace68e97$var$ih(a, e), $0331271bace68e97$var$gi(d, a, e, -1));
        }
        $0331271bace68e97$var$tj();
        d = $0331271bace68e97$var$Ki(Error($0331271bace68e97$var$p(421)));
        return $0331271bace68e97$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0331271bace68e97$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0331271bace68e97$var$yg = $0331271bace68e97$var$Lf(e.nextSibling);
    $0331271bace68e97$var$xg = b;
    $0331271bace68e97$var$I = !0;
    $0331271bace68e97$var$zg = null;
    null !== a && ($0331271bace68e97$var$og[$0331271bace68e97$var$pg++] = $0331271bace68e97$var$rg, $0331271bace68e97$var$og[$0331271bace68e97$var$pg++] = $0331271bace68e97$var$sg, $0331271bace68e97$var$og[$0331271bace68e97$var$pg++] = $0331271bace68e97$var$qg, $0331271bace68e97$var$rg = a.id, $0331271bace68e97$var$sg = a.overflow, $0331271bace68e97$var$qg = b);
    b = $0331271bace68e97$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0331271bace68e97$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0331271bace68e97$var$bh(a.return, b, c);
}
function $0331271bace68e97$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0331271bace68e97$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0331271bace68e97$var$Xi(a, b, d.children, c);
    d = $0331271bace68e97$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0331271bace68e97$var$vj(a, c, b);
            else if (19 === a.tag) $0331271bace68e97$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0331271bace68e97$var$G($0331271bace68e97$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0331271bace68e97$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0331271bace68e97$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0331271bace68e97$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0331271bace68e97$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0331271bace68e97$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0331271bace68e97$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0331271bace68e97$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0331271bace68e97$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0331271bace68e97$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0331271bace68e97$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0331271bace68e97$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0331271bace68e97$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0331271bace68e97$var$kj(b);
            $0331271bace68e97$var$Ig();
            break;
        case 5:
            $0331271bace68e97$var$Ah(b);
            break;
        case 1:
            $0331271bace68e97$var$Zf(b.type) && $0331271bace68e97$var$cg(b);
            break;
        case 4:
            $0331271bace68e97$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0331271bace68e97$var$G($0331271bace68e97$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0331271bace68e97$var$G($0331271bace68e97$var$L, $0331271bace68e97$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0331271bace68e97$var$oj(a, b, c);
                $0331271bace68e97$var$G($0331271bace68e97$var$L, $0331271bace68e97$var$L.current & 1);
                a = $0331271bace68e97$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0331271bace68e97$var$G($0331271bace68e97$var$L, $0331271bace68e97$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0331271bace68e97$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0331271bace68e97$var$G($0331271bace68e97$var$L, $0331271bace68e97$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0331271bace68e97$var$dj(a, b, c);
    }
    return $0331271bace68e97$var$Zi(a, b, c);
}
var $0331271bace68e97$var$zj, $0331271bace68e97$var$Aj, $0331271bace68e97$var$Bj, $0331271bace68e97$var$Cj;
$0331271bace68e97$var$zj = function zj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0331271bace68e97$var$Aj = function Aj() {};
$0331271bace68e97$var$Bj = function Bj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0331271bace68e97$var$xh($0331271bace68e97$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0331271bace68e97$var$Ya(a, e);
                d = $0331271bace68e97$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0331271bace68e97$var$A({}, e, {
                    value: void 0
                });
                d = $0331271bace68e97$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0331271bace68e97$var$gb(a, e);
                d = $0331271bace68e97$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0331271bace68e97$var$Bf);
        }
        $0331271bace68e97$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0331271bace68e97$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0331271bace68e97$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0331271bace68e97$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0331271bace68e97$var$Cj = function Cj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0331271bace68e97$var$Dj(a, b) {
    if (!$0331271bace68e97$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0331271bace68e97$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0331271bace68e97$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0331271bace68e97$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0331271bace68e97$var$S(b), null;
        case 1:
            return $0331271bace68e97$var$Zf(b.type) && $0331271bace68e97$var$$f(), $0331271bace68e97$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0331271bace68e97$var$zh();
            $0331271bace68e97$var$E($0331271bace68e97$var$Wf);
            $0331271bace68e97$var$E($0331271bace68e97$var$H);
            $0331271bace68e97$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0331271bace68e97$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0331271bace68e97$var$zg && ($0331271bace68e97$var$Fj($0331271bace68e97$var$zg), $0331271bace68e97$var$zg = null));
            $0331271bace68e97$var$Aj(a, b);
            $0331271bace68e97$var$S(b);
            return null;
        case 5:
            $0331271bace68e97$var$Bh(b);
            var e = $0331271bace68e97$var$xh($0331271bace68e97$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0331271bace68e97$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0331271bace68e97$var$p(166));
                    $0331271bace68e97$var$S(b);
                    return null;
                }
                a = $0331271bace68e97$var$xh($0331271bace68e97$var$uh.current);
                if ($0331271bace68e97$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0331271bace68e97$var$Of] = b;
                    d[$0331271bace68e97$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0331271bace68e97$var$D("cancel", d);
                            $0331271bace68e97$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0331271bace68e97$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0331271bace68e97$var$lf.length; e++)$0331271bace68e97$var$D($0331271bace68e97$var$lf[e], d);
                            break;
                        case "source":
                            $0331271bace68e97$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0331271bace68e97$var$D("error", d);
                            $0331271bace68e97$var$D("load", d);
                            break;
                        case "details":
                            $0331271bace68e97$var$D("toggle", d);
                            break;
                        case "input":
                            $0331271bace68e97$var$Za(d, f);
                            $0331271bace68e97$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0331271bace68e97$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0331271bace68e97$var$hb(d, f), $0331271bace68e97$var$D("invalid", d);
                    }
                    $0331271bace68e97$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0331271bace68e97$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0331271bace68e97$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0331271bace68e97$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0331271bace68e97$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0331271bace68e97$var$Va(d);
                            $0331271bace68e97$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0331271bace68e97$var$Va(d);
                            $0331271bace68e97$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0331271bace68e97$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0331271bace68e97$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0331271bace68e97$var$Of] = b;
                    a[$0331271bace68e97$var$Pf] = d;
                    $0331271bace68e97$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0331271bace68e97$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0331271bace68e97$var$D("cancel", a);
                                $0331271bace68e97$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0331271bace68e97$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0331271bace68e97$var$lf.length; e++)$0331271bace68e97$var$D($0331271bace68e97$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0331271bace68e97$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0331271bace68e97$var$D("error", a);
                                $0331271bace68e97$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0331271bace68e97$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0331271bace68e97$var$Za(a, d);
                                e = $0331271bace68e97$var$Ya(a, d);
                                $0331271bace68e97$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0331271bace68e97$var$A({}, d, {
                                    value: void 0
                                });
                                $0331271bace68e97$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0331271bace68e97$var$hb(a, d);
                                e = $0331271bace68e97$var$gb(a, d);
                                $0331271bace68e97$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0331271bace68e97$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0331271bace68e97$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0331271bace68e97$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0331271bace68e97$var$ob(a, k) : "number" === typeof k && $0331271bace68e97$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0331271bace68e97$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0331271bace68e97$var$D("scroll", a) : null != k && $0331271bace68e97$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0331271bace68e97$var$Va(a);
                                $0331271bace68e97$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0331271bace68e97$var$Va(a);
                                $0331271bace68e97$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0331271bace68e97$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0331271bace68e97$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0331271bace68e97$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0331271bace68e97$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0331271bace68e97$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0331271bace68e97$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0331271bace68e97$var$p(166));
                c = $0331271bace68e97$var$xh($0331271bace68e97$var$wh.current);
                $0331271bace68e97$var$xh($0331271bace68e97$var$uh.current);
                if ($0331271bace68e97$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0331271bace68e97$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0331271bace68e97$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0331271bace68e97$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0331271bace68e97$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0331271bace68e97$var$Of] = b, b.stateNode = d;
            }
            $0331271bace68e97$var$S(b);
            return null;
        case 13:
            $0331271bace68e97$var$E($0331271bace68e97$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0331271bace68e97$var$I && null !== $0331271bace68e97$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0331271bace68e97$var$Hg(), $0331271bace68e97$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0331271bace68e97$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0331271bace68e97$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0331271bace68e97$var$p(317));
                        f[$0331271bace68e97$var$Of] = b;
                    } else $0331271bace68e97$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0331271bace68e97$var$S(b);
                    f = !1;
                } else null !== $0331271bace68e97$var$zg && ($0331271bace68e97$var$Fj($0331271bace68e97$var$zg), $0331271bace68e97$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0331271bace68e97$var$L.current & 1) ? 0 === $0331271bace68e97$var$T && ($0331271bace68e97$var$T = 3) : $0331271bace68e97$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0331271bace68e97$var$S(b);
            return null;
        case 4:
            return $0331271bace68e97$var$zh(), $0331271bace68e97$var$Aj(a, b), null === a && $0331271bace68e97$var$sf(b.stateNode.containerInfo), $0331271bace68e97$var$S(b), null;
        case 10:
            return $0331271bace68e97$var$ah(b.type._context), $0331271bace68e97$var$S(b), null;
        case 17:
            return $0331271bace68e97$var$Zf(b.type) && $0331271bace68e97$var$$f(), $0331271bace68e97$var$S(b), null;
        case 19:
            $0331271bace68e97$var$E($0331271bace68e97$var$L);
            f = b.memoizedState;
            if (null === f) return $0331271bace68e97$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0331271bace68e97$var$Dj(f, !1);
                else {
                    if (0 !== $0331271bace68e97$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0331271bace68e97$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0331271bace68e97$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0331271bace68e97$var$G($0331271bace68e97$var$L, $0331271bace68e97$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0331271bace68e97$var$B() > $0331271bace68e97$var$Gj && (b.flags |= 128, d = !0, $0331271bace68e97$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0331271bace68e97$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0331271bace68e97$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0331271bace68e97$var$I) return $0331271bace68e97$var$S(b), null;
                    } else 2 * $0331271bace68e97$var$B() - f.renderingStartTime > $0331271bace68e97$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0331271bace68e97$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0331271bace68e97$var$B(), b.sibling = null, c = $0331271bace68e97$var$L.current, $0331271bace68e97$var$G($0331271bace68e97$var$L, d ? c & 1 | 2 : c & 1), b;
            $0331271bace68e97$var$S(b);
            return null;
        case 22:
        case 23:
            return $0331271bace68e97$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0331271bace68e97$var$fj & 1073741824) && ($0331271bace68e97$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0331271bace68e97$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0331271bace68e97$var$p(156, b.tag));
}
function $0331271bace68e97$var$Ij(a, b) {
    $0331271bace68e97$var$wg(b);
    switch(b.tag){
        case 1:
            return $0331271bace68e97$var$Zf(b.type) && $0331271bace68e97$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0331271bace68e97$var$zh(), $0331271bace68e97$var$E($0331271bace68e97$var$Wf), $0331271bace68e97$var$E($0331271bace68e97$var$H), $0331271bace68e97$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0331271bace68e97$var$Bh(b), null;
        case 13:
            $0331271bace68e97$var$E($0331271bace68e97$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0331271bace68e97$var$p(340));
                $0331271bace68e97$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0331271bace68e97$var$E($0331271bace68e97$var$L), null;
        case 4:
            return $0331271bace68e97$var$zh(), null;
        case 10:
            return $0331271bace68e97$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0331271bace68e97$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0331271bace68e97$var$Jj = !1, $0331271bace68e97$var$U = !1, $0331271bace68e97$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0331271bace68e97$var$V = null;
function $0331271bace68e97$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0331271bace68e97$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0331271bace68e97$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0331271bace68e97$var$W(a, b, d);
    }
}
var $0331271bace68e97$var$Nj = !1;
function $0331271bace68e97$var$Oj(a, b) {
    $0331271bace68e97$var$Cf = $0331271bace68e97$var$dd;
    a = $0331271bace68e97$var$Me();
    if ($0331271bace68e97$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0331271bace68e97$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0331271bace68e97$var$dd = !1;
    for($0331271bace68e97$var$V = b; null !== $0331271bace68e97$var$V;)if (b = $0331271bace68e97$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0331271bace68e97$var$V = a;
    else for(; null !== $0331271bace68e97$var$V;){
        b = $0331271bace68e97$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0331271bace68e97$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0331271bace68e97$var$p(163));
            }
        } catch (F) {
            $0331271bace68e97$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0331271bace68e97$var$V = a;
            break;
        }
        $0331271bace68e97$var$V = b.return;
    }
    n = $0331271bace68e97$var$Nj;
    $0331271bace68e97$var$Nj = !1;
    return n;
}
function $0331271bace68e97$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0331271bace68e97$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0331271bace68e97$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0331271bace68e97$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0331271bace68e97$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0331271bace68e97$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0331271bace68e97$var$Of], delete b[$0331271bace68e97$var$Pf], delete b[$0331271bace68e97$var$of], delete b[$0331271bace68e97$var$Qf], delete b[$0331271bace68e97$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0331271bace68e97$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0331271bace68e97$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0331271bace68e97$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0331271bace68e97$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0331271bace68e97$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0331271bace68e97$var$Vj(a, b, c), a = a.sibling; null !== a;)$0331271bace68e97$var$Vj(a, b, c), a = a.sibling;
}
function $0331271bace68e97$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0331271bace68e97$var$Wj(a, b, c), a = a.sibling; null !== a;)$0331271bace68e97$var$Wj(a, b, c), a = a.sibling;
}
var $0331271bace68e97$var$X = null, $0331271bace68e97$var$Xj = !1;
function $0331271bace68e97$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0331271bace68e97$var$Zj(a, b, c), c = c.sibling;
}
function $0331271bace68e97$var$Zj(a, b, c) {
    if ($0331271bace68e97$var$lc && "function" === typeof $0331271bace68e97$var$lc.onCommitFiberUnmount) try {
        $0331271bace68e97$var$lc.onCommitFiberUnmount($0331271bace68e97$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0331271bace68e97$var$U || $0331271bace68e97$var$Lj(c, b);
        case 6:
            var d = $0331271bace68e97$var$X, e = $0331271bace68e97$var$Xj;
            $0331271bace68e97$var$X = null;
            $0331271bace68e97$var$Yj(a, b, c);
            $0331271bace68e97$var$X = d;
            $0331271bace68e97$var$Xj = e;
            null !== $0331271bace68e97$var$X && ($0331271bace68e97$var$Xj ? (a = $0331271bace68e97$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0331271bace68e97$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0331271bace68e97$var$X && ($0331271bace68e97$var$Xj ? (a = $0331271bace68e97$var$X, c = c.stateNode, 8 === a.nodeType ? $0331271bace68e97$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0331271bace68e97$var$Kf(a, c), $0331271bace68e97$var$bd(a)) : $0331271bace68e97$var$Kf($0331271bace68e97$var$X, c.stateNode));
            break;
        case 4:
            d = $0331271bace68e97$var$X;
            e = $0331271bace68e97$var$Xj;
            $0331271bace68e97$var$X = c.stateNode.containerInfo;
            $0331271bace68e97$var$Xj = !0;
            $0331271bace68e97$var$Yj(a, b, c);
            $0331271bace68e97$var$X = d;
            $0331271bace68e97$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0331271bace68e97$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0331271bace68e97$var$Mj(c, b, g) : 0 !== (f & 4) && $0331271bace68e97$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0331271bace68e97$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0331271bace68e97$var$U && ($0331271bace68e97$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0331271bace68e97$var$W(c, b, h);
            }
            $0331271bace68e97$var$Yj(a, b, c);
            break;
        case 21:
            $0331271bace68e97$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0331271bace68e97$var$U = (d = $0331271bace68e97$var$U) || null !== c.memoizedState, $0331271bace68e97$var$Yj(a, b, c), $0331271bace68e97$var$U = d) : $0331271bace68e97$var$Yj(a, b, c);
            break;
        default:
            $0331271bace68e97$var$Yj(a, b, c);
    }
}
function $0331271bace68e97$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0331271bace68e97$var$Kj);
        b.forEach(function(b) {
            var d = $0331271bace68e97$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0331271bace68e97$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0331271bace68e97$var$X = h.stateNode;
                        $0331271bace68e97$var$Xj = !1;
                        break a;
                    case 3:
                        $0331271bace68e97$var$X = h.stateNode.containerInfo;
                        $0331271bace68e97$var$Xj = !0;
                        break a;
                    case 4:
                        $0331271bace68e97$var$X = h.stateNode.containerInfo;
                        $0331271bace68e97$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0331271bace68e97$var$X) throw Error($0331271bace68e97$var$p(160));
            $0331271bace68e97$var$Zj(f, g, e);
            $0331271bace68e97$var$X = null;
            $0331271bace68e97$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0331271bace68e97$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0331271bace68e97$var$dk(b, a), b = b.sibling;
}
function $0331271bace68e97$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            if (d & 4) {
                try {
                    $0331271bace68e97$var$Pj(3, a, a.return), $0331271bace68e97$var$Qj(3, a);
                } catch (t) {
                    $0331271bace68e97$var$W(a, a.return, t);
                }
                try {
                    $0331271bace68e97$var$Pj(5, a, a.return);
                } catch (t) {
                    $0331271bace68e97$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            d & 512 && null !== c && $0331271bace68e97$var$Lj(c, c.return);
            break;
        case 5:
            $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            d & 512 && null !== c && $0331271bace68e97$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0331271bace68e97$var$ob(e, "");
                } catch (t) {
                    $0331271bace68e97$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0331271bace68e97$var$ab(e, f);
                    $0331271bace68e97$var$vb(h, g);
                    var l = $0331271bace68e97$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0331271bace68e97$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0331271bace68e97$var$nb(e, q) : "children" === m ? $0331271bace68e97$var$ob(e, q) : $0331271bace68e97$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0331271bace68e97$var$bb(e, f);
                            break;
                        case "textarea":
                            $0331271bace68e97$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0331271bace68e97$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0331271bace68e97$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0331271bace68e97$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0331271bace68e97$var$Pf] = f;
                } catch (t) {
                    $0331271bace68e97$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0331271bace68e97$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0331271bace68e97$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0331271bace68e97$var$bd(b.containerInfo);
            } catch (t) {
                $0331271bace68e97$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            break;
        case 13:
            $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0331271bace68e97$var$fk = $0331271bace68e97$var$B()));
            d & 4 && $0331271bace68e97$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0331271bace68e97$var$U = (l = $0331271bace68e97$var$U) || m, $0331271bace68e97$var$ck(b, a), $0331271bace68e97$var$U = l) : $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0331271bace68e97$var$V = a, m = a.child; null !== m;){
                    for(q = $0331271bace68e97$var$V = m; null !== $0331271bace68e97$var$V;){
                        r = $0331271bace68e97$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0331271bace68e97$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0331271bace68e97$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0331271bace68e97$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0331271bace68e97$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0331271bace68e97$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0331271bace68e97$var$V = y) : $0331271bace68e97$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0331271bace68e97$var$rb("display", g));
                            } catch (t) {
                                $0331271bace68e97$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0331271bace68e97$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0331271bace68e97$var$ck(b, a);
            $0331271bace68e97$var$ek(a);
            d & 4 && $0331271bace68e97$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0331271bace68e97$var$ck(b, a), $0331271bace68e97$var$ek(a);
    }
}
function $0331271bace68e97$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0331271bace68e97$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0331271bace68e97$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0331271bace68e97$var$ob(e, ""), d.flags &= -33);
                    var f = $0331271bace68e97$var$Uj(a);
                    $0331271bace68e97$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0331271bace68e97$var$Uj(a);
                    $0331271bace68e97$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0331271bace68e97$var$p(161));
            }
        } catch (k) {
            $0331271bace68e97$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0331271bace68e97$var$hk(a, b, c) {
    $0331271bace68e97$var$V = a;
    $0331271bace68e97$var$ik(a, b, c);
}
function $0331271bace68e97$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0331271bace68e97$var$V;){
        var e = $0331271bace68e97$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0331271bace68e97$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0331271bace68e97$var$U;
                h = $0331271bace68e97$var$Jj;
                var l = $0331271bace68e97$var$U;
                $0331271bace68e97$var$Jj = g;
                if (($0331271bace68e97$var$U = k) && !l) for($0331271bace68e97$var$V = e; null !== $0331271bace68e97$var$V;)g = $0331271bace68e97$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0331271bace68e97$var$jk(e) : null !== k ? (k.return = g, $0331271bace68e97$var$V = k) : $0331271bace68e97$var$jk(e);
                for(; null !== f;)$0331271bace68e97$var$V = f, $0331271bace68e97$var$ik(f, b, c), f = f.sibling;
                $0331271bace68e97$var$V = e;
                $0331271bace68e97$var$Jj = h;
                $0331271bace68e97$var$U = l;
            }
            $0331271bace68e97$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0331271bace68e97$var$V = f) : $0331271bace68e97$var$kk(a, b, c);
    }
}
function $0331271bace68e97$var$kk(a) {
    for(; null !== $0331271bace68e97$var$V;){
        var b = $0331271bace68e97$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0331271bace68e97$var$U || $0331271bace68e97$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0331271bace68e97$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0331271bace68e97$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0331271bace68e97$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0331271bace68e97$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0331271bace68e97$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0331271bace68e97$var$p(163));
                }
                $0331271bace68e97$var$U || b.flags & 512 && $0331271bace68e97$var$Rj(b);
            } catch (r) {
                $0331271bace68e97$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0331271bace68e97$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0331271bace68e97$var$V = c;
            break;
        }
        $0331271bace68e97$var$V = b.return;
    }
}
function $0331271bace68e97$var$gk(a) {
    for(; null !== $0331271bace68e97$var$V;){
        var b = $0331271bace68e97$var$V;
        if (b === a) {
            $0331271bace68e97$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0331271bace68e97$var$V = c;
            break;
        }
        $0331271bace68e97$var$V = b.return;
    }
}
function $0331271bace68e97$var$jk(a) {
    for(; null !== $0331271bace68e97$var$V;){
        var b = $0331271bace68e97$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0331271bace68e97$var$Qj(4, b);
                    } catch (k) {
                        $0331271bace68e97$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0331271bace68e97$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0331271bace68e97$var$Rj(b);
                    } catch (k) {
                        $0331271bace68e97$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0331271bace68e97$var$Rj(b);
                    } catch (k) {
                        $0331271bace68e97$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0331271bace68e97$var$W(b, b.return, k);
        }
        if (b === a) {
            $0331271bace68e97$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0331271bace68e97$var$V = h;
            break;
        }
        $0331271bace68e97$var$V = b.return;
    }
}
var $0331271bace68e97$var$lk = Math.ceil, $0331271bace68e97$var$mk = $0331271bace68e97$var$ua.ReactCurrentDispatcher, $0331271bace68e97$var$nk = $0331271bace68e97$var$ua.ReactCurrentOwner, $0331271bace68e97$var$ok = $0331271bace68e97$var$ua.ReactCurrentBatchConfig, $0331271bace68e97$var$K = 0, $0331271bace68e97$var$Q = null, $0331271bace68e97$var$Y = null, $0331271bace68e97$var$Z = 0, $0331271bace68e97$var$fj = 0, $0331271bace68e97$var$ej = $0331271bace68e97$var$Uf(0), $0331271bace68e97$var$T = 0, $0331271bace68e97$var$pk = null, $0331271bace68e97$var$rh = 0, $0331271bace68e97$var$qk = 0, $0331271bace68e97$var$rk = 0, $0331271bace68e97$var$sk = null, $0331271bace68e97$var$tk = null, $0331271bace68e97$var$fk = 0, $0331271bace68e97$var$Gj = Infinity, $0331271bace68e97$var$uk = null, $0331271bace68e97$var$Oi = !1, $0331271bace68e97$var$Pi = null, $0331271bace68e97$var$Ri = null, $0331271bace68e97$var$vk = !1, $0331271bace68e97$var$wk = null, $0331271bace68e97$var$xk = 0, $0331271bace68e97$var$yk = 0, $0331271bace68e97$var$zk = null, $0331271bace68e97$var$Ak = -1, $0331271bace68e97$var$Bk = 0;
function $0331271bace68e97$var$R() {
    return 0 !== ($0331271bace68e97$var$K & 6) ? $0331271bace68e97$var$B() : -1 !== $0331271bace68e97$var$Ak ? $0331271bace68e97$var$Ak : $0331271bace68e97$var$Ak = $0331271bace68e97$var$B();
}
function $0331271bace68e97$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0331271bace68e97$var$K & 2) && 0 !== $0331271bace68e97$var$Z) return $0331271bace68e97$var$Z & -$0331271bace68e97$var$Z;
    if (null !== $0331271bace68e97$var$Kg.transition) return 0 === $0331271bace68e97$var$Bk && ($0331271bace68e97$var$Bk = $0331271bace68e97$var$yc()), $0331271bace68e97$var$Bk;
    a = $0331271bace68e97$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0331271bace68e97$var$jd(a.type);
    return a;
}
function $0331271bace68e97$var$gi(a, b, c, d) {
    if (50 < $0331271bace68e97$var$yk) throw $0331271bace68e97$var$yk = 0, $0331271bace68e97$var$zk = null, Error($0331271bace68e97$var$p(185));
    $0331271bace68e97$var$Ac(a, c, d);
    if (0 === ($0331271bace68e97$var$K & 2) || a !== $0331271bace68e97$var$Q) a === $0331271bace68e97$var$Q && (0 === ($0331271bace68e97$var$K & 2) && ($0331271bace68e97$var$qk |= c), 4 === $0331271bace68e97$var$T && $0331271bace68e97$var$Ck(a, $0331271bace68e97$var$Z)), $0331271bace68e97$var$Dk(a, d), 1 === c && 0 === $0331271bace68e97$var$K && 0 === (b.mode & 1) && ($0331271bace68e97$var$Gj = $0331271bace68e97$var$B() + 500, $0331271bace68e97$var$fg && $0331271bace68e97$var$jg());
}
function $0331271bace68e97$var$Dk(a, b) {
    var c = a.callbackNode;
    $0331271bace68e97$var$wc(a, b);
    var d = $0331271bace68e97$var$uc(a, a === $0331271bace68e97$var$Q ? $0331271bace68e97$var$Z : 0);
    if (0 === d) null !== c && $0331271bace68e97$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0331271bace68e97$var$bc(c);
        if (1 === b) 0 === a.tag ? $0331271bace68e97$var$ig($0331271bace68e97$var$Ek.bind(null, a)) : $0331271bace68e97$var$hg($0331271bace68e97$var$Ek.bind(null, a)), $0331271bace68e97$var$Jf(function() {
            0 === ($0331271bace68e97$var$K & 6) && $0331271bace68e97$var$jg();
        }), c = null;
        else {
            switch($0331271bace68e97$var$Dc(d)){
                case 1:
                    c = $0331271bace68e97$var$fc;
                    break;
                case 4:
                    c = $0331271bace68e97$var$gc;
                    break;
                case 16:
                    c = $0331271bace68e97$var$hc;
                    break;
                case 536870912:
                    c = $0331271bace68e97$var$jc;
                    break;
                default:
                    c = $0331271bace68e97$var$hc;
            }
            c = $0331271bace68e97$var$Fk(c, $0331271bace68e97$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0331271bace68e97$var$Gk(a, b) {
    $0331271bace68e97$var$Ak = -1;
    $0331271bace68e97$var$Bk = 0;
    if (0 !== ($0331271bace68e97$var$K & 6)) throw Error($0331271bace68e97$var$p(327));
    var c = a.callbackNode;
    if ($0331271bace68e97$var$Hk() && a.callbackNode !== c) return null;
    var d = $0331271bace68e97$var$uc(a, a === $0331271bace68e97$var$Q ? $0331271bace68e97$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0331271bace68e97$var$Ik(a, d);
    else {
        b = d;
        var e = $0331271bace68e97$var$K;
        $0331271bace68e97$var$K |= 2;
        var f = $0331271bace68e97$var$Jk();
        if ($0331271bace68e97$var$Q !== a || $0331271bace68e97$var$Z !== b) $0331271bace68e97$var$uk = null, $0331271bace68e97$var$Gj = $0331271bace68e97$var$B() + 500, $0331271bace68e97$var$Kk(a, b);
        for(;;)try {
            $0331271bace68e97$var$Lk();
            break;
        } catch (h) {
            $0331271bace68e97$var$Mk(a, h);
        }
        $0331271bace68e97$var$$g();
        $0331271bace68e97$var$mk.current = f;
        $0331271bace68e97$var$K = e;
        null !== $0331271bace68e97$var$Y ? b = 0 : ($0331271bace68e97$var$Q = null, $0331271bace68e97$var$Z = 0, b = $0331271bace68e97$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0331271bace68e97$var$xc(a), 0 !== e && (d = e, b = $0331271bace68e97$var$Nk(a, e)));
        if (1 === b) throw c = $0331271bace68e97$var$pk, $0331271bace68e97$var$Kk(a, 0), $0331271bace68e97$var$Ck(a, d), $0331271bace68e97$var$Dk(a, $0331271bace68e97$var$B()), c;
        if (6 === b) $0331271bace68e97$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0331271bace68e97$var$Ok(e) && (b = $0331271bace68e97$var$Ik(a, d), 2 === b && (f = $0331271bace68e97$var$xc(a), 0 !== f && (d = f, b = $0331271bace68e97$var$Nk(a, f))), 1 === b)) throw c = $0331271bace68e97$var$pk, $0331271bace68e97$var$Kk(a, 0), $0331271bace68e97$var$Ck(a, d), $0331271bace68e97$var$Dk(a, $0331271bace68e97$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0331271bace68e97$var$p(345));
                case 2:
                    $0331271bace68e97$var$Pk(a, $0331271bace68e97$var$tk, $0331271bace68e97$var$uk);
                    break;
                case 3:
                    $0331271bace68e97$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0331271bace68e97$var$fk + 500 - $0331271bace68e97$var$B(), 10 < b)) {
                        if (0 !== $0331271bace68e97$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0331271bace68e97$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0331271bace68e97$var$Ff($0331271bace68e97$var$Pk.bind(null, a, $0331271bace68e97$var$tk, $0331271bace68e97$var$uk), b);
                        break;
                    }
                    $0331271bace68e97$var$Pk(a, $0331271bace68e97$var$tk, $0331271bace68e97$var$uk);
                    break;
                case 4:
                    $0331271bace68e97$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0331271bace68e97$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0331271bace68e97$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0331271bace68e97$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0331271bace68e97$var$Ff($0331271bace68e97$var$Pk.bind(null, a, $0331271bace68e97$var$tk, $0331271bace68e97$var$uk), d);
                        break;
                    }
                    $0331271bace68e97$var$Pk(a, $0331271bace68e97$var$tk, $0331271bace68e97$var$uk);
                    break;
                case 5:
                    $0331271bace68e97$var$Pk(a, $0331271bace68e97$var$tk, $0331271bace68e97$var$uk);
                    break;
                default:
                    throw Error($0331271bace68e97$var$p(329));
            }
        }
    }
    $0331271bace68e97$var$Dk(a, $0331271bace68e97$var$B());
    return a.callbackNode === c ? $0331271bace68e97$var$Gk.bind(null, a) : null;
}
function $0331271bace68e97$var$Nk(a, b) {
    var c = $0331271bace68e97$var$sk;
    a.current.memoizedState.isDehydrated && ($0331271bace68e97$var$Kk(a, b).flags |= 256);
    a = $0331271bace68e97$var$Ik(a, b);
    2 !== a && (b = $0331271bace68e97$var$tk, $0331271bace68e97$var$tk = c, null !== b && $0331271bace68e97$var$Fj(b));
    return a;
}
function $0331271bace68e97$var$Fj(a) {
    null === $0331271bace68e97$var$tk ? $0331271bace68e97$var$tk = a : $0331271bace68e97$var$tk.push.apply($0331271bace68e97$var$tk, a);
}
function $0331271bace68e97$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0331271bace68e97$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0331271bace68e97$var$Ck(a, b) {
    b &= ~$0331271bace68e97$var$rk;
    b &= ~$0331271bace68e97$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0331271bace68e97$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0331271bace68e97$var$Ek(a) {
    if (0 !== ($0331271bace68e97$var$K & 6)) throw Error($0331271bace68e97$var$p(327));
    $0331271bace68e97$var$Hk();
    var b = $0331271bace68e97$var$uc(a, 0);
    if (0 === (b & 1)) return $0331271bace68e97$var$Dk(a, $0331271bace68e97$var$B()), null;
    var c = $0331271bace68e97$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0331271bace68e97$var$xc(a);
        0 !== d && (b = d, c = $0331271bace68e97$var$Nk(a, d));
    }
    if (1 === c) throw c = $0331271bace68e97$var$pk, $0331271bace68e97$var$Kk(a, 0), $0331271bace68e97$var$Ck(a, b), $0331271bace68e97$var$Dk(a, $0331271bace68e97$var$B()), c;
    if (6 === c) throw Error($0331271bace68e97$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0331271bace68e97$var$Pk(a, $0331271bace68e97$var$tk, $0331271bace68e97$var$uk);
    $0331271bace68e97$var$Dk(a, $0331271bace68e97$var$B());
    return null;
}
function $0331271bace68e97$var$Qk(a, b) {
    var c = $0331271bace68e97$var$K;
    $0331271bace68e97$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0331271bace68e97$var$K = c, 0 === $0331271bace68e97$var$K && ($0331271bace68e97$var$Gj = $0331271bace68e97$var$B() + 500, $0331271bace68e97$var$fg && $0331271bace68e97$var$jg());
    }
}
function $0331271bace68e97$var$Rk(a) {
    null !== $0331271bace68e97$var$wk && 0 === $0331271bace68e97$var$wk.tag && 0 === ($0331271bace68e97$var$K & 6) && $0331271bace68e97$var$Hk();
    var b = $0331271bace68e97$var$K;
    $0331271bace68e97$var$K |= 1;
    var c = $0331271bace68e97$var$ok.transition, d = $0331271bace68e97$var$C;
    try {
        if ($0331271bace68e97$var$ok.transition = null, $0331271bace68e97$var$C = 1, a) return a();
    } finally{
        $0331271bace68e97$var$C = d, $0331271bace68e97$var$ok.transition = c, $0331271bace68e97$var$K = b, 0 === ($0331271bace68e97$var$K & 6) && $0331271bace68e97$var$jg();
    }
}
function $0331271bace68e97$var$Hj() {
    $0331271bace68e97$var$fj = $0331271bace68e97$var$ej.current;
    $0331271bace68e97$var$E($0331271bace68e97$var$ej);
}
function $0331271bace68e97$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0331271bace68e97$var$Gf(c));
    if (null !== $0331271bace68e97$var$Y) for(c = $0331271bace68e97$var$Y.return; null !== c;){
        var d = c;
        $0331271bace68e97$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0331271bace68e97$var$$f();
                break;
            case 3:
                $0331271bace68e97$var$zh();
                $0331271bace68e97$var$E($0331271bace68e97$var$Wf);
                $0331271bace68e97$var$E($0331271bace68e97$var$H);
                $0331271bace68e97$var$Eh();
                break;
            case 5:
                $0331271bace68e97$var$Bh(d);
                break;
            case 4:
                $0331271bace68e97$var$zh();
                break;
            case 13:
                $0331271bace68e97$var$E($0331271bace68e97$var$L);
                break;
            case 19:
                $0331271bace68e97$var$E($0331271bace68e97$var$L);
                break;
            case 10:
                $0331271bace68e97$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0331271bace68e97$var$Hj();
        }
        c = c.return;
    }
    $0331271bace68e97$var$Q = a;
    $0331271bace68e97$var$Y = a = $0331271bace68e97$var$Pg(a.current, null);
    $0331271bace68e97$var$Z = $0331271bace68e97$var$fj = b;
    $0331271bace68e97$var$T = 0;
    $0331271bace68e97$var$pk = null;
    $0331271bace68e97$var$rk = $0331271bace68e97$var$qk = $0331271bace68e97$var$rh = 0;
    $0331271bace68e97$var$tk = $0331271bace68e97$var$sk = null;
    if (null !== $0331271bace68e97$var$fh) {
        for(b = 0; b < $0331271bace68e97$var$fh.length; b++)if (c = $0331271bace68e97$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0331271bace68e97$var$fh = null;
    }
    return a;
}
function $0331271bace68e97$var$Mk(a, b) {
    do {
        var c = $0331271bace68e97$var$Y;
        try {
            $0331271bace68e97$var$$g();
            $0331271bace68e97$var$Fh.current = $0331271bace68e97$var$Rh;
            if ($0331271bace68e97$var$Ih) {
                for(var d = $0331271bace68e97$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0331271bace68e97$var$Ih = !1;
            }
            $0331271bace68e97$var$Hh = 0;
            $0331271bace68e97$var$O = $0331271bace68e97$var$N = $0331271bace68e97$var$M = null;
            $0331271bace68e97$var$Jh = !1;
            $0331271bace68e97$var$Kh = 0;
            $0331271bace68e97$var$nk.current = null;
            if (null === c || null === c.return) {
                $0331271bace68e97$var$T = 1;
                $0331271bace68e97$var$pk = b;
                $0331271bace68e97$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0331271bace68e97$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === (typeof k === "undefined" ? "undefined" : (0, $bJtXW._)(k)) && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0331271bace68e97$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0331271bace68e97$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0331271bace68e97$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0331271bace68e97$var$Si(f, l, b);
                            $0331271bace68e97$var$tj();
                            break a;
                        }
                        k = Error($0331271bace68e97$var$p(426));
                    }
                } else if ($0331271bace68e97$var$I && h.mode & 1) {
                    var J = $0331271bace68e97$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0331271bace68e97$var$Vi(J, g, h, f, b);
                        $0331271bace68e97$var$Jg($0331271bace68e97$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0331271bace68e97$var$Ji(k, h);
                4 !== $0331271bace68e97$var$T && ($0331271bace68e97$var$T = 2);
                null === $0331271bace68e97$var$sk ? $0331271bace68e97$var$sk = [
                    f
                ] : $0331271bace68e97$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0331271bace68e97$var$Ni(f, k, b);
                            $0331271bace68e97$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0331271bace68e97$var$Ri || !$0331271bace68e97$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0331271bace68e97$var$Qi(f, h, b);
                                $0331271bace68e97$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0331271bace68e97$var$Sk(c);
        } catch (na) {
            b = na;
            $0331271bace68e97$var$Y === c && null !== c && ($0331271bace68e97$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0331271bace68e97$var$Jk() {
    var a = $0331271bace68e97$var$mk.current;
    $0331271bace68e97$var$mk.current = $0331271bace68e97$var$Rh;
    return null === a ? $0331271bace68e97$var$Rh : a;
}
function $0331271bace68e97$var$tj() {
    if (0 === $0331271bace68e97$var$T || 3 === $0331271bace68e97$var$T || 2 === $0331271bace68e97$var$T) $0331271bace68e97$var$T = 4;
    null === $0331271bace68e97$var$Q || 0 === ($0331271bace68e97$var$rh & 268435455) && 0 === ($0331271bace68e97$var$qk & 268435455) || $0331271bace68e97$var$Ck($0331271bace68e97$var$Q, $0331271bace68e97$var$Z);
}
function $0331271bace68e97$var$Ik(a, b) {
    var c = $0331271bace68e97$var$K;
    $0331271bace68e97$var$K |= 2;
    var d = $0331271bace68e97$var$Jk();
    if ($0331271bace68e97$var$Q !== a || $0331271bace68e97$var$Z !== b) $0331271bace68e97$var$uk = null, $0331271bace68e97$var$Kk(a, b);
    for(;;)try {
        $0331271bace68e97$var$Tk();
        break;
    } catch (e) {
        $0331271bace68e97$var$Mk(a, e);
    }
    $0331271bace68e97$var$$g();
    $0331271bace68e97$var$K = c;
    $0331271bace68e97$var$mk.current = d;
    if (null !== $0331271bace68e97$var$Y) throw Error($0331271bace68e97$var$p(261));
    $0331271bace68e97$var$Q = null;
    $0331271bace68e97$var$Z = 0;
    return $0331271bace68e97$var$T;
}
function $0331271bace68e97$var$Tk() {
    for(; null !== $0331271bace68e97$var$Y;)$0331271bace68e97$var$Uk($0331271bace68e97$var$Y);
}
function $0331271bace68e97$var$Lk() {
    for(; null !== $0331271bace68e97$var$Y && !$0331271bace68e97$var$cc();)$0331271bace68e97$var$Uk($0331271bace68e97$var$Y);
}
function $0331271bace68e97$var$Uk(a) {
    var b = $0331271bace68e97$var$Vk(a.alternate, a, $0331271bace68e97$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0331271bace68e97$var$Sk(a) : $0331271bace68e97$var$Y = b;
    $0331271bace68e97$var$nk.current = null;
}
function $0331271bace68e97$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0331271bace68e97$var$Ej(c, b, $0331271bace68e97$var$fj), null !== c) {
                $0331271bace68e97$var$Y = c;
                return;
            }
        } else {
            c = $0331271bace68e97$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0331271bace68e97$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0331271bace68e97$var$T = 6;
                $0331271bace68e97$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0331271bace68e97$var$Y = b;
            return;
        }
        $0331271bace68e97$var$Y = b = a;
    }while (null !== b);
    0 === $0331271bace68e97$var$T && ($0331271bace68e97$var$T = 5);
}
function $0331271bace68e97$var$Pk(a, b, c) {
    var d = $0331271bace68e97$var$C, e = $0331271bace68e97$var$ok.transition;
    try {
        $0331271bace68e97$var$ok.transition = null, $0331271bace68e97$var$C = 1, $0331271bace68e97$var$Wk(a, b, c, d);
    } finally{
        $0331271bace68e97$var$ok.transition = e, $0331271bace68e97$var$C = d;
    }
    return null;
}
function $0331271bace68e97$var$Wk(a, b, c, d) {
    do $0331271bace68e97$var$Hk();
    while (null !== $0331271bace68e97$var$wk);
    if (0 !== ($0331271bace68e97$var$K & 6)) throw Error($0331271bace68e97$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0331271bace68e97$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0331271bace68e97$var$Bc(a, f);
    a === $0331271bace68e97$var$Q && ($0331271bace68e97$var$Y = $0331271bace68e97$var$Q = null, $0331271bace68e97$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0331271bace68e97$var$vk || ($0331271bace68e97$var$vk = !0, $0331271bace68e97$var$Fk($0331271bace68e97$var$hc, function() {
        $0331271bace68e97$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0331271bace68e97$var$ok.transition;
        $0331271bace68e97$var$ok.transition = null;
        var g = $0331271bace68e97$var$C;
        $0331271bace68e97$var$C = 1;
        var h = $0331271bace68e97$var$K;
        $0331271bace68e97$var$K |= 4;
        $0331271bace68e97$var$nk.current = null;
        $0331271bace68e97$var$Oj(a, c);
        $0331271bace68e97$var$dk(c, a);
        $0331271bace68e97$var$Oe($0331271bace68e97$var$Df);
        $0331271bace68e97$var$dd = !!$0331271bace68e97$var$Cf;
        $0331271bace68e97$var$Df = $0331271bace68e97$var$Cf = null;
        a.current = c;
        $0331271bace68e97$var$hk(c, a, e);
        $0331271bace68e97$var$dc();
        $0331271bace68e97$var$K = h;
        $0331271bace68e97$var$C = g;
        $0331271bace68e97$var$ok.transition = f;
    } else a.current = c;
    $0331271bace68e97$var$vk && ($0331271bace68e97$var$vk = !1, $0331271bace68e97$var$wk = a, $0331271bace68e97$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0331271bace68e97$var$Ri = null);
    $0331271bace68e97$var$mc(c.stateNode, d);
    $0331271bace68e97$var$Dk(a, $0331271bace68e97$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0331271bace68e97$var$Oi) throw $0331271bace68e97$var$Oi = !1, a = $0331271bace68e97$var$Pi, $0331271bace68e97$var$Pi = null, a;
    0 !== ($0331271bace68e97$var$xk & 1) && 0 !== a.tag && $0331271bace68e97$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0331271bace68e97$var$zk ? $0331271bace68e97$var$yk++ : ($0331271bace68e97$var$yk = 0, $0331271bace68e97$var$zk = a) : $0331271bace68e97$var$yk = 0;
    $0331271bace68e97$var$jg();
    return null;
}
function $0331271bace68e97$var$Hk() {
    if (null !== $0331271bace68e97$var$wk) {
        var a = $0331271bace68e97$var$Dc($0331271bace68e97$var$xk), b = $0331271bace68e97$var$ok.transition, c = $0331271bace68e97$var$C;
        try {
            $0331271bace68e97$var$ok.transition = null;
            $0331271bace68e97$var$C = 16 > a ? 16 : a;
            if (null === $0331271bace68e97$var$wk) var d = !1;
            else {
                a = $0331271bace68e97$var$wk;
                $0331271bace68e97$var$wk = null;
                $0331271bace68e97$var$xk = 0;
                if (0 !== ($0331271bace68e97$var$K & 6)) throw Error($0331271bace68e97$var$p(331));
                var e = $0331271bace68e97$var$K;
                $0331271bace68e97$var$K |= 4;
                for($0331271bace68e97$var$V = a.current; null !== $0331271bace68e97$var$V;){
                    var f = $0331271bace68e97$var$V, g = f.child;
                    if (0 !== ($0331271bace68e97$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0331271bace68e97$var$V = l; null !== $0331271bace68e97$var$V;){
                                    var m = $0331271bace68e97$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0331271bace68e97$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0331271bace68e97$var$V = q;
                                    else for(; null !== $0331271bace68e97$var$V;){
                                        m = $0331271bace68e97$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0331271bace68e97$var$Sj(m);
                                        if (m === l) {
                                            $0331271bace68e97$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0331271bace68e97$var$V = r;
                                            break;
                                        }
                                        $0331271bace68e97$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0331271bace68e97$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0331271bace68e97$var$V = g;
                    else b: for(; null !== $0331271bace68e97$var$V;){
                        f = $0331271bace68e97$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0331271bace68e97$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0331271bace68e97$var$V = x;
                            break b;
                        }
                        $0331271bace68e97$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0331271bace68e97$var$V = w; null !== $0331271bace68e97$var$V;){
                    g = $0331271bace68e97$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0331271bace68e97$var$V = u;
                    else b: for(g = w; null !== $0331271bace68e97$var$V;){
                        h = $0331271bace68e97$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0331271bace68e97$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0331271bace68e97$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0331271bace68e97$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0331271bace68e97$var$V = F;
                            break b;
                        }
                        $0331271bace68e97$var$V = h.return;
                    }
                }
                $0331271bace68e97$var$K = e;
                $0331271bace68e97$var$jg();
                if ($0331271bace68e97$var$lc && "function" === typeof $0331271bace68e97$var$lc.onPostCommitFiberRoot) try {
                    $0331271bace68e97$var$lc.onPostCommitFiberRoot($0331271bace68e97$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0331271bace68e97$var$C = c, $0331271bace68e97$var$ok.transition = b;
        }
    }
    return !1;
}
function $0331271bace68e97$var$Xk(a, b, c) {
    b = $0331271bace68e97$var$Ji(c, b);
    b = $0331271bace68e97$var$Ni(a, b, 1);
    a = $0331271bace68e97$var$nh(a, b, 1);
    b = $0331271bace68e97$var$R();
    null !== a && ($0331271bace68e97$var$Ac(a, 1, b), $0331271bace68e97$var$Dk(a, b));
}
function $0331271bace68e97$var$W(a, b, c) {
    if (3 === a.tag) $0331271bace68e97$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0331271bace68e97$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0331271bace68e97$var$Ri || !$0331271bace68e97$var$Ri.has(d))) {
                a = $0331271bace68e97$var$Ji(c, a);
                a = $0331271bace68e97$var$Qi(b, a, 1);
                b = $0331271bace68e97$var$nh(b, a, 1);
                a = $0331271bace68e97$var$R();
                null !== b && ($0331271bace68e97$var$Ac(b, 1, a), $0331271bace68e97$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0331271bace68e97$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0331271bace68e97$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0331271bace68e97$var$Q === a && ($0331271bace68e97$var$Z & c) === c && (4 === $0331271bace68e97$var$T || 3 === $0331271bace68e97$var$T && ($0331271bace68e97$var$Z & 130023424) === $0331271bace68e97$var$Z && 500 > $0331271bace68e97$var$B() - $0331271bace68e97$var$fk ? $0331271bace68e97$var$Kk(a, 0) : $0331271bace68e97$var$rk |= c);
    $0331271bace68e97$var$Dk(a, b);
}
function $0331271bace68e97$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0331271bace68e97$var$sc, $0331271bace68e97$var$sc <<= 1, 0 === ($0331271bace68e97$var$sc & 130023424) && ($0331271bace68e97$var$sc = 4194304)));
    var c = $0331271bace68e97$var$R();
    a = $0331271bace68e97$var$ih(a, b);
    null !== a && ($0331271bace68e97$var$Ac(a, b, c), $0331271bace68e97$var$Dk(a, c));
}
function $0331271bace68e97$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0331271bace68e97$var$Yk(a, c);
}
function $0331271bace68e97$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0331271bace68e97$var$p(314));
    }
    null !== d && d.delete(b);
    $0331271bace68e97$var$Yk(a, c);
}
var $0331271bace68e97$var$Vk;
$0331271bace68e97$var$Vk = function Vk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0331271bace68e97$var$Wf.current) $0331271bace68e97$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0331271bace68e97$var$dh = !1, $0331271bace68e97$var$yj(a, b, c);
            $0331271bace68e97$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0331271bace68e97$var$dh = !1, $0331271bace68e97$var$I && 0 !== (b.flags & 1048576) && $0331271bace68e97$var$ug(b, $0331271bace68e97$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0331271bace68e97$var$ij(a, b);
            a = b.pendingProps;
            var e = $0331271bace68e97$var$Yf(b, $0331271bace68e97$var$H.current);
            $0331271bace68e97$var$ch(b, c);
            e = $0331271bace68e97$var$Nh(null, b, d, a, e, c);
            var f = $0331271bace68e97$var$Sh();
            b.flags |= 1;
            "object" === (typeof e === "undefined" ? "undefined" : (0, $bJtXW._)(e)) && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0331271bace68e97$var$Zf(d) ? (f = !0, $0331271bace68e97$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0331271bace68e97$var$kh(b), e.updater = $0331271bace68e97$var$Ei, b.stateNode = e, e._reactInternals = b, $0331271bace68e97$var$Ii(b, d, a, c), b = $0331271bace68e97$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0331271bace68e97$var$I && f && $0331271bace68e97$var$vg(b), $0331271bace68e97$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0331271bace68e97$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0331271bace68e97$var$Zk(d);
                a = $0331271bace68e97$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0331271bace68e97$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0331271bace68e97$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0331271bace68e97$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0331271bace68e97$var$$i(null, b, d, $0331271bace68e97$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0331271bace68e97$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0331271bace68e97$var$Ci(d, e), $0331271bace68e97$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0331271bace68e97$var$Ci(d, e), $0331271bace68e97$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0331271bace68e97$var$kj(b);
                if (null === a) throw Error($0331271bace68e97$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0331271bace68e97$var$lh(a, b);
                $0331271bace68e97$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0331271bace68e97$var$Ji(Error($0331271bace68e97$var$p(423)), b);
                        b = $0331271bace68e97$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0331271bace68e97$var$Ji(Error($0331271bace68e97$var$p(424)), b);
                        b = $0331271bace68e97$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0331271bace68e97$var$yg = $0331271bace68e97$var$Lf(b.stateNode.containerInfo.firstChild), $0331271bace68e97$var$xg = b, $0331271bace68e97$var$I = !0, $0331271bace68e97$var$zg = null, c = $0331271bace68e97$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0331271bace68e97$var$Ig();
                    if (d === e) {
                        b = $0331271bace68e97$var$Zi(a, b, c);
                        break a;
                    }
                    $0331271bace68e97$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0331271bace68e97$var$Ah(b), null === a && $0331271bace68e97$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0331271bace68e97$var$Ef(d, e) ? g = null : null !== f && $0331271bace68e97$var$Ef(d, f) && (b.flags |= 32), $0331271bace68e97$var$gj(a, b), $0331271bace68e97$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0331271bace68e97$var$Eg(b), null;
        case 13:
            return $0331271bace68e97$var$oj(a, b, c);
        case 4:
            return $0331271bace68e97$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0331271bace68e97$var$Ug(b, null, d, c) : $0331271bace68e97$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0331271bace68e97$var$Ci(d, e), $0331271bace68e97$var$Yi(a, b, d, e, c);
        case 7:
            return $0331271bace68e97$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0331271bace68e97$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0331271bace68e97$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0331271bace68e97$var$G($0331271bace68e97$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0331271bace68e97$var$He(f.value, g)) {
                        if (f.children === e.children && !$0331271bace68e97$var$Wf.current) {
                            b = $0331271bace68e97$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0331271bace68e97$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0331271bace68e97$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0331271bace68e97$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0331271bace68e97$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0331271bace68e97$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0331271bace68e97$var$ch(b, c), e = $0331271bace68e97$var$eh(e), d = d(e), b.flags |= 1, $0331271bace68e97$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0331271bace68e97$var$Ci(d, b.pendingProps), e = $0331271bace68e97$var$Ci(d.type, e), $0331271bace68e97$var$$i(a, b, d, e, c);
        case 15:
            return $0331271bace68e97$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0331271bace68e97$var$Ci(d, e), $0331271bace68e97$var$ij(a, b), b.tag = 1, $0331271bace68e97$var$Zf(d) ? (a = !0, $0331271bace68e97$var$cg(b)) : a = !1, $0331271bace68e97$var$ch(b, c), $0331271bace68e97$var$Gi(b, d, e), $0331271bace68e97$var$Ii(b, d, e, c), $0331271bace68e97$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0331271bace68e97$var$xj(a, b, c);
        case 22:
            return $0331271bace68e97$var$dj(a, b, c);
    }
    throw Error($0331271bace68e97$var$p(156, b.tag));
};
function $0331271bace68e97$var$Fk(a, b) {
    return $0331271bace68e97$var$ac(a, b);
}
function $0331271bace68e97$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0331271bace68e97$var$Bg(a, b, c, d) {
    return new $0331271bace68e97$var$$k(a, b, c, d);
}
function $0331271bace68e97$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0331271bace68e97$var$Zk(a) {
    if ("function" === typeof a) return $0331271bace68e97$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0331271bace68e97$var$Da) return 11;
        if (a === $0331271bace68e97$var$Ga) return 14;
    }
    return 2;
}
function $0331271bace68e97$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0331271bace68e97$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0331271bace68e97$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0331271bace68e97$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0331271bace68e97$var$ya:
            return $0331271bace68e97$var$Tg(c.children, e, f, b);
        case $0331271bace68e97$var$za:
            g = 8;
            e |= 8;
            break;
        case $0331271bace68e97$var$Aa:
            return a = $0331271bace68e97$var$Bg(12, c, b, e | 2), a.elementType = $0331271bace68e97$var$Aa, a.lanes = f, a;
        case $0331271bace68e97$var$Ea:
            return a = $0331271bace68e97$var$Bg(13, c, b, e), a.elementType = $0331271bace68e97$var$Ea, a.lanes = f, a;
        case $0331271bace68e97$var$Fa:
            return a = $0331271bace68e97$var$Bg(19, c, b, e), a.elementType = $0331271bace68e97$var$Fa, a.lanes = f, a;
        case $0331271bace68e97$var$Ia:
            return $0331271bace68e97$var$pj(c, e, f, b);
        default:
            if ("object" === (typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a)) && null !== a) switch(a.$$typeof){
                case $0331271bace68e97$var$Ba:
                    g = 10;
                    break a;
                case $0331271bace68e97$var$Ca:
                    g = 9;
                    break a;
                case $0331271bace68e97$var$Da:
                    g = 11;
                    break a;
                case $0331271bace68e97$var$Ga:
                    g = 14;
                    break a;
                case $0331271bace68e97$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0331271bace68e97$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $bJtXW._)(a), ""));
    }
    b = $0331271bace68e97$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0331271bace68e97$var$Tg(a, b, c, d) {
    a = $0331271bace68e97$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0331271bace68e97$var$pj(a, b, c, d) {
    a = $0331271bace68e97$var$Bg(22, a, d, b);
    a.elementType = $0331271bace68e97$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0331271bace68e97$var$Qg(a, b, c) {
    a = $0331271bace68e97$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0331271bace68e97$var$Sg(a, b, c) {
    b = $0331271bace68e97$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0331271bace68e97$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0331271bace68e97$var$zc(0);
    this.expirationTimes = $0331271bace68e97$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0331271bace68e97$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0331271bace68e97$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0331271bace68e97$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0331271bace68e97$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0331271bace68e97$var$kh(f);
    return a;
}
function $0331271bace68e97$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0331271bace68e97$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0331271bace68e97$var$dl(a) {
    if (!a) return $0331271bace68e97$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0331271bace68e97$var$Vb(a) !== a || 1 !== a.tag) throw Error($0331271bace68e97$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0331271bace68e97$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0331271bace68e97$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0331271bace68e97$var$Zf(c)) return $0331271bace68e97$var$bg(a, c, b);
    }
    return b;
}
function $0331271bace68e97$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0331271bace68e97$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0331271bace68e97$var$dl(null);
    c = a.current;
    d = $0331271bace68e97$var$R();
    e = $0331271bace68e97$var$yi(c);
    f = $0331271bace68e97$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0331271bace68e97$var$nh(c, f, e);
    a.current.lanes = e;
    $0331271bace68e97$var$Ac(a, e, d);
    $0331271bace68e97$var$Dk(a, d);
    return a;
}
function $0331271bace68e97$var$fl(a, b, c, d) {
    var e = b.current, f = $0331271bace68e97$var$R(), g = $0331271bace68e97$var$yi(e);
    c = $0331271bace68e97$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0331271bace68e97$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0331271bace68e97$var$nh(e, b, g);
    null !== a && ($0331271bace68e97$var$gi(a, e, g, f), $0331271bace68e97$var$oh(a, e, g));
    return g;
}
function $0331271bace68e97$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0331271bace68e97$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0331271bace68e97$var$il(a, b) {
    $0331271bace68e97$var$hl(a, b);
    (a = a.alternate) && $0331271bace68e97$var$hl(a, b);
}
function $0331271bace68e97$var$jl() {
    return null;
}
var $0331271bace68e97$var$kl = "function" === typeof reportError ? reportError : function kl(a) {
    console.error(a);
};
function $0331271bace68e97$var$ll(a) {
    this._internalRoot = a;
}
$0331271bace68e97$var$ml.prototype.render = $0331271bace68e97$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0331271bace68e97$var$p(409));
    $0331271bace68e97$var$fl(a, b, null, null);
};
$0331271bace68e97$var$ml.prototype.unmount = $0331271bace68e97$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0331271bace68e97$var$Rk(function() {
            $0331271bace68e97$var$fl(null, a, null, null);
        });
        b[$0331271bace68e97$var$uf] = null;
    }
};
function $0331271bace68e97$var$ml(a) {
    this._internalRoot = a;
}
$0331271bace68e97$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0331271bace68e97$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0331271bace68e97$var$Qc.length && 0 !== b && b < $0331271bace68e97$var$Qc[c].priority; c++);
        $0331271bace68e97$var$Qc.splice(c, 0, a);
        0 === c && $0331271bace68e97$var$Vc(a);
    }
};
function $0331271bace68e97$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0331271bace68e97$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0331271bace68e97$var$pl() {}
function $0331271bace68e97$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $0331271bace68e97$var$gl(g);
                f.call(_$a);
            };
        }
        var g = $0331271bace68e97$var$el(b, d, a, 0, null, !1, !1, "", $0331271bace68e97$var$pl);
        a._reactRootContainer = g;
        a[$0331271bace68e97$var$uf] = g.current;
        $0331271bace68e97$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0331271bace68e97$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $0331271bace68e97$var$gl(k);
            h.call(_$a);
        };
    }
    var k = $0331271bace68e97$var$bl(a, 0, !1, null, null, !1, !1, "", $0331271bace68e97$var$pl);
    a._reactRootContainer = k;
    a[$0331271bace68e97$var$uf] = k.current;
    $0331271bace68e97$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0331271bace68e97$var$Rk(function() {
        $0331271bace68e97$var$fl(b, k, c, d);
    });
    return k;
}
function $0331271bace68e97$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $0331271bace68e97$var$gl(g);
                h.call(_$a);
            };
        }
        $0331271bace68e97$var$fl(b, g, a, e);
    } else g = $0331271bace68e97$var$ql(c, b, a, e, d);
    return $0331271bace68e97$var$gl(g);
}
$0331271bace68e97$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0331271bace68e97$var$tc(b.pendingLanes);
                0 !== c && ($0331271bace68e97$var$Cc(b, c | 1), $0331271bace68e97$var$Dk(b, $0331271bace68e97$var$B()), 0 === ($0331271bace68e97$var$K & 6) && ($0331271bace68e97$var$Gj = $0331271bace68e97$var$B() + 500, $0331271bace68e97$var$jg()));
            }
            break;
        case 13:
            $0331271bace68e97$var$Rk(function() {
                var b = $0331271bace68e97$var$ih(a, 1);
                if (null !== b) {
                    var c = $0331271bace68e97$var$R();
                    $0331271bace68e97$var$gi(b, a, 1, c);
                }
            }), $0331271bace68e97$var$il(a, 1);
    }
};
$0331271bace68e97$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $0331271bace68e97$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0331271bace68e97$var$R();
            $0331271bace68e97$var$gi(b, a, 134217728, c);
        }
        $0331271bace68e97$var$il(a, 134217728);
    }
};
$0331271bace68e97$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $0331271bace68e97$var$yi(a), c = $0331271bace68e97$var$ih(a, b);
        if (null !== c) {
            var d = $0331271bace68e97$var$R();
            $0331271bace68e97$var$gi(c, a, b, d);
        }
        $0331271bace68e97$var$il(a, b);
    }
};
$0331271bace68e97$var$Hc = function Hc() {
    return $0331271bace68e97$var$C;
};
$0331271bace68e97$var$Ic = function Ic(a, b) {
    var c = $0331271bace68e97$var$C;
    try {
        return $0331271bace68e97$var$C = a, b();
    } finally{
        $0331271bace68e97$var$C = c;
    }
};
$0331271bace68e97$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $0331271bace68e97$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0331271bace68e97$var$Db(d);
                        if (!e) throw Error($0331271bace68e97$var$p(90));
                        $0331271bace68e97$var$Wa(d);
                        $0331271bace68e97$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0331271bace68e97$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0331271bace68e97$var$fb(a, !!c.multiple, b, !1);
    }
};
$0331271bace68e97$var$Gb = $0331271bace68e97$var$Qk;
$0331271bace68e97$var$Hb = $0331271bace68e97$var$Rk;
var $0331271bace68e97$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0331271bace68e97$var$Cb,
        $0331271bace68e97$var$ue,
        $0331271bace68e97$var$Db,
        $0331271bace68e97$var$Eb,
        $0331271bace68e97$var$Fb,
        $0331271bace68e97$var$Qk
    ]
}, $0331271bace68e97$var$tl = {
    findFiberByHostInstance: $0331271bace68e97$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0331271bace68e97$var$ul = {
    bundleType: $0331271bace68e97$var$tl.bundleType,
    version: $0331271bace68e97$var$tl.version,
    rendererPackageName: $0331271bace68e97$var$tl.rendererPackageName,
    rendererConfig: $0331271bace68e97$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0331271bace68e97$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $0331271bace68e97$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0331271bace68e97$var$tl.findFiberByHostInstance || $0331271bace68e97$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0331271bace68e97$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0331271bace68e97$var$vl.isDisabled && $0331271bace68e97$var$vl.supportsFiber) try {
        $0331271bace68e97$var$kc = $0331271bace68e97$var$vl.inject($0331271bace68e97$var$ul), $0331271bace68e97$var$lc = $0331271bace68e97$var$vl;
    } catch (a) {}
}
$0331271bace68e97$export$ae55be85d98224ed = $0331271bace68e97$var$sl;
$0331271bace68e97$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0331271bace68e97$var$nl(b)) throw Error($0331271bace68e97$var$p(200));
    return $0331271bace68e97$var$cl(a, b, null, c);
};
$0331271bace68e97$export$882461b6382ed46c = function(a, b) {
    if (!$0331271bace68e97$var$nl(a)) throw Error($0331271bace68e97$var$p(299));
    var c = !1, d = "", e = $0331271bace68e97$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0331271bace68e97$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0331271bace68e97$var$uf] = b.current;
    $0331271bace68e97$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0331271bace68e97$var$ll(b);
};
$0331271bace68e97$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0331271bace68e97$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0331271bace68e97$var$p(268, a));
    }
    a = $0331271bace68e97$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0331271bace68e97$export$cd75ccfd720a3cd4 = function(a) {
    return $0331271bace68e97$var$Rk(a);
};
$0331271bace68e97$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0331271bace68e97$var$ol(b)) throw Error($0331271bace68e97$var$p(200));
    return $0331271bace68e97$var$rl(null, a, b, !0, c);
};
$0331271bace68e97$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0331271bace68e97$var$nl(a)) throw Error($0331271bace68e97$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0331271bace68e97$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0331271bace68e97$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0331271bace68e97$var$uf] = b.current;
    $0331271bace68e97$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0331271bace68e97$var$ml(b);
};
$0331271bace68e97$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0331271bace68e97$var$ol(b)) throw Error($0331271bace68e97$var$p(200));
    return $0331271bace68e97$var$rl(null, a, b, !1, c);
};
$0331271bace68e97$export$502457920280e6be = function(a) {
    if (!$0331271bace68e97$var$ol(a)) throw Error($0331271bace68e97$var$p(40));
    return a._reactRootContainer ? ($0331271bace68e97$var$Rk(function() {
        $0331271bace68e97$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0331271bace68e97$var$uf] = null;
        });
    }), !0) : !1;
};
$0331271bace68e97$export$c78a37762a8d58e1 = $0331271bace68e97$var$Qk;
$0331271bace68e97$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0331271bace68e97$var$ol(c)) throw Error($0331271bace68e97$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0331271bace68e97$var$p(38));
    return $0331271bace68e97$var$rl(a, b, c, !1, d);
};
$0331271bace68e97$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("1iyD5", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2nkgC"));

});
parcelRegister("2nkgC", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $1bad735fa80bcaf4$export$c4744153514ff05d; }, function (v) { return $1bad735fa80bcaf4$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $1bad735fa80bcaf4$export$3e506c1ccc9cc1a7; }, function (v) { return $1bad735fa80bcaf4$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $1bad735fa80bcaf4$export$e26fe2ed2fa76875; }, function (v) { return $1bad735fa80bcaf4$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $1bad735fa80bcaf4$export$502329bbf4b505b1; }, function (v) { return $1bad735fa80bcaf4$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $1bad735fa80bcaf4$export$6e3807111c4874c4; }, function (v) { return $1bad735fa80bcaf4$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $1bad735fa80bcaf4$export$c27134553091fb3a; }, function (v) { return $1bad735fa80bcaf4$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $1bad735fa80bcaf4$export$33ee1acdc04fd2a2; }, function (v) { return $1bad735fa80bcaf4$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $1bad735fa80bcaf4$export$b00a404bbd5edef2; }, function (v) { return $1bad735fa80bcaf4$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $1bad735fa80bcaf4$export$8352ce38b91d0c62; }, function (v) { return $1bad735fa80bcaf4$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $1bad735fa80bcaf4$export$d66a1c1c77bd778b; }, function (v) { return $1bad735fa80bcaf4$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $1bad735fa80bcaf4$export$d3dfb8e4810cb555; }, function (v) { return $1bad735fa80bcaf4$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $1bad735fa80bcaf4$export$839f9183b0465a69; }, function (v) { return $1bad735fa80bcaf4$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $1bad735fa80bcaf4$export$72fdf0e06517287b; }, function (v) { return $1bad735fa80bcaf4$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $1bad735fa80bcaf4$export$4b844e58a3e414b4; }, function (v) { return $1bad735fa80bcaf4$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $1bad735fa80bcaf4$export$816d2913ae6b83b1; }, function (v) { return $1bad735fa80bcaf4$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $1bad735fa80bcaf4$export$61bcfe829111a1d0; }, function (v) { return $1bad735fa80bcaf4$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $1bad735fa80bcaf4$export$7ee8c9beb337bc3f; }, function (v) { return $1bad735fa80bcaf4$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $1bad735fa80bcaf4$export$b5836b71941fa3ed; }, function (v) { return $1bad735fa80bcaf4$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $1bad735fa80bcaf4$export$cf845f2c119da08a; }, function (v) { return $1bad735fa80bcaf4$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $bJtXW = parcelRequire("bJtXW");
var $1bad735fa80bcaf4$export$c4744153514ff05d;
var $1bad735fa80bcaf4$export$3e506c1ccc9cc1a7;
var $1bad735fa80bcaf4$export$e26fe2ed2fa76875;
var $1bad735fa80bcaf4$export$502329bbf4b505b1;
var $1bad735fa80bcaf4$export$6e3807111c4874c4;
var $1bad735fa80bcaf4$export$c27134553091fb3a;
var $1bad735fa80bcaf4$export$33ee1acdc04fd2a2;
var $1bad735fa80bcaf4$export$b00a404bbd5edef2;
var $1bad735fa80bcaf4$export$8352ce38b91d0c62;
var $1bad735fa80bcaf4$export$d66a1c1c77bd778b;
var $1bad735fa80bcaf4$export$d3dfb8e4810cb555;
var $1bad735fa80bcaf4$export$839f9183b0465a69;
var $1bad735fa80bcaf4$export$72fdf0e06517287b;
var $1bad735fa80bcaf4$export$4b844e58a3e414b4;
var $1bad735fa80bcaf4$export$816d2913ae6b83b1;
var $1bad735fa80bcaf4$export$61bcfe829111a1d0;
var $1bad735fa80bcaf4$export$7ee8c9beb337bc3f;
var $1bad735fa80bcaf4$export$b5836b71941fa3ed;
var $1bad735fa80bcaf4$export$cf845f2c119da08a;
'use strict';
function $1bad735fa80bcaf4$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $1bad735fa80bcaf4$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $1bad735fa80bcaf4$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $1bad735fa80bcaf4$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $1bad735fa80bcaf4$var$g(C, c)) n < e && 0 > $1bad735fa80bcaf4$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $1bad735fa80bcaf4$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $1bad735fa80bcaf4$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === (typeof performance === "undefined" ? "undefined" : (0, $bJtXW._)(performance)) && "function" === typeof performance.now) {
    var $1bad735fa80bcaf4$var$l = performance;
    $1bad735fa80bcaf4$export$c4744153514ff05d = function() {
        return $1bad735fa80bcaf4$var$l.now();
    };
} else {
    var $1bad735fa80bcaf4$var$p = Date, $1bad735fa80bcaf4$var$q = $1bad735fa80bcaf4$var$p.now();
    $1bad735fa80bcaf4$export$c4744153514ff05d = function() {
        return $1bad735fa80bcaf4$var$p.now() - $1bad735fa80bcaf4$var$q;
    };
}
var $1bad735fa80bcaf4$var$r = [], $1bad735fa80bcaf4$var$t = [], $1bad735fa80bcaf4$var$u = 1, $1bad735fa80bcaf4$var$v = null, $1bad735fa80bcaf4$var$y = 3, $1bad735fa80bcaf4$var$z = !1, $1bad735fa80bcaf4$var$A = !1, $1bad735fa80bcaf4$var$B = !1, $1bad735fa80bcaf4$var$D = "function" === typeof setTimeout ? setTimeout : null, $1bad735fa80bcaf4$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $1bad735fa80bcaf4$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $1bad735fa80bcaf4$var$G(a) {
    for(var b = $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$t); null !== b;){
        if (null === b.callback) $1bad735fa80bcaf4$var$k($1bad735fa80bcaf4$var$t);
        else if (b.startTime <= a) $1bad735fa80bcaf4$var$k($1bad735fa80bcaf4$var$t), b.sortIndex = b.expirationTime, $1bad735fa80bcaf4$var$f($1bad735fa80bcaf4$var$r, b);
        else break;
        b = $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$t);
    }
}
function $1bad735fa80bcaf4$var$H(a) {
    $1bad735fa80bcaf4$var$B = !1;
    $1bad735fa80bcaf4$var$G(a);
    if (!$1bad735fa80bcaf4$var$A) {
        if (null !== $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$r)) $1bad735fa80bcaf4$var$A = !0, $1bad735fa80bcaf4$var$I($1bad735fa80bcaf4$var$J);
        else {
            var b = $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$t);
            null !== b && $1bad735fa80bcaf4$var$K($1bad735fa80bcaf4$var$H, b.startTime - a);
        }
    }
}
function $1bad735fa80bcaf4$var$J(a, b) {
    $1bad735fa80bcaf4$var$A = !1;
    $1bad735fa80bcaf4$var$B && ($1bad735fa80bcaf4$var$B = !1, $1bad735fa80bcaf4$var$E($1bad735fa80bcaf4$var$L), $1bad735fa80bcaf4$var$L = -1);
    $1bad735fa80bcaf4$var$z = !0;
    var c = $1bad735fa80bcaf4$var$y;
    try {
        $1bad735fa80bcaf4$var$G(b);
        for($1bad735fa80bcaf4$var$v = $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$r); null !== $1bad735fa80bcaf4$var$v && (!($1bad735fa80bcaf4$var$v.expirationTime > b) || a && !$1bad735fa80bcaf4$var$M());){
            var d = $1bad735fa80bcaf4$var$v.callback;
            if ("function" === typeof d) {
                $1bad735fa80bcaf4$var$v.callback = null;
                $1bad735fa80bcaf4$var$y = $1bad735fa80bcaf4$var$v.priorityLevel;
                var e = d($1bad735fa80bcaf4$var$v.expirationTime <= b);
                b = $1bad735fa80bcaf4$export$c4744153514ff05d();
                "function" === typeof e ? $1bad735fa80bcaf4$var$v.callback = e : $1bad735fa80bcaf4$var$v === $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$r) && $1bad735fa80bcaf4$var$k($1bad735fa80bcaf4$var$r);
                $1bad735fa80bcaf4$var$G(b);
            } else $1bad735fa80bcaf4$var$k($1bad735fa80bcaf4$var$r);
            $1bad735fa80bcaf4$var$v = $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$r);
        }
        if (null !== $1bad735fa80bcaf4$var$v) var w = !0;
        else {
            var m = $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$t);
            null !== m && $1bad735fa80bcaf4$var$K($1bad735fa80bcaf4$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $1bad735fa80bcaf4$var$v = null, $1bad735fa80bcaf4$var$y = c, $1bad735fa80bcaf4$var$z = !1;
    }
}
var $1bad735fa80bcaf4$var$N = !1, $1bad735fa80bcaf4$var$O = null, $1bad735fa80bcaf4$var$L = -1, $1bad735fa80bcaf4$var$P = 5, $1bad735fa80bcaf4$var$Q = -1;
function $1bad735fa80bcaf4$var$M() {
    return $1bad735fa80bcaf4$export$c4744153514ff05d() - $1bad735fa80bcaf4$var$Q < $1bad735fa80bcaf4$var$P ? !1 : !0;
}
function $1bad735fa80bcaf4$var$R() {
    if (null !== $1bad735fa80bcaf4$var$O) {
        var a = $1bad735fa80bcaf4$export$c4744153514ff05d();
        $1bad735fa80bcaf4$var$Q = a;
        var b = !0;
        try {
            b = $1bad735fa80bcaf4$var$O(!0, a);
        } finally{
            b ? $1bad735fa80bcaf4$var$S() : ($1bad735fa80bcaf4$var$N = !1, $1bad735fa80bcaf4$var$O = null);
        }
    } else $1bad735fa80bcaf4$var$N = !1;
}
var $1bad735fa80bcaf4$var$S;
if ("function" === typeof $1bad735fa80bcaf4$var$F) $1bad735fa80bcaf4$var$S = function S() {
    $1bad735fa80bcaf4$var$F($1bad735fa80bcaf4$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $1bad735fa80bcaf4$var$T = new MessageChannel, $1bad735fa80bcaf4$var$U = $1bad735fa80bcaf4$var$T.port2;
    $1bad735fa80bcaf4$var$T.port1.onmessage = $1bad735fa80bcaf4$var$R;
    $1bad735fa80bcaf4$var$S = function S() {
        $1bad735fa80bcaf4$var$U.postMessage(null);
    };
} else $1bad735fa80bcaf4$var$S = function S() {
    $1bad735fa80bcaf4$var$D($1bad735fa80bcaf4$var$R, 0);
};
function $1bad735fa80bcaf4$var$I(a) {
    $1bad735fa80bcaf4$var$O = a;
    $1bad735fa80bcaf4$var$N || ($1bad735fa80bcaf4$var$N = !0, $1bad735fa80bcaf4$var$S());
}
function $1bad735fa80bcaf4$var$K(a, b) {
    $1bad735fa80bcaf4$var$L = $1bad735fa80bcaf4$var$D(function() {
        a($1bad735fa80bcaf4$export$c4744153514ff05d());
    }, b);
}
$1bad735fa80bcaf4$export$3e506c1ccc9cc1a7 = 5;
$1bad735fa80bcaf4$export$e26fe2ed2fa76875 = 1;
$1bad735fa80bcaf4$export$502329bbf4b505b1 = 4;
$1bad735fa80bcaf4$export$6e3807111c4874c4 = 3;
$1bad735fa80bcaf4$export$c27134553091fb3a = null;
$1bad735fa80bcaf4$export$33ee1acdc04fd2a2 = 2;
$1bad735fa80bcaf4$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$1bad735fa80bcaf4$export$8352ce38b91d0c62 = function() {
    $1bad735fa80bcaf4$var$A || $1bad735fa80bcaf4$var$z || ($1bad735fa80bcaf4$var$A = !0, $1bad735fa80bcaf4$var$I($1bad735fa80bcaf4$var$J));
};
$1bad735fa80bcaf4$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $1bad735fa80bcaf4$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$1bad735fa80bcaf4$export$d3dfb8e4810cb555 = function() {
    return $1bad735fa80bcaf4$var$y;
};
$1bad735fa80bcaf4$export$839f9183b0465a69 = function() {
    return $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$r);
};
$1bad735fa80bcaf4$export$72fdf0e06517287b = function(a) {
    switch($1bad735fa80bcaf4$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $1bad735fa80bcaf4$var$y;
    }
    var c = $1bad735fa80bcaf4$var$y;
    $1bad735fa80bcaf4$var$y = b;
    try {
        return a();
    } finally{
        $1bad735fa80bcaf4$var$y = c;
    }
};
$1bad735fa80bcaf4$export$4b844e58a3e414b4 = function() {};
$1bad735fa80bcaf4$export$816d2913ae6b83b1 = function() {};
$1bad735fa80bcaf4$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $1bad735fa80bcaf4$var$y;
    $1bad735fa80bcaf4$var$y = a;
    try {
        return b();
    } finally{
        $1bad735fa80bcaf4$var$y = c;
    }
};
$1bad735fa80bcaf4$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $1bad735fa80bcaf4$export$c4744153514ff05d();
    "object" === (typeof c === "undefined" ? "undefined" : (0, $bJtXW._)(c)) && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $1bad735fa80bcaf4$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $1bad735fa80bcaf4$var$f($1bad735fa80bcaf4$var$t, a), null === $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$r) && a === $1bad735fa80bcaf4$var$h($1bad735fa80bcaf4$var$t) && ($1bad735fa80bcaf4$var$B ? ($1bad735fa80bcaf4$var$E($1bad735fa80bcaf4$var$L), $1bad735fa80bcaf4$var$L = -1) : $1bad735fa80bcaf4$var$B = !0, $1bad735fa80bcaf4$var$K($1bad735fa80bcaf4$var$H, c - d))) : (a.sortIndex = e, $1bad735fa80bcaf4$var$f($1bad735fa80bcaf4$var$r, a), $1bad735fa80bcaf4$var$A || $1bad735fa80bcaf4$var$z || ($1bad735fa80bcaf4$var$A = !0, $1bad735fa80bcaf4$var$I($1bad735fa80bcaf4$var$J)));
    return a;
};
$1bad735fa80bcaf4$export$b5836b71941fa3ed = $1bad735fa80bcaf4$var$M;
$1bad735fa80bcaf4$export$cf845f2c119da08a = function(a) {
    var b = $1bad735fa80bcaf4$var$y;
    return function() {
        var c = $1bad735fa80bcaf4$var$y;
        $1bad735fa80bcaf4$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $1bad735fa80bcaf4$var$y = c;
        }
    };
};

});



parcelRegister("gl7zH", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return Action; });
$parcel$export(module.exports, "createMemoryHistory", function () { return createMemoryHistory; });
$parcel$export(module.exports, "createPath", function () { return createPath; });
$parcel$export(module.exports, "parsePath", function () { return parsePath; });
$parcel$export(module.exports, "createBrowserHistory", function () { return createBrowserHistory; });
$parcel$export(module.exports, "createHashHistory", function () { return createHashHistory; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return invariant; });
$parcel$export(module.exports, "matchRoutes", function () { return matchRoutes; });
$parcel$export(module.exports, "stripBasename", function () { return stripBasename; });
$parcel$export(module.exports, "UNSAFE_decodePath", function () { return decodePath; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return convertRouteMatchToUiMatch; });
$parcel$export(module.exports, "joinPaths", function () { return joinPaths; });
$parcel$export(module.exports, "matchPath", function () { return matchPath; });
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", function () { return getResolveToMatches; });
$parcel$export(module.exports, "resolveTo", function () { return resolveTo; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return AbortedDeferredError; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return ErrorResponseImpl; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return isRouteErrorResponse; });
$parcel$export(module.exports, "IDLE_FETCHER", function () { return IDLE_FETCHER; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return IDLE_BLOCKER; });
$parcel$export(module.exports, "createRouter", function () { return createRouter; });
/**
 * @remix-run/router v1.21.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $g3gsR = parcelRequire("g3gsR");

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $72osQ = parcelRequire("72osQ");

var $j6Mzi = parcelRequire("j6Mzi");

var $2nwvT = parcelRequire("2nwvT");

var $l8eKX = parcelRequire("l8eKX");

var $2us1u = parcelRequire("2us1u");

var $bJtXW = parcelRequire("bJtXW");

var $1EZOw = parcelRequire("1EZOw");

var $fRv9I = parcelRequire("fRv9I");

var $fRv9I = parcelRequire("fRv9I");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var Action;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
var PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function createMemoryHistory(options) {
    if (options === void 0) options = {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = Action.Pop;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        var location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL: function(to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = Action.Push;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = Action.Replace;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = Action.Pop;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function createBrowserHistory(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        var _window_location = window1.location, pathname = _window_location.pathname, search = _window_location.search, hash = _window_location.hash;
        return createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function createHashHistory(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        var _parsePath = parsePath(window1.location.hash.substr(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        var base = window1.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window1.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    var location = _extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function createPath(_ref) {
    var _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? "/" : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function parsePath(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    var _options_window = options.window, window1 = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window1.history;
    var action = Action.Pop;
    var listener = null;
    var index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState(_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = Action.Pop;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = Action.Push;
        var location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = Action.Replace;
        var location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        var base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        var href = typeof to === "string" ? to : createPath(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        invariant(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window1.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            // Encode a Location the same way window.location would
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
var immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function convertRoutesToDataRoutes(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map(function(route, index) {
        var treePath = (0, $2us1u._)(parentPath).concat([
            String(index)
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if (isIndexRoute(route)) {
            var indexRoute = _extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = _extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function matchRoutes(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    var location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    var pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        var decoded = decodePath(pathname);
        matches = matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route$path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function explodeOptionalSegments(path) {
    var // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $l8eKX._)(segments), first = _segments[0], rest = _segments.slice(1);
    // Optional path segments are denoted by a trailing `?`
    var isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $2us1u._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $2us1u._)(restExploded));
    // for absolute paths, ensure `/` instead of empty segment
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score // Higher score first
         : compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var paramRe = /^:[\w-]+$/;
var dynamicSegmentValue = 3;
var indexRouteValue = 2;
var emptySegmentValue = 1;
var staticSegmentValue = 10;
var splatPenalty = -2;
var isSplat = function(s) {
    return s === "*";
};
function computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter(function(s) {
        return !isSplat(s);
    }).reduce(function(score, segment) {
        return score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue);
    }, initialScore);
}
function compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        var route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function generatePath(originalPath, params) {
    if (params === void 0) params = {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            var star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        var keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, $2nwvT._)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            invariant(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $2nwvT._)(compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], compiledParams = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = compiledParams.reduce(function(memo, _ref, index) {
        var paramName = _ref.paramName, isOptional = _ref.isOptional;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        var value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    var params = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, function(_, paramName, isOptional) {
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map(function(v) {
            return decodeURIComponent(v).replace(/\//g, "%2F");
        }).join("/");
    } catch (error) {
        warning(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function resolvePath(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    var _ref = typeof to === "string" ? parsePath(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function getPathContributingMatches(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function getResolveToMatches(matches, v7_relativeSplatPath) {
    var pathMatches = getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map(function(match, idx) {
        return idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase;
    });
    return pathMatches.map(function(match) {
        return match.pathnameBase;
    });
}
/**
 * @private
 */ function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    var to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = _extends({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = resolvePath(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? parsePath(to).pathname : to.pathname;
}
/**
 * @private
 */ var joinPaths = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */ var normalizePathname = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */ var normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */ var normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ var json = function json(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    var headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), _extends({}, responseInit, {
        headers: headers
    }));
};
var DataWithResponseInit = function DataWithResponseInit(data, init) {
    "use strict";
    (0, $grujF._)(this, DataWithResponseInit);
    this.type = "DataWithResponseInit";
    this.data = data;
    this.init = init || null;
};
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function data(data, init) {
    return new DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
var AbortedDeferredError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $j6Mzi._)(AbortedDeferredError, Error1);
    function AbortedDeferredError() {
        (0, $grujF._)(this, AbortedDeferredError);
        return (0, $f3Okx._)(this, AbortedDeferredError, arguments);
    }
    return AbortedDeferredError;
}((0, $1EZOw._)(Error));
var DeferredData = /*#__PURE__*/ function() {
    "use strict";
    function DeferredData(data, responseInit) {
        var _this = this;
        (0, $grujF._)(this, DeferredData);
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        invariant(data && (typeof data === "undefined" ? "undefined" : (0, $bJtXW._)(data)) === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        var reject;
        this.abortPromise = new Promise(function(_, r) {
            return reject = r;
        });
        this.controller = new AbortController();
        var onAbort = function() {
            return reject(new AbortedDeferredError("Deferred data aborted"));
        };
        this.unlistenAbortSignal = function() {
            return _this.controller.signal.removeEventListener("abort", onAbort);
        };
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce(function(acc, _ref2) {
            var _$_ref2 = (0, $2nwvT._)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
            return Object.assign(acc, (0, $72osQ._)({}, key, _this.trackPromise(key, value)));
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    (0, $dhMkv._)(DeferredData, [
        {
            key: "trackPromise",
            value: function trackPromise(key, value) {
                var _this = this;
                if (!(value instanceof Promise)) return value;
                this.deferredKeys.push(key);
                this.pendingKeysSet.add(key);
                // We store a little wrapper promise that will be extended with
                // _data/_error props upon resolve/reject
                var promise = Promise.race([
                    value,
                    this.abortPromise
                ]).then(function(data) {
                    return _this.onSettle(promise, key, undefined, data);
                }, function(error) {
                    return _this.onSettle(promise, key, error);
                });
                // Register rejection listeners to avoid uncaught promise rejections on
                // errors or aborted deferred values
                promise.catch(function() {});
                Object.defineProperty(promise, "_tracked", {
                    get: function() {
                        return true;
                    }
                });
                return promise;
            }
        },
        {
            key: "onSettle",
            value: function onSettle(promise, key, error, data) {
                if (this.controller.signal.aborted && error instanceof AbortedDeferredError) {
                    this.unlistenAbortSignal();
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    return Promise.reject(error);
                }
                this.pendingKeysSet.delete(key);
                if (this.done) // Nothing left to abort!
                this.unlistenAbortSignal();
                // If the promise was resolved/rejected with undefined, we'll throw an error as you
                // should always resolve with a value or null
                if (error === undefined && data === undefined) {
                    var undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return undefinedError;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(undefinedError);
                }
                if (data === undefined) {
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(error);
                }
                Object.defineProperty(promise, "_data", {
                    get: function() {
                        return data;
                    }
                });
                this.emit(false, key);
                return data;
            }
        },
        {
            key: "emit",
            value: function emit(aborted, settledKey) {
                this.subscribers.forEach(function(subscriber) {
                    return subscriber(aborted, settledKey);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscribers.add(fn);
                return function() {
                    return _this.subscribers.delete(fn);
                };
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this = this;
                this.controller.abort();
                this.pendingKeysSet.forEach(function(v, k) {
                    return _this.pendingKeysSet.delete(k);
                });
                this.emit(true);
            }
        },
        {
            key: "resolveData",
            value: function resolveData(signal) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
                    var _this, aborted, onAbort;
                    return (0, $fRv9I.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                aborted = false;
                                if (!!this.done) return [
                                    3,
                                    2
                                ];
                                onAbort = function() {
                                    return _this.cancel();
                                };
                                signal.addEventListener("abort", onAbort);
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.subscribe(function(aborted) {
                                            signal.removeEventListener("abort", onAbort);
                                            if (aborted || _this.done) resolve(aborted);
                                        });
                                    })
                                ];
                            case 1:
                                aborted = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    aborted
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "done",
            get: function get() {
                return this.pendingKeysSet.size === 0;
            }
        },
        {
            key: "unwrappedData",
            get: function get() {
                invariant(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
                return Object.entries(this.data).reduce(function(acc, _ref3) {
                    var _$_ref3 = (0, $2nwvT._)(_ref3, 2), key = _$_ref3[0], value = _$_ref3[1];
                    return Object.assign(acc, (0, $72osQ._)({}, key, unwrapTrackedPromise(value)));
                }, {});
            }
        },
        {
            key: "pendingKeys",
            get: function get() {
                return Array.from(this.pendingKeysSet);
            }
        }
    ]);
    return DeferredData;
}();
function isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function unwrapTrackedPromise(value) {
    if (!isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ var defer = function defer(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new DeferredData(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var redirect = function redirect(url, init) {
    if (init === void 0) init = 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, _extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var redirectDocument = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var replace = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ var ErrorResponseImpl = function ErrorResponseImpl(status, statusText, data, internal) {
    "use strict";
    (0, $grujF._)(this, ErrorResponseImpl);
    if (internal === void 0) internal = false;
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
var validMutationMethods = new Set(validMutationMethodsArr);
var validRequestMethodsArr = [
    "get"
].concat((0, $2us1u._)(validMutationMethodsArr));
var validRequestMethods = new Set(validRequestMethodsArr);
var redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var IDLE_NAVIGATION = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var IDLE_FETCHER = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var IDLE_BLOCKER = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
var ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
var TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function createRouter(init) {
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    var isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    var isServer = !isBrowser;
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = defaultMapRouteProperties;
    // Routes keyed by ID
    var manifest = {};
    // Routes in tree format for matching
    var dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties, undefined, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/";
    var dataStrategyImpl = init.dataStrategy || defaultDataStrategy;
    var patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    var future = _extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    var unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    var subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    var savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    var getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    var getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    var initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        var error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = (0, $72osQ._)({}, route.id, error);
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        var fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    var initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            var fogOfWar1 = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar1.active && fogOfWar1.matches) initialMatches = fogOfWar1.matches;
        }
    } else if (initialMatches.some(function(m) {
        return m.route.lazy;
    })) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some(function(m) {
        return m.route.loader;
    })) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        var loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        var errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            var idx = initialMatches.findIndex(function(m) {
                return errors[m.route.id] !== undefined;
            });
            initialized = initialMatches.slice(0, idx + 1).every(function(m) {
                return !shouldLoadRouteOnHydration(m.route, loaderData, errors);
            });
        } else initialized = initialMatches.every(function(m) {
            return !shouldLoadRouteOnHydration(m.route, loaderData, errors);
        });
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    var pendingAction = Action.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    var pendingPreventScrollReset = false;
    // AbortController for the active navigation
    var pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    var pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    var appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    var removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    var isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    var isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    var cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    var cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    var fetchControllers = new Map();
    // Track loads based on the order in which they started
    var incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    var pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    var fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    var fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    var fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    var activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    var deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    var activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    var blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    var unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen(function(_ref) {
            var historyAction = _ref.action, location = _ref.location, delta = _ref.delta;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                var nextHistoryUpdatePromise = new Promise(function(resolve) {
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(function() {
                            return init.history.go(delta);
                        });
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            var _saveAppliedTransitions = function() {
                return persistAppliedTransitions(routerWindow, appliedViewTransitions);
            };
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = function() {
                return routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
            };
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation(Action.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers.delete(fn);
        };
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = _extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        var completedFetchers = [];
        var deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach(function(fetcher, key) {
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        (0, $2us1u._)(subscribers).forEach(function(subscriber) {
            return subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            });
        });
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach(function(key) {
                return state.fetchers.delete(key);
            });
            deletedFetchersKeys.forEach(function(key) {
                return deleteFetcher(key);
            });
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        var flushSync = (_temp === void 0 ? {} : _temp).flushSync;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        var loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, IDLE_BLOCKER);
            });
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === Action.Pop) ;
        else if (pendingAction === Action.Push) init.history.push(location, location.state);
        else if (pendingAction === Action.Replace) init.history.replace(location, location.state);
        var viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === Action.Pop) {
            // Forward takes precedence so they behave like the original navigation
            var priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            var toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState(_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = Action.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    function navigate(to, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, flushSync, blockerKey;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
                        _normalizeNavigateOptions = normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = createLocation(state.location, path, opts && opts.state);
                        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
                        // URL from window.location, so we need to encode it here so the behavior
                        // remains the same as POP and non-data-router usages.  new URL() does all
                        // the same encoding we'd get from a history.pushState/window.location read
                        // without having to touch history
                        nextLocation = _extends({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : undefined;
                        historyAction = Action.Push;
                        if (userReplace === true) historyAction = Action.Replace;
                        else if (userReplace === false) ;
                        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
                        // users don't have to double-click the back button to get to the prior
                        // location.  If the user redirects to a different location from the
                        // action/loader this will be ignored and the redirect will be a PUSH
                        historyAction = Action.Replace;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
                        flushSync = (opts && opts.flushSync) === true;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            // Put the blocker into a blocked state
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: undefined,
                                        reset: undefined,
                                        location: nextLocation
                                    });
                                    // Send the same navigation through
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, IDLE_BLOCKER);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace,
                                enableViewTransition: opts && opts.viewTransition,
                                flushSync: flushSync
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        })();
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    function startNavigation(historyAction, location, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var routesToUse, loadingNavigation, matches, flushSync, fogOfWar, _handleNavigational404, error, notFoundMatches, route, request, pendingActionResult, actionResult, _actionResult_pendingActionResult, routeId, result, _ref, shortCircuited, updatedMatches, loaderData, errors;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Abort any in-progress navigations and start a new one. Unset any ongoing
                        // uninterrupted revalidations unless told otherwise, since we want this
                        // new navigation to update history normally
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        // Save the current scroll position every time we start a new navigation,
                        // and track whether we should reset scroll on completion
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = matchRoutes(routesToUse, location, basename);
                        flushSync = (opts && opts.flushSync) === true;
                        fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
                        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
                        // Short circuit with a 404 on the root error boundary if we match nothing
                        if (!matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $72osQ._)({}, route.id, error)
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Short circuit if it's only a hash change and not a revalidation or
                        // mutation submission.
                        //
                        // Ignore on initial page loads because since the initial hydration will always
                        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
                        // which will default to a navigation to /page
                        if (state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Create a controller/Request for this navigation
                        pendingNavigationController = new AbortController();
                        request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        // If we have a pendingError, it means the user attempted a GET submission
                        // with binary FormData so assign here and skip to handleLoaders.  That
                        // way we handle calling loaders above the boundary etc.  It's not really
                        // different from an actionError in that sense.
                        pendingActionResult = [
                            findNearestBoundary(matches).route.id,
                            {
                                type: ResultType.error,
                                error: opts.pendingError
                            }
                        ];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                                replace: opts.replace,
                                flushSync: flushSync
                            })
                        ];
                    case 2:
                        actionResult = _state.sent();
                        if (actionResult.shortCircuited) return [
                            2
                        ];
                        // If we received a 404 from handleAction, it's because we couldn't lazily
                        // discover the destination route so we don't want to call loaders
                        if (actionResult.pendingActionResult) {
                            _actionResult_pendingActionResult = (0, $2nwvT._)(actionResult.pendingActionResult, 2), routeId = _actionResult_pendingActionResult[0], result = _actionResult_pendingActionResult[1];
                            if (isErrorResult(result) && isRouteErrorResponse(result.error) && result.error.status === 404) {
                                pendingNavigationController = null;
                                completeNavigation(location, {
                                    matches: actionResult.matches,
                                    loaderData: {},
                                    errors: (0, $72osQ._)({}, routeId, result.error)
                                });
                                return [
                                    2
                                ];
                            }
                        }
                        matches = actionResult.matches || matches;
                        pendingActionResult = actionResult.pendingActionResult;
                        loadingNavigation = getLoadingNavigation(location, opts.submission);
                        flushSync = false;
                        // No need to do fog of war matching again on loader execution
                        fogOfWar.active = false;
                        // Create a GET request for the loaders
                        request = createClientSideRequest(init.history, request.url, request.signal);
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, updatedMatches = _ref.matches, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                        // Clean up now that the action/loaders have completed.  Don't clean up if
                        // we short circuited because pendingNavigationController will have already
                        // been assigned to a new controller for the next navigation
                        pendingNavigationController = null;
                        completeNavigation(location, _extends({
                            matches: updatedMatches || matches
                        }, getActionDataForCommit(pendingActionResult), {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        })();
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var navigation, discoverResult, boundaryId, _handleNavigational404, notFoundMatches, error, route, result, actionMatch, results, replace, _$location, boundaryMatch;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (opts === void 0) opts = {};
                        interruptActiveLoads();
                        // Put us in a submitting state
                        navigation = getSubmittingNavigation(location, submission);
                        updateState({
                            navigation: navigation
                        }, {
                            flushSync: opts.flushSync === true
                        });
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    pendingActionResult: [
                                        boundaryId,
                                        {
                                            type: ResultType.error,
                                            error: discoverResult.error
                                        }
                                    ]
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), notFoundMatches = _handleNavigational404.notFoundMatches, error = _handleNavigational404.error, route = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    pendingActionResult: [
                                        route.id,
                                        {
                                            type: ResultType.error,
                                            error: error
                                        }
                                    ]
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        actionMatch = getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            3
                        ];
                        result = {
                            type: ResultType.error,
                            error: getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            callDataStrategy("action", state, request, [
                                actionMatch
                            ], matches, null)
                        ];
                    case 4:
                        results = _state.sent();
                        result = results[actionMatch.route.id];
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 5;
                    case 5:
                        if (!isRedirectResult(result)) return [
                            3,
                            7
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else {
                            // If the user didn't explicity indicate replace behavior, replace if
                            // we redirected to the exact same location we're currently at to avoid
                            // double back-buttons
                            _$location = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                            replace = _$location === state.location.pathname + state.location.search;
                        }
                        return [
                            4,
                            startRedirectNavigation(request, result, true, {
                                submission: submission,
                                replace: replace
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        if (isDeferredResult(result)) throw getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        if (isErrorResult(result)) {
                            // Store off the pending error - we use it to determine which loaders
                            // to call and will commit it when we complete the navigation
                            boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
                            // By default, all submissions to the current location are REPLACE
                            // navigations, but if the action threw an error that'll be rendered in
                            // an errorElement, we fall back to PUSH so that the user can use the
                            // back button to get back to the pre-submission form location to try
                            // again
                            if ((opts && opts.replace) !== true) pendingAction = Action.Push;
                            return [
                                2,
                                {
                                    matches: matches,
                                    pendingActionResult: [
                                        boundaryMatch.route.id,
                                        result
                                    ]
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                matches: matches,
                                pendingActionResult: [
                                    actionMatch.route.id,
                                    result
                                ]
                            }
                        ];
                }
            });
        })();
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var loadingNavigation, activeSubmission, shouldUpdateNavigationState, actionData, discoverResult, boundaryId, _handleNavigational404, error, notFoundMatches, route, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, updatedFetchers, updates, actionData1, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect, _processLoaderData, loaderData, errors, updatedFetchers1, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Figure out the right navigation we want to use for data loading
                        loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
                        // If this was a redirect from an action we don't have a "submission" but
                        // we have it on the loading navigation so use that if available
                        activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
                        // If this is an uninterrupted revalidation, we remain in our current idle
                        // state.  If not, we need to switch to our loading state and load data,
                        // preserving any new action data or existing action data (in the case of
                        // a revalidation interrupting an actionReload)
                        // If we have partialHydration enabled, then don't update the state for the
                        // initial data load since it's not a "navigation"
                        shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        if (shouldUpdateNavigationState) {
                            actionData = getUpdatedActionData(pendingActionResult);
                            updateState(_extends({
                                navigation: loadingNavigation
                            }, actionData !== undefined ? {
                                actionData: actionData
                            } : {}), {
                                flushSync: flushSync
                            });
                        }
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    loaderData: {},
                                    errors: (0, $72osQ._)({}, boundaryId, discoverResult.error)
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    errors: (0, $72osQ._)({}, route.id, error)
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, $2nwvT._)(getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Cancel pending deferreds for no-longer-matched routes or routes we're
                        // about to reload.  Note that if this is an action reload we would have
                        // already cancelled all pending deferreds so this would be a no-op
                        cancelActiveDeferreds(function(routeId) {
                            return !(matches && matches.some(function(m) {
                                return m.route.id === routeId;
                            })) || matchesToLoad && matchesToLoad.some(function(m) {
                                return m.route.id === routeId;
                            });
                        });
                        pendingNavigationLoadId = ++incrementingLoadId;
                        // Short circuit if we have no loaders to run
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            updatedFetchers = markFetchRedirectsDone();
                            completeNavigation(location, _extends({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? (0, $72osQ._)({}, pendingActionResult[0], pendingActionResult[1].error) : null
                            }, getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {}), {
                                flushSync: flushSync
                            });
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        if (shouldUpdateNavigationState) {
                            updates = {};
                            if (!isFogOfWar) {
                                // Only update navigation/actionNData if we didn't already do it above
                                updates.navigation = loadingNavigation;
                                actionData1 = getUpdatedActionData(pendingActionResult);
                                if (actionData1 !== undefined) updates.actionData = actionData1;
                            }
                            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
                            updateState(updates, {
                                flushSync: flushSync
                            });
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            abortFetcher(rf.key);
                            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
                            // (via deleteFetcher) does not abort the triggering navigation that
                            // triggered the revalidation
                            fetchControllers.set(rf.key, rf.controller);
                        });
                        // Proxy navigation abort through to revalidation fetchers
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 3:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        // Clean up _after_ loaders have completed.  Don't clean up if we short
                        // circuited because fetchControllers would have been aborted and
                        // reassigned to new controllers for the next navigation
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        });
                        // If any loaders returned a redirect Response, start a new REPLACE navigation
                        redirect = findRedirect(loaderResults);
                        if (!redirect) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            startRedirectNavigation(request, redirect.result, true, {
                                replace: replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        redirect = findRedirect(fetcherResults);
                        if (!redirect) return [
                            3,
                            7
                        ];
                        // If this redirect came from a fetcher make sure we mark it in
                        // fetchRedirectIds so it doesn't get revalidated on the next set of
                        // loader executions
                        fetchRedirectIds.add(redirect.key);
                        return [
                            4,
                            startRedirectNavigation(request, redirect.result, true, {
                                replace: replace
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        // Process and commit output from loaders
                        _processLoaderData = processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Wire up subscribers to update loaderData as promises settle
                        activeDeferreds.forEach(function(deferredData, routeId) {
                            deferredData.subscribe(function(aborted) {
                                // Note: No need to updateState here since the TrackedPromise on
                                // loaderData is stable across resolve/reject
                                // Remove this instance if we were aborted or if promises have settled
                                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
                            });
                        });
                        // Preserve SSR errors during partial hydration
                        if (future.v7_partialHydration && initialHydration && state.errors) errors = _extends({}, state.errors, errors);
                        updatedFetchers1 = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers1 || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            _extends({
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        })();
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return (0, $72osQ._)({}, pendingActionResult[0], pendingActionResult[1].data);
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach(function(rf) {
            var fetcher = state.fetchers.get(rf.key);
            var revalidatingFetcher = getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        var flushSync = (opts && opts.flushSync) === true;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        var matches = matchRoutes(routesToUse, normalizedPath, basename);
        var fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        var _normalizeNavigateOptions = normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        var match = getTargetMatch(matches, path);
        var preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var existingFetcher, abortController, fetchRequest, discoverResult, originatingLoadId, actionResults, actionResult, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect, _processLoaderData, loaderData, errors, doneFetcher;
            function detectAndHandle405Error(m) {
                if (!m.route.action && !m.route.lazy) {
                    var error = getInternalRouterError(405, {
                        method: submission.formMethod,
                        pathname: path,
                        routeId: routeId
                    });
                    setFetcherError(key, routeId, error, {
                        flushSync: flushSync
                    });
                    return true;
                }
                return false;
            }
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        if (!isFogOfWar && detectAndHandle405Error(match)) return [
                            2
                        ];
                        // Put this fetcher into it's submitting state
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(requestMatches, path, fetchRequest.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            setFetcherError(key, routeId, discoverResult.error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else {
                            requestMatches = discoverResult.matches;
                            match = getTargetMatch(requestMatches, path);
                            if (detectAndHandle405Error(match)) return [
                                2
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        // Call the action for the fetcher
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy("action", state, fetchRequest, [
                                match
                            ], requestMatches, key)
                        ];
                    case 3:
                        actionResults = _state.sent();
                        actionResult = actionResults[match.route.id];
                        if (fetchRequest.signal.aborted) {
                            // We can delete this so long as we weren't aborted by our own fetcher
                            // re-submit which would have put _new_ controller is in fetchControllers
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
                        // or redirects processed for unmounted fetchers so we just revert them to
                        // idle
                        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
                            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                                updateFetcherState(key, getDoneFetcher(undefined));
                                return [
                                    2
                                ];
                            }
                        } else {
                            if (isRedirectResult(actionResult)) {
                                fetchControllers.delete(key);
                                if (pendingNavigationLoadId > originatingLoadId) {
                                    // A new navigation was kicked off after our action started, so that
                                    // should take precedence over this redirect navigation.  We already
                                    // set isRevalidationRequired so all loaders for the new route should
                                    // fire unless opted out via shouldRevalidate
                                    updateFetcherState(key, getDoneFetcher(undefined));
                                    return [
                                        2
                                    ];
                                } else {
                                    fetchRedirectIds.add(key);
                                    updateFetcherState(key, getLoadingFetcher(submission));
                                    return [
                                        2,
                                        startRedirectNavigation(fetchRequest, actionResult, false, {
                                            fetcherSubmission: submission,
                                            preventScrollReset: preventScrollReset
                                        })
                                    ];
                                }
                            }
                            // Process any non-redirect errors thrown
                            if (isErrorResult(actionResult)) {
                                setFetcherError(key, routeId, actionResult.error);
                                return [
                                    2
                                ];
                            }
                        }
                        if (isDeferredResult(actionResult)) throw getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        // Start the data load for current matches, or the next location if we're
                        // in the middle of a navigation
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
                        invariant(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = getLoadingFetcher(submission, actionResult.data);
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, $2nwvT._)(getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
                            match.route.id,
                            actionResult
                        ]), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Put all revalidating fetchers into the loading state, except for the
                        // current fetcher which we want to keep in it's current loading state which
                        // contains it's action submission info + action data
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = state.fetchers.get(staleKey);
                            var revalidatingFetcher = getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 4:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        redirect = findRedirect(loaderResults);
                        if (redirect) return [
                            2,
                            startRedirectNavigation(revalidationRequest, redirect.result, false, {
                                preventScrollReset: preventScrollReset
                            })
                        ];
                        redirect = findRedirect(fetcherResults);
                        if (redirect) {
                            // If this redirect came from a fetcher make sure we mark it in
                            // fetchRedirectIds so it doesn't get revalidated on the next set of
                            // loader executions
                            fetchRedirectIds.add(redirect.key);
                            return [
                                2,
                                startRedirectNavigation(revalidationRequest, redirect.result, false, {
                                    preventScrollReset: preventScrollReset
                                })
                            ];
                        }
                        // Process and commit output from loaders
                        _processLoaderData = processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Since we let revalidations complete even if the submitting fetcher was
                        // deleted, only put it back to idle if it hasn't been deleted
                        if (state.fetchers.has(key)) {
                            doneFetcher = getDoneFetcher(actionResult.data);
                            state.fetchers.set(key, doneFetcher);
                        }
                        abortStaleFetchLoads(loadId);
                        // If we are currently in a navigation loading state and this fetcher is
                        // more recent than the navigation, we want the newer data so abort the
                        // navigation and complete it with the fetcher data
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            invariant(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            // otherwise just update with the fetcher data, preserving any existing
                            // loaderData for loaders that did not need to reload.  We have to
                            // manually merge here since we aren't going through completeNavigation
                            updateState({
                                errors: errors,
                                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                                fetchers: new Map(state.fetchers)
                            });
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var existingFetcher, abortController, fetchRequest, discoverResult, originatingLoadId, results, result;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, path, fetchRequest.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            setFetcherError(key, routeId, discoverResult.error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else {
                            matches = discoverResult.matches;
                            match = getTargetMatch(matches, path);
                        }
                        _state.label = 2;
                    case 2:
                        // Call the loader for this fetcher route match
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy("loader", state, fetchRequest, [
                                match
                            ], matches, key)
                        ];
                    case 3:
                        results = _state.sent();
                        result = results[match.route.id];
                        if (!isDeferredResult(result)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            resolveDeferredData(result, fetchRequest.signal, true)
                        ];
                    case 4:
                        result = _state.sent() || result;
                        _state.label = 5;
                    case 5:
                        // We can delete this so long as we weren't aborted by our our own fetcher
                        // re-load which would have put _new_ controller is in fetchControllers
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        // We don't want errors bubbling up or redirects followed for unmounted
                        // fetchers, so short circuit here if it was removed from the UI
                        if (deletedFetchers.has(key)) {
                            updateFetcherState(key, getDoneFetcher(undefined));
                            return [
                                2
                            ];
                        }
                        if (!isRedirectResult(result)) return [
                            3,
                            8
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            6
                        ];
                        // A new navigation was kicked off after our loader started, so that
                        // should take precedence over this redirect navigation
                        updateFetcherState(key, getDoneFetcher(undefined));
                        return [
                            2
                        ];
                    case 6:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(fetchRequest, result, false, {
                                preventScrollReset: preventScrollReset
                            })
                        ];
                    case 7:
                        _state.sent();
                        return [
                            2
                        ];
                    case 8:
                        // Process any non-redirect errors thrown
                        if (isErrorResult(result)) {
                            setFetcherError(key, routeId, result.error);
                            return [
                                2
                            ];
                        }
                        invariant(!isDeferredResult(result), "Unhandled fetcher deferred data");
                        // Put the fetcher back into an idle state
                        updateFetcherState(key, getDoneFetcher(result.data));
                        return [
                            2
                        ];
                }
            });
        })();
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var _ref, submission, fetcherSubmission, preventScrollReset, replace, location, redirectLocation, isDocumentReload, url, redirectHistoryAction, _state_navigation, formMethod, formAction, formEncType, activeSubmission, overrideNavigation;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp2 === void 0 ? {} : _temp2, submission = _ref.submission, fetcherSubmission = _ref.fetcherSubmission, preventScrollReset = _ref.preventScrollReset, replace = _ref.replace;
                        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
                        location = redirect.response.headers.get("Location");
                        invariant(location, "Expected a Location header on the redirect Response");
                        location = normalizeRedirectLocation(location, new URL(request.url), basename);
                        redirectLocation = createLocation(state.location, location, {
                            _isRedirect: true
                        });
                        if (isBrowser) {
                            isDocumentReload = false;
                            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
                            isDocumentReload = true;
                            else if (ABSOLUTE_URL_REGEX.test(location)) {
                                url = init.history.createURL(location);
                                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                                stripBasename(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace) routerWindow.location.replace(location);
                                else routerWindow.location.assign(location);
                                return [
                                    2
                                ];
                            }
                        }
                        // There's no need to abort on redirects, since we don't detect the
                        // redirect until the action/loaders have settled
                        pendingNavigationController = null;
                        redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? Action.Replace : Action.Push;
                        // Use the incoming submission if provided, fallback on the active one in
                        // state.navigation
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType;
                        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
                        // If this was a 307/308 submission we want to preserve the HTTP method and
                        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
                        // redirected location
                        activeSubmission = submission || fetcherSubmission;
                        if (!(redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                submission: _extends({}, activeSubmission, {
                                    formAction: location
                                }),
                                // Preserve these flags across redirects
                                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        // If we have a navigation submission, we will preserve it through the
                        // redirect navigation
                        overrideNavigation = getLoadingNavigation(redirectLocation, submission);
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Send fetcher submissions through for shouldRevalidate
                                fetcherSubmission: fetcherSubmission,
                                // Preserve these flags across redirects
                                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var results, dataResults, e, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, routeId, result, response, err;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dataResults = {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties)
                        ];
                    case 2:
                        results = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        // If the outer dataStrategy method throws, just return the error for all
                        // matches - and it'll naturally bubble to the root
                        matchesToLoad.forEach(function(m) {
                            dataResults[m.route.id] = {
                                type: ResultType.error,
                                error: e
                            };
                        });
                        return [
                            2,
                            dataResults
                        ];
                    case 4:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            11,
                            12,
                            13
                        ]);
                        _iterator = Object.entries(results)[Symbol.iterator]();
                        _state.label = 6;
                    case 6:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            10
                        ];
                        _step_value = (0, $2nwvT._)(_step.value, 2), routeId = _step_value[0], result = _step_value[1];
                        if (!isRedirectDataStrategyResultResult(result)) return [
                            3,
                            7
                        ];
                        response = result.result;
                        dataResults[routeId] = {
                            type: ResultType.redirect,
                            response: normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
                        };
                        return [
                            3,
                            9
                        ];
                    case 7:
                        return [
                            4,
                            convertDataStrategyResultToDataResult(result)
                        ];
                    case 8:
                        dataResults[routeId] = _state.sent();
                        _state.label = 9;
                    case 9:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            6
                        ];
                    case 10:
                        return [
                            3,
                            13
                        ];
                    case 11:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 12:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2,
                            dataResults
                        ];
                }
            });
        })();
    }
    function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var currentMatches, loaderResultsPromise, fetcherResultsPromise, loaderResults, fetcherResults;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        currentMatches = state.matches;
                        // Kick off loaders and fetchers in parallel
                        loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
                        fetcherResultsPromise = Promise.all(fetchersToLoad.map(function(f) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
                                var results, result;
                                return (0, $fRv9I.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(f.matches && f.match && f.controller)) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                callDataStrategy("loader", state, createClientSideRequest(init.history, f.path, f.controller.signal), [
                                                    f.match
                                                ], f.matches, f.key)
                                            ];
                                        case 1:
                                            results = _state.sent();
                                            result = results[f.match.route.id];
                                            // Fetcher results are keyed by fetcher key from here on out, not routeId
                                            return [
                                                2,
                                                (0, $72osQ._)({}, f.key, result)
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                Promise.resolve((0, $72osQ._)({}, f.key, {
                                                    type: ResultType.error,
                                                    error: getInternalRouterError(404, {
                                                        pathname: f.path
                                                    })
                                                }))
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        }));
                        return [
                            4,
                            loaderResultsPromise
                        ];
                    case 1:
                        loaderResults = _state.sent();
                        return [
                            4,
                            fetcherResultsPromise
                        ];
                    case 2:
                        fetcherResults = _state.sent().reduce(function(acc, r) {
                            return Object.assign(acc, r);
                        }, {});
                        return [
                            4,
                            Promise.all([
                                resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
                                resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
                            ])
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2,
                            {
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        })();
    }
    function interruptActiveLoads() {
        var // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        _cancelledDeferredRoutes;
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        (_cancelledDeferredRoutes = cancelledDeferredRoutes).push.apply(_cancelledDeferredRoutes, (0, $2us1u._)(cancelActiveDeferreds()));
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        var boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, $72osQ._)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function deleteFetcher(key) {
        var fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            var count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = getDoneFetcher(fetcher.data);
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                invariant(fetcher, "Expected fetcher: " + key);
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $2nwvT._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    invariant(fetcher, "Expected fetcher: " + key);
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        var currentLocation = _ref2.currentLocation, nextLocation = _ref2.nextLocation, historyAction = _ref2.historyAction;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $2nwvT._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        var error = getInternalRouterError(404, {
            pathname: pathname
        });
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var _getShortCircuitMatches = getShortCircuitMatches(routesToUse), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        var cancelledRouteIds = [];
        activeDeferreds.forEach(function(dfd, routeId) {
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            var key = getScrollRestorationKey(location, matches.map(function(m) {
                return convertRouteMatchToUiMatch(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                var fogMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                var partialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    function discoverRoutes(matches, pathname, signal) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var _loop, partialMatches, _ret;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _loop = function() {
                            var isNonHMR, routesToUse, localManifest, e, newMatches, newPartialMatches;
                            return (0, $fRv9I.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        isNonHMR = inFlightDataRoutes == null;
                                        routesToUse = inFlightDataRoutes || dataRoutes;
                                        localManifest = manifest;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            4,
                                            5
                                        ]);
                                        return [
                                            4,
                                            patchRoutesOnNavigationImpl({
                                                path: pathname,
                                                matches: partialMatches,
                                                patch: function(routeId, children) {
                                                    if (signal.aborted) return;
                                                    patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                                                }
                                            })
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        e = _state.sent();
                                        return [
                                            2,
                                            {
                                                v: {
                                                    type: "error",
                                                    error: e,
                                                    partialMatches: partialMatches
                                                }
                                            }
                                        ];
                                    case 4:
                                        // If we are not in the middle of an HMR revalidation and we changed the
                                        // routes, provide a new identity so when we `updateState` at the end of
                                        // this navigation/fetch `router.routes` will be a new identity and
                                        // trigger a re-run of memoized `router.routes` dependencies.
                                        // HMR will already update the identity and reflow when it lands
                                        // `inFlightDataRoutes` in `completeNavigation`
                                        if (isNonHMR && !signal.aborted) dataRoutes = (0, $2us1u._)(dataRoutes);
                                        return [
                                            7
                                        ];
                                    case 5:
                                        if (signal.aborted) return [
                                            2,
                                            {
                                                v: {
                                                    type: "aborted"
                                                }
                                            }
                                        ];
                                        newMatches = matchRoutes(routesToUse, pathname, basename);
                                        if (newMatches) return [
                                            2,
                                            {
                                                v: {
                                                    type: "success",
                                                    matches: newMatches
                                                }
                                            }
                                        ];
                                        newPartialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                                        // Avoid loops if the second pass results in the same partial matches
                                        if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every(function(m, i) {
                                            return m.route.id === newPartialMatches[i].route.id;
                                        })) return [
                                            2,
                                            {
                                                v: {
                                                    type: "success",
                                                    matches: null
                                                }
                                            }
                                        ];
                                        partialMatches = newPartialMatches;
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        if (!patchRoutesOnNavigationImpl) return [
                            2,
                            {
                                type: "success",
                                matches: matches
                            }
                        ];
                        partialMatches = matches;
                        _state.label = 1;
                    case 1:
                        if (!true) return [
                            3,
                            3
                        ];
                        return [
                            5,
                            (0, $fRv9I.__values)(_loop())
                        ];
                    case 2:
                        _ret = _state.sent();
                        if ((0, $bJtXW._)(_ret) === "object") return [
                            2,
                            _ret.v
                        ];
                        return [
                            3,
                            1
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        var isNonHMR = inFlightDataRoutes == null;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = (0, $2us1u._)(dataRoutes);
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var UNSAFE_DEFERRED_SYMBOL = Symbol("deferred");
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = defaultMapRouteProperties;
    // Config driven behavior flags
    var future = _extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    var dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ function query(request, _temp3) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var _ref, requestContext, skipLoaderErrorBubbling, dataStrategy, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp3 === void 0 ? {} : _temp3, requestContext = _ref.requestContext, skipLoaderErrorBubbling = _ref.skipLoaderErrorBubbling, dataStrategy = _ref.dataStrategy;
                        url = new URL(request.url);
                        method = request.method;
                        location = createLocation("", createPath(url), null, "default");
                        matches = matchRoutes(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!isValidMethod(method) && method !== "HEAD") {
                            error = getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $72osQ._)({}, route.id, error),
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        } else if (!matches) {
                            error1 = getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $72osQ._)({}, route1.id, error1),
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null)
                        ];
                    case 1:
                        result = _state.sent();
                        if (isResponse(result)) return [
                            2,
                            result
                        ];
                        // When returning StaticHandlerContext, we patch back in the location here
                        // since we need it for React Context.  But this helps keep our submit and
                        // loadRouteData operating on a Request instead of a Location
                        return [
                            2,
                            _extends({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        })();
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ function queryRoute(request, _temp4) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var _ref, routeId, requestContext, dataStrategy, url, method, location, matches, match, result, error, _result$activeDeferre, data;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp4 === void 0 ? {} : _temp4, routeId = _ref.routeId, requestContext = _ref.requestContext, dataStrategy = _ref.dataStrategy;
                        url = new URL(request.url);
                        method = request.method;
                        location = createLocation("", createPath(url), null, "default");
                        matches = matchRoutes(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : getTargetMatch(matches, location);
                        if (routeId && !match) throw getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) // This should never hit I don't think?
                        throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if (isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : undefined;
                        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
                        // _something_ that wasn't a Response, but it's not guaranteed/required
                        // to be an `instanceof Error` either, so we have to use throw here to
                        // preserve the "error" state outside of queryImpl.
                        throw error;
                        // Pick off the right state value to return
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) {
                            ;
                            data = Object.values(result.loaderData)[0];
                            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[UNSAFE_DEFERRED_SYMBOL] = result.activeDeferreds[match.route.id];
                            return [
                                2,
                                data
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        })();
    }
    function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var result, result1, e;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!isMutationMethod(request.method.toLowerCase())) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch)
                        ];
                    case 4:
                        result1 = _state.sent();
                        return [
                            2,
                            isResponse(result1) ? result1 : _extends({}, result1, {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        // If the user threw/returned a Response in callLoaderOrAction for a
                        // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
                        // and then return or throw the raw Response here accordingly
                        if (isDataStrategyResult(e) && isResponse(e.result)) {
                            if (e.type === ResultType.error) throw e.result;
                            return [
                                2,
                                e.result
                            ];
                        }
                        // Redirects are always returned since they don't propagate to catch
                        // boundaries
                        if (isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var result, error, results, error1, loaderRequest, boundaryMatch, context, context1;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: ResultType.error,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            callDataStrategy("action", request, [
                                actionMatch
                            ], matches, isRouteRequest, requestContext, dataStrategy)
                        ];
                    case 2:
                        results = _state.sent();
                        result = results[actionMatch.route.id];
                        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        _state.label = 3;
                    case 3:
                        if (isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
                        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
                        // can get back on the "throw all redirect responses" train here should
                        // this ever happen :/
                        throw new Response(null, {
                            status: result.response.status,
                            headers: {
                                Location: result.response.headers.get("Location")
                            }
                        });
                        if (isDeferredResult(result)) {
                            error1 = getInternalRouterError(400, {
                                type: "defer-action"
                            });
                            if (isRouteRequest) throw error1;
                            result = {
                                type: ResultType.error,
                                error: error1
                            };
                        }
                        if (isRouteRequest) {
                            // Note: This should only be non-Response values if we get here, since
                            // isRouteRequest should throw any Response received in callLoaderOrAction
                            if (isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $72osQ._)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        // Create a GET request for the loaders
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        if (!isErrorResult(result)) return [
                            3,
                            5
                        ];
                        // Store off the pending error - we use it to determine which loaders
                        // to call and will commit it when we complete the navigation
                        boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                                boundaryMatch.route.id,
                                result
                            ])
                        ];
                    case 4:
                        context = _state.sent();
                        // action status codes take precedence over loader status codes
                        return [
                            2,
                            _extends({}, context, {
                                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                                actionData: null,
                                actionHeaders: _extends({}, result.headers ? (0, $72osQ._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null)
                        ];
                    case 6:
                        context1 = _state.sent();
                        return [
                            2,
                            _extends({}, context1, {
                                actionData: (0, $72osQ._)({}, actionMatch.route.id, result.data)
                            }, result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}, {
                                actionHeaders: result.headers ? (0, $72osQ._)({}, actionMatch.route.id, result.headers) : {}
                            })
                        ];
                }
            });
        })();
    }
    function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var isRouteRequest, requestMatches, matchesToLoad, results, activeDeferreds, context, executedLoaders;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        // Short circuit if we have no loaders to run (queryRoute())
                        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch == null ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : pendingActionResult && isErrorResult(pendingActionResult[1]) ? getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        });
                        // Short circuit if we have no loaders to run (query())
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches: matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, (0, $72osQ._)({}, m.route.id, null));
                                }, {}),
                                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? (0, $72osQ._)({}, pendingActionResult[0], pendingActionResult[1].error) : null,
                                statusCode: 200,
                                loaderHeaders: {},
                                activeDeferreds: null
                            }
                        ];
                        return [
                            4,
                            callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy)
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        // Process and commit output from loaders
                        activeDeferreds = new Map();
                        context = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
                        // Add a null for any non-loader matches for proper revalidation on the client
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            _extends({}, context, {
                                matches: matches,
                                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
                            })
                        ];
                }
            });
        })();
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var results, dataResults;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            callDataStrategyImpl(dataStrategy || defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext)
                        ];
                    case 1:
                        results = _state.sent();
                        dataResults = {};
                        return [
                            4,
                            Promise.all(matches.map(function(match) {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
                                    var result, response, _;
                                    return (0, $fRv9I.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!(match.route.id in results)) return [
                                                    2
                                                ];
                                                result = results[match.route.id];
                                                if (isRedirectDataStrategyResultResult(result)) {
                                                    response = result.result;
                                                    // Throw redirects and let the server handle them with an HTTP redirect
                                                    throw normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
                                                }
                                                if (isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
                                                // directly without unwrapping
                                                throw result;
                                                _ = match.route.id;
                                                return [
                                                    4,
                                                    convertDataStrategyResultToDataResult(result)
                                                ];
                                            case 1:
                                                dataResults[_] = _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            }))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            dataResults
                        ];
                }
            });
        })();
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function getStaticContextFromError(routes, context, error) {
    var newContext = _extends({}, context, {
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: (0, $72osQ._)({}, context._deepestRenderedBoundaryId || routes[0].id, error)
    });
    return newContext;
}
function throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    var method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    var path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches, v7_relativeSplatPath), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        var nakedIndex = hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            var params = new URLSearchParams(path.search);
            var indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter(function(v) {
                return v;
            }).forEach(function(v) {
                return params.append("index", v);
            });
            var qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path: path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    // Create a Submission on non-GET navigations
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    var formAction = stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, _ref3) {
                var _$_ref3 = (0, $2nwvT._)(_ref3, 2), name = _$_ref3[0], value = _$_ref3[1];
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if (isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    var parsedPath = parsePath(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: createPath(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    var index = matches.findIndex(function(m) {
        return m.route.id === boundaryId;
    });
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    var actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    var boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    var actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    var shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        var route = match.route;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if (isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function(id) {
            return id === match.route.id;
        })) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return shouldRevalidateLoader(match, _extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some(function(m) {
            return m.route.id === f.routeId;
        }) || deletedFetchers.has(key)) return;
        var fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        var fetcher = state.fetchers.get(key);
        var fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        var shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = shouldRevalidateLoader(fetcherMatch, _extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    var hasData = loaderData != null && loaderData[route.id] !== undefined;
    var hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    var isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    var _childrenToPatch1;
    var childrenToPatch;
    if (routeId) {
        var route = manifest[routeId];
        invariant(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    var uniqueChildren = children.filter(function(newRoute) {
        return !childrenToPatch.some(function(existingRoute) {
            return isSameRoute(newRoute, existingRoute);
        });
    });
    var newRoutes = convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch1 = childrenToPatch) == null ? void 0 : _childrenToPatch1.length) || "0")
    ], manifest);
    (_childrenToPatch = childrenToPatch).push.apply(_childrenToPatch, (0, $2us1u._)(newRoutes));
}
function isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every(function(aChild, i) {
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some(function(bChild) {
            return isSameRoute(aChild, bChild);
        });
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ function loadLazyRouteModule(route, mapRouteProperties, manifest) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    // If the lazy route function was executed and removed by another parallel
                    // call then we can return - first lazy() to finish wins because the return
                    // value of lazy is expected to be static
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    invariant(routeToUpdate, "No route found in manifest");
                    // Update the route in place.  This should be safe because there's no way
                    // we could yet be sitting on this route as we can't get there without
                    // resolving lazy() first.
                    //
                    // This is different than the HMR "update" use-case where we may actively be
                    // on the route being updated.  The main concern boils down to "does this
                    // mutation affect any ongoing navigations or any current state.matches
                    // values?".  If not, it should be safe to update in place.
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        warning(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
                        if (!isPropertyStaticallyDefined && !immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    }
                    // Mutate the route with the provided updates.  Do this first so we pass
                    // the updated version to mapRouteProperties
                    Object.assign(routeToUpdate, routeUpdates);
                    // Mutate the `hasErrorBoundary` property on the route based on the route
                    // updates and remove the `lazy` function so we don't resolve the lazy
                    // route again.
                    Object.assign(routeToUpdate, _extends({}, mapRouteProperties(routeToUpdate), {
                        lazy: undefined
                    }));
                    return [
                        2
                    ];
            }
        });
    })();
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function defaultDataStrategy(_ref4) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
        var matches, matchesToLoad, results;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    matches = _ref4.matches;
                    matchesToLoad = matches.filter(function(m) {
                        return m.shouldLoad;
                    });
                    return [
                        4,
                        Promise.all(matchesToLoad.map(function(m) {
                            return m.resolve();
                        }))
                    ];
                case 1:
                    results = _state.sent();
                    return [
                        2,
                        results.reduce(function(acc, result, i) {
                            return Object.assign(acc, (0, $72osQ._)({}, matchesToLoad[i].route.id, result));
                        }, {})
                    ];
            }
        });
    })();
}
function callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
        var loadRouteDefinitionsPromises, dsMatches, results, e;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    loadRouteDefinitionsPromises = matches.map(function(m) {
                        return m.route.lazy ? loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined;
                    });
                    dsMatches = matches.map(function(match, i) {
                        var loadRoutePromise = loadRouteDefinitionsPromises[i];
                        var shouldLoad = matchesToLoad.some(function(m) {
                            return m.route.id === match.route.id;
                        });
                        // `resolve` encapsulates route.lazy(), executing the loader/action,
                        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
                        // can pass a callback to take fine-grained control over the execution
                        // of the loader/action
                        var resolve = function(handlerOverride) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
                                return (0, $fRv9I.__generator)(this, function(_state) {
                                    if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
                                    return [
                                        2,
                                        shouldLoad ? callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                                            type: ResultType.data,
                                            result: undefined
                                        })
                                    ];
                                });
                            })();
                        };
                        return _extends({}, match, {
                            shouldLoad: shouldLoad,
                            resolve: resolve
                        });
                    });
                    return [
                        4,
                        dataStrategyImpl({
                            matches: dsMatches,
                            request: request,
                            params: matches[0].params,
                            fetcherKey: fetcherKey,
                            context: requestContext
                        })
                    ];
                case 1:
                    results = _state.sent();
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        Promise.all(loadRouteDefinitionsPromises)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2,
                        results
                    ];
            }
        });
    })();
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
function callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
        var result, onReject, runHandler, handler, handlerError, _ref, value, url, pathname, url1, pathname1, e;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    runHandler = function(handler) {
                        // Setup a promise we can race against so that abort signals short circuit
                        var reject;
                        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
                        // satisfy the function return value
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        var actualHandler = function(ctx) {
                            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
                            return handler.apply(void 0, [
                                {
                                    request: request,
                                    params: match.params,
                                    context: staticContext
                                }
                            ].concat((0, $2us1u._)(ctx !== undefined ? [
                                ctx
                            ] : [])));
                        };
                        var handlerPromise = function() {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
                                var val, e;
                                return (0, $fRv9I.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _state.trys.push([
                                                0,
                                                2,
                                                ,
                                                3
                                            ]);
                                            return [
                                                4,
                                                handlerOverride ? handlerOverride(function(ctx) {
                                                    return actualHandler(ctx);
                                                }) : actualHandler()
                                            ];
                                        case 1:
                                            val = _state.sent();
                                            return [
                                                2,
                                                {
                                                    type: "data",
                                                    result: val
                                                }
                                            ];
                                        case 2:
                                            e = _state.sent();
                                            return [
                                                2,
                                                {
                                                    type: "error",
                                                    result: e
                                                }
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        }();
                        return Promise.race([
                            handlerPromise,
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = match.route[type];
                    if (!loadRoutePromise) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            // If the handler throws, don't let it immediately bubble out,
                            // since we need to let the lazy() execution finish so we know if this
                            // route has a boundary that can handle the error
                            runHandler(handler).catch(function(e) {
                                handlerError = e;
                            }),
                            loadRoutePromise
                        ])
                    ];
                case 2:
                    _ref = (0, $2nwvT._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), value = _ref[0];
                    if (handlerError !== undefined) throw handlerError;
                    result = value;
                    return [
                        3,
                        7
                    ];
                case 3:
                    // Load lazy route module, then run any returned handler
                    return [
                        4,
                        loadRoutePromise
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    // Handler still runs even if we got interrupted to maintain consistency
                    // with un-abortable behavior of handler execution on non-lazy or
                    // previously-lazy-loaded routes
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else // lazy() route has no loader to run.  Short circuit here so we don't
                    // hit the invariant below that errors on returning undefined.
                    return [
                        2,
                        {
                            type: ResultType.data,
                            result: undefined
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    invariant(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    // We should already be catching and converting normal handler executions to
                    // DataStrategyResults and returning them, so anything that throws here is an
                    // unexpected error we still need to wrap
                    return [
                        2,
                        {
                            type: ResultType.error,
                            result: e
                        }
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    return [
                        2,
                        result
                    ];
            }
        });
    })();
}
function convertDataStrategyResultToDataResult(dataStrategyResult) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
        var result, type, data, contentType, e, _result$init2, _result$init, _result$init3, _result$init4, _result$init5, _result$init6;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    result = dataStrategyResult.result, type = dataStrategyResult.type;
                    if (!isResponse(result)) return [
                        3,
                        10
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        ,
                        9
                    ]);
                    contentType = result.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        5
                    ];
                    if (!(result.body == null)) return [
                        3,
                        2
                    ];
                    data = null;
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        result.json()
                    ];
                case 3:
                    data = _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        7
                    ];
                case 5:
                    return [
                        4,
                        result.text()
                    ];
                case 6:
                    data = _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        9
                    ];
                case 8:
                    e = _state.sent();
                    return [
                        2,
                        {
                            type: ResultType.error,
                            error: e
                        }
                    ];
                case 9:
                    if (type === ResultType.error) return [
                        2,
                        {
                            type: ResultType.error,
                            error: new ErrorResponseImpl(result.status, result.statusText, data),
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 10:
                    if (type === ResultType.error) {
                        if (isDataWithResponseInit(result)) {
                            ;
                            if (result.data instanceof Error) {
                                ;
                                return [
                                    2,
                                    {
                                        type: ResultType.error,
                                        error: result.data,
                                        statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                                    }
                                ];
                            }
                            // Convert thrown data() to ErrorResponse instances
                            result = new ErrorResponseImpl(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
                        }
                        return [
                            2,
                            {
                                type: ResultType.error,
                                error: result,
                                statusCode: isRouteErrorResponse(result) ? result.status : undefined
                            }
                        ];
                    }
                    if (isDeferredData(result)) {
                        ;
                        return [
                            2,
                            {
                                type: ResultType.deferred,
                                deferredData: result,
                                statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
                                headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
                            }
                        ];
                    }
                    if (isDataWithResponseInit(result)) {
                        ;
                        return [
                            2,
                            {
                                type: ResultType.data,
                                data: result.data,
                                statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
                                headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: result
                        }
                    ];
            }
        });
    })();
}
// Support relative routing in internal redirects
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    var location = response.headers.get("Location");
    invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!ABSOLUTE_URL_REGEX.test(location)) {
        var trimmedMatches = matches.slice(0, matches.findIndex(function(m) {
            return m.route.id === routeId;
        }) + 1);
        location = normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function normalizeRedirectLocation(location, currentUrl, basename) {
    if (ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        var normalizedLocation = location;
        var url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        var isSameBasename = stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL(stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $2nwvT._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $2nwvT._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    var pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach(function(match) {
        if (!(match.route.id in results)) return;
        var id = match.route.id;
        var result = results[id];
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            var error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                var boundaryMatch = findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if (isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = (0, $72osQ._)({}, pendingActionResult[0], pendingError);
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    var _processRouteLoaderData = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    ), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach(function(rf) {
        var key = rf.key, match = rf.match, controller = rf.controller;
        var result = fetcherResults[key];
        invariant(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if (isErrorResult(result)) {
            var boundaryMatch = findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = _extends({}, errors, (0, $72osQ._)({}, boundaryMatch.route.id, result.error));
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        invariant(false, "Unhandled fetcher revalidation redirect");
        else if (isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        invariant(false, "Unhandled fetcher deferred data");
        else {
            var doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = _extends({}, newLoaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (newLoaderData.hasOwnProperty(id)) {
                if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
            } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
            // wasn't removed by HMR
            mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: (0, $72osQ._)({}, pendingActionResult[0], pendingActionResult[1].data)
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $2us1u._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    var route = routes.length === 1 ? routes[0] : routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function getInternalRouterError(status, _temp5) {
    var _ref = _temp5 === void 0 ? {} : _temp5, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type, message = _ref.message;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function findRedirect(results) {
    var entries = Object.entries(results);
    for(var i = entries.length - 1; i >= 0; i--){
        var _entries_i = (0, $2nwvT._)(entries[i], 2), key = _entries_i[0], result = _entries_i[1];
        if (isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath(_extends({}, parsedPath, {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function isDataStrategyResult(result) {
    return result != null && (typeof result === "undefined" ? "undefined" : (0, $bJtXW._)(result)) === "object" && "type" in result && "result" in result && (result.type === ResultType.data || result.type === ResultType.error);
}
function isRedirectDataStrategyResultResult(result) {
    return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isDeferredResult(result) {
    return result.type === ResultType.deferred;
}
function isErrorResult(result) {
    return result.type === ResultType.error;
}
function isRedirectResult(result) {
    return (result && result.type) === ResultType.redirect;
}
function isDataWithResponseInit(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function isDeferredData(value) {
    var deferred = value;
    return deferred && (typeof deferred === "undefined" ? "undefined" : (0, $bJtXW._)(deferred)) === "object" && (0, $bJtXW._)(deferred.data) === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && (0, $bJtXW._)(value.headers) === "object" && typeof value.body !== "undefined";
}
function isRedirectResponse(result) {
    if (!isResponse(result)) return false;
    var status = result.status;
    var location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toLowerCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toLowerCase());
}
function resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
        var _loop, entries, index;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var _entries_index, routeId, result, match, currentMatch, isRevalidatingLoader;
                        return (0, $fRv9I.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _entries_index = (0, $2nwvT._)(entries[index], 2), routeId = _entries_index[0], result = _entries_index[1];
                                    match = matches.find(function(m) {
                                        return (m == null ? void 0 : m.route.id) === routeId;
                                    });
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    currentMatch = currentMatches.find(function(m) {
                                        return m.route.id === match.route.id;
                                    });
                                    isRevalidatingLoader = currentMatch != null && !isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                                    if (!(isDeferredResult(result) && isRevalidatingLoader)) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    return [
                                        4,
                                        resolveDeferredData(result, signal, false).then(function(result) {
                                            if (result) results[routeId] = result;
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    entries = Object.entries(results);
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < entries.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $fRv9I.__values)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}
function resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
        var _loop, index;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var _revalidatingFetchers_index, key, routeId, controller, result, match;
                        return (0, $fRv9I.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _revalidatingFetchers_index = revalidatingFetchers[index], key = _revalidatingFetchers_index.key, routeId = _revalidatingFetchers_index.routeId, controller = _revalidatingFetchers_index.controller;
                                    result = results[key];
                                    match = matches.find(function(m) {
                                        return (m == null ? void 0 : m.route.id) === routeId;
                                    });
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    if (!isDeferredResult(result)) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    invariant(controller, "Expected an AbortController for revalidating fetcher deferred result");
                                    return [
                                        4,
                                        resolveDeferredData(result, controller.signal, true).then(function(result) {
                                            if (result) results[key] = result;
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < revalidatingFetchers.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $fRv9I.__values)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}
function resolveDeferredData(result, signal, unwrap) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
        var aborted;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (unwrap === void 0) unwrap = false;
                    return [
                        4,
                        result.deferredData.resolveData(signal)
                    ];
                case 1:
                    aborted = _state.sent();
                    if (aborted) return [
                        2
                    ];
                    if (unwrap) try {
                        return [
                            2,
                            {
                                type: ResultType.data,
                                data: result.deferredData.unwrappedData
                            }
                        ];
                    } catch (e) {
                        // Handle any TrackedPromise._error values encountered while unwrapping
                        return [
                            2,
                            {
                                type: ResultType.error,
                                error: e
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: result.deferredData.data
                        }
                    ];
            }
        });
    })();
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
function getTargetMatch(matches, location) {
    var search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    var pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation1;
    }
}
function getSubmittingNavigation(location, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher1;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function getDoneFetcher(data) {
    var fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        var sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            var json = JSON.parse(sessionPositions);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(json || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $2nwvT._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                    if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        var json = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $2nwvT._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                json[k] = (0, $2us1u._)(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});
parcelRegister("g3gsR", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $baf9b2a64fedef68$export$71511d61b312f219; });
function $baf9b2a64fedef68$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $baf9b2a64fedef68$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $baf9b2a64fedef68$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $baf9b2a64fedef68$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("f3Okx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $af6e2d59c2ac092d$export$71511d61b312f219; });

var $gyGuQ = parcelRequire("gyGuQ");

var $ftVlM = parcelRequire("ftVlM");

var $gvVNz = parcelRequire("gvVNz");
function $af6e2d59c2ac092d$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $gyGuQ._)(derived);
    return (0, $gvVNz._)(_this, (0, $ftVlM._)() ? Reflect.construct(derived, args || [], (0, $gyGuQ._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("gyGuQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c0e0c9403f4e59d3$export$71511d61b312f219; });
function $c0e0c9403f4e59d3$export$71511d61b312f219(o) {
    $c0e0c9403f4e59d3$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c0e0c9403f4e59d3$export$71511d61b312f219(o);
}

});

parcelRegister("ftVlM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b4560d09ed0b6bd9$export$71511d61b312f219; });
function $b4560d09ed0b6bd9$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($b4560d09ed0b6bd9$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("gvVNz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $031a439d9bd8f8b3$export$71511d61b312f219; });

var $dcJGd = parcelRequire("dcJGd");

var $bJtXW = parcelRequire("bJtXW");
function $031a439d9bd8f8b3$export$71511d61b312f219(self, call) {
    if (call && ((0, $bJtXW._)(call) === "object" || typeof call === "function")) return call;
    return (0, $dcJGd._)(self);
}

});
parcelRegister("dcJGd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $99cfd4696d3ae8ed$export$71511d61b312f219; });
function $99cfd4696d3ae8ed$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("grujF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bf86af1e5034cb56$export$71511d61b312f219; });
function $bf86af1e5034cb56$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("dhMkv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9ac25a306229a9ff$export$71511d61b312f219; });
function $9ac25a306229a9ff$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9ac25a306229a9ff$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $9ac25a306229a9ff$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9ac25a306229a9ff$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("72osQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $51fbb26672273063$export$71511d61b312f219; });
function $51fbb26672273063$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("j6Mzi", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $de944088b801fe33$export$71511d61b312f219; });

var $fMryZ = parcelRequire("fMryZ");
function $de944088b801fe33$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $fMryZ._)(subClass, superClass);
}

});
parcelRegister("fMryZ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b7d0b832e35ee57e$export$71511d61b312f219; });
function $b7d0b832e35ee57e$export$71511d61b312f219(o, p) {
    $b7d0b832e35ee57e$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b7d0b832e35ee57e$export$71511d61b312f219(o, p);
}

});


parcelRegister("2nwvT", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1bb6f341c8f857d6$export$71511d61b312f219; });

var $1g4fM = parcelRequire("1g4fM");

var $aPFUy = parcelRequire("aPFUy");

var $9kJqn = parcelRequire("9kJqn");

var $2DD2t = parcelRequire("2DD2t");
function $1bb6f341c8f857d6$export$71511d61b312f219(arr, i) {
    return (0, $1g4fM._)(arr) || (0, $aPFUy._)(arr, i) || (0, $2DD2t._)(arr, i) || (0, $9kJqn._)();
}

});
parcelRegister("1g4fM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0eaa95b9f3cb7234$export$71511d61b312f219; });
function $0eaa95b9f3cb7234$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("aPFUy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7e2f2d8338cd036c$export$71511d61b312f219; });
function $7e2f2d8338cd036c$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("9kJqn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6cb937a794637792$export$71511d61b312f219; });
function $6cb937a794637792$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("2DD2t", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1ebd819a91fcf92e$export$71511d61b312f219; });

var $6exmR = parcelRequire("6exmR");
function $1ebd819a91fcf92e$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $6exmR._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $6exmR._)(o, minLen);
}

});
parcelRegister("6exmR", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $489def0a77882a2a$export$71511d61b312f219; });
function $489def0a77882a2a$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("l8eKX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f625ca9f0dc92caa$export$71511d61b312f219; });

var $1g4fM = parcelRequire("1g4fM");

var $eaxdf = parcelRequire("eaxdf");

var $9kJqn = parcelRequire("9kJqn");

var $2DD2t = parcelRequire("2DD2t");
function $f625ca9f0dc92caa$export$71511d61b312f219(arr) {
    return (0, $1g4fM._)(arr) || (0, $eaxdf._)(arr) || (0, $2DD2t._)(arr) || (0, $9kJqn._)();
}

});
parcelRegister("eaxdf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a50bc32ea5ddcbbf$export$71511d61b312f219; });
function $a50bc32ea5ddcbbf$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});


parcelRegister("2us1u", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1d041ee89e51af1b$export$71511d61b312f219; });

var $eYsRh = parcelRequire("eYsRh");

var $eaxdf = parcelRequire("eaxdf");

var $46sYX = parcelRequire("46sYX");

var $2DD2t = parcelRequire("2DD2t");
function $1d041ee89e51af1b$export$71511d61b312f219(arr) {
    return (0, $eYsRh._)(arr) || (0, $eaxdf._)(arr) || (0, $2DD2t._)(arr) || (0, $46sYX._)();
}

});
parcelRegister("eYsRh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ae6d0dee9f5eb3eb$export$71511d61b312f219; });

var $6exmR = parcelRequire("6exmR");
function $ae6d0dee9f5eb3eb$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $6exmR._)(arr);
}

});

parcelRegister("46sYX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2fce3437f4cf1874$export$71511d61b312f219; });
function $2fce3437f4cf1874$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("1EZOw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $135979cf6d0dc133$export$71511d61b312f219; });

var $8wAe0 = parcelRequire("8wAe0");

var $gyGuQ = parcelRequire("gyGuQ");

var $aFtfV = parcelRequire("aFtfV");

var $fMryZ = parcelRequire("fMryZ");
function $135979cf6d0dc133$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $135979cf6d0dc133$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $aFtfV._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $8wAe0._)(Class, arguments, (0, $gyGuQ._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $fMryZ._)(Wrapper, Class);
    };
    return $135979cf6d0dc133$export$71511d61b312f219(Class);
}

});
parcelRegister("8wAe0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $634d6964686a1afa$export$71511d61b312f219; });

var $ftVlM = parcelRequire("ftVlM");

var $fMryZ = parcelRequire("fMryZ");
function $634d6964686a1afa$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $ftVlM._)()) $634d6964686a1afa$export$71511d61b312f219 = Reflect.construct;
    else $634d6964686a1afa$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $fMryZ._)(instance, Class.prototype);
        return instance;
    };
    return $634d6964686a1afa$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("aFtfV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7c446d547ed0cd60$export$71511d61b312f219; });
function $7c446d547ed0cd60$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("fRv9I", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $b8c3f91e5973f862$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $b8c3f91e5973f862$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $bJtXW = parcelRequire("bJtXW");
var $b8c3f91e5973f862$var$extendStatics = function extendStatics1(d, b) {
    $b8c3f91e5973f862$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $b8c3f91e5973f862$var$extendStatics(d, b);
};
function $b8c3f91e5973f862$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $b8c3f91e5973f862$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b8c3f91e5973f862$export$18ce0697a983be9b = function __assign1() {
    $b8c3f91e5973f862$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b8c3f91e5973f862$export$18ce0697a983be9b.apply(this, arguments);
};
function $b8c3f91e5973f862$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b8c3f91e5973f862$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $bJtXW._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b8c3f91e5973f862$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b8c3f91e5973f862$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $bJtXW._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $b8c3f91e5973f862$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $b8c3f91e5973f862$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $bJtXW._)(x)) === "symbol" ? x : "".concat(x);
}
function $b8c3f91e5973f862$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $bJtXW._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $b8c3f91e5973f862$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $bJtXW._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b8c3f91e5973f862$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b8c3f91e5973f862$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $b8c3f91e5973f862$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $b8c3f91e5973f862$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $b8c3f91e5973f862$export$45d3717a4c69092e(o, m, p);
}
function $b8c3f91e5973f862$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b8c3f91e5973f862$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b8c3f91e5973f862$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b8c3f91e5973f862$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b8c3f91e5973f862$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b8c3f91e5973f862$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $b8c3f91e5973f862$export$10c90e4f7922046c(v) {
    return this instanceof $b8c3f91e5973f862$export$10c90e4f7922046c ? (this.v = v, this) : new $b8c3f91e5973f862$export$10c90e4f7922046c(v);
}
function $b8c3f91e5973f862$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $b8c3f91e5973f862$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $b8c3f91e5973f862$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b8c3f91e5973f862$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $b8c3f91e5973f862$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b8c3f91e5973f862$export$19a8beecd37a4c45 === "function" ? $b8c3f91e5973f862$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $b8c3f91e5973f862$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $b8c3f91e5973f862$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $b8c3f91e5973f862$var$ownKeys = function ownKeys1(o) {
    $b8c3f91e5973f862$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $b8c3f91e5973f862$var$ownKeys(o);
};
function $b8c3f91e5973f862$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $b8c3f91e5973f862$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $b8c3f91e5973f862$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $b8c3f91e5973f862$var$__setModuleDefault(result, mod);
    return result;
}
function $b8c3f91e5973f862$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $b8c3f91e5973f862$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $b8c3f91e5973f862$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $b8c3f91e5973f862$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $bJtXW._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $b8c3f91e5973f862$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $b8c3f91e5973f862$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $b8c3f91e5973f862$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $b8c3f91e5973f862$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $b8c3f91e5973f862$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $b8c3f91e5973f862$export$2e2bcd8739ae039 = {
    __extends: $b8c3f91e5973f862$export$a8ba968b8961cb8a,
    __assign: $b8c3f91e5973f862$export$18ce0697a983be9b,
    __rest: $b8c3f91e5973f862$export$3c9a16f847548506,
    __decorate: $b8c3f91e5973f862$export$29e00dfd3077644b,
    __param: $b8c3f91e5973f862$export$d5ad3fd78186038f,
    __esDecorate: $b8c3f91e5973f862$export$3a84e1ae4e97e9b0,
    __runInitializers: $b8c3f91e5973f862$export$d831c04e792af3d,
    __propKey: $b8c3f91e5973f862$export$6a2a36740a146cb8,
    __setFunctionName: $b8c3f91e5973f862$export$d1a06452d3489bc7,
    __metadata: $b8c3f91e5973f862$export$f1db080c865becb9,
    __awaiter: $b8c3f91e5973f862$export$1050f835b63b671e,
    __generator: $b8c3f91e5973f862$export$67ebef60e6f28a6,
    __createBinding: $b8c3f91e5973f862$export$45d3717a4c69092e,
    __exportStar: $b8c3f91e5973f862$export$f33643c0debef087,
    __values: $b8c3f91e5973f862$export$19a8beecd37a4c45,
    __read: $b8c3f91e5973f862$export$8d051b38c9118094,
    __spread: $b8c3f91e5973f862$export$afc72e2116322959,
    __spreadArrays: $b8c3f91e5973f862$export$6388937ca91ccae8,
    __spreadArray: $b8c3f91e5973f862$export$1216008129fb82ed,
    __await: $b8c3f91e5973f862$export$10c90e4f7922046c,
    __asyncGenerator: $b8c3f91e5973f862$export$e427f37a30a4de9b,
    __asyncDelegator: $b8c3f91e5973f862$export$bbd80228419bb833,
    __asyncValues: $b8c3f91e5973f862$export$e3b29a3d6162315f,
    __makeTemplateObject: $b8c3f91e5973f862$export$4fb47efe1390b86f,
    __importStar: $b8c3f91e5973f862$export$c21735bcef00d192,
    __importDefault: $b8c3f91e5973f862$export$da59b14a69baef04,
    __classPrivateFieldGet: $b8c3f91e5973f862$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $b8c3f91e5973f862$export$d40a35129aaff81f,
    __classPrivateFieldIn: $b8c3f91e5973f862$export$81fdc39f203e4e04,
    __addDisposableResource: $b8c3f91e5973f862$export$88ac25d8e944e405,
    __disposeResources: $b8c3f91e5973f862$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $b8c3f91e5973f862$export$889dfb5d17574b0b
};

});


parcelRegister("imka8", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $d5d9ebee7c4f223e$export$bf730a2d8bf68b42; }, function (v) { return $d5d9ebee7c4f223e$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d5d9ebee7c4f223e$export$bf730a2d8bf68b42;
"use strict";

var $dQFEZ = parcelRequire("dQFEZ");
function $d5d9ebee7c4f223e$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $d5d9ebee7c4f223e$var$objectIs = "function" === typeof Object.is ? Object.is : $d5d9ebee7c4f223e$var$is, $d5d9ebee7c4f223e$var$useSyncExternalStore = $dQFEZ.useSyncExternalStore, $d5d9ebee7c4f223e$var$useRef = $dQFEZ.useRef, $d5d9ebee7c4f223e$var$useEffect = $dQFEZ.useEffect, $d5d9ebee7c4f223e$var$useMemo = $dQFEZ.useMemo, $d5d9ebee7c4f223e$var$useDebugValue = $dQFEZ.useDebugValue;
$d5d9ebee7c4f223e$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $d5d9ebee7c4f223e$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $d5d9ebee7c4f223e$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($d5d9ebee7c4f223e$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $d5d9ebee7c4f223e$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $d5d9ebee7c4f223e$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $d5d9ebee7c4f223e$var$useDebugValue(value);
    return value;
};

});

parcelRegister("kK8g8", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return isDraft; });
$parcel$export(module.exports, "isDraftable", function () { return isDraftable; });
$parcel$export(module.exports, "current", function () { return current; });
$parcel$export(module.exports, "produce", function () { return produce; });

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $72osQ = parcelRequire("72osQ");

var $j6Mzi = parcelRequire("j6Mzi");

var $2nwvT = parcelRequire("2nwvT");

var $2us1u = parcelRequire("2us1u");

var $bJtXW = parcelRequire("bJtXW");

var $1EZOw = parcelRequire("1EZOw");
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (__getOwnPropSymbols) try {
        for(var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var errors = [];
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    throw new Error("[Immer] minified error nr: ".concat(error, ". Full error at: https://bit.ly/3cXEKWf"));
}
// src/utils/common.ts
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
    return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
    var _a;
    if (!value) return false;
    return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!((_a = value.constructor) == null ? void 0 : _a[DRAFTABLE]) || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
function isPlainObject(value) {
    if (!value || (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) !== "object") return false;
    var proto = getPrototypeOf(value);
    if (proto === null) return true;
    var Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
}
function original(value) {
    if (!isDraft(value)) die(15, value);
    return value[DRAFT_STATE].base_;
}
function each(obj, iter) {
    if (getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach(function(key) {
        iter(key, obj[key], obj);
    });
    else obj.forEach(function(entry, index) {
        return iter(index, entry, obj);
    });
}
function getArchtype(thing) {
    var state = thing[DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : isMap(thing) ? 2 /* Map */  : isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function has(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function get(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function set(thing, propOrOldValue, value) {
    var t = getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function isMap(target) {
    return target instanceof Map;
}
function isSet(target) {
    return target instanceof Set;
}
function latest(state) {
    return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
    if (isMap(base)) return new Map(base);
    if (isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    var isPlain = isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        var descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[DRAFT_STATE];
        var keys = Reflect.ownKeys(descriptors);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            var desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create(getPrototypeOf(base), descriptors);
    } else {
        var proto = getPrototypeOf(base);
        if (proto !== null && isPlain) return __spreadValues({}, base);
        var obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function freeze(obj) {
    var deep = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj)) return obj;
    if (getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(function(param) {
        var _param = (0, $2nwvT._)(param, 2), key = _param[0], value = _param[1];
        return freeze(value, true);
    });
    return obj;
}
function dontMutateFrozenCollections() {
    die(2);
}
function isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var plugins = {};
function getPlugin(pluginKey) {
    var plugin = plugins[pluginKey];
    if (!plugin) die(0, pluginKey);
    return plugin;
}
function loadPlugin(pluginKey, implementation) {
    if (!plugins[pluginKey]) plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var currentScope;
function getCurrentScope() {
    return currentScope;
}
function createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function revokeScope(scope) {
    leaveScope(scope);
    scope.drafts_.forEach(revokeDraft);
    scope.drafts_ = null;
}
function leaveScope(scope) {
    if (scope === currentScope) currentScope = scope.parent_;
}
function enterScope(immer2) {
    return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
    var state = draft[DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    var baseDraft = scope.drafts_[0];
    var isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[DRAFT_STATE].modified_) {
            revokeScope(scope);
            die(4);
        }
        if (isDraftable(result)) {
            result = finalize(scope, result);
            if (!scope.parent_) maybeFreeze(scope, result);
        }
        if (scope.patches_) getPlugin("Patches").generateReplacementPatches_(baseDraft[DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = finalize(scope, baseDraft, []);
    revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
    if (isFrozen(value)) return value;
    var state = value[DRAFT_STATE];
    if (!state) {
        each(value, function(key, childValue) {
            return finalizeProperty(rootScope, state, value, key, childValue, path);
        });
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        var result = state.copy_;
        var resultEach = result;
        var isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        each(resultEach, function(key, childValue) {
            return finalizeProperty(rootScope, state, result, key, childValue, path, isSet2);
        });
        maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if (isDraft(childValue)) {
        var path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        var res = finalize(rootScope, childValue, path);
        set(targetObject, prop, res);
        if (isDraft(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if (isDraftable(childValue) && !isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && (typeof prop === "undefined" ? "undefined" : (0, $bJtXW._)(prop)) !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) maybeFreeze(rootScope, childValue);
    }
}
function maybeFreeze(scope, value) {
    var deep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) freeze(value, deep);
}
// src/core/proxy.ts
function createProxyProxy(base, parent) {
    var isArray = Array.isArray(base);
    var state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    var target = state;
    var traps = objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = arrayTraps;
    }
    var _Proxy_revocable = Proxy.revocable(target, traps), revoke = _Proxy_revocable.revoke, proxy = _Proxy_revocable.proxy;
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var objectTraps = {
    get: function(state, prop) {
        if (prop === DRAFT_STATE) return state;
        var source = latest(state);
        if (!has(source, prop)) return readPropFromProto(state, source, prop);
        var value = source[prop];
        if (state.finalized_ || !isDraftable(value)) return value;
        if (value === peek(state.base_, prop)) {
            prepareCopy(state);
            return state.copy_[prop] = createProxy(value, state);
        }
        return value;
    },
    has: function(state, prop) {
        return prop in latest(state);
    },
    ownKeys: function(state) {
        return Reflect.ownKeys(latest(state));
    },
    set: function(state, prop, value) {
        var desc = getDescriptorFromProto(latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            var current2 = peek(latest(state), prop);
            var currentState = current2 == null ? void 0 : current2[DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if (is(value, current2) && (value !== void 0 || has(state.base_, prop))) return true;
            prepareCopy(state);
            markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty: function(state, prop) {
        if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            prepareCopy(state);
            markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor: function(state, prop) {
        var owner = latest(state);
        var desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty: function() {
        die(11);
    },
    getPrototypeOf: function(state) {
        return getPrototypeOf(state.base_);
    },
    setPrototypeOf: function() {
        die(12);
    }
};
var arrayTraps = {};
each(objectTraps, function(key, fn) {
    arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
arrayTraps.deleteProperty = function(state, prop) {
    return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
    return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
    var state = draft[DRAFT_STATE];
    var source = state ? latest(state) : draft;
    return source[prop];
}
function readPropFromProto(state, source, prop) {
    var _a;
    var desc = getDescriptorFromProto(source, prop);
    return desc ? "value" in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    var proto = getPrototypeOf(source);
    while(proto){
        var desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = getPrototypeOf(proto);
    }
    return void 0;
}
function markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) markChanged(state.parent_);
    }
}
function prepareCopy(state) {
    if (!state.copy_) state.copy_ = shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var Immer2 = /*#__PURE__*/ function() {
    "use strict";
    function Immer2(config) {
        var _this = this;
        (0, $grujF._)(this, Immer2);
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = function(base, recipe, patchListener) {
            if (typeof base === "function" && typeof recipe !== "function") {
                var defaultBase = recipe;
                recipe = base;
                var self = _this;
                return function curriedProduce() {
                    var _this = this;
                    var base2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultBase;
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    var _recipe;
                    return self.produce(base2, function(draft) {
                        return (_recipe = recipe).call.apply(_recipe, [
                            _this,
                            draft
                        ].concat((0, $2us1u._)(args)));
                    });
                };
            }
            if (typeof recipe !== "function") die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") die(7);
            var result;
            if (isDraftable(base)) {
                var scope = enterScope(_this);
                var proxy = createProxy(base, void 0);
                var hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) revokeScope(scope);
                    else leaveScope(scope);
                }
                usePatchesInScope(scope, patchListener);
                return processResult(result, scope);
            } else if (!base || (typeof base === "undefined" ? "undefined" : (0, $bJtXW._)(base)) !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === NOTHING) result = void 0;
                if (_this.autoFreeze_) freeze(result, true);
                if (patchListener) {
                    var p = [];
                    var ip = [];
                    getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else die(1, base);
        };
        this.produceWithPatches = function(base, recipe) {
            var _this1 = _this;
            if (typeof base === "function") return function(state) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                return _this1.produceWithPatches(state, function(draft) {
                    return base.apply(void 0, [
                        draft
                    ].concat((0, $2us1u._)(args)));
                });
            };
            var patches, inversePatches;
            var result = _this.produce(base, recipe, function(p, ip) {
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    (0, $dhMkv._)(Immer2, [
        {
            key: "createDraft",
            value: function createDraft(base) {
                if (!isDraftable(base)) die(8);
                if (isDraft(base)) base = current(base);
                var scope = enterScope(this);
                var proxy = createProxy(base, void 0);
                proxy[DRAFT_STATE].isManual_ = true;
                leaveScope(scope);
                return proxy;
            }
        },
        {
            key: "finishDraft",
            value: function finishDraft(draft, patchListener) {
                var state = draft && draft[DRAFT_STATE];
                if (!state || !state.isManual_) die(9);
                var scope = state.scope_;
                usePatchesInScope(scope, patchListener);
                return processResult(void 0, scope);
            }
        },
        {
            /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ key: "setAutoFreeze",
            value: function setAutoFreeze(value) {
                this.autoFreeze_ = value;
            }
        },
        {
            /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ key: "setUseStrictShallowCopy",
            value: function setUseStrictShallowCopy(value) {
                this.useStrictShallowCopy_ = value;
            }
        },
        {
            key: "applyPatches",
            value: function applyPatches(base, patches) {
                var i;
                for(i = patches.length - 1; i >= 0; i--){
                    var patch = patches[i];
                    if (patch.path.length === 0 && patch.op === "replace") {
                        base = patch.value;
                        break;
                    }
                }
                if (i > -1) patches = patches.slice(i + 1);
                var applyPatchesImpl = getPlugin("Patches").applyPatches_;
                if (isDraft(base)) return applyPatchesImpl(base, patches);
                return this.produce(base, function(draft) {
                    return applyPatchesImpl(draft, patches);
                });
            }
        }
    ]);
    return Immer2;
}();
function createProxy(value, parent) {
    var draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
    var scope = parent ? parent.scope_ : getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function current(value) {
    if (!isDraft(value)) die(10, value);
    return currentImpl(value);
}
function currentImpl(value) {
    if (!isDraftable(value) || isFrozen(value)) return value;
    var state = value[DRAFT_STATE];
    var copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = shallowCopy(value, true);
    each(copy, function(key, childValue) {
        set(copy, key, currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function enablePatches() {
    var errorOffset = 16;
    var REPLACE = "replace";
    var ADD = "add";
    var REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        var base_ = state.base_, assigned_ = state.assigned_;
        var copy_ = state.copy_;
        if (copy_.length < base_.length) {
            var ref;
            ref = [
                copy_,
                base_
            ], base_ = ref[0], copy_ = ref[1], ref;
            var ref1;
            ref1 = [
                inversePatches,
                patches
            ], patches = ref1[0], inversePatches = ref1[1], ref1;
        }
        for(var i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            var path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(var i1 = base_.length; i1 < copy_.length; i1++){
            var path1 = basePath.concat([
                i1
            ]);
            patches.push({
                op: ADD,
                path: path1,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i1])
            });
        }
        for(var i2 = copy_.length - 1; base_.length <= i2; --i2){
            var path2 = basePath.concat([
                i2
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path2
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        var base_ = state.base_, copy_ = state.copy_;
        each(state.assigned_, function(key, assignedValue) {
            var origValue = get(base_, key);
            var value = get(copy_, key);
            var op = !assignedValue ? REMOVE : has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            var path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        var base_ = state.base_, copy_ = state.copy_;
        var i = 0;
        base_.forEach(function(value) {
            if (!copy_.has(value)) {
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach(function(value) {
            if (!base_.has(value)) {
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === NOTHING ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach(function(patch) {
            var path = patch.path, op = patch.op;
            var base = draft;
            for(var i = 0; i < path.length - 1; i++){
                var parentType = getArchtype(base);
                var p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") die(errorOffset + 3);
                base = get(base, p);
                if ((typeof base === "undefined" ? "undefined" : (0, $bJtXW._)(base)) !== "object") die(errorOffset + 2, path.join("/"));
            }
            var type = getArchtype(base);
            var value = deepClonePatchValue(patch.value);
            var key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!isDraftable(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if (isMap(obj)) return new Map(Array.from(obj.entries()).map(function(param) {
            var _param = (0, $2nwvT._)(param, 2), k = _param[0], v = _param[1];
            return [
                k,
                deepClonePatchValue(v)
            ];
        }));
        if (isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        var cloned = Object.create(getPrototypeOf(obj));
        for(var key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if (has(obj, DRAFTABLE)) cloned[DRAFTABLE] = obj[DRAFTABLE];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if (isDraft(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function enableMapSet() {
    var DraftMap = /*#__PURE__*/ function(Map1) {
        "use strict";
        (0, $j6Mzi._)(DraftMap, Map1);
        function DraftMap(target, parent) {
            (0, $grujF._)(this, DraftMap);
            var _this;
            _this = (0, $f3Okx._)(this, DraftMap);
            _this[DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: _this,
                isManual_: false,
                revoked_: false
            };
            return _this;
        }
        (0, $dhMkv._)(DraftMap, [
            {
                key: "size",
                get: function get() {
                    return latest(this[DRAFT_STATE]).size;
                }
            },
            {
                key: "has",
                value: function has(key) {
                    return latest(this[DRAFT_STATE]).has(key);
                }
            },
            {
                key: "set",
                value: function set(key, value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!latest(state).has(key) || latest(state).get(key) !== value) {
                        prepareMapCopy(state);
                        markChanged(state);
                        state.assigned_.set(key, true);
                        state.copy_.set(key, value);
                        state.assigned_.set(key, true);
                    }
                    return this;
                }
            },
            {
                key: "delete",
                value: function _delete(key) {
                    if (!this.has(key)) return false;
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareMapCopy(state);
                    markChanged(state);
                    if (state.base_.has(key)) state.assigned_.set(key, false);
                    else state.assigned_.delete(key);
                    state.copy_.delete(key);
                    return true;
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (latest(state).size) {
                        prepareMapCopy(state);
                        markChanged(state);
                        state.assigned_ = /* @__PURE__ */ new Map();
                        each(state.base_, function(key) {
                            state.assigned_.set(key, false);
                        });
                        state.copy_.clear();
                    }
                }
            },
            {
                key: "forEach",
                value: function forEach(cb, thisArg) {
                    var _this = this;
                    var state = this[DRAFT_STATE];
                    latest(state).forEach(function(_value, key, _map) {
                        cb.call(thisArg, _this.get(key), key, _this);
                    });
                }
            },
            {
                key: "get",
                value: function get(key) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    var value = latest(state).get(key);
                    if (state.finalized_ || !isDraftable(value)) return value;
                    if (value !== state.base_.get(key)) return value;
                    var draft = createProxy(value, state);
                    prepareMapCopy(state);
                    state.copy_.set(key, draft);
                    return draft;
                }
            },
            {
                key: "keys",
                value: function keys() {
                    return latest(this[DRAFT_STATE]).keys();
                }
            },
            {
                key: "values",
                value: function values() {
                    var _this = this;
                    var iterator = this.keys();
                    var _obj;
                    return _obj = {}, (0, $72osQ._)(_obj, Symbol.iterator, function() {
                        return _this.values();
                    }), (0, $72osQ._)(_obj, "next", function() {
                        var r = iterator.next();
                        if (r.done) return r;
                        var value = _this.get(r.value);
                        return {
                            done: false,
                            value: value
                        };
                    }), _obj;
                }
            },
            {
                key: "entries",
                value: function entries() {
                    var _this = this;
                    var iterator = this.keys();
                    var _obj;
                    return _obj = {}, (0, $72osQ._)(_obj, Symbol.iterator, function() {
                        return _this.entries();
                    }), (0, $72osQ._)(_obj, "next", function() {
                        var r = iterator.next();
                        if (r.done) return r;
                        var value = _this.get(r.value);
                        return {
                            done: false,
                            value: [
                                r.value,
                                value
                            ]
                        };
                    }), _obj;
                }
            },
            {
                key: (DRAFT_STATE, Symbol.iterator),
                value: function value() {
                    return this.entries();
                }
            }
        ]);
        return DraftMap;
    }((0, $1EZOw._)(Map));
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    var DraftSet = /*#__PURE__*/ function(Set1) {
        "use strict";
        (0, $j6Mzi._)(DraftSet, Set1);
        function DraftSet(target, parent) {
            (0, $grujF._)(this, DraftSet);
            var _this;
            _this = (0, $f3Okx._)(this, DraftSet);
            _this[DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: _this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
            return _this;
        }
        (0, $dhMkv._)(DraftSet, [
            {
                key: "size",
                get: function get() {
                    return latest(this[DRAFT_STATE]).size;
                }
            },
            {
                key: "has",
                value: function has(value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!state.copy_) return state.base_.has(value);
                    if (state.copy_.has(value)) return true;
                    if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
                    return false;
                }
            },
            {
                key: "add",
                value: function add(value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!this.has(value)) {
                        prepareSetCopy(state);
                        markChanged(state);
                        state.copy_.add(value);
                    }
                    return this;
                }
            },
            {
                key: "delete",
                value: function _delete(value) {
                    if (!this.has(value)) return false;
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    markChanged(state);
                    return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (latest(state).size) {
                        prepareSetCopy(state);
                        markChanged(state);
                        state.copy_.clear();
                    }
                }
            },
            {
                key: "values",
                value: function values() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    return state.copy_.values();
                }
            },
            {
                key: "entries",
                value: function entries() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    return state.copy_.entries();
                }
            },
            {
                key: "keys",
                value: function keys() {
                    return this.values();
                }
            },
            {
                key: (DRAFT_STATE, Symbol.iterator),
                value: function value() {
                    return this.values();
                }
            },
            {
                key: "forEach",
                value: function forEach(cb, thisArg) {
                    var iterator = this.values();
                    var result = iterator.next();
                    while(!result.done){
                        cb.call(thisArg, result.value, result.value, this);
                        result = iterator.next();
                    }
                }
            }
        ]);
        return DraftSet;
    }((0, $1EZOw._)(Set));
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach(function(value) {
                if (isDraftable(value)) {
                    var draft = createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) die(3, JSON.stringify(latest(state)));
    }
    loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
var produceWithPatches = immer.produceWithPatches.bind(immer);
var setAutoFreeze = immer.setAutoFreeze.bind(immer);
var setUseStrictShallowCopy = immer.setUseStrictShallowCopy.bind(immer);
var applyPatches = immer.applyPatches.bind(immer);
var createDraft = immer.createDraft.bind(immer);
var finishDraft = immer.finishDraft.bind(immer);
function castDraft(value) {
    return value;
}
function castImmutable(value) {
    return value;
}

});

parcelRegister("5gfhY", function(module, exports) {

module.exports = (parcelRequire("dxJzZ"))($parcel$resolve("eUs6h")).then(function() {
    return parcelRequire('4M3lk');
});

});
parcelRegister("dxJzZ", function(module, exports) {
"use strict";

var $dzhUQ = parcelRequire("dzhUQ");
module.exports = $dzhUQ(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("dzhUQ", function(module, exports) {
"use strict";
var $9e0c70f198b0df6a$var$cachedBundles = {};
var $9e0c70f198b0df6a$var$cachedPreloads = {};
var $9e0c70f198b0df6a$var$cachedPrefetches = {};
function $9e0c70f198b0df6a$var$getCache(type) {
    switch(type){
        case 'preload':
            return $9e0c70f198b0df6a$var$cachedPreloads;
        case 'prefetch':
            return $9e0c70f198b0df6a$var$cachedPrefetches;
        default:
            return $9e0c70f198b0df6a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $9e0c70f198b0df6a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $ed63022dfaecff35$exports = {};
$parcel$extendImportMap({
    "eUs6h": "Grocery.687f4a73.js"
});


var $2nwvT = parcelRequire("2nwvT");

var $iD4WH = parcelRequire("iD4WH");

var $dQFEZ = parcelRequire("dQFEZ");
var $8dbfa3fee6dc40a7$exports = {};

$parcel$export($8dbfa3fee6dc40a7$exports, "createRoot", function () { return $8dbfa3fee6dc40a7$export$882461b6382ed46c; }, function (v) { return $8dbfa3fee6dc40a7$export$882461b6382ed46c = v; });
$parcel$export($8dbfa3fee6dc40a7$exports, "hydrateRoot", function () { return $8dbfa3fee6dc40a7$export$757ceba2d55c277e; }, function (v) { return $8dbfa3fee6dc40a7$export$757ceba2d55c277e = v; });
var $8dbfa3fee6dc40a7$export$882461b6382ed46c;
var $8dbfa3fee6dc40a7$export$757ceba2d55c277e;
'use strict';
var $4288f0eb191085d1$exports = {};
'use strict';
function $4288f0eb191085d1$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($4288f0eb191085d1$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$4288f0eb191085d1$var$checkDCE();

$4288f0eb191085d1$exports = (parcelRequire("gZreO"));


var $8dbfa3fee6dc40a7$var$i;
$8dbfa3fee6dc40a7$export$882461b6382ed46c = $4288f0eb191085d1$exports.createRoot;
$8dbfa3fee6dc40a7$export$757ceba2d55c277e = $4288f0eb191085d1$exports.hydrateRoot;


/**
 * React Router DOM v6.28.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $g3gsR = parcelRequire("g3gsR");

var $grujF = parcelRequire("grujF");

var $2nwvT = parcelRequire("2nwvT");

var $fRv9I = parcelRequire("fRv9I");

var $dQFEZ = parcelRequire("dQFEZ");


var $gl7zH = parcelRequire("gl7zH");/**
 * React Router v6.28.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $2nwvT = parcelRequire("2nwvT");

var $2us1u = parcelRequire("2us1u");

var $dQFEZ = parcelRequire("dQFEZ");

var $gl7zH = parcelRequire("gl7zH");
function $8c3ad80f8a436e0f$var$_extends() {
    $8c3ad80f8a436e0f$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8c3ad80f8a436e0f$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
var $8c3ad80f8a436e0f$export$3add0d5dce533e2e = /*#__PURE__*/ $dQFEZ.createContext(null);
var $8c3ad80f8a436e0f$export$145dfa71566a64dc = /*#__PURE__*/ $dQFEZ.createContext(null);
var $8c3ad80f8a436e0f$var$AwaitContext = /*#__PURE__*/ $dQFEZ.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ var $8c3ad80f8a436e0f$export$26749e8557646306 = /*#__PURE__*/ $dQFEZ.createContext(null);
var $8c3ad80f8a436e0f$export$c7914228fb69b0f5 = /*#__PURE__*/ $dQFEZ.createContext(null);
var $8c3ad80f8a436e0f$export$9072aa6dd1f93057 = /*#__PURE__*/ $dQFEZ.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
var $8c3ad80f8a436e0f$var$RouteErrorContext = /*#__PURE__*/ $dQFEZ.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $8c3ad80f8a436e0f$export$b66bb29c5006f12f(to, _temp) {
    var relative = (_temp === void 0 ? {} : _temp).relative;
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $gl7zH.UNSAFE_invariant)(false);
    var _React_useContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var _useResolvedPath = $8c3ad80f8a436e0f$export$e75d2a2d1b3c245b(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $gl7zH.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $8c3ad80f8a436e0f$export$9c954a9d03d32f4a() {
    return $dQFEZ.useContext($8c3ad80f8a436e0f$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $8c3ad80f8a436e0f$export$45d76561a5302f2b() {
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $gl7zH.UNSAFE_invariant)(false);
    return $dQFEZ.useContext($8c3ad80f8a436e0f$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $8c3ad80f8a436e0f$export$1b3f31771c5d07c() {
    return $dQFEZ.useContext($8c3ad80f8a436e0f$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $8c3ad80f8a436e0f$export$6c330e8992e8a295(pattern) {
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $gl7zH.UNSAFE_invariant)(false);
    var pathname = $8c3ad80f8a436e0f$export$45d76561a5302f2b().pathname;
    return $dQFEZ.useMemo(function() {
        return (0, $gl7zH.matchPath)(pattern, (0, $gl7zH.UNSAFE_decodePath)(pathname));
    }, [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ var $8c3ad80f8a436e0f$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $8c3ad80f8a436e0f$var$useIsomorphicLayoutEffect(cb) {
    var isStatic = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $dQFEZ.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $8c3ad80f8a436e0f$export$9770f232ac06a008() {
    var isDataRoute = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).isDataRoute;
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $8c3ad80f8a436e0f$var$useNavigateStable() : $8c3ad80f8a436e0f$var$useNavigateUnstable();
}
function $8c3ad80f8a436e0f$var$useNavigateUnstable() {
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $gl7zH.UNSAFE_invariant)(false);
    var dataRouterContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$3add0d5dce533e2e);
    var _React_useContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306), basename = _React_useContext.basename, future = _React_useContext.future, navigator = _React_useContext.navigator;
    var matches = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).matches;
    var _useLocation = $8c3ad80f8a436e0f$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $gl7zH.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    var activeRef = $dQFEZ.useRef(false);
    $8c3ad80f8a436e0f$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $dQFEZ.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, $gl7zH.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $gl7zH.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $8c3ad80f8a436e0f$var$OutletContext = /*#__PURE__*/ $dQFEZ.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $8c3ad80f8a436e0f$export$4138103a3ae699cc() {
    return $dQFEZ.useContext($8c3ad80f8a436e0f$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $8c3ad80f8a436e0f$export$a3be3530d8e40d0b(context) {
    var outlet = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $8c3ad80f8a436e0f$export$99eaa27ddbbb95ef() {
    var matches = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $8c3ad80f8a436e0f$export$e75d2a2d1b3c245b(to, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var future = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306).future;
    var matches = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).matches;
    var _useLocation = $8c3ad80f8a436e0f$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $gl7zH.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $dQFEZ.useMemo(function() {
        return (0, $gl7zH.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $8c3ad80f8a436e0f$export$5d3fca4a98652595(routes, locationArg) {
    return $8c3ad80f8a436e0f$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $8c3ad80f8a436e0f$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $gl7zH.UNSAFE_invariant)(false);
    var navigator = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306).navigator;
    var _React_useContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057), parentMatches = _React_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    var locationFromContext = $8c3ad80f8a436e0f$export$45d76561a5302f2b();
    var location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        var parsedLocationArg = typeof locationArg === "string" ? (0, $gl7zH.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $gl7zH.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        var parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        var segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    var matches = (0, $gl7zH.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    var renderedMatches = $8c3ad80f8a436e0f$var$_renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $gl7zH.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $gl7zH.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $8c3ad80f8a436e0f$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $gl7zH.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $8c3ad80f8a436e0f$var$DefaultErrorComponent() {
    var error = $8c3ad80f8a436e0f$export$ed527bf60f6e05f2();
    var message = (0, $gl7zH.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    return /*#__PURE__*/ $dQFEZ.createElement($dQFEZ.Fragment, null, /*#__PURE__*/ $dQFEZ.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $dQFEZ.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $dQFEZ.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $8c3ad80f8a436e0f$var$defaultErrorElement = /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$DefaultErrorComponent, null);
var $8c3ad80f8a436e0f$var$RenderErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $j6Mzi._)(RenderErrorBoundary, _React_Component);
    function RenderErrorBoundary(props) {
        (0, $grujF._)(this, RenderErrorBoundary);
        var _this;
        _this = (0, $f3Okx._)(this, RenderErrorBoundary, [
            props
        ]);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $dhMkv._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error !== undefined ? /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$9072aa6dd1f93057.Provider, {
                    value: this.props.routeContext
                }, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // When we get into an error state, the user will likely click "back" to the
                // previous page that didn't have an error. Because this wraps the entire
                // application, that will have no effect--the error page continues to display.
                // This gives us a mechanism to recover from the error when the location changes.
                //
                // Whether we're in an error state or not, we update the location in state
                // so that when we are in an error state, it gets reset when a new location
                // comes in and the user recovers from the error.
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                // If we're not changing locations, preserve the location but still surface
                // any new errors that may come through. We retain the existing error, we do
                // this because the error provided from the app state may be cleared without
                // the location changing.
                return {
                    error: props.error !== undefined ? props.error : state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($dQFEZ.Component);
function $8c3ad80f8a436e0f$var$RenderedRoute(_ref) {
    var routeContext = _ref.routeContext, match = _ref.match, children = _ref.children;
    var dataRouterContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $8c3ad80f8a436e0f$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    var errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined;
        });
        !(errorIndex >= 0) && (0, $gl7zH.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    var renderFallback = false;
    var fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(var i = 0; i < renderedMatches.length; i++){
        var match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            var loaderData = dataRouterState.loaderData, errors1 = dataRouterState.errors;
            var needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors1 || errors1[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        // Only data routers handle errors/fallbacks
        var error;
        var shouldRenderHydrateFallback = false;
        var errorElement = null;
        var hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $8c3ad80f8a436e0f$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $8c3ad80f8a436e0f$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $dQFEZ.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: _$matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $8c3ad80f8a436e0f$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($8c3ad80f8a436e0f$var$DataRouterHook || {});
var $8c3ad80f8a436e0f$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($8c3ad80f8a436e0f$var$DataRouterStateHook || {});
function $8c3ad80f8a436e0f$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $8c3ad80f8a436e0f$var$useDataRouterContext(hookName) {
    var ctx = $dQFEZ.useContext($8c3ad80f8a436e0f$export$3add0d5dce533e2e);
    !ctx && (0, $gl7zH.UNSAFE_invariant)(false);
    return ctx;
}
function $8c3ad80f8a436e0f$var$useDataRouterState(hookName) {
    var state = $dQFEZ.useContext($8c3ad80f8a436e0f$export$145dfa71566a64dc);
    !state && (0, $gl7zH.UNSAFE_invariant)(false);
    return state;
}
function $8c3ad80f8a436e0f$var$useRouteContext(hookName) {
    var route = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057);
    !route && (0, $gl7zH.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $8c3ad80f8a436e0f$var$useCurrentRouteId(hookName) {
    var route = $8c3ad80f8a436e0f$var$useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $gl7zH.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $8c3ad80f8a436e0f$export$5fc8298006ad9e58() {
    return $8c3ad80f8a436e0f$var$useCurrentRouteId($8c3ad80f8a436e0f$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $8c3ad80f8a436e0f$export$d0fd4b7106de2769() {
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $8c3ad80f8a436e0f$export$600dc272ed516c15() {
    var dataRouterContext = $8c3ad80f8a436e0f$var$useDataRouterContext($8c3ad80f8a436e0f$var$DataRouterHook.UseRevalidator);
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseRevalidator);
    return $dQFEZ.useMemo(function() {
        return {
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        };
    }, [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $8c3ad80f8a436e0f$export$2378eb7f5ff86053() {
    var _useDataRouterState = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseMatches), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $dQFEZ.useMemo(function() {
        return matches.map(function(m) {
            return (0, $gl7zH.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData);
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $8c3ad80f8a436e0f$export$1448a5050d252c4d() {
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseLoaderData);
    var routeId = $8c3ad80f8a436e0f$var$useCurrentRouteId($8c3ad80f8a436e0f$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $8c3ad80f8a436e0f$export$fd5d37484eab868d(routeId) {
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $8c3ad80f8a436e0f$export$fdc00f3f26066d5e() {
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseActionData);
    var routeId = $8c3ad80f8a436e0f$var$useCurrentRouteId($8c3ad80f8a436e0f$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $8c3ad80f8a436e0f$export$ed527bf60f6e05f2() {
    var _state$errors;
    var error = $dQFEZ.useContext($8c3ad80f8a436e0f$var$RouteErrorContext);
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseRouteError);
    var routeId = $8c3ad80f8a436e0f$var$useCurrentRouteId($8c3ad80f8a436e0f$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $8c3ad80f8a436e0f$export$78a72ddb39bdd145() {
    var value = $dQFEZ.useContext($8c3ad80f8a436e0f$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $8c3ad80f8a436e0f$export$17f53340677d5831() {
    var value = $dQFEZ.useContext($8c3ad80f8a436e0f$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
var $8c3ad80f8a436e0f$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $8c3ad80f8a436e0f$export$b273b3273281a049(shouldBlock) {
    var _useDataRouterContext = $8c3ad80f8a436e0f$var$useDataRouterContext($8c3ad80f8a436e0f$var$DataRouterHook.UseBlocker), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = $8c3ad80f8a436e0f$var$useDataRouterState($8c3ad80f8a436e0f$var$DataRouterStateHook.UseBlocker);
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState(""), 2), blockerKey = _React_useState[0], setBlockerKey = _React_useState[1];
    var blockerFunction = $dQFEZ.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: $8c3ad80f8a436e0f$var$_extends({}, currentLocation, {
                pathname: (0, $gl7zH.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $8c3ad80f8a436e0f$var$_extends({}, nextLocation, {
                pathname: (0, $gl7zH.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $dQFEZ.useEffect(function() {
        var key = String(++$8c3ad80f8a436e0f$var$blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $dQFEZ.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $gl7zH.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $8c3ad80f8a436e0f$var$useNavigateStable() {
    var router = $8c3ad80f8a436e0f$var$useDataRouterContext($8c3ad80f8a436e0f$var$DataRouterHook.UseNavigateStable).router;
    var id = $8c3ad80f8a436e0f$var$useCurrentRouteId($8c3ad80f8a436e0f$var$DataRouterStateHook.UseNavigateStable);
    var activeRef = $dQFEZ.useRef(false);
    $8c3ad80f8a436e0f$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $dQFEZ.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $8c3ad80f8a436e0f$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
var $8c3ad80f8a436e0f$var$alreadyWarned$1 = {};
function $8c3ad80f8a436e0f$var$warningOnce(key, cond, message) {
    if (!cond && !$8c3ad80f8a436e0f$var$alreadyWarned$1[key]) $8c3ad80f8a436e0f$var$alreadyWarned$1[key] = true;
}
var $8c3ad80f8a436e0f$var$alreadyWarned = {};
function $8c3ad80f8a436e0f$var$warnOnce(key, message) {
    if (!$8c3ad80f8a436e0f$var$alreadyWarned[message]) {
        $8c3ad80f8a436e0f$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}
var $8c3ad80f8a436e0f$var$logDeprecation = function(flag, msg, link) {
    return $8c3ad80f8a436e0f$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
};
function $8c3ad80f8a436e0f$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if (!(renderFuture != null && renderFuture.v7_startTransition)) $8c3ad80f8a436e0f$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if (!(renderFuture != null && renderFuture.v7_relativeSplatPath) && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $8c3ad80f8a436e0f$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (!routerFuture.v7_fetcherPersist) $8c3ad80f8a436e0f$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (!routerFuture.v7_normalizeFormMethod) $8c3ad80f8a436e0f$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (!routerFuture.v7_partialHydration) $8c3ad80f8a436e0f$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (!routerFuture.v7_skipActionErrorRevalidation) $8c3ad80f8a436e0f$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $8c3ad80f8a436e0f$var$START_TRANSITION = "startTransition";
var $8c3ad80f8a436e0f$var$startTransitionImpl = $dQFEZ[$8c3ad80f8a436e0f$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $8c3ad80f8a436e0f$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $dQFEZ.useCallback(function(newState) {
        if (v7_startTransition && $8c3ad80f8a436e0f$var$startTransitionImpl) $8c3ad80f8a436e0f$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        });
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $dQFEZ.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    $dQFEZ.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $dQFEZ.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $dQFEZ.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    $dQFEZ.useEffect(function() {
        return $8c3ad80f8a436e0f$export$db5148ec97d6af7a(future, router.future);
    }, [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $dQFEZ.createElement($dQFEZ.Fragment, null, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $8c3ad80f8a436e0f$var$DataRoutes(_ref2) {
    var routes = _ref2.routes, future = _ref2.future, state = _ref2.state;
    return $8c3ad80f8a436e0f$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $8c3ad80f8a436e0f$export$ae46f04cfaffe093(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, initialEntries = _ref3.initialEntries, initialIndex = _ref3.initialIndex, future = _ref3.future;
    var historyRef = $dQFEZ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $gl7zH.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $dQFEZ.useCallback(function(newState) {
        v7_startTransition && $8c3ad80f8a436e0f$var$startTransitionImpl ? $8c3ad80f8a436e0f$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dQFEZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    $dQFEZ.useEffect(function() {
        return $8c3ad80f8a436e0f$export$db5148ec97d6af7a(future);
    }, [
        future
    ]);
    return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $8c3ad80f8a436e0f$export$444b3ab0cb9aec40(_ref4) {
    var to = _ref4.to, replace = _ref4.replace, state = _ref4.state, relative = _ref4.relative;
    !$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $gl7zH.UNSAFE_invariant)(false);
    var _React_useContext = $dQFEZ.useContext($8c3ad80f8a436e0f$export$26749e8557646306), future = _React_useContext.future, isStatic = _React_useContext.static;
    var matches = $dQFEZ.useContext($8c3ad80f8a436e0f$export$9072aa6dd1f93057).matches;
    var _useLocation = $8c3ad80f8a436e0f$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var navigate = $8c3ad80f8a436e0f$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    var path = (0, $gl7zH.resolveTo)(to, (0, $gl7zH.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $dQFEZ.useEffect(function() {
        return navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $8c3ad80f8a436e0f$export$910ae8079b2c2852(props) {
    return $8c3ad80f8a436e0f$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $8c3ad80f8a436e0f$export$e7b0ac011bb776c6(_props) {
    (0, $gl7zH.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $8c3ad80f8a436e0f$export$55185c17a0fcbe46(_ref5) {
    var tmp = _ref5.basename, basenameProp = tmp === void 0 ? "/" : tmp, _ref5_children = _ref5.children, children = _ref5_children === void 0 ? null : _ref5_children, locationProp = _ref5.location, _ref5_navigationType = _ref5.navigationType, navigationType = _ref5_navigationType === void 0 ? (0, $gl7zH.Action).Pop : _ref5_navigationType, navigator = _ref5.navigator, tmp1 = _ref5.static, staticProp = tmp1 === void 0 ? false : tmp1, future = _ref5.future;
    !!$8c3ad80f8a436e0f$export$9c954a9d03d32f4a() && (0, $gl7zH.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $dQFEZ.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $8c3ad80f8a436e0f$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        };
    }, [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $gl7zH.parsePath)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = $dQFEZ.useMemo(function() {
        var trailingPathname = (0, $gl7zH.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $8c3ad80f8a436e0f$export$3565eb3d00ca5a74(_ref6) {
    var children = _ref6.children, location = _ref6.location;
    return $8c3ad80f8a436e0f$export$5d3fca4a98652595($8c3ad80f8a436e0f$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $8c3ad80f8a436e0f$export$6ddabde395c8c576(_ref7) {
    var children = _ref7.children, errorElement = _ref7.errorElement, resolve = _ref7.resolve;
    return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$ResolveAwait, null, children));
}
var $8c3ad80f8a436e0f$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($8c3ad80f8a436e0f$var$AwaitRenderStatus || {});
var $8c3ad80f8a436e0f$var$neverSettledPromise = new Promise(function() {});
var $8c3ad80f8a436e0f$var$AwaitErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $j6Mzi._)(AwaitErrorBoundary, _React_Component);
    function AwaitErrorBoundary(props) {
        (0, $grujF._)(this, AwaitErrorBoundary);
        var _this;
        _this = (0, $f3Okx._)(this, AwaitErrorBoundary, [
            props
        ]);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $dhMkv._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = $8c3ad80f8a436e0f$var$AwaitRenderStatus.pending;
                if (!(resolve instanceof Promise)) {
                    // Didn't get a promise - provide as a resolved promise
                    status = $8c3ad80f8a436e0f$var$AwaitRenderStatus.success;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    // Caught a render error, provide it as a rejected promise
                    status = $8c3ad80f8a436e0f$var$AwaitRenderStatus.error;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {}); // Avoid unhandled rejection warnings
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    // Already tracked promise - check contents
                    promise = resolve;
                    status = "_error" in promise ? $8c3ad80f8a436e0f$var$AwaitRenderStatus.error : "_data" in promise ? $8c3ad80f8a436e0f$var$AwaitRenderStatus.success : $8c3ad80f8a436e0f$var$AwaitRenderStatus.pending;
                } else {
                    // Raw (untracked) promise - track it
                    status = $8c3ad80f8a436e0f$var$AwaitRenderStatus.pending;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === $8c3ad80f8a436e0f$var$AwaitRenderStatus.error && promise._error instanceof (0, $gl7zH.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
                throw $8c3ad80f8a436e0f$var$neverSettledPromise;
                if (status === $8c3ad80f8a436e0f$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
                throw promise._error;
                if (status === $8c3ad80f8a436e0f$var$AwaitRenderStatus.error) // Render via our errorElement
                return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === $8c3ad80f8a436e0f$var$AwaitRenderStatus.success) // Render children with resolved value
                return /*#__PURE__*/ $dQFEZ.createElement($8c3ad80f8a436e0f$var$AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                // Throw to the suspense boundary
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($dQFEZ.Component);
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $8c3ad80f8a436e0f$var$ResolveAwait(_ref8) {
    var children = _ref8.children;
    var data = $8c3ad80f8a436e0f$export$78a72ddb39bdd145();
    var toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $dQFEZ.createElement($dQFEZ.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $8c3ad80f8a436e0f$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    var routes = [];
    $dQFEZ.Children.forEach(children, function(element, index) {
        if (!/*#__PURE__*/ $dQFEZ.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        var treePath = (0, $2us1u._)(parentPath).concat([
            index
        ]);
        if (element.type === $dQFEZ.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $8c3ad80f8a436e0f$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $8c3ad80f8a436e0f$export$e7b0ac011bb776c6) && (0, $gl7zH.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $gl7zH.UNSAFE_invariant)(false);
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $8c3ad80f8a436e0f$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $8c3ad80f8a436e0f$export$daf73786167a7f72(matches) {
    return $8c3ad80f8a436e0f$var$_renderMatches(matches);
}
function $8c3ad80f8a436e0f$export$52b333d321859367(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $dQFEZ.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $dQFEZ.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $dQFEZ.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $8c3ad80f8a436e0f$export$f30f7e456d254e83(routes, opts) {
    return (0, $gl7zH.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $8c3ad80f8a436e0f$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $gl7zH.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $8c3ad80f8a436e0f$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



var $gl7zH = parcelRequire("gl7zH");
function $fc41d09ddc03e3ec$var$_extends() {
    $fc41d09ddc03e3ec$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fc41d09ddc03e3ec$var$_extends.apply(this, arguments);
}
function $fc41d09ddc03e3ec$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $fc41d09ddc03e3ec$var$defaultMethod = "get";
var $fc41d09ddc03e3ec$var$defaultEncType = "application/x-www-form-urlencoded";
function $fc41d09ddc03e3ec$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $fc41d09ddc03e3ec$var$isButtonElement(object) {
    return $fc41d09ddc03e3ec$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $fc41d09ddc03e3ec$var$isFormElement(object) {
    return $fc41d09ddc03e3ec$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $fc41d09ddc03e3ec$var$isInputElement(object) {
    return $fc41d09ddc03e3ec$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $fc41d09ddc03e3ec$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $fc41d09ddc03e3ec$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$fc41d09ddc03e3ec$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $fc41d09ddc03e3ec$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $fc41d09ddc03e3ec$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = $fc41d09ddc03e3ec$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
var $fc41d09ddc03e3ec$var$_formDataSupportsSubmitter = null;
function $fc41d09ddc03e3ec$var$isFormDataSubmitterSupported() {
    if ($fc41d09ddc03e3ec$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $fc41d09ddc03e3ec$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $fc41d09ddc03e3ec$var$_formDataSupportsSubmitter = true;
    }
    return $fc41d09ddc03e3ec$var$_formDataSupportsSubmitter;
}
var $fc41d09ddc03e3ec$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $fc41d09ddc03e3ec$var$getFormEncType(encType) {
    if (encType != null && !$fc41d09ddc03e3ec$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $fc41d09ddc03e3ec$var$getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if ($fc41d09ddc03e3ec$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr = target.getAttribute("action");
        action = attr ? (0, $gl7zH.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $fc41d09ddc03e3ec$var$defaultMethod;
        encType = $fc41d09ddc03e3ec$var$getFormEncType(target.getAttribute("enctype")) || $fc41d09ddc03e3ec$var$defaultEncType;
        formData = new FormData(target);
    } else if ($fc41d09ddc03e3ec$var$isButtonElement(target) || $fc41d09ddc03e3ec$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? (0, $gl7zH.stripBasename)(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $fc41d09ddc03e3ec$var$defaultMethod;
        encType = $fc41d09ddc03e3ec$var$getFormEncType(target.getAttribute("formenctype")) || $fc41d09ddc03e3ec$var$getFormEncType(form.getAttribute("enctype")) || $fc41d09ddc03e3ec$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$fc41d09ddc03e3ec$var$isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($fc41d09ddc03e3ec$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $fc41d09ddc03e3ec$var$defaultMethod;
        action = null;
        encType = $fc41d09ddc03e3ec$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
var $fc41d09ddc03e3ec$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $fc41d09ddc03e3ec$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $fc41d09ddc03e3ec$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
var $fc41d09ddc03e3ec$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $fc41d09ddc03e3ec$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $fc41d09ddc03e3ec$export$1f3f55432a00e06d(routes, opts) {
    return (0, $gl7zH.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $fc41d09ddc03e3ec$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $gl7zH.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $fc41d09ddc03e3ec$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $8c3ad80f8a436e0f$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $fc41d09ddc03e3ec$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $gl7zH.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $fc41d09ddc03e3ec$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $gl7zH.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $fc41d09ddc03e3ec$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $8c3ad80f8a436e0f$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $fc41d09ddc03e3ec$var$parseHydrationData() {
    var _window;
    var state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $fc41d09ddc03e3ec$var$_extends({}, state, {
        errors: $fc41d09ddc03e3ec$var$deserializeErrors(state.errors)
    });
    return state;
}
function $fc41d09ddc03e3ec$var$deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $2nwvT._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            // Hey you!  If you change this, please change the corresponding logic in
            // serializeErrors in react-router-dom/server.tsx :)
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $gl7zH.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
                if (val.__subType) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        // @ts-expect-error
                        var error = new ErrorConstructor(val.message);
                        // Wipe away the client-side stack trace.  Nothing to fill it in with
                        // because we don't serialize SSR stack traces for security reasons
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {
                    // no-op - fall through and create a normal Error
                    }
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
var $fc41d09ddc03e3ec$export$7ad602f0e94e62d1 = /*#__PURE__*/ $dQFEZ.createContext({
    isTransitioning: false
});
var $fc41d09ddc03e3ec$export$148fd98d095596d4 = /*#__PURE__*/ $dQFEZ.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $fc41d09ddc03e3ec$var$START_TRANSITION = "startTransition";
var $fc41d09ddc03e3ec$var$startTransitionImpl = $dQFEZ[$fc41d09ddc03e3ec$var$START_TRANSITION];
var $fc41d09ddc03e3ec$var$FLUSH_SYNC = "flushSync";
var $fc41d09ddc03e3ec$var$flushSyncImpl = $4288f0eb191085d1$exports[$fc41d09ddc03e3ec$var$FLUSH_SYNC];
var $fc41d09ddc03e3ec$var$USE_ID = "useId";
var $fc41d09ddc03e3ec$var$useIdImpl = $dQFEZ[$fc41d09ddc03e3ec$var$USE_ID];
function $fc41d09ddc03e3ec$var$startTransitionSafe(cb) {
    if ($fc41d09ddc03e3ec$var$startTransitionImpl) $fc41d09ddc03e3ec$var$startTransitionImpl(cb);
    else cb();
}
function $fc41d09ddc03e3ec$var$flushSyncSafe(cb) {
    if ($fc41d09ddc03e3ec$var$flushSyncImpl) $fc41d09ddc03e3ec$var$flushSyncImpl(cb);
    else cb();
}
var $fc41d09ddc03e3ec$var$Deferred = function Deferred() {
    "use strict";
    var _this = this;
    (0, $grujF._)(this, Deferred);
    this.status = "pending";
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = function(value) {
            if (_this.status === "pending") {
                _this.status = "resolved";
                resolve(value);
            }
        };
        _this.reject = function(reason) {
            if (_this.status === "pending") {
                _this.status = "rejected";
                reject(reason);
            }
        };
    });
};
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $fc41d09ddc03e3ec$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var _React_useState1 = (0, $2nwvT._)($dQFEZ.useState(), 2), pendingState = _React_useState1[0], setPendingState = _React_useState1[1];
    var _React_useState2 = (0, $2nwvT._)($dQFEZ.useState({
        isTransitioning: false
    }), 2), vtContext = _React_useState2[0], setVtContext = _React_useState2[1];
    var _React_useState3 = (0, $2nwvT._)($dQFEZ.useState(), 2), renderDfd = _React_useState3[0], setRenderDfd = _React_useState3[1];
    var _React_useState4 = (0, $2nwvT._)($dQFEZ.useState(), 2), transition = _React_useState4[0], setTransition = _React_useState4[1];
    var _React_useState5 = (0, $2nwvT._)($dQFEZ.useState(), 2), interruption = _React_useState5[0], setInterruption = _React_useState5[1];
    var fetcherData = $dQFEZ.useRef(new Map());
    var v7_startTransition = (future || {}).v7_startTransition;
    var optInStartTransition = $dQFEZ.useCallback(function(cb) {
        if (v7_startTransition) $fc41d09ddc03e3ec$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    var setState = $dQFEZ.useCallback(function(newState, _ref2) {
        var deletedFetchers = _ref2.deletedFetchers, flushSync = _ref2.flushSync, viewTransitionOpts = _ref2.viewTransitionOpts;
        deletedFetchers.forEach(function(key) {
            return fetcherData.current.delete(key);
        });
        newState.fetchers.forEach(function(fetcher, key) {
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        var isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $fc41d09ddc03e3ec$var$flushSyncSafe(function() {
                return setStateImpl(newState);
            });
            else optInStartTransition(function() {
                return setStateImpl(newState);
            });
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $fc41d09ddc03e3ec$var$flushSyncSafe(function() {
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            var t = router.window.document.startViewTransition(function() {
                $fc41d09ddc03e3ec$var$flushSyncSafe(function() {
                    return setStateImpl(newState);
                });
            });
            // Clean up after the animation completes
            t.finished.finally(function() {
                $fc41d09ddc03e3ec$var$flushSyncSafe(function() {
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $fc41d09ddc03e3ec$var$flushSyncSafe(function() {
                return setTransition(t);
            });
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $dQFEZ.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $dQFEZ.useEffect(function() {
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $fc41d09ddc03e3ec$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $dQFEZ.useEffect(function() {
        if (renderDfd && pendingState && router.window) {
            var newState = pendingState;
            var renderPromise = renderDfd.promise;
            var transition = router.window.document.startViewTransition(function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
                    return (0, $fRv9I.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                optInStartTransition(function() {
                                    return setStateImpl(newState);
                                });
                                return [
                                    4,
                                    renderPromise
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            });
            transition.finished.finally(function() {
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $dQFEZ.useEffect(function() {
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $dQFEZ.useEffect(function() {
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $dQFEZ.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $dQFEZ.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $dQFEZ.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    var routerFuture = $dQFEZ.useMemo(function() {
        return {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        };
    }, [
        router.future.v7_relativeSplatPath
    ]);
    $dQFEZ.useEffect(function() {
        return (0, $8c3ad80f8a436e0f$export$db5148ec97d6af7a)(future, router.future);
    }, [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $dQFEZ.createElement($dQFEZ.Fragment, null, /*#__PURE__*/ $dQFEZ.createElement((0, $8c3ad80f8a436e0f$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $dQFEZ.createElement((0, $8c3ad80f8a436e0f$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $dQFEZ.createElement($fc41d09ddc03e3ec$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $dQFEZ.createElement($fc41d09ddc03e3ec$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $dQFEZ.createElement((0, $8c3ad80f8a436e0f$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $dQFEZ.createElement($fc41d09ddc03e3ec$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
var $fc41d09ddc03e3ec$var$MemoizedDataRoutes = /*#__PURE__*/ $dQFEZ.memo($fc41d09ddc03e3ec$var$DataRoutes);
function $fc41d09ddc03e3ec$var$DataRoutes(_ref3) {
    var routes = _ref3.routes, future = _ref3.future, state = _ref3.state;
    return (0, $8c3ad80f8a436e0f$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $fc41d09ddc03e3ec$export$9ba4e89fdfa1fc54(_ref4) {
    var basename = _ref4.basename, children = _ref4.children, future = _ref4.future, _$window = _ref4.window;
    var historyRef = $dQFEZ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $gl7zH.createBrowserHistory)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $dQFEZ.useCallback(function(newState) {
        v7_startTransition && $fc41d09ddc03e3ec$var$startTransitionImpl ? $fc41d09ddc03e3ec$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dQFEZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    $dQFEZ.useEffect(function() {
        return (0, $8c3ad80f8a436e0f$export$db5148ec97d6af7a)(future);
    }, [
        future
    ]);
    return /*#__PURE__*/ $dQFEZ.createElement((0, $8c3ad80f8a436e0f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $fc41d09ddc03e3ec$export$7221d69dcfc8e36b(_ref5) {
    var basename = _ref5.basename, children = _ref5.children, future = _ref5.future, _$window = _ref5.window;
    var historyRef = $dQFEZ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $gl7zH.createHashHistory)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $dQFEZ.useCallback(function(newState) {
        v7_startTransition && $fc41d09ddc03e3ec$var$startTransitionImpl ? $fc41d09ddc03e3ec$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dQFEZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    $dQFEZ.useEffect(function() {
        return (0, $8c3ad80f8a436e0f$export$db5148ec97d6af7a)(future);
    }, [
        future
    ]);
    return /*#__PURE__*/ $dQFEZ.createElement((0, $8c3ad80f8a436e0f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $fc41d09ddc03e3ec$export$eefb0c834599897e(_ref6) {
    var basename = _ref6.basename, children = _ref6.children, future = _ref6.future, history = _ref6.history;
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $dQFEZ.useCallback(function(newState) {
        v7_startTransition && $fc41d09ddc03e3ec$var$startTransitionImpl ? $fc41d09ddc03e3ec$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dQFEZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    $dQFEZ.useEffect(function() {
        return (0, $8c3ad80f8a436e0f$export$db5148ec97d6af7a)(future);
    }, [
        future
    ]);
    return /*#__PURE__*/ $dQFEZ.createElement((0, $8c3ad80f8a436e0f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
var $fc41d09ddc03e3ec$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var $fc41d09ddc03e3ec$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ var $fc41d09ddc03e3ec$export$a6c7ac8248d6e38a = /*#__PURE__*/ $dQFEZ.forwardRef(function LinkWithRef(_ref7, ref) {
    var onClick = _ref7.onClick, relative = _ref7.relative, reloadDocument = _ref7.reloadDocument, replace = _ref7.replace, state = _ref7.state, target = _ref7.target, to = _ref7.to, preventScrollReset = _ref7.preventScrollReset, viewTransition = _ref7.viewTransition, rest = $fc41d09ddc03e3ec$var$_objectWithoutPropertiesLoose(_ref7, $fc41d09ddc03e3ec$var$_excluded);
    var basename = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$26749e8557646306)).basename;
    // Rendered into <a href> for absolute URLs
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && $fc41d09ddc03e3ec$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($fc41d09ddc03e3ec$var$isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = (0, $gl7zH.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    var href = (0, $8c3ad80f8a436e0f$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    var internalOnClick = $fc41d09ddc03e3ec$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $dQFEZ.createElement("a", $fc41d09ddc03e3ec$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ var $fc41d09ddc03e3ec$export$b0d92dbee9b5b60d = /*#__PURE__*/ $dQFEZ.forwardRef(function NavLinkWithRef(_ref8, ref) {
    var tmp = _ref8["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _ref8_caseSensitive = _ref8.caseSensitive, caseSensitive = _ref8_caseSensitive === void 0 ? false : _ref8_caseSensitive, tmp1 = _ref8.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _ref8_end = _ref8.end, end = _ref8_end === void 0 ? false : _ref8_end, styleProp = _ref8.style, to = _ref8.to, viewTransition = _ref8.viewTransition, children = _ref8.children, rest = $fc41d09ddc03e3ec$var$_objectWithoutPropertiesLoose(_ref8, $fc41d09ddc03e3ec$var$_excluded2);
    var path = (0, $8c3ad80f8a436e0f$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    var location = (0, $8c3ad80f8a436e0f$export$45d76561a5302f2b)();
    var routerState = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$145dfa71566a64dc));
    var _React_useContext = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$26749e8557646306)), navigator = _React_useContext.navigator, basename = _React_useContext.basename;
    var isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $fc41d09ddc03e3ec$export$e262bd1977bea848(path) && viewTransition === true;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $gl7zH.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    var endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    var ariaCurrent = isActive ? ariaCurrentProp : undefined;
    var className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $dQFEZ.createElement($fc41d09ddc03e3ec$export$a6c7ac8248d6e38a, $fc41d09ddc03e3ec$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ var $fc41d09ddc03e3ec$export$a7fed597f4b8afd8 = /*#__PURE__*/ $dQFEZ.forwardRef(function(_ref9, forwardedRef) {
    var fetcherKey = _ref9.fetcherKey, navigate = _ref9.navigate, reloadDocument = _ref9.reloadDocument, replace = _ref9.replace, state = _ref9.state, _ref9_method = _ref9.method, method = _ref9_method === void 0 ? $fc41d09ddc03e3ec$var$defaultMethod : _ref9_method, action = _ref9.action, onSubmit = _ref9.onSubmit, relative = _ref9.relative, preventScrollReset = _ref9.preventScrollReset, viewTransition = _ref9.viewTransition, props = $fc41d09ddc03e3ec$var$_objectWithoutPropertiesLoose(_ref9, $fc41d09ddc03e3ec$var$_excluded3);
    var submit = $fc41d09ddc03e3ec$export$47c85c6e3a081d3();
    var formAction = $fc41d09ddc03e3ec$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $dQFEZ.createElement("form", $fc41d09ddc03e3ec$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $fc41d09ddc03e3ec$export$11aac1aab828f1fa(_ref10) {
    var getKey = _ref10.getKey, storageKey = _ref10.storageKey;
    $fc41d09ddc03e3ec$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $fc41d09ddc03e3ec$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($fc41d09ddc03e3ec$var$DataRouterHook || ($fc41d09ddc03e3ec$var$DataRouterHook = {}));
var $fc41d09ddc03e3ec$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($fc41d09ddc03e3ec$var$DataRouterStateHook || ($fc41d09ddc03e3ec$var$DataRouterStateHook = {}));
// Internal hooks
function $fc41d09ddc03e3ec$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $fc41d09ddc03e3ec$var$useDataRouterContext(hookName) {
    var ctx = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$3add0d5dce533e2e));
    !ctx && (0, $gl7zH.UNSAFE_invariant)(false);
    return ctx;
}
function $fc41d09ddc03e3ec$var$useDataRouterState(hookName) {
    var state = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$145dfa71566a64dc));
    !state && (0, $gl7zH.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $fc41d09ddc03e3ec$export$67621102c14d847(to, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative, viewTransition = _ref.viewTransition;
    var navigate = (0, $8c3ad80f8a436e0f$export$9770f232ac06a008)();
    var location = (0, $8c3ad80f8a436e0f$export$45d76561a5302f2b)();
    var path = (0, $8c3ad80f8a436e0f$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $dQFEZ.useCallback(function(event) {
        if ($fc41d09ddc03e3ec$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            var replace = replaceProp !== undefined ? replaceProp : (0, $gl7zH.createPath)(location) === (0, $gl7zH.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $fc41d09ddc03e3ec$export$f1a78c17382fe22a(defaultInit) {
    var defaultSearchParamsRef = $dQFEZ.useRef($fc41d09ddc03e3ec$export$a2e4e2dcc7b1f22f(defaultInit));
    var hasSetSearchParamsRef = $dQFEZ.useRef(false);
    var location = (0, $8c3ad80f8a436e0f$export$45d76561a5302f2b)();
    var searchParams = $dQFEZ.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $fc41d09ddc03e3ec$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = (0, $8c3ad80f8a436e0f$export$9770f232ac06a008)();
    var setSearchParams = $dQFEZ.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = $fc41d09ddc03e3ec$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $fc41d09ddc03e3ec$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
var $fc41d09ddc03e3ec$var$fetcherId = 0;
var $fc41d09ddc03e3ec$var$getUniqueFetcherId = function() {
    return "__" + String(++$fc41d09ddc03e3ec$var$fetcherId) + "__";
};
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $fc41d09ddc03e3ec$export$47c85c6e3a081d3() {
    var router = $fc41d09ddc03e3ec$var$useDataRouterContext($fc41d09ddc03e3ec$var$DataRouterHook.UseSubmit).router;
    var basename = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$26749e8557646306)).basename;
    var currentRouteId = (0, $8c3ad80f8a436e0f$export$5fc8298006ad9e58)();
    return $dQFEZ.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $fc41d09ddc03e3ec$var$validateClientSideSubmission();
        var _getFormSubmissionInfo = $fc41d09ddc03e3ec$var$getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        if (options.navigate === false) {
            var key = options.fetcherKey || $fc41d09ddc03e3ec$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $fc41d09ddc03e3ec$export$89a6bd6db0d97c56(action, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var basename = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$26749e8557646306)).basename;
    var routeContext = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$9072aa6dd1f93057));
    !routeContext && (0, $gl7zH.UNSAFE_invariant)(false);
    var _routeContext_matches_slice = (0, $2nwvT._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    var path = $fc41d09ddc03e3ec$var$_extends({}, (0, $8c3ad80f8a436e0f$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    var location = (0, $8c3ad80f8a436e0f$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        var params = new URLSearchParams(path.search);
        var indexValues = params.getAll("index");
        var hasNakedIndexParam = indexValues.some(function(v) {
            return v === "";
        });
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter(function(v) {
                return v;
            }).forEach(function(v) {
                return params.append("index", v);
            });
            var qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $gl7zH.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $gl7zH.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $fc41d09ddc03e3ec$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    var key = (_temp3 === void 0 ? {} : _temp3).key;
    var router = $fc41d09ddc03e3ec$var$useDataRouterContext($fc41d09ddc03e3ec$var$DataRouterHook.UseFetcher).router;
    var state = $fc41d09ddc03e3ec$var$useDataRouterState($fc41d09ddc03e3ec$var$DataRouterStateHook.UseFetcher);
    var fetcherData = $dQFEZ.useContext($fc41d09ddc03e3ec$export$148fd98d095596d4);
    var route = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$9072aa6dd1f93057));
    var routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $gl7zH.UNSAFE_invariant)(false);
    !route && (0, $gl7zH.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $gl7zH.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var defaultKey = $fc41d09ddc03e3ec$var$useIdImpl ? $fc41d09ddc03e3ec$var$useIdImpl() : "";
    var _React_useState = (0, $2nwvT._)($dQFEZ.useState(key || defaultKey), 2), fetcherKey = _React_useState[0], setFetcherKey = _React_useState[1];
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($fc41d09ddc03e3ec$var$getUniqueFetcherId());
    // Registration/cleanup
    $dQFEZ.useEffect(function() {
        router.getFetcher(fetcherKey);
        return function() {
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    var load = $dQFEZ.useCallback(function(href, opts) {
        !routeId && (0, $gl7zH.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    var submitImpl = $fc41d09ddc03e3ec$export$47c85c6e3a081d3();
    var submit = $dQFEZ.useCallback(function(target, opts) {
        submitImpl(target, $fc41d09ddc03e3ec$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    var FetcherForm = $dQFEZ.useMemo(function() {
        var FetcherForm = /*#__PURE__*/ $dQFEZ.forwardRef(function(props, ref) {
            return /*#__PURE__*/ $dQFEZ.createElement($fc41d09ddc03e3ec$export$a7fed597f4b8afd8, $fc41d09ddc03e3ec$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    var fetcher = state.fetchers.get(fetcherKey) || (0, $gl7zH.IDLE_FETCHER);
    var data = fetcherData.get(fetcherKey);
    var fetcherWithComponents = $dQFEZ.useMemo(function() {
        return $fc41d09ddc03e3ec$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        });
    }, [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $fc41d09ddc03e3ec$export$fa996778a3a31087() {
    var state = $fc41d09ddc03e3ec$var$useDataRouterState($fc41d09ddc03e3ec$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map(function(_ref11) {
        var _$_ref11 = (0, $2nwvT._)(_ref11, 2), key = _$_ref11[0], fetcher = _$_ref11[1];
        return $fc41d09ddc03e3ec$var$_extends({}, fetcher, {
            key: key
        });
    });
}
var $fc41d09ddc03e3ec$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $fc41d09ddc03e3ec$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $fc41d09ddc03e3ec$export$25057cfe5591e3e9(_temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = $fc41d09ddc03e3ec$var$useDataRouterContext($fc41d09ddc03e3ec$var$DataRouterHook.UseScrollRestoration).router;
    var _useDataRouterState = $fc41d09ddc03e3ec$var$useDataRouterState($fc41d09ddc03e3ec$var$DataRouterStateHook.UseScrollRestoration), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var basename = $dQFEZ.useContext((0, $8c3ad80f8a436e0f$export$26749e8557646306)).basename;
    var location = (0, $8c3ad80f8a436e0f$export$45d76561a5302f2b)();
    var matches = (0, $8c3ad80f8a436e0f$export$2378eb7f5ff86053)();
    var navigation = (0, $8c3ad80f8a436e0f$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $dQFEZ.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $fc41d09ddc03e3ec$var$usePageHide($dQFEZ.useCallback(function() {
        if (navigation.state === "idle") {
            var key = (getKey ? getKey(location, matches) : null) || location.key;
            $fc41d09ddc03e3ec$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $fc41d09ddc03e3ec$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($fc41d09ddc03e3ec$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dQFEZ.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || $fc41d09ddc03e3ec$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $fc41d09ddc03e3ec$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dQFEZ.useLayoutEffect(function() {
            var getKeyWithoutBasename = getKey && basename !== "/" ? function(location, matches) {
                return getKey($fc41d09ddc03e3ec$var$_extends({}, location, {
                    pathname: (0, $gl7zH.stripBasename)(location.pathname, basename) || location.pathname
                }), matches);
            } : getKey;
            var disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($fc41d09ddc03e3ec$var$savedScrollPositions, function() {
                return window.scrollY;
            }, getKeyWithoutBasename);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dQFEZ.useLayoutEffect(function() {
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $fc41d09ddc03e3ec$export$c0a586b329cae57d(callback, options) {
    var capture = (options || {}).capture;
    $dQFEZ.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $fc41d09ddc03e3ec$var$usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $dQFEZ.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $fc41d09ddc03e3ec$export$39f4eb3dbd812741(_ref12) {
    var when = _ref12.when, message = _ref12.message;
    var blocker = (0, $8c3ad80f8a436e0f$export$b273b3273281a049)(when);
    $dQFEZ.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $dQFEZ.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $fc41d09ddc03e3ec$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    var vtContext = $dQFEZ.useContext($fc41d09ddc03e3ec$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $gl7zH.UNSAFE_invariant)(false);
    var basename = $fc41d09ddc03e3ec$var$useDataRouterContext($fc41d09ddc03e3ec$var$DataRouterHook.useViewTransitionState).basename;
    var path = (0, $8c3ad80f8a436e0f$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    var currentPath = (0, $gl7zH.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    var nextPath = (0, $gl7zH.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $gl7zH.matchPath)(path.pathname, nextPath) != null || (0, $gl7zH.matchPath)(path.pathname, currentPath) != null;
}



var $72osQ = parcelRequire("72osQ");

var $2nwvT = parcelRequire("2nwvT");

var $2us1u = parcelRequire("2us1u");

var $bJtXW = parcelRequire("bJtXW");

var $dQFEZ = parcelRequire("dQFEZ");
var $f6758991d88cb14f$exports = {};
'use strict';

$f6758991d88cb14f$exports = (parcelRequire("imka8"));


var $d7d37dc522b09008$var$__defProp = Object.defineProperty;
var $d7d37dc522b09008$var$__defProps = Object.defineProperties;
var $d7d37dc522b09008$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d7d37dc522b09008$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d7d37dc522b09008$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d7d37dc522b09008$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d7d37dc522b09008$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $d7d37dc522b09008$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $d7d37dc522b09008$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($d7d37dc522b09008$var$__hasOwnProp.call(b, prop)) $d7d37dc522b09008$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($d7d37dc522b09008$var$__getOwnPropSymbols) try {
        for(var _iterator = $d7d37dc522b09008$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($d7d37dc522b09008$var$__propIsEnum.call(b, prop)) $d7d37dc522b09008$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $d7d37dc522b09008$var$__spreadProps = function(a, b) {
    return $d7d37dc522b09008$var$__defProps(a, $d7d37dc522b09008$var$__getOwnPropDescs(b));
};
var $d7d37dc522b09008$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($d7d37dc522b09008$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (source != null && $d7d37dc522b09008$var$__getOwnPropSymbols) try {
        for(var _iterator = $d7d37dc522b09008$var$__getOwnPropSymbols(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (exclude.indexOf(prop) < 0 && $d7d37dc522b09008$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return target;
};
// src/utils/react-is.ts
var $d7d37dc522b09008$var$IS_REACT_19 = /* @__PURE__ */ $dQFEZ.version.startsWith("19");
var $d7d37dc522b09008$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($d7d37dc522b09008$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $d7d37dc522b09008$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $d7d37dc522b09008$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $d7d37dc522b09008$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $d7d37dc522b09008$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $d7d37dc522b09008$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $d7d37dc522b09008$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $d7d37dc522b09008$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $d7d37dc522b09008$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $d7d37dc522b09008$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $d7d37dc522b09008$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $d7d37dc522b09008$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $d7d37dc522b09008$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $d7d37dc522b09008$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $d7d37dc522b09008$var$ForwardRef = $d7d37dc522b09008$var$REACT_FORWARD_REF_TYPE;
var $d7d37dc522b09008$var$Memo = $d7d37dc522b09008$var$REACT_MEMO_TYPE;
function $d7d37dc522b09008$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $d7d37dc522b09008$var$REACT_FRAGMENT_TYPE || type === $d7d37dc522b09008$var$REACT_PROFILER_TYPE || type === $d7d37dc522b09008$var$REACT_STRICT_MODE_TYPE || type === $d7d37dc522b09008$var$REACT_SUSPENSE_TYPE || type === $d7d37dc522b09008$var$REACT_SUSPENSE_LIST_TYPE || type === $d7d37dc522b09008$var$REACT_OFFSCREEN_TYPE || (typeof type === "undefined" ? "undefined" : (0, $bJtXW._)(type)) === "object" && type !== null && (type.$$typeof === $d7d37dc522b09008$var$REACT_LAZY_TYPE || type.$$typeof === $d7d37dc522b09008$var$REACT_MEMO_TYPE || type.$$typeof === $d7d37dc522b09008$var$REACT_CONTEXT_TYPE || type.$$typeof === $d7d37dc522b09008$var$REACT_CONSUMER_TYPE || type.$$typeof === $d7d37dc522b09008$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $d7d37dc522b09008$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $d7d37dc522b09008$var$typeOf(object) {
    if ((typeof object === "undefined" ? "undefined" : (0, $bJtXW._)(object)) === "object" && object !== null) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $d7d37dc522b09008$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $d7d37dc522b09008$var$REACT_FRAGMENT_TYPE:
                    case $d7d37dc522b09008$var$REACT_PROFILER_TYPE:
                    case $d7d37dc522b09008$var$REACT_STRICT_MODE_TYPE:
                    case $d7d37dc522b09008$var$REACT_SUSPENSE_TYPE:
                    case $d7d37dc522b09008$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $d7d37dc522b09008$var$REACT_CONTEXT_TYPE:
                            case $d7d37dc522b09008$var$REACT_FORWARD_REF_TYPE:
                            case $d7d37dc522b09008$var$REACT_LAZY_TYPE:
                            case $d7d37dc522b09008$var$REACT_MEMO_TYPE:
                                return object;
                            case $d7d37dc522b09008$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $d7d37dc522b09008$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $d7d37dc522b09008$var$isContextConsumer(object) {
    return $d7d37dc522b09008$var$IS_REACT_19 ? $d7d37dc522b09008$var$typeOf(object) === $d7d37dc522b09008$var$REACT_CONSUMER_TYPE : $d7d37dc522b09008$var$typeOf(object) === $d7d37dc522b09008$var$REACT_CONTEXT_TYPE;
}
function $d7d37dc522b09008$var$isMemo(object) {
    return $d7d37dc522b09008$var$typeOf(object) === $d7d37dc522b09008$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $d7d37dc522b09008$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $d7d37dc522b09008$var$verify(selector, methodName) {
    if (!selector) throw new Error("Unexpected value for ".concat(methodName, " in connect."));
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $d7d37dc522b09008$var$warning("The selector for ".concat(methodName, " of connect did not specify a value for dependsOnOwnProps."));
    }
}
function $d7d37dc522b09008$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $d7d37dc522b09008$var$verify(mapStateToProps, "mapStateToProps");
    $d7d37dc522b09008$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $d7d37dc522b09008$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $d7d37dc522b09008$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, param) {
    var areStatesEqual = param.areStatesEqual, areOwnPropsEqual = param.areOwnPropsEqual, areStatePropsEqual = param.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $d7d37dc522b09008$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, initMapStateToProps = _b.initMapStateToProps, initMapDispatchToProps = _b.initMapDispatchToProps, initMergeProps = _b.initMergeProps, options = $d7d37dc522b09008$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    return $d7d37dc522b09008$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $d7d37dc522b09008$var$bindActionCreators(actionCreators, dispatch) {
    var _loop = function(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return dispatch(actionCreator.apply(void 0, (0, $2us1u._)(args)));
        };
    };
    var boundActionCreators = {};
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $d7d37dc522b09008$var$isPlainObject(obj) {
    if ((typeof obj === "undefined" ? "undefined" : (0, $bJtXW._)(obj)) !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $d7d37dc522b09008$var$verifyPlainObject(value, displayName, methodName) {
    if (!$d7d37dc522b09008$var$isPlainObject(value)) $d7d37dc522b09008$var$warning("".concat(methodName, "() in ").concat(displayName, " must return a plain object. Instead received ").concat(value, "."));
}
// src/connect/wrapMapToProps.ts
function $d7d37dc522b09008$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        var constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $d7d37dc522b09008$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $d7d37dc522b09008$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, param) {
        var displayName = param.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $d7d37dc522b09008$var$getDependsOnOwnProps(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $d7d37dc522b09008$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $d7d37dc522b09008$var$createInvalidArgFactory(arg, name) {
    return function(dispatch, options) {
        throw new Error("Invalid value of type ".concat(typeof arg === "undefined" ? "undefined" : (0, $bJtXW._)(arg), " for ").concat(name, " argument when connecting component ").concat(options.wrappedComponentName, "."));
    };
}
// src/connect/mapDispatchToProps.ts
function $d7d37dc522b09008$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && (typeof mapDispatchToProps === "undefined" ? "undefined" : (0, $bJtXW._)(mapDispatchToProps)) === "object" ? $d7d37dc522b09008$var$wrapMapToPropsConstant(function(dispatch) {
        return(// @ts-ignore
        $d7d37dc522b09008$var$bindActionCreators(mapDispatchToProps, dispatch));
    }) : !mapDispatchToProps ? $d7d37dc522b09008$var$wrapMapToPropsConstant(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $d7d37dc522b09008$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $d7d37dc522b09008$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $d7d37dc522b09008$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $d7d37dc522b09008$var$wrapMapToPropsConstant(function() {
        return {};
    }) : typeof mapStateToProps === "function" ? // @ts-ignore
    $d7d37dc522b09008$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $d7d37dc522b09008$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $d7d37dc522b09008$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $d7d37dc522b09008$var$__spreadValues($d7d37dc522b09008$var$__spreadValues($d7d37dc522b09008$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $d7d37dc522b09008$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, param) {
        var displayName = param.displayName, areMergedPropsEqual = param.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $d7d37dc522b09008$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? function() {
        return $d7d37dc522b09008$var$defaultMergeProps;
    } : typeof mergeProps === "function" ? $d7d37dc522b09008$var$wrapMergePropsFunc(mergeProps) : $d7d37dc522b09008$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $d7d37dc522b09008$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $d7d37dc522b09008$var$createListenerCollection() {
    var first = null;
    var last = null;
    return {
        clear: function() {
            first = null;
            last = null;
        },
        notify: function() {
            $d7d37dc522b09008$var$defaultNoopBatch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $d7d37dc522b09008$var$nullListeners = {
    notify: function() {},
    get: function() {
        return [];
    }
};
function $d7d37dc522b09008$var$createSubscription(store, parentSub) {
    var unsubscribe;
    var listeners = $d7d37dc522b09008$var$nullListeners;
    var subscriptionsAmount = 0;
    var selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        var cleanupListener = listeners.subscribe(listener);
        var removed = false;
        return function() {
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $d7d37dc522b09008$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $d7d37dc522b09008$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: function() {
            return listeners;
        }
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $d7d37dc522b09008$var$canUseDOM = function() {
    return !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
};
var $d7d37dc522b09008$var$isDOM = /* @__PURE__ */ $d7d37dc522b09008$var$canUseDOM();
var $d7d37dc522b09008$var$isRunningInReactNative = function() {
    return typeof navigator !== "undefined" && navigator.product === "ReactNative";
};
var $d7d37dc522b09008$var$isReactNative = /* @__PURE__ */ $d7d37dc522b09008$var$isRunningInReactNative();
var $d7d37dc522b09008$var$getUseIsomorphicLayoutEffect = function() {
    return $d7d37dc522b09008$var$isDOM || $d7d37dc522b09008$var$isReactNative ? $dQFEZ.useLayoutEffect : $dQFEZ.useEffect;
};
var $d7d37dc522b09008$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $d7d37dc522b09008$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $d7d37dc522b09008$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $d7d37dc522b09008$export$d36bdfa510afb180(objA, objB) {
    if ($d7d37dc522b09008$var$is(objA, objB)) return true;
    if ((typeof objA === "undefined" ? "undefined" : (0, $bJtXW._)(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : (0, $bJtXW._)(objB)) !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$d7d37dc522b09008$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $d7d37dc522b09008$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $d7d37dc522b09008$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $d7d37dc522b09008$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $d7d37dc522b09008$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $d7d37dc522b09008$var$_obj;
var $d7d37dc522b09008$var$TYPE_STATICS = ($d7d37dc522b09008$var$_obj = {}, (0, $72osQ._)($d7d37dc522b09008$var$_obj, $d7d37dc522b09008$var$ForwardRef, $d7d37dc522b09008$var$FORWARD_REF_STATICS), (0, $72osQ._)($d7d37dc522b09008$var$_obj, $d7d37dc522b09008$var$Memo, $d7d37dc522b09008$var$MEMO_STATICS), $d7d37dc522b09008$var$_obj);
function $d7d37dc522b09008$var$getStatics(component) {
    if ($d7d37dc522b09008$var$isMemo(component)) return $d7d37dc522b09008$var$MEMO_STATICS;
    return $d7d37dc522b09008$var$TYPE_STATICS[component["$$typeof"]] || $d7d37dc522b09008$var$REACT_STATICS;
}
var $d7d37dc522b09008$var$defineProperty = Object.defineProperty;
var $d7d37dc522b09008$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $d7d37dc522b09008$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $d7d37dc522b09008$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $d7d37dc522b09008$var$getPrototypeOf = Object.getPrototypeOf;
var $d7d37dc522b09008$var$objectPrototype = Object.prototype;
function $d7d37dc522b09008$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($d7d37dc522b09008$var$objectPrototype) {
            var inheritedComponent = $d7d37dc522b09008$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $d7d37dc522b09008$var$objectPrototype) $d7d37dc522b09008$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        var keys = $d7d37dc522b09008$var$getOwnPropertyNames(sourceComponent);
        if ($d7d37dc522b09008$var$getOwnPropertySymbols) keys = keys.concat($d7d37dc522b09008$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $d7d37dc522b09008$var$getStatics(targetComponent);
        var sourceStatics = $d7d37dc522b09008$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$d7d37dc522b09008$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $d7d37dc522b09008$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $d7d37dc522b09008$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $d7d37dc522b09008$var$ContextKey = /* @__PURE__ */ Symbol.for("react-redux-context");
var $d7d37dc522b09008$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $d7d37dc522b09008$var$getContext() {
    var _a;
    if (!$dQFEZ.createContext) return {};
    var contextMap = (_a = $d7d37dc522b09008$var$gT[$d7d37dc522b09008$var$ContextKey]) != null ? _a : $d7d37dc522b09008$var$gT[$d7d37dc522b09008$var$ContextKey] = /* @__PURE__ */ new Map();
    var realContext = contextMap.get($dQFEZ.createContext);
    if (!realContext) {
        realContext = $dQFEZ.createContext(null);
        contextMap.set($dQFEZ.createContext, realContext);
    }
    return realContext;
}
var $d7d37dc522b09008$export$cc80c08dc91f1c00 = /* @__PURE__ */ $d7d37dc522b09008$var$getContext();
// src/components/connect.tsx
var $d7d37dc522b09008$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $d7d37dc522b09008$var$stringifyComponent = function(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $d7d37dc522b09008$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $d7d37dc522b09008$var$useIsomorphicLayoutEffect(function() {
        return effectFunc.apply(void 0, (0, $2us1u._)(effectArgs));
    }, dependencies);
}
function $d7d37dc522b09008$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $d7d37dc522b09008$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return function() {};
    var didUnsubscribe = false;
    var lastThrownError = null;
    var checkForUpdates = function() {
        if (didUnsubscribe || !isMounted.current) return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    var unsubscribeWrapper = function() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $d7d37dc522b09008$var$strictEqual(a, b) {
    return a === b;
}
var $d7d37dc522b09008$var$hasWarnedAboutDeprecatedPureOption = false;
function $d7d37dc522b09008$var$connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
    // @ts-ignore
    pure = _ref.pure, _ref_areStatesEqual = _ref.areStatesEqual, areStatesEqual = _ref_areStatesEqual === void 0 ? $d7d37dc522b09008$var$strictEqual : _ref_areStatesEqual, _ref_areOwnPropsEqual = _ref.areOwnPropsEqual, areOwnPropsEqual = _ref_areOwnPropsEqual === void 0 ? $d7d37dc522b09008$export$d36bdfa510afb180 : _ref_areOwnPropsEqual, _ref_areStatePropsEqual = _ref.areStatePropsEqual, areStatePropsEqual = _ref_areStatePropsEqual === void 0 ? $d7d37dc522b09008$export$d36bdfa510afb180 : _ref_areStatePropsEqual, _ref_areMergedPropsEqual = _ref.areMergedPropsEqual, areMergedPropsEqual = _ref_areMergedPropsEqual === void 0 ? $d7d37dc522b09008$export$d36bdfa510afb180 : _ref_areMergedPropsEqual, _ref_forwardRef = _ref.// use React's forwardRef to expose a ref of the wrapped component
    forwardRef, forwardRef = _ref_forwardRef === void 0 ? false : _ref_forwardRef, _ref_context = _ref.// the context consumer to use
    context, context = _ref_context === void 0 ? $d7d37dc522b09008$export$cc80c08dc91f1c00 : _ref_context;
    var Context = context;
    var initMapStateToProps = $d7d37dc522b09008$var$mapStateToPropsFactory(mapStateToProps);
    var initMapDispatchToProps = $d7d37dc522b09008$var$mapDispatchToPropsFactory(mapDispatchToProps);
    var initMergeProps = $d7d37dc522b09008$var$mergePropsFactory(mergeProps);
    var shouldHandleStateChanges = Boolean(mapStateToProps);
    var wrapWithConnect = function(WrappedComponent) {
        var ConnectFunction = function ConnectFunction(props) {
            var _React_useMemo = (0, $2nwvT._)($dQFEZ.useMemo(function() {
                var _a = props, reactReduxForwardedRef2 = _a.reactReduxForwardedRef, wrapperProps2 = $d7d37dc522b09008$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]), 3), propsContext = _React_useMemo[0], reactReduxForwardedRef = _React_useMemo[1], wrapperProps = _React_useMemo[2];
            var ContextToUse = $dQFEZ.useMemo(function() {
                var ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            var contextValue = $dQFEZ.useContext(ContextToUse);
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            var childPropsSelector = $dQFEZ.useMemo(function() {
                return $d7d37dc522b09008$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            var _React_useMemo1 = (0, $2nwvT._)($dQFEZ.useMemo(function() {
                if (!shouldHandleStateChanges) return $d7d37dc522b09008$var$NO_SUBSCRIPTION_ARRAY;
                var subscription2 = $d7d37dc522b09008$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                var notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), 2), subscription = _React_useMemo1[0], notifyNestedSubs = _React_useMemo1[1];
            var overriddenContextValue = $dQFEZ.useMemo(function() {
                if (didStoreComeFromProps) return contextValue;
                return $d7d37dc522b09008$var$__spreadProps($d7d37dc522b09008$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            var lastChildProps = $dQFEZ.useRef(void 0);
            var lastWrapperProps = $dQFEZ.useRef(wrapperProps);
            var childPropsFromStoreUpdate = $dQFEZ.useRef(void 0);
            var renderIsScheduled = $dQFEZ.useRef(false);
            var isMounted = $dQFEZ.useRef(false);
            var latestSubscriptionCallbackError = $dQFEZ.useRef(void 0);
            $d7d37dc522b09008$var$useIsomorphicLayoutEffect(function() {
                isMounted.current = true;
                return function() {
                    isMounted.current = false;
                };
            }, []);
            var actualChildPropsSelector = $dQFEZ.useMemo(function() {
                var selector = function() {
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            var subscribeForReact = $dQFEZ.useMemo(function() {
                var subscribe = function(reactListener) {
                    if (!subscription) return function() {};
                    return $d7d37dc522b09008$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $d7d37dc522b09008$var$useIsomorphicLayoutEffectWithArgs($d7d37dc522b09008$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            var actualChildProps;
            try {
                actualChildProps = $dQFEZ.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? function() {
                    return childPropsSelector(getServerState(), wrapperProps);
                } : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n".concat(latestSubscriptionCallbackError.current.stack, "\n\n");
                throw err;
            }
            $d7d37dc522b09008$var$useIsomorphicLayoutEffect(function() {
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            var renderedWrappedComponent = $dQFEZ.useMemo(function() {
                return(// @ts-ignore
                /* @__PURE__ */ $dQFEZ.createElement(WrappedComponent, $d7d37dc522b09008$var$__spreadProps($d7d37dc522b09008$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            var renderedChild = $dQFEZ.useMemo(function() {
                if (shouldHandleStateChanges) return /* @__PURE__ */ $dQFEZ.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        };
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = "Connect(".concat(wrappedComponentName, ")");
        var selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            // @ts-ignore
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        var _Connect = $dQFEZ.memo(ConnectFunction);
        var Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var _forwarded = $dQFEZ.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $dQFEZ.createElement(Connect, $d7d37dc522b09008$var$__spreadProps($d7d37dc522b09008$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            var forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $d7d37dc522b09008$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $d7d37dc522b09008$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $d7d37dc522b09008$export$64605811ab45167f = $d7d37dc522b09008$var$connect;
// src/components/Provider.tsx
function $d7d37dc522b09008$var$Provider(providerProps) {
    var children = providerProps.children, context = providerProps.context, serverState = providerProps.serverState, store = providerProps.store;
    var contextValue = $dQFEZ.useMemo(function() {
        var subscription = $d7d37dc522b09008$var$createSubscription(store);
        var baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? function() {
                return serverState;
            } : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    var previousState = $dQFEZ.useMemo(function() {
        return store.getState();
    }, [
        store
    ]);
    $d7d37dc522b09008$var$useIsomorphicLayoutEffect(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || $d7d37dc522b09008$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $dQFEZ.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $d7d37dc522b09008$export$2881499e37b75b9a = $d7d37dc522b09008$var$Provider;
// src/hooks/useReduxContext.ts
function $d7d37dc522b09008$var$createReduxContextHook() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $d7d37dc522b09008$export$cc80c08dc91f1c00;
    return function useReduxContext2() {
        var contextValue = $dQFEZ.useContext(context);
        return contextValue;
    };
}
var $d7d37dc522b09008$var$useReduxContext = /* @__PURE__ */ $d7d37dc522b09008$var$createReduxContextHook();
// src/hooks/useStore.ts
function $d7d37dc522b09008$export$671dba69185d0304() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $d7d37dc522b09008$export$cc80c08dc91f1c00;
    var useReduxContext2 = context === $d7d37dc522b09008$export$cc80c08dc91f1c00 ? $d7d37dc522b09008$var$useReduxContext : // @ts-ignore
    $d7d37dc522b09008$var$createReduxContextHook(context);
    var useStore2 = function() {
        var store = useReduxContext2().store;
        return store;
    };
    Object.assign(useStore2, {
        withTypes: function() {
            return useStore2;
        }
    });
    return useStore2;
}
var $d7d37dc522b09008$export$6ccbb43953eebf8 = /* @__PURE__ */ $d7d37dc522b09008$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $d7d37dc522b09008$export$bc9b55530897c558() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $d7d37dc522b09008$export$cc80c08dc91f1c00;
    var useStore2 = context === $d7d37dc522b09008$export$cc80c08dc91f1c00 ? $d7d37dc522b09008$export$6ccbb43953eebf8 : $d7d37dc522b09008$export$671dba69185d0304(context);
    var useDispatch2 = function() {
        var store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: function() {
            return useDispatch2;
        }
    });
    return useDispatch2;
}
var $d7d37dc522b09008$export$8ad76b76a4c905f8 = /* @__PURE__ */ $d7d37dc522b09008$export$bc9b55530897c558();
var $d7d37dc522b09008$var$refEquality = function(a, b) {
    return a === b;
};
function $d7d37dc522b09008$export$2b53f90d2bd1cbfb() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $d7d37dc522b09008$export$cc80c08dc91f1c00;
    var useReduxContext2 = context === $d7d37dc522b09008$export$cc80c08dc91f1c00 ? $d7d37dc522b09008$var$useReduxContext : $d7d37dc522b09008$var$createReduxContextHook(context);
    var useSelector2 = function(selector) {
        var equalityFnOrOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _ref = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions, _ref_equalityFn = _ref.equalityFn, equalityFn = _ref_equalityFn === void 0 ? $d7d37dc522b09008$var$refEquality : _ref_equalityFn;
        var reduxContext = useReduxContext2();
        var store = reduxContext.store, subscription = reduxContext.subscription, getServerState = reduxContext.getServerState;
        var firstRun = $dQFEZ.useRef(true);
        var wrappedSelector = $dQFEZ.useCallback((0, $72osQ._)({}, selector.name, function(state) {
            var selected = selector(state);
            var e, e1;
            return selected;
        })[selector.name], [
            selector
        ]);
        var selectedState = (0, $f6758991d88cb14f$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $dQFEZ.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: function() {
            return useSelector2;
        }
    });
    return useSelector2;
}
var $d7d37dc522b09008$export$2105062e25df4afe = /* @__PURE__ */ $d7d37dc522b09008$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $d7d37dc522b09008$export$712ea50be43a7858 = $d7d37dc522b09008$var$defaultNoopBatch;



var $2nwvT = parcelRequire("2nwvT");

var $iD4WH = parcelRequire("iD4WH");

var $dQFEZ = parcelRequire("dQFEZ");
var $38cd5b14fd1a4b6a$var$LOGO_URL = "https://www.logodesign.net/logo/smoking-burger-with-lettuce-3624ld.png?nwm=1&nws=1&industry=fast-food&sf=&txt_keyword=All";
var $38cd5b14fd1a4b6a$export$2e2bcd8739ae039 = $38cd5b14fd1a4b6a$var$LOGO_URL;
var $38cd5b14fd1a4b6a$export$d43f2f435f160490 = "https://quickbites-gg47.onrender.com";




var $dQFEZ = parcelRequire("dQFEZ");
var $d868f44da76e6f1f$var$userContext = /*#__PURE__*/ (0, $dQFEZ.createContext)({
    loggedInUser: "default User"
});
var $d868f44da76e6f1f$export$2e2bcd8739ae039 = $d868f44da76e6f1f$var$userContext;



var $2nwvT = parcelRequire("2nwvT");

var $dQFEZ = parcelRequire("dQFEZ");
var $c749438cc5c10da8$var$useonlineStatus = function() {
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)(true), 2), onlineStatus = _useState[0], setonlineStatus = _useState[1];
    (0, $dQFEZ.useEffect)(function() {
        window.addEventListener("offline", function() {
            setonlineStatus(false);
        });
        window.addEventListener("online", function() {
            setonlineStatus(true);
        });
    }, []);
    return onlineStatus;
};
var $c749438cc5c10da8$export$2e2bcd8739ae039 = $c749438cc5c10da8$var$useonlineStatus;



var $b31165b6a74e9de9$var$Header = function() {
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)("Login"), 2), btnNameReact = _useState[0], setbtnNameReact = _useState[1];
    var loggedInUser = (0, $dQFEZ.useContext)((0, $d868f44da76e6f1f$export$2e2bcd8739ae039)).loggedInUser;
    var onlineStatus = (0, $c749438cc5c10da8$export$2e2bcd8739ae039)();
    var cartItems = (0, $d7d37dc522b09008$export$2105062e25df4afe)(function(store) {
        return store.cart.items;
    });
    return /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
        className: "sticky top-0 z-50 bg-white shadow-md",
        children: /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
            className: "max-w-7xl mx-auto flex items-center justify-between px-6 py-3",
            children: [
                /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                    className: "flex items-center",
                    children: /*#__PURE__*/ (0, $iD4WH.jsx)("img", {
                        className: "w-40 object-contain",
                        src: (0, $38cd5b14fd1a4b6a$export$2e2bcd8739ae039)
                    })
                }),
                /*#__PURE__*/ (0, $iD4WH.jsxs)("ul", {
                    className: "flex items-center gap-6 text-gray-700 font-medium",
                    children: [
                        /*#__PURE__*/ (0, $iD4WH.jsx)("li", {
                            className: "text-sm",
                            children: onlineStatus ? "\uD83D\uDFE2 Online" : "\uD83D\uDD34 Offline"
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsx)("li", {
                            className: "hover:text-green-600 transition",
                            children: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $fc41d09ddc03e3ec$export$a6c7ac8248d6e38a), {
                                to: "/",
                                children: "Home"
                            })
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsx)("li", {
                            className: "hover:text-green-600 transition",
                            children: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $fc41d09ddc03e3ec$export$a6c7ac8248d6e38a), {
                                to: "/about",
                                children: "About"
                            })
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsx)("li", {
                            className: "hover:text-green-600 transition",
                            children: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $fc41d09ddc03e3ec$export$a6c7ac8248d6e38a), {
                                to: "/contact",
                                children: "Contact"
                            })
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsx)("li", {
                            className: "hover:text-green-600 transition",
                            children: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $fc41d09ddc03e3ec$export$a6c7ac8248d6e38a), {
                                to: "/grocery",
                                children: "Grocery"
                            })
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsx)("li", {
                            className: "font-semibold hover:text-green-600 transition",
                            children: /*#__PURE__*/ (0, $iD4WH.jsxs)((0, $fc41d09ddc03e3ec$export$a6c7ac8248d6e38a), {
                                to: "/cart",
                                children: [
                                    "Cart (",
                                    cartItems.length,
                                    ")"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                            className: "px-5 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition",
                            onClick: function() {
                                btnNameReact === "Login" ? setbtnNameReact("Logout") : setbtnNameReact("Login");
                            },
                            children: btnNameReact
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsx)("li", {
                            className: "font-semibold text-gray-800",
                            children: loggedInUser
                        })
                    ]
                })
            ]
        })
    });
};
var $b31165b6a74e9de9$export$2e2bcd8739ae039 = $b31165b6a74e9de9$var$Header;



var $g3gsR = parcelRequire("g3gsR");

var $2nwvT = parcelRequire("2nwvT");

var $fRv9I = parcelRequire("fRv9I");

var $iD4WH = parcelRequire("iD4WH");

var $dQFEZ = parcelRequire("dQFEZ");


var $iD4WH = parcelRequire("iD4WH");
var $aa723e6d45ed0f27$var$Shimmer = function() {
    return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
        className: "shimmer-container",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "shimmer-cards"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "shimmer-cards"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "shimmer-cards",
                children: " "
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "shimmer-cards"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "shimmer-cards"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "shimmer-cards",
                children: " "
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "shimmer-cards"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "shimmer-cards"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "shimmer-cards",
                children: " "
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "shimmer-cards"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "shimmer-cards"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "shimmer-cards",
                children: " "
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "shimmer-cards",
                children: " "
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "shimmer-cards"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "shimmer-cards"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "shimmer-cards",
                children: " "
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "shimmer-cards",
                children: " "
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "shimmer-cards"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "shimmer-cards"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "shimmer-cards",
                children: " "
            })
        ]
    });
};
var $aa723e6d45ed0f27$export$2e2bcd8739ae039 = $aa723e6d45ed0f27$var$Shimmer;



var $72osQ = parcelRequire("72osQ");
function $e1f0c9b9d3f0410c$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $72osQ._)(target, key, source[key]);
        });
    }
    return target;
}



var $iD4WH = parcelRequire("iD4WH");
var $6b00d8588769f042$var$RestaurantCard = function(props) {
    var resData = props.resData;
    var _ref = resData === null || resData === void 0 ? void 0 : resData.card.card.info, name = _ref.name, avgRating = _ref.avgRating, cuisines = _ref.cuisines, cloudinaryImageId = _ref.cloudinaryImageId;
    return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
        className: "w-[260px] rounded-xl bg-white shadow-md hover:shadow-xl transition duration-300 overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsx)("img", {
                className: "h-40 w-full object-cover",
                src: "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/" + cloudinaryImageId,
                alt: name
            }),
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "p-4",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsx)("h3", {
                        className: "font-semibold text-lg truncate",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("h4", {
                        className: "text-sm text-gray-500 truncate",
                        children: cuisines.join(", ")
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                        className: "mt-2 flex items-center justify-between",
                        children: /*#__PURE__*/ (0, $iD4WH.jsxs)("span", {
                            className: "px-2 py-1 text-sm bg-green-100 text-green-700 rounded-md",
                            children: [
                                "\u2B50 ",
                                avgRating
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $6b00d8588769f042$export$ccb02a230af14023 = function(RestaurantCard) {
    return function(props) {
        return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
            className: "relative",
            children: [
                /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                    className: "absolute top-2 left-2 z-10 bg-black text-white text-xs px-2 py-1 rounded-md",
                    children: "PROMOTED"
                }),
                /*#__PURE__*/ (0, $iD4WH.jsx)(RestaurantCard, (0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, props))
            ]
        });
    };
};
var $6b00d8588769f042$export$2e2bcd8739ae039 = $6b00d8588769f042$var$RestaurantCard;





var $df1724acf1d1a14f$var$Body = function() {
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)([]), 2), listOfRestaurant = _useState[0], setListOfRestaurant = _useState[1];
    var _useState1 = (0, $2nwvT._)((0, $dQFEZ.useState)([]), 2), filteredRestaurant = _useState1[0], setFilteredRestaurant = _useState1[1];
    var _useState2 = (0, $2nwvT._)((0, $dQFEZ.useState)(""), 2), searchText = _useState2[0], setSearchText = _useState2[1];
    var onlineStatus = (0, $c749438cc5c10da8$export$2e2bcd8739ae039)();
    var RestaurantCardPromoted = (0, $6b00d8588769f042$export$ccb02a230af14023)((0, $6b00d8588769f042$export$2e2bcd8739ae039));
    var _useContext = (0, $dQFEZ.useContext)((0, $d868f44da76e6f1f$export$2e2bcd8739ae039)), loggedInUser = _useContext.loggedInUser, setUserName = _useContext.setUserName;
    (0, $dQFEZ.useEffect)(function() {
        fetchData();
    }, []);
    var fetchData = function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var _json_data_cards__groupedCard_cardGroupMap_RESTAURANT, _json_data_cards__groupedCard_cardGroupMap, _json_data_cards__groupedCard, _json_data_cards, response, json, restaurants, err;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fetch("".concat((0, $38cd5b14fd1a4b6a$export$d43f2f435f160490), "/api/search"))
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        json = _state.sent();
                        restaurants = (json === null || json === void 0 ? void 0 : (_json_data_cards = json.data.cards) === null || _json_data_cards === void 0 ? void 0 : (_json_data_cards__groupedCard = _json_data_cards[1].groupedCard) === null || _json_data_cards__groupedCard === void 0 ? void 0 : (_json_data_cards__groupedCard_cardGroupMap = _json_data_cards__groupedCard.cardGroupMap) === null || _json_data_cards__groupedCard_cardGroupMap === void 0 ? void 0 : (_json_data_cards__groupedCard_cardGroupMap_RESTAURANT = _json_data_cards__groupedCard_cardGroupMap.RESTAURANT) === null || _json_data_cards__groupedCard_cardGroupMap_RESTAURANT === void 0 ? void 0 : _json_data_cards__groupedCard_cardGroupMap_RESTAURANT.cards) || [];
                        setListOfRestaurant(restaurants);
                        setFilteredRestaurant(restaurants);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        console.log("Error fetching restaurants:", err);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    if (!onlineStatus) return /*#__PURE__*/ (0, $iD4WH.jsx)("h1", {
        children: "Looks like you are offline! Please check your internet connection."
    });
    return listOfRestaurant.length === 0 ? /*#__PURE__*/ (0, $iD4WH.jsx)((0, $aa723e6d45ed0f27$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
        className: "body max-w-7xl mx-auto px-4",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "filter flex flex-col md:flex-row md:items-center md:justify-between gap-4 py-6",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "flex flex-col sm:flex-row gap-3 w-full md:w-auto",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsx)("input", {
                                type: "text",
                                placeholder: "Search restaurants...",
                                className: "border border-gray-300 rounded-lg px-4 py-2 w-full sm:w-64 focus:outline-none focus:ring-2 focus:ring-green-400",
                                value: searchText,
                                onChange: function(e) {
                                    return setSearchText(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                                className: "px-5 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition",
                                onClick: function() {
                                    var filtered = listOfRestaurant.filter(function(res) {
                                        return res.card.card.info.name.toLowerCase().includes(searchText.toLowerCase());
                                    });
                                    setFilteredRestaurant(filtered);
                                },
                                children: "Search"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                                className: "px-5 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition",
                                onClick: function() {
                                    var topRated = listOfRestaurant.filter(function(res) {
                                        return res.card.card.info.avgRating > 4;
                                    });
                                    setFilteredRestaurant(topRated);
                                },
                                children: "\u2B50 Top Rated"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsx)("label", {
                                className: "text-gray-600 font-medium",
                                children: "User:"
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("input", {
                                className: "border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400",
                                value: loggedInUser,
                                onChange: function(e) {
                                    return setUserName(e.target.value);
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6",
                children: filteredRestaurant.map(function(restaurant) {
                    return /*#__PURE__*/ (0, $iD4WH.jsx)((0, $fc41d09ddc03e3ec$export$a6c7ac8248d6e38a), {
                        to: "/restaurant/" + restaurant.card.card.info.id,
                        className: "hover:scale-[1.02] transition-transform",
                        children: restaurant.card.card.info.promoted ? /*#__PURE__*/ (0, $iD4WH.jsx)(RestaurantCardPromoted, {
                            resData: restaurant
                        }) : /*#__PURE__*/ (0, $iD4WH.jsx)((0, $6b00d8588769f042$export$2e2bcd8739ae039), {
                            resData: restaurant
                        })
                    }, restaurant.card.card.info.id);
                })
            })
        ]
    });
};
var $df1724acf1d1a14f$export$2e2bcd8739ae039 = $df1724acf1d1a14f$var$Body;



var $iD4WH = parcelRequire("iD4WH");
var $b8195d93c2c9d902$var$Contact = function() {
    return /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
        className: "min-h-screen flex items-center justify-center px-4",
        children: /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
            className: "w-full max-w-lg text-center",
            children: [
                /*#__PURE__*/ (0, $iD4WH.jsx)("h1", {
                    className: "font-bold mb-6 text-3xl",
                    children: "Contact Us"
                }),
                /*#__PURE__*/ (0, $iD4WH.jsxs)("form", {
                    className: "bg-white shadow-lg rounded-xl p-6 space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $iD4WH.jsx)("input", {
                            type: "text",
                            placeholder: "Name",
                            className: "w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-green-400"
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsx)("input", {
                            type: "text",
                            placeholder: "Message",
                            className: "w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-green-400"
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                            className: "w-full bg-green-500 text-white py-3 rounded-lg font-medium hover:bg-green-600 transition",
                            children: "Submit"
                        })
                    ]
                })
            ]
        })
    });
};
var $b8195d93c2c9d902$export$2e2bcd8739ae039 = $b8195d93c2c9d902$var$Contact;



var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $iD4WH = parcelRequire("iD4WH");

var $2nwvT = parcelRequire("2nwvT");

var $iD4WH = parcelRequire("iD4WH");

var $dQFEZ = parcelRequire("dQFEZ");
var $da3522e35a4d7200$var$User = function(param) {
    var name = param.name;
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)(0), 2), count = _useState[0], setcount = _useState[1];
    return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
        className: "user-card m-4 p-4 bg-gray-50 rounded-lg",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsx)("h1", {
                children: " I am a frontend Develpoer"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsxs)("h2", {
                children: [
                    "count: ",
                    count
                ]
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                onClick: function() {
                    count = count - 1;
                    setcount(count);
                },
                children: "increase"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsxs)("h2", {
                children: [
                    "Name:",
                    name
                ]
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("h3", {
                children: "Location:up"
            })
        ]
    });
};
var $da3522e35a4d7200$export$2e2bcd8739ae039 = $da3522e35a4d7200$var$User;



var $g3gsR = parcelRequire("g3gsR");

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $j6Mzi = parcelRequire("j6Mzi");

var $fRv9I = parcelRequire("fRv9I");

var $iD4WH = parcelRequire("iD4WH");

var $dQFEZ = parcelRequire("dQFEZ");
var $9f5463d8fd1d91fd$var$UserClass = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $j6Mzi._)(UserClass, _React_Component);
    function UserClass(props) {
        (0, $grujF._)(this, UserClass);
        var _this;
        _this = (0, $f3Okx._)(this, UserClass, [
            props
        ]);
        //  console.log("child constructor is called")
        _this.state = {
            userInfo: {
                name: "dummy",
                location: "up"
            }
        };
        return _this;
    }
    (0, $dhMkv._)(UserClass, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
                    var response, data, err;
                    return (0, $fRv9I.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    fetch("https://api.github.com/users/ifnavneetrajput")
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                data = _state.sent();
                                this.setState({
                                    userInfo: data
                                });
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                err = _state.sent();
                                console.log("error is ", err);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                console.log("componenet did update");
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                console.log("component will unmount");
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_state_userInfo = this.state.userInfo, name = _this_state_userInfo.name, location = _this_state_userInfo.location, bio = _this_state_userInfo.bio;
                //console.log("child render called")
                return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                    className: "user-card",
                    children: [
                        /*#__PURE__*/ (0, $iD4WH.jsx)("h1", {
                            children: " I am a frontend Develpoer"
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsxs)("h2", {
                            children: [
                                "Name:",
                                name
                            ]
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsxs)("h3", {
                            children: [
                                "Bio:",
                                bio
                            ]
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsxs)("h4", {
                            children: [
                                "Location:",
                                location
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return UserClass;
}((0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).Component);
var $9f5463d8fd1d91fd$export$2e2bcd8739ae039 = $9f5463d8fd1d91fd$var$UserClass;



var $dQFEZ = parcelRequire("dQFEZ");

var $3a22b9b2156a6d0c$var$About = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $j6Mzi._)(About, _React_Component);
    function About(props) {
        (0, $grujF._)(this, About);
        var _this;
        _this = (0, $f3Okx._)(this, About, [
            props
        ]);
        console.log("parent constructor");
        return _this;
    }
    (0, $dhMkv._)(About, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                console.log("parent did mount called");
            }
        },
        {
            key: "render",
            value: function render() {
                console.log("parent render ");
                return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                            children: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $d868f44da76e6f1f$export$2e2bcd8739ae039).Consumer, {
                                children: function(param) {
                                    var loggedInUser = param.loggedInUser;
                                    return /*#__PURE__*/ (0, $iD4WH.jsx)("h1", {
                                        className: "text-xl font-bold",
                                        children: loggedInUser
                                    });
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsx)((0, $9f5463d8fd1d91fd$export$2e2bcd8739ae039), {})
                    ]
                });
            }
        }
    ]);
    return About;
}((0, (/*@__PURE__*/$parcel$interopDefault($dQFEZ))).Component);
var $3a22b9b2156a6d0c$export$2e2bcd8739ae039 = $3a22b9b2156a6d0c$var$About;



var $iD4WH = parcelRequire("iD4WH");

var $3ad99775c31f630e$var$Error = function() {
    var err = new (0, $8c3ad80f8a436e0f$export$ed527bf60f6e05f2)();
    console.log(err);
    return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
        className: "min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4 text-center",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsx)("h1", {
                className: "text-5xl font-bold text-red-500 mb-4",
                children: "Oops!"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("h2", {
                className: "text-xl font-semibold text-gray-700 mb-2",
                children: err.status + " " + err.statusText
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("h2", {
                className: "text-gray-500 text-lg",
                children: "Something went wrong"
            })
        ]
    });
};
var $3ad99775c31f630e$export$2e2bcd8739ae039 = $3ad99775c31f630e$var$Error;



var $2nwvT = parcelRequire("2nwvT");

var $iD4WH = parcelRequire("iD4WH");



var $g3gsR = parcelRequire("g3gsR");

var $2nwvT = parcelRequire("2nwvT");

var $fRv9I = parcelRequire("fRv9I");

var $dQFEZ = parcelRequire("dQFEZ");

var $dd0108b4f6c17030$var$useRestaurantMenu = function(resId) {
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)(null), 2), resInfo = _useState[0], setResInfo = _useState[1];
    (0, $dQFEZ.useEffect)(function() {
        if (resId) fetchMenu();
    }, [
        resId
    ]);
    var fetchMenu = function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var response, json, err;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fetch("".concat((0, $38cd5b14fd1a4b6a$export$d43f2f435f160490), "/api/menu?resId=").concat(resId))
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        json = _state.sent();
                        setResInfo(json.data);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        console.log("Error fetching menu:", err);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return resInfo;
};
var $dd0108b4f6c17030$export$2e2bcd8739ae039 = $dd0108b4f6c17030$var$useRestaurantMenu;



var $iD4WH = parcelRequire("iD4WH");
parcelRequire("dQFEZ");

var $iD4WH = parcelRequire("iD4WH");


var $g3gsR = parcelRequire("g3gsR");

var $f3Okx = parcelRequire("f3Okx");

var $grujF = parcelRequire("grujF");

var $8wAe0 = parcelRequire("8wAe0");

var $dhMkv = parcelRequire("dhMkv");

var $72osQ = parcelRequire("72osQ");

var $gyGuQ = parcelRequire("gyGuQ");
function $d079121360b168c5$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $gyGuQ._)(object);
        if (object === null) break;
    }
    return object;
}


function $8665ac34acf389ad$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $8665ac34acf389ad$export$71511d61b312f219 = Reflect.get;
    else $8665ac34acf389ad$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $d079121360b168c5$export$71511d61b312f219)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $8665ac34acf389ad$export$71511d61b312f219(target, property, receiver || target);
}



var $gyGuQ = parcelRequire("gyGuQ");

var $j6Mzi = parcelRequire("j6Mzi");

var $2nwvT = parcelRequire("2nwvT");

var $2us1u = parcelRequire("2us1u");

var $bJtXW = parcelRequire("bJtXW");

var $1EZOw = parcelRequire("1EZOw");

var $fRv9I = parcelRequire("fRv9I");
// src/utils/formatProdErrorMessage.ts

var $72osQ = parcelRequire("72osQ");

function $68f469483b2832ee$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $68f469483b2832ee$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $68f469483b2832ee$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}



var $2us1u = parcelRequire("2us1u");

var $bJtXW = parcelRequire("bJtXW");
function $20ec22595b3da151$var$formatProdErrorMessage(code) {
    return "Minified Redux error #".concat(code, "; visit https://redux.js.org/Errors?code=").concat(code, " for the full message or use the non-minified dev environment for full errors. ");
}
// src/utils/symbol-observable.ts
var $20ec22595b3da151$var$$$observable = /* @__PURE__ */ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
var $20ec22595b3da151$var$symbol_observable_default = $20ec22595b3da151$var$$$observable;
// src/utils/actionTypes.ts
var $20ec22595b3da151$var$randomString = function() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $20ec22595b3da151$var$ActionTypes = {
    INIT: "@@redux/INIT".concat($20ec22595b3da151$var$randomString()),
    REPLACE: "@@redux/REPLACE".concat($20ec22595b3da151$var$randomString()),
    PROBE_UNKNOWN_ACTION: function() {
        return "@@redux/PROBE_UNKNOWN_ACTION".concat($20ec22595b3da151$var$randomString());
    }
};
var $20ec22595b3da151$export$4219e499db7ca678 = $20ec22595b3da151$var$ActionTypes;
// src/utils/isPlainObject.ts
function $20ec22595b3da151$export$53b83ca8eaab0383(obj) {
    if ((typeof obj === "undefined" ? "undefined" : (0, $bJtXW._)(obj)) !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $20ec22595b3da151$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val === "undefined" ? "undefined" : (0, $bJtXW._)(val);
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($20ec22595b3da151$var$isDate(val)) return "date";
    if ($20ec22595b3da151$var$isError(val)) return "error";
    var constructorName = $20ec22595b3da151$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $20ec22595b3da151$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $20ec22595b3da151$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $20ec22595b3da151$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $20ec22595b3da151$var$kindOf(val) {
    var typeOfVal = typeof val === "undefined" ? "undefined" : (0, $bJtXW._)(val);
    return typeOfVal;
}
// src/createStore.ts
function $20ec22595b3da151$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(1));
        return enhancer($20ec22595b3da151$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = /* @__PURE__ */ new Map();
    var nextListeners = currentListeners;
    var listenerIdCounter = 0;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach(function(listener, key) {
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        var listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$20ec22595b3da151$export$53b83ca8eaab0383(action)) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        listeners.forEach(function(listener) {
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $20ec22595b3da151$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        var outerSubscribe = subscribe;
        return (0, $72osQ._)({
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function(observer) {
                if ((typeof observer === "undefined" ? "undefined" : (0, $bJtXW._)(observer)) !== "object" || observer === null) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(11));
                function observeState() {
                    var observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, $20ec22595b3da151$var$symbol_observable_default, function() {
            return this;
        });
    }
    dispatch({
        type: $20ec22595b3da151$export$4219e499db7ca678.INIT
    });
    var store = (0, $72osQ._)({
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, $20ec22595b3da151$var$symbol_observable_default, observable);
    return store;
}
function $20ec22595b3da151$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $20ec22595b3da151$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $20ec22595b3da151$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $20ec22595b3da151$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $20ec22595b3da151$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$20ec22595b3da151$export$53b83ca8eaab0383(inputState)) return "The ".concat(argumentName, ' has unexpected type of "').concat($20ec22595b3da151$var$kindOf(inputState), '". Expected argument to be an object with the following keys: "').concat(reducerKeys.join('", "'), '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $20ec22595b3da151$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected ".concat(unexpectedKeys.length > 1 ? "keys" : "key", ' "').concat(unexpectedKeys.join('", "'), '" found in ').concat(argumentName, '. Expected to find one of the known reducer keys instead: "').concat(reducerKeys.join('", "'), '". Unexpected keys will be ignored.');
}
function $20ec22595b3da151$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(void 0, {
            type: $20ec22595b3da151$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $20ec22595b3da151$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($20ec22595b3da151$var$formatProdErrorMessage(13));
    });
}
function $20ec22595b3da151$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $20ec22595b3da151$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, action = arguments.length > 1 ? arguments[1] : void 0;
        if (shapeAssertionError) throw shapeAssertionError;
        var hasChanged = false;
        var nextState = {};
        for(var i = 0; i < finalReducerKeys.length; i++){
            var key = finalReducerKeys[i];
            var reducer = finalReducers[key];
            var previousStateForKey = state[key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($20ec22595b3da151$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $20ec22595b3da151$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return dispatch(actionCreator.apply(this, args));
    };
}
function $20ec22595b3da151$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $20ec22595b3da151$var$bindActionCreator(actionCreators, dispatch);
    if ((typeof actionCreators === "undefined" ? "undefined" : (0, $bJtXW._)(actionCreators)) !== "object" || actionCreators === null) throw new Error($20ec22595b3da151$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $20ec22595b3da151$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $20ec22595b3da151$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++){
        funcs[_key] = arguments[_key];
    }
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return a(b.apply(void 0, (0, $2us1u._)(args)));
        };
    });
}
// src/applyMiddleware.ts
function $20ec22595b3da151$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
        middlewares[_key] = arguments[_key];
    }
    return function(createStore2) {
        return function(reducer, preloadedState) {
            var store = createStore2(reducer, preloadedState);
            var dispatch = function() {
                throw new Error($20ec22595b3da151$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function(action) {
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    return dispatch.apply(void 0, [
                        action
                    ].concat((0, $2us1u._)(args)));
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            dispatch = $20ec22595b3da151$export$f672e0b6f7222cd7.apply(void 0, (0, $2us1u._)(chain))(store.dispatch);
            return (0, $68f469483b2832ee$export$71511d61b312f219)((0, $e1f0c9b9d3f0410c$export$71511d61b312f219)({}, store), {
                dispatch: dispatch
            });
        };
    };
}
// src/utils/isAction.ts
function $20ec22595b3da151$export$b956e38827fca970(action) {
    return $20ec22595b3da151$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}



var $kK8g8 = parcelRequire("kK8g8");

var $grujF = parcelRequire("grujF");

var $dhMkv = parcelRequire("dhMkv");

var $2nwvT = parcelRequire("2nwvT");

var $2us1u = parcelRequire("2us1u");

var $bJtXW = parcelRequire("bJtXW");
var $b262cabcae0d8be6$var$__defProp = Object.defineProperty;
var $b262cabcae0d8be6$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b262cabcae0d8be6$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b262cabcae0d8be6$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b262cabcae0d8be6$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $b262cabcae0d8be6$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $b262cabcae0d8be6$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($b262cabcae0d8be6$var$__hasOwnProp.call(b, prop)) $b262cabcae0d8be6$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($b262cabcae0d8be6$var$__getOwnPropSymbols) try {
        for(var _iterator = $b262cabcae0d8be6$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($b262cabcae0d8be6$var$__propIsEnum.call(b, prop)) $b262cabcae0d8be6$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $b262cabcae0d8be6$var$__publicField = function(obj, key, value) {
    $b262cabcae0d8be6$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : (0, $bJtXW._)(key)) !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $b262cabcae0d8be6$var$runIdentityFunctionCheck = function(resultFunc, inputSelectorsResults, outputSelectorResult) {
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        var isInputSameAsOutput = false;
        try {
            var emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            var stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                stack = e.stack;
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $b262cabcae0d8be6$var$runInputStabilityCheck = function(inputSelectorResultsObject, options, inputSelectorArgs) {
    var memoize = options.memoize, memoizeOptions = options.memoizeOptions;
    var inputSelectorResults = inputSelectorResultsObject.inputSelectorResults, inputSelectorResultsCopy = inputSelectorResultsObject.inputSelectorResultsCopy;
    var createAnEmptyObject = memoize.apply(void 0, [
        function() {
            return {};
        }
    ].concat((0, $2us1u._)(memoizeOptions)));
    var areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        var stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            stack = e.stack;
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $b262cabcae0d8be6$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $b262cabcae0d8be6$export$1e290349de99e28c = function(devModeChecks) {
    Object.assign($b262cabcae0d8be6$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $b262cabcae0d8be6$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $b262cabcae0d8be6$var$assertIsFunction(func) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected a function, instead received ".concat(typeof func === "undefined" ? "undefined" : (0, $bJtXW._)(func));
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $b262cabcae0d8be6$var$assertIsObject(object) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected an object, instead received ".concat(typeof object === "undefined" ? "undefined" : (0, $bJtXW._)(object));
    if ((typeof object === "undefined" ? "undefined" : (0, $bJtXW._)(object)) !== "object") throw new TypeError(errorMessage);
}
function $b262cabcae0d8be6$var$assertIsArrayOfFunctions(array) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected all items to be functions, instead received the following types: ";
    if (!array.every(function(item) {
        return typeof item === "function";
    })) {
        var itemTypes = array.map(function(item) {
            return typeof item === "function" ? "function ".concat(item.name || "unnamed", "()") : typeof item === "undefined" ? "undefined" : (0, $bJtXW._)(item);
        }).join(", ");
        throw new TypeError("".concat(errorMessage, "[").concat(itemTypes, "]"));
    }
}
var $b262cabcae0d8be6$var$ensureIsArray = function(item) {
    return Array.isArray(item) ? item : [
        item
    ];
};
function $b262cabcae0d8be6$var$getDependencies(createSelectorArgs) {
    var dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $b262cabcae0d8be6$var$assertIsArrayOfFunctions(dependencies, "createSelector expects all input-selectors to be functions, but received the following types: ");
    return dependencies;
}
function $b262cabcae0d8be6$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    var inputSelectorResults = [];
    var length = dependencies.length;
    for(var i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $b262cabcae0d8be6$var$getDevModeChecksExecutionInfo = function(firstRun, devModeChecks) {
    var __spreadValues1 = $b262cabcae0d8be6$var$__spreadValues($b262cabcae0d8be6$var$__spreadValues({}, $b262cabcae0d8be6$var$globalDevModeChecks), devModeChecks), identityFunctionCheck = __spreadValues1.identityFunctionCheck, inputStabilityCheck = __spreadValues1.inputStabilityCheck;
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $b262cabcae0d8be6$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $b262cabcae0d8be6$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $b262cabcae0d8be6$var$$REVISION = 0;
var $b262cabcae0d8be6$var$CURRENT_TRACKER = null;
var $b262cabcae0d8be6$var$Cell = /*#__PURE__*/ function() {
    "use strict";
    function Cell(initialValue) {
        var isEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b262cabcae0d8be6$var$tripleEq;
        (0, $grujF._)(this, Cell);
        $b262cabcae0d8be6$var$__publicField(this, "revision", $b262cabcae0d8be6$var$$REVISION);
        $b262cabcae0d8be6$var$__publicField(this, "_value");
        $b262cabcae0d8be6$var$__publicField(this, "_lastValue");
        $b262cabcae0d8be6$var$__publicField(this, "_isEqual", $b262cabcae0d8be6$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    (0, $dhMkv._)(Cell, [
        {
            key: "value",
            get: // Whenever a storage value is read, it'll add itself to the current tracker if
            // one exists, entangling its state with that cache.
            function get() {
                $b262cabcae0d8be6$var$CURRENT_TRACKER == null || $b262cabcae0d8be6$var$CURRENT_TRACKER.add(this);
                return this._value;
            },
            set: // Whenever a storage value is updated, we bump the global revision clock,
            // assign the revision for this storage to the new value, _and_ we schedule a
            // rerender. This is important, and it's what makes autotracking  _pull_
            // based. We don't actively tell the caches which depend on the storage that
            // anything has happened. Instead, we recompute the caches when needed.
            function set(newValue) {
                if (this.value === newValue) return;
                this._value = newValue;
                this.revision = ++$b262cabcae0d8be6$var$$REVISION;
            }
        }
    ]);
    return Cell;
}();
function $b262cabcae0d8be6$var$tripleEq(a, b) {
    return a === b;
}
var $b262cabcae0d8be6$var$TrackingCache = /*#__PURE__*/ function() {
    "use strict";
    function TrackingCache(fn) {
        (0, $grujF._)(this, TrackingCache);
        $b262cabcae0d8be6$var$__publicField(this, "_cachedValue");
        $b262cabcae0d8be6$var$__publicField(this, "_cachedRevision", -1);
        $b262cabcae0d8be6$var$__publicField(this, "_deps", []);
        $b262cabcae0d8be6$var$__publicField(this, "hits", 0);
        $b262cabcae0d8be6$var$__publicField(this, "fn");
        this.fn = fn;
    }
    (0, $dhMkv._)(TrackingCache, [
        {
            key: "clear",
            value: function clear() {
                this._cachedValue = void 0;
                this._cachedRevision = -1;
                this._deps = [];
                this.hits = 0;
            }
        },
        {
            key: "value",
            get: function get() {
                if (this.revision > this._cachedRevision) {
                    var fn = this.fn;
                    var currentTracker = /* @__PURE__ */ new Set();
                    var prevTracker = $b262cabcae0d8be6$var$CURRENT_TRACKER;
                    $b262cabcae0d8be6$var$CURRENT_TRACKER = currentTracker;
                    this._cachedValue = fn();
                    $b262cabcae0d8be6$var$CURRENT_TRACKER = prevTracker;
                    this.hits++;
                    this._deps = Array.from(currentTracker);
                    this._cachedRevision = this.revision;
                }
                $b262cabcae0d8be6$var$CURRENT_TRACKER == null || $b262cabcae0d8be6$var$CURRENT_TRACKER.add(this);
                return this._cachedValue;
            }
        },
        {
            key: "revision",
            get: function get() {
                var _Math;
                return (_Math = Math).max.apply(_Math, (0, $2us1u._)(this._deps.map(function(d) {
                    return d.revision;
                })).concat([
                    0
                ]));
            }
        }
    ]);
    return TrackingCache;
}();
function $b262cabcae0d8be6$var$getValue(cell) {
    if (!(cell instanceof $b262cabcae0d8be6$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $b262cabcae0d8be6$var$setValue(storage, value) {
    if (!(storage instanceof $b262cabcae0d8be6$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $b262cabcae0d8be6$var$createCell(initialValue) {
    var isEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b262cabcae0d8be6$var$tripleEq;
    return new $b262cabcae0d8be6$var$Cell(initialValue, isEqual);
}
function $b262cabcae0d8be6$var$createCache(fn) {
    $b262cabcae0d8be6$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $b262cabcae0d8be6$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $b262cabcae0d8be6$var$neverEq = function(a, b) {
    return false;
};
function $b262cabcae0d8be6$var$createTag() {
    return $b262cabcae0d8be6$var$createCell(null, $b262cabcae0d8be6$var$neverEq);
}
function $b262cabcae0d8be6$var$dirtyTag(tag, value) {
    $b262cabcae0d8be6$var$setValue(tag, value);
}
var $b262cabcae0d8be6$var$consumeCollection = function(node) {
    var tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $b262cabcae0d8be6$var$createTag();
    $b262cabcae0d8be6$var$getValue(tag);
};
var $b262cabcae0d8be6$var$dirtyCollection = function(node) {
    var tag = node.collectionTag;
    if (tag !== null) $b262cabcae0d8be6$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $b262cabcae0d8be6$var$REDUX_PROXY_LABEL = Symbol();
var $b262cabcae0d8be6$var$nextId = 0;
var $b262cabcae0d8be6$var$proto = Object.getPrototypeOf({});
var $b262cabcae0d8be6$var$ObjectTreeNode = function ObjectTreeNode(value) {
    "use strict";
    (0, $grujF._)(this, ObjectTreeNode);
    this.value = value;
    $b262cabcae0d8be6$var$__publicField(this, "proxy", new Proxy(this, $b262cabcae0d8be6$var$objectProxyHandler));
    $b262cabcae0d8be6$var$__publicField(this, "tag", $b262cabcae0d8be6$var$createTag());
    $b262cabcae0d8be6$var$__publicField(this, "tags", {});
    $b262cabcae0d8be6$var$__publicField(this, "children", {});
    $b262cabcae0d8be6$var$__publicField(this, "collectionTag", null);
    $b262cabcae0d8be6$var$__publicField(this, "id", $b262cabcae0d8be6$var$nextId++);
    this.value = value;
    this.tag.value = value;
};
var $b262cabcae0d8be6$var$objectProxyHandler = {
    get: function(node, key) {
        function calculateResult() {
            var value = node.value;
            var childValue = Reflect.get(value, key);
            if ((typeof key === "undefined" ? "undefined" : (0, $bJtXW._)(key)) === "symbol") return childValue;
            if (key in $b262cabcae0d8be6$var$proto) return childValue;
            if ((typeof childValue === "undefined" ? "undefined" : (0, $bJtXW._)(childValue)) === "object" && childValue !== null) {
                var childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $b262cabcae0d8be6$var$createNode(childValue);
                if (childNode.tag) $b262cabcae0d8be6$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                var tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $b262cabcae0d8be6$var$createTag();
                    tag.value = childValue;
                }
                $b262cabcae0d8be6$var$getValue(tag);
                return childValue;
            }
        }
        var res = calculateResult();
        return res;
    },
    ownKeys: function(node) {
        $b262cabcae0d8be6$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor: function(node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has: function(node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $b262cabcae0d8be6$var$ArrayTreeNode = function ArrayTreeNode(value) {
    "use strict";
    (0, $grujF._)(this, ArrayTreeNode);
    this.value = value;
    $b262cabcae0d8be6$var$__publicField(this, "proxy", new Proxy([
        this
    ], $b262cabcae0d8be6$var$arrayProxyHandler));
    $b262cabcae0d8be6$var$__publicField(this, "tag", $b262cabcae0d8be6$var$createTag());
    $b262cabcae0d8be6$var$__publicField(this, "tags", {});
    $b262cabcae0d8be6$var$__publicField(this, "children", {});
    $b262cabcae0d8be6$var$__publicField(this, "collectionTag", null);
    $b262cabcae0d8be6$var$__publicField(this, "id", $b262cabcae0d8be6$var$nextId++);
    this.value = value;
    this.tag.value = value;
};
var $b262cabcae0d8be6$var$arrayProxyHandler = {
    get: function(param, key) {
        var _param = (0, $2nwvT._)(param, 1), node = _param[0];
        if (key === "length") $b262cabcae0d8be6$var$consumeCollection(node);
        return $b262cabcae0d8be6$var$objectProxyHandler.get(node, key);
    },
    ownKeys: function(param) {
        var _param = (0, $2nwvT._)(param, 1), node = _param[0];
        return $b262cabcae0d8be6$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor: function(param, prop) {
        var _param = (0, $2nwvT._)(param, 1), node = _param[0];
        return $b262cabcae0d8be6$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has: function(param, prop) {
        var _param = (0, $2nwvT._)(param, 1), node = _param[0];
        return $b262cabcae0d8be6$var$objectProxyHandler.has(node, prop);
    }
};
function $b262cabcae0d8be6$var$createNode(value) {
    if (Array.isArray(value)) return new $b262cabcae0d8be6$var$ArrayTreeNode(value);
    return new $b262cabcae0d8be6$var$ObjectTreeNode(value);
}
function $b262cabcae0d8be6$var$updateNode(node, newValue) {
    var value = node.value, tags = node.tags, children = node.children;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $b262cabcae0d8be6$var$dirtyCollection(node);
    else if (value !== newValue) {
        var oldKeysSize = 0;
        var newKeysSize = 0;
        var anyKeysAdded = false;
        for(var _key in value)oldKeysSize++;
        for(var key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        var isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $b262cabcae0d8be6$var$dirtyCollection(node);
    }
    for(var key1 in tags){
        var childValue = value[key1];
        var newChildValue = newValue[key1];
        if (childValue !== newChildValue) {
            $b262cabcae0d8be6$var$dirtyCollection(node);
            $b262cabcae0d8be6$var$dirtyTag(tags[key1], newChildValue);
        }
        if ((typeof newChildValue === "undefined" ? "undefined" : (0, $bJtXW._)(newChildValue)) === "object" && newChildValue !== null) delete tags[key1];
    }
    for(var key2 in children){
        var childNode = children[key2];
        var newChildValue1 = newValue[key2];
        var childValue1 = childNode.value;
        if (childValue1 === newChildValue1) continue;
        else if ((typeof newChildValue1 === "undefined" ? "undefined" : (0, $bJtXW._)(newChildValue1)) === "object" && newChildValue1 !== null) $b262cabcae0d8be6$var$updateNode(childNode, newChildValue1);
        else {
            $b262cabcae0d8be6$var$deleteNode(childNode);
            delete children[key2];
        }
    }
}
function $b262cabcae0d8be6$var$deleteNode(node) {
    if (node.tag) $b262cabcae0d8be6$var$dirtyTag(node.tag, null);
    $b262cabcae0d8be6$var$dirtyCollection(node);
    for(var key in node.tags)$b262cabcae0d8be6$var$dirtyTag(node.tags[key], null);
    for(var key1 in node.children)$b262cabcae0d8be6$var$deleteNode(node.children[key1]);
}
// src/lruMemoize.ts
function $b262cabcae0d8be6$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $b262cabcae0d8be6$var$NOT_FOUND;
        },
        put: function(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function() {
            entry = void 0;
        }
    };
}
function $b262cabcae0d8be6$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        });
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $b262cabcae0d8be6$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $b262cabcae0d8be6$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $b262cabcae0d8be6$export$3f025202a230c6dd = function(a, b) {
    return a === b;
};
function $b262cabcae0d8be6$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $b262cabcae0d8be6$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    var providedOptions = (typeof equalityCheckOrOptions === "undefined" ? "undefined" : (0, $bJtXW._)(equalityCheckOrOptions)) === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions_equalityCheck = providedOptions.equalityCheck, equalityCheck = _providedOptions_equalityCheck === void 0 ? $b262cabcae0d8be6$export$3f025202a230c6dd : _providedOptions_equalityCheck, _providedOptions_maxSize = providedOptions.maxSize, maxSize = _providedOptions_maxSize === void 0 ? 1 : _providedOptions_maxSize, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $b262cabcae0d8be6$var$createCacheKeyComparator(equalityCheck);
    var resultsCount = 0;
    var cache = maxSize <= 1 ? $b262cabcae0d8be6$var$createSingletonCache(comparator) : $b262cabcae0d8be6$var$createLruCache(maxSize, comparator);
    function memoized() {
        var value = cache.get(arguments);
        if (value === $b262cabcae0d8be6$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $b262cabcae0d8be6$export$c8f9cf88d9fdee55(func) {
    var node = $b262cabcae0d8be6$var$createNode([]);
    var lastArgs = null;
    var shallowEqual = $b262cabcae0d8be6$var$createCacheKeyComparator($b262cabcae0d8be6$export$3f025202a230c6dd);
    var cache = $b262cabcae0d8be6$var$createCache(function() {
        var res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $b262cabcae0d8be6$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $b262cabcae0d8be6$var$StrongRef = /*#__PURE__*/ function() {
    "use strict";
    function StrongRef(value) {
        (0, $grujF._)(this, StrongRef);
        this.value = value;
    }
    (0, $dhMkv._)(StrongRef, [
        {
            key: "deref",
            value: function deref() {
                return this.value;
            }
        }
    ]);
    return StrongRef;
}();
var $b262cabcae0d8be6$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $b262cabcae0d8be6$var$StrongRef;
var $b262cabcae0d8be6$var$UNTERMINATED = 0;
var $b262cabcae0d8be6$var$TERMINATED = 1;
function $b262cabcae0d8be6$var$createCacheNode() {
    return {
        s: $b262cabcae0d8be6$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $b262cabcae0d8be6$export$8402dc26d96f6902(func) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var fnNode = $b262cabcae0d8be6$var$createCacheNode();
    var resultEqualityCheck = options.resultEqualityCheck;
    var lastResult;
    var resultsCount = 0;
    function memoized() {
        var _a, _b;
        var cacheNode = fnNode;
        var length = arguments.length;
        for(var i = 0, l = length; i < l; i++){
            var arg = arguments[i];
            if (typeof arg === "function" || (typeof arg === "undefined" ? "undefined" : (0, $bJtXW._)(arg)) === "object" && arg !== null) {
                var objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                var objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $b262cabcae0d8be6$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                var primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                var primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $b262cabcae0d8be6$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        var terminatedNode = cacheNode;
        var result;
        if (cacheNode.s === $b262cabcae0d8be6$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                var lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                var needsWeakRef = (typeof result === "undefined" ? "undefined" : (0, $bJtXW._)(result)) === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $b262cabcae0d8be6$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $b262cabcae0d8be6$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = function() {
        fnNode = $b262cabcae0d8be6$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $b262cabcae0d8be6$export$5943f4447f6ef248(memoizeOrOptions) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    }
    var createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    var createSelector2 = function() {
        for(var _len = arguments.length, createSelectorArgs = new Array(_len), _key = 0; _key < _len; _key++){
            createSelectorArgs[_key] = arguments[_key];
        }
        var recomputations = 0;
        var dependencyRecomputations = 0;
        var lastResult;
        var directlyPassedOptions = {};
        var resultFunc = createSelectorArgs.pop();
        if ((typeof resultFunc === "undefined" ? "undefined" : (0, $bJtXW._)(resultFunc)) === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $b262cabcae0d8be6$var$assertIsFunction(resultFunc, "createSelector expects an output function after the inputs, but received: [".concat(typeof resultFunc === "undefined" ? "undefined" : (0, $bJtXW._)(resultFunc), "]"));
        var combinedOptions = $b262cabcae0d8be6$var$__spreadValues($b262cabcae0d8be6$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        var memoize = combinedOptions.memoize, _combinedOptions_memoizeOptions = combinedOptions.memoizeOptions, memoizeOptions = _combinedOptions_memoizeOptions === void 0 ? [] : _combinedOptions_memoizeOptions, _combinedOptions_argsMemoize = combinedOptions.argsMemoize, argsMemoize = _combinedOptions_argsMemoize === void 0 ? $b262cabcae0d8be6$export$8402dc26d96f6902 : _combinedOptions_argsMemoize, _combinedOptions_argsMemoizeOptions = combinedOptions.argsMemoizeOptions, argsMemoizeOptions = _combinedOptions_argsMemoizeOptions === void 0 ? [] : _combinedOptions_argsMemoizeOptions, _combinedOptions_devModeChecks = combinedOptions.devModeChecks, devModeChecks = _combinedOptions_devModeChecks === void 0 ? {} : _combinedOptions_devModeChecks;
        var finalMemoizeOptions = $b262cabcae0d8be6$var$ensureIsArray(memoizeOptions);
        var finalArgsMemoizeOptions = $b262cabcae0d8be6$var$ensureIsArray(argsMemoizeOptions);
        var dependencies = $b262cabcae0d8be6$var$getDependencies(createSelectorArgs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                recomputations++;
                return resultFunc.apply(null, arguments);
            }
        ].concat((0, $2us1u._)(finalMemoizeOptions)));
        var firstRun = true;
        var selector = argsMemoize.apply(void 0, [
            function dependenciesChecker() {
                dependencyRecomputations++;
                var inputSelectorResults = $b262cabcae0d8be6$var$collectInputSelectorResults(dependencies, arguments);
                lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
                return lastResult;
            }
        ].concat((0, $2us1u._)(finalArgsMemoizeOptions)));
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: function() {
                return dependencyRecomputations;
            },
            resetDependencyRecomputations: function() {
                dependencyRecomputations = 0;
            },
            lastResult: function() {
                return lastResult;
            },
            recomputations: function() {
                return recomputations;
            },
            resetRecomputations: function() {
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: function() {
            return createSelector2;
        }
    });
    return createSelector2;
}
var $b262cabcae0d8be6$export$595d22ed68ca2841 = /* @__PURE__ */ $b262cabcae0d8be6$export$5943f4447f6ef248($b262cabcae0d8be6$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $b262cabcae0d8be6$export$75979cfcd91bf38f = Object.assign(function(inputSelectorsObject) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b262cabcae0d8be6$export$595d22ed68ca2841;
    $b262cabcae0d8be6$var$assertIsObject(inputSelectorsObject, "createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ".concat(typeof inputSelectorsObject === "undefined" ? "undefined" : (0, $bJtXW._)(inputSelectorsObject)));
    var inputSelectorKeys = Object.keys(inputSelectorsObject);
    var dependencies = inputSelectorKeys.map(function(key) {
        return inputSelectorsObject[key];
    });
    var structuredSelector = selectorCreator(dependencies, function() {
        for(var _len = arguments.length, inputSelectorResults = new Array(_len), _key = 0; _key < _len; _key++){
            inputSelectorResults[_key] = arguments[_key];
        }
        return inputSelectorResults.reduce(function(composition, value, index) {
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: function() {
        return $b262cabcae0d8be6$export$75979cfcd91bf38f;
    }
});


// src/index.ts
function $21ccc86701ec53ef$var$createThunkMiddleware(extraArgument) {
    var middleware = function(param) {
        var dispatch = param.dispatch, getState = param.getState;
        return function(next) {
            return function(action) {
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
        };
    };
    return middleware;
}
var $21ccc86701ec53ef$export$dd164f5517779f15 = $21ccc86701ec53ef$var$createThunkMiddleware();
var $21ccc86701ec53ef$export$16d06542a1949d9e = $21ccc86701ec53ef$var$createThunkMiddleware;


var $ca04af99794d5fdc$var$__defProp = Object.defineProperty;
var $ca04af99794d5fdc$var$__defProps = Object.defineProperties;
var $ca04af99794d5fdc$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $ca04af99794d5fdc$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $ca04af99794d5fdc$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ca04af99794d5fdc$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $ca04af99794d5fdc$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $ca04af99794d5fdc$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $ca04af99794d5fdc$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($ca04af99794d5fdc$var$__hasOwnProp.call(b, prop)) $ca04af99794d5fdc$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($ca04af99794d5fdc$var$__getOwnPropSymbols) try {
        for(var _iterator = $ca04af99794d5fdc$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($ca04af99794d5fdc$var$__propIsEnum.call(b, prop)) $ca04af99794d5fdc$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $ca04af99794d5fdc$var$__spreadProps = function(a, b) {
    return $ca04af99794d5fdc$var$__defProps(a, $ca04af99794d5fdc$var$__getOwnPropDescs(b));
};
var $ca04af99794d5fdc$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($ca04af99794d5fdc$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (source != null && $ca04af99794d5fdc$var$__getOwnPropSymbols) try {
        for(var _iterator = $ca04af99794d5fdc$var$__getOwnPropSymbols(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (exclude.indexOf(prop) < 0 && $ca04af99794d5fdc$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return target;
};
var $ca04af99794d5fdc$var$__publicField = function(obj, key, value) {
    return $ca04af99794d5fdc$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : (0, $bJtXW._)(key)) !== "symbol" ? key + "" : key, value);
};
var $ca04af99794d5fdc$export$aab6de9e3dbb1473 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var createSelector2 = (0, $b262cabcae0d8be6$export$5943f4447f6ef248).apply(void 0, (0, $2us1u._)(args));
    var createDraftSafeSelector2 = Object.assign(function() {
        for(var _len = arguments.length, args2 = new Array(_len), _key = 0; _key < _len; _key++){
            args2[_key] = arguments[_key];
        }
        var selector = createSelector2.apply(void 0, (0, $2us1u._)(args2));
        var wrappedSelector = function(value) {
            for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                rest[_key - 1] = arguments[_key];
            }
            return selector.apply(void 0, [
                (0, $kK8g8.isDraft)(value) ? (0, $kK8g8.current)(value) : value
            ].concat((0, $2us1u._)(rest)));
        };
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: function() {
            return createDraftSafeSelector2;
        }
    });
    return createDraftSafeSelector2;
};
var $ca04af99794d5fdc$export$a5d3c27355e35910 = /* @__PURE__ */ $ca04af99794d5fdc$export$aab6de9e3dbb1473((0, $b262cabcae0d8be6$export$8402dc26d96f6902));
var $ca04af99794d5fdc$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function composeWithDevTools() {
    if (arguments.length === 0) return void 0;
    if ((0, $bJtXW._)(arguments[0]) === "object") return 0, $20ec22595b3da151$export$f672e0b6f7222cd7;
    return (0, $20ec22595b3da151$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $ca04af99794d5fdc$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function devToolsEnhancer() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $ca04af99794d5fdc$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $ca04af99794d5fdc$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, (0, $2us1u._)(args));
            if (!prepared) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(0));
            return $ca04af99794d5fdc$var$__spreadValues($ca04af99794d5fdc$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "".concat(type);
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return (0, $20ec22595b3da151$export$b956e38827fca970)(action) && action.type === type;
    };
    return actionCreator;
}
function $ca04af99794d5fdc$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $ca04af99794d5fdc$var$hasMatchFunction(action);
}
function $ca04af99794d5fdc$export$ebd532f9034651f3(action) {
    return (0, $20ec22595b3da151$export$b956e38827fca970)(action) && Object.keys(action).every($ca04af99794d5fdc$var$isValidKey);
}
function $ca04af99794d5fdc$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $ca04af99794d5fdc$var$getMessage(type) {
    var splitType = type ? "".concat(type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return 'Detected an action creator with type "'.concat(type || "unknown", "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(").concat(actionName, "())` instead of `dispatch(").concat(actionName, ")`. This is necessary even if the action has no payload.");
}
function $ca04af99794d5fdc$export$6a1fcb4ceef578f() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $ca04af99794d5fdc$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn("".concat(fnName, " took ").concat(elapsed, "ms, which is more than the warning threshold of ").concat(maxDelay, "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that."));
        }
    };
}
var $ca04af99794d5fdc$export$1908877435b1d5e9 = /*#__PURE__*/ function(Array1) {
    "use strict";
    (0, $j6Mzi._)(_Tuple, Array1);
    function _Tuple() {
        for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
            items[_key] = arguments[_key];
        }
        (0, $grujF._)(this, _Tuple);
        var _this;
        _this = (0, $f3Okx._)(this, _Tuple, (0, $2us1u._)(items));
        Object.setPrototypeOf(_this, _Tuple.prototype);
        return _this;
    }
    (0, $dhMkv._)(_Tuple, [
        {
            key: "concat",
            value: function concat() {
                for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                    arr[_key] = arguments[_key];
                }
                return (0, $8665ac34acf389ad$export$71511d61b312f219)((0, $gyGuQ._)(_Tuple.prototype), "concat", this).apply(this, arr);
            }
        },
        {
            key: "prepend",
            value: function prepend() {
                for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                    arr[_key] = arguments[_key];
                }
                if (arr.length === 1 && Array.isArray(arr[0])) return (0, $8wAe0._)(_Tuple, (0, $2us1u._)(arr[0].concat(this)));
                return (0, $8wAe0._)(_Tuple, (0, $2us1u._)(arr.concat(this)));
            }
        }
    ], [
        {
            key: Symbol.species,
            get: function get() {
                return _Tuple;
            }
        }
    ]);
    return _Tuple;
}((0, $1EZOw._)(Array));
function $ca04af99794d5fdc$var$freezeDraftable(val) {
    return (0, $kK8g8.isDraftable)(val) ? (0, $kK8g8.produce)(val, function() {}) : val;
}
function $ca04af99794d5fdc$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $ca04af99794d5fdc$export$9021b2733a0028a3(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) !== "object" || value == null || Object.isFrozen(value);
}
function $ca04af99794d5fdc$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $ca04af99794d5fdc$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $ca04af99794d5fdc$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $ca04af99794d5fdc$var$trackProperties(isImmutable) {
    var ignorePaths = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], obj = arguments.length > 2 ? arguments[2] : void 0, path = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", checkedObjects = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : /* @__PURE__ */ new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $ca04af99794d5fdc$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $ca04af99794d5fdc$var$detectMutations(isImmutable) {
    var _loop = function(key2) {
        var nestedPath = path ? path + "." + key2 : key2;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $ca04af99794d5fdc$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key2], obj[key2], sameRef, nestedPath);
        if (result.wasMutated) return {
            v: result
        };
    };
    var ignoredPaths = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], trackedProperty = arguments.length > 2 ? arguments[2] : void 0, obj = arguments.length > 3 ? arguments[3] : void 0, sameParentRef = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, path = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key1 in obj)keysToDetect[key1] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    for(var key2 in keysToDetect){
        var _ret = _loop(key2);
        if ((0, $bJtXW._)(_ret) === "object") return _ret.v;
    }
    return {
        wasMutated: false
    };
}
function $ca04af99794d5fdc$export$9181bb1a5474289() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var stringify, getSerialize, getState, next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $ca04af99794d5fdc$export$77670485918dab4e(val) {
    var type = typeof val === "undefined" ? "undefined" : (0, $bJtXW._)(val);
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $20ec22595b3da151$export$53b83ca8eaab0383)(val);
}
function $ca04af99794d5fdc$export$ada5dca0b571bc7(value) {
    var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", isSerializable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $ca04af99794d5fdc$export$77670485918dab4e, getEntries = arguments.length > 3 ? arguments[3] : void 0, ignoredPaths = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], cache = arguments.length > 5 ? arguments[5] : void 0;
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if ((typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $2nwvT._)(_step.value, 2), key = _step_value[0], nestedValue = _step_value[1];
            var nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                var hasMatches = ignoredPaths.some(function(ignored) {
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) return "continue";
            }
            if (!isSerializable(nestedValue)) return {
                v: {
                    keyPath: nestedPath,
                    value: nestedValue
                }
            };
            if ((typeof nestedValue === "undefined" ? "undefined" : (0, $bJtXW._)(nestedValue)) === "object") {
                foundNestedSerializable = $ca04af99794d5fdc$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
                if (foundNestedSerializable) return {
                    v: foundNestedSerializable
                };
            }
        };
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if ((0, $bJtXW._)(_ret) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (cache && $ca04af99794d5fdc$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $ca04af99794d5fdc$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(value)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var nestedValue = _step.value;
            if ((typeof nestedValue === "undefined" ? "undefined" : (0, $bJtXW._)(nestedValue)) !== "object" || nestedValue === null) continue;
            if (!$ca04af99794d5fdc$var$isNestedFrozen(nestedValue)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $ca04af99794d5fdc$export$6dea1aad6dac5ac2() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var storeAPI, next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $ca04af99794d5fdc$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $ca04af99794d5fdc$var$buildGetDefaultMiddleware = function() {
    return function getDefaultMiddleware(options) {
        var _ref = options != null ? options : {}, _ref_thunk = _ref.thunk, thunk = _ref_thunk === void 0 ? true : _ref_thunk, _ref_immutableCheck = _ref.immutableCheck, immutableCheck = _ref_immutableCheck === void 0 ? true : _ref_immutableCheck, _ref_serializableCheck = _ref.serializableCheck, serializableCheck = _ref_serializableCheck === void 0 ? true : _ref_serializableCheck, _ref_actionCreatorCheck = _ref.actionCreatorCheck, actionCreatorCheck = _ref_actionCreatorCheck === void 0 ? true : _ref_actionCreatorCheck;
        var middlewareArray = new $ca04af99794d5fdc$export$1908877435b1d5e9();
        if (thunk) {
            if ($ca04af99794d5fdc$var$isBoolean(thunk)) middlewareArray.push((0, $21ccc86701ec53ef$export$dd164f5517779f15));
            else middlewareArray.push((0, $21ccc86701ec53ef$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
};
// src/autoBatchEnhancer.ts
var $ca04af99794d5fdc$export$8fb31c0f05df007b = "RTK_autoBatch";
var $ca04af99794d5fdc$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        return {
            payload: payload,
            meta: (0, $72osQ._)({}, $ca04af99794d5fdc$export$8fb31c0f05df007b, true)
        };
    };
};
var $ca04af99794d5fdc$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $ca04af99794d5fdc$export$676277d7dca0f396 = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        type: "raf"
    };
    return function(next) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var store = next.apply(void 0, (0, $2us1u._)(args));
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = /* @__PURE__ */ new Set();
            var queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $ca04af99794d5fdc$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $ca04af99794d5fdc$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$ca04af99794d5fdc$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/getDefaultEnhancers.ts
var $ca04af99794d5fdc$var$buildGetDefaultEnhancers = function(middlewareEnhancer) {
    return function getDefaultEnhancers(options) {
        var _ref = options != null ? options : {}, _ref_autoBatch = _ref.autoBatch, autoBatch = _ref_autoBatch === void 0 ? true : _ref_autoBatch;
        var enhancerArray = new $ca04af99794d5fdc$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($ca04af99794d5fdc$export$676277d7dca0f396((typeof autoBatch === "undefined" ? "undefined" : (0, $bJtXW._)(autoBatch)) === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
};
// src/configureStore.ts
function $ca04af99794d5fdc$export$7d8a5b498da695ac(options) {
    var getDefaultMiddleware = $ca04af99794d5fdc$var$buildGetDefaultMiddleware();
    var _ref = options || {}, reducer = _ref.reducer, middleware = _ref.middleware, _ref_devTools = _ref.devTools, devTools = _ref_devTools === void 0 ? true : _ref_devTools, preloadedState = _ref.preloadedState, enhancers = _ref.enhancers;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $20ec22595b3da151$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $20ec22595b3da151$export$66e4520cdb265d18)(reducer);
    else throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(1));
    var finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var finalCompose = (0, $20ec22595b3da151$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $ca04af99794d5fdc$var$composeWithDevTools($ca04af99794d5fdc$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, (typeof devTools === "undefined" ? "undefined" : (0, $bJtXW._)(devTools)) === "object" && devTools));
    var middlewareEnhancer = (0, $20ec22595b3da151$export$9ff26e0402cc7b7).apply(void 0, (0, $2us1u._)(finalMiddleware));
    var getDefaultEnhancers = $ca04af99794d5fdc$var$buildGetDefaultEnhancers(middlewareEnhancer);
    var storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    var composedEnhancer = finalCompose.apply(void 0, (0, $2us1u._)(storeEnhancers));
    return (0, $20ec22595b3da151$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $ca04af99794d5fdc$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $ca04af99794d5fdc$var$isStateFunction(x) {
    return typeof x === "function";
}
function $ca04af99794d5fdc$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    var _executeReducerBuilderCallback = (0, $2nwvT._)($ca04af99794d5fdc$var$executeReducerBuilderCallback(mapOrBuilderCallback), 3), actionsMap = _executeReducerBuilderCallback[0], finalActionMatchers = _executeReducerBuilderCallback[1], finalDefaultCaseReducer = _executeReducerBuilderCallback[2];
    var getInitialState;
    if ($ca04af99794d5fdc$var$isStateFunction(initialState)) getInitialState = function() {
        return $ca04af99794d5fdc$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState = $ca04af99794d5fdc$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState;
        };
    }
    function reducer() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getInitialState(), action = arguments.length > 1 ? arguments[1] : void 0;
        var caseReducers = [
            actionsMap[action.type]
        ].concat((0, $2us1u._)(finalActionMatchers.filter(function(param) {
            var matcher = param.matcher;
            return matcher(action);
        }).map(function(param) {
            var reducer2 = param.reducer;
            return reducer2;
        })));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $kK8g8.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $kK8g8.isDraftable)(previousState)) {
                    var result1 = caseReducer(previousState, action);
                    if (result1 === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result1;
                } else return (0, $kK8g8.produce)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $ca04af99794d5fdc$var$matches = function(matcher, action) {
    if ($ca04af99794d5fdc$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $ca04af99794d5fdc$export$2c3435c7647f7b0d() {
    for(var _len = arguments.length, matchers = new Array(_len), _key = 0; _key < _len; _key++){
        matchers[_key] = arguments[_key];
    }
    return function(action) {
        return matchers.some(function(matcher) {
            return $ca04af99794d5fdc$var$matches(matcher, action);
        });
    };
}
function $ca04af99794d5fdc$export$9dd1fb32974da385() {
    for(var _len = arguments.length, matchers = new Array(_len), _key = 0; _key < _len; _key++){
        matchers[_key] = arguments[_key];
    }
    return function(action) {
        return matchers.every(function(matcher) {
            return $ca04af99794d5fdc$var$matches(matcher, action);
        });
    };
}
function $ca04af99794d5fdc$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $ca04af99794d5fdc$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $ca04af99794d5fdc$export$872dec21e9a69476() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $ca04af99794d5fdc$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$ca04af99794d5fdc$var$isAsyncThunkArray(asyncThunks)) return $ca04af99794d5fdc$export$872dec21e9a69476()(asyncThunks[0]);
    return $ca04af99794d5fdc$export$2c3435c7647f7b0d.apply(void 0, (0, $2us1u._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.pending;
    })));
}
function $ca04af99794d5fdc$export$a5c5d27e3994c5be() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $ca04af99794d5fdc$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$ca04af99794d5fdc$var$isAsyncThunkArray(asyncThunks)) return $ca04af99794d5fdc$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $ca04af99794d5fdc$export$2c3435c7647f7b0d.apply(void 0, (0, $2us1u._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.rejected;
    })));
}
function $ca04af99794d5fdc$export$fcc3388fb56de601() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $ca04af99794d5fdc$export$9dd1fb32974da385($ca04af99794d5fdc$export$a5c5d27e3994c5be.apply(void 0, (0, $2us1u._)(asyncThunks)), hasFlag);
    if (!$ca04af99794d5fdc$var$isAsyncThunkArray(asyncThunks)) return $ca04af99794d5fdc$export$fcc3388fb56de601()(asyncThunks[0]);
    return $ca04af99794d5fdc$export$9dd1fb32974da385($ca04af99794d5fdc$export$a5c5d27e3994c5be.apply(void 0, (0, $2us1u._)(asyncThunks)), hasFlag);
}
function $ca04af99794d5fdc$export$1da80a6ef1307441() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $ca04af99794d5fdc$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$ca04af99794d5fdc$var$isAsyncThunkArray(asyncThunks)) return $ca04af99794d5fdc$export$1da80a6ef1307441()(asyncThunks[0]);
    return $ca04af99794d5fdc$export$2c3435c7647f7b0d.apply(void 0, (0, $2us1u._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.fulfilled;
    })));
}
function $ca04af99794d5fdc$export$6aa4142d99c1abce() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $ca04af99794d5fdc$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$ca04af99794d5fdc$var$isAsyncThunkArray(asyncThunks)) return $ca04af99794d5fdc$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $ca04af99794d5fdc$export$2c3435c7647f7b0d.apply(void 0, (0, $2us1u._)(asyncThunks.flatMap(function(asyncThunk) {
        return [
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ];
    })));
}
// src/nanoid.ts
var $ca04af99794d5fdc$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $ca04af99794d5fdc$export$ac4959f4f1338dfc = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 21;
    var id = "";
    var i = size;
    while(i--)id += $ca04af99794d5fdc$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $ca04af99794d5fdc$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $ca04af99794d5fdc$var$RejectWithValue = function RejectWithValue(payload, meta) {
    "use strict";
    (0, $grujF._)(this, RejectWithValue);
    this.payload = payload;
    this.meta = meta;
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $ca04af99794d5fdc$var$__publicField(this, "_type");
};
var $ca04af99794d5fdc$var$FulfillWithMeta = function FulfillWithMeta(payload, meta) {
    "use strict";
    (0, $grujF._)(this, FulfillWithMeta);
    this.payload = payload;
    this.meta = meta;
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $ca04af99794d5fdc$var$__publicField(this, "_type");
};
var $ca04af99794d5fdc$export$c97c53d0b2d5d81e = function(value) {
    if ((typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) === "object" && value !== null) {
        var simpleError = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = $ca04af99794d5fdc$var$commonProperties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var property = _step.value;
                if (typeof value[property] === "string") simpleError[property] = value[property];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $ca04af99794d5fdc$export$6abd22dc03e5063f = /* @__PURE__ */ function() {
    var createAsyncThunk2 = function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $ca04af99794d5fdc$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $ca04af99794d5fdc$var$__spreadProps($ca04af99794d5fdc$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $ca04af99794d5fdc$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $ca04af99794d5fdc$var$__spreadProps($ca04af99794d5fdc$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $ca04af99794d5fdc$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $ca04af99794d5fdc$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $ca04af99794d5fdc$var$__spreadProps($ca04af99794d5fdc$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var abort = function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                };
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $ca04af99794d5fdc$export$ac4959f4f1338dfc();
                var abortController = new AbortController();
                var abortHandler;
                var abortReason;
                var promise = function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err, skipDispatch;
                        return (0, $fRv9I.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        4,
                                        5,
                                        6
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$ca04af99794d5fdc$var$isThenable(conditionResult)) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _state.sent();
                                    _state.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    abortedPromise = new Promise(function(_, reject) {
                                        abortHandler = function() {
                                            reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        };
                                        abortController.signal.addEventListener("abort", abortHandler);
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $ca04af99794d5fdc$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $ca04af99794d5fdc$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $ca04af99794d5fdc$var$RejectWithValue) throw result;
                                                if (result instanceof $ca04af99794d5fdc$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _state.sent();
                                    return [
                                        3,
                                        6
                                    ];
                                case 4:
                                    err = _state.sent();
                                    finalAction = err instanceof $ca04af99794d5fdc$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                                    return [
                                        3,
                                        6
                                    ];
                                case 5:
                                    if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                                    return [
                                        7
                                    ];
                                case 6:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2,
                                        finalAction
                                    ];
                            }
                        });
                    })();
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise.then($ca04af99794d5fdc$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $ca04af99794d5fdc$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    };
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $ca04af99794d5fdc$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $ca04af99794d5fdc$var$isThenable(value) {
    return value !== null && (typeof value === "undefined" ? "undefined" : (0, $bJtXW._)(value)) === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $ca04af99794d5fdc$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $ca04af99794d5fdc$export$343355ed40c51c46 = (0, $72osQ._)({}, $ca04af99794d5fdc$var$asyncThunkSymbol, $ca04af99794d5fdc$export$6abd22dc03e5063f);
var $ca04af99794d5fdc$export$23a094319a4b586 = /* @__PURE__ */ function(ReducerType2) {
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
}($ca04af99794d5fdc$export$23a094319a4b586 || {});
function $ca04af99794d5fdc$var$getType(slice, actionKey) {
    return "".concat(slice, "/").concat(actionKey);
}
function $ca04af99794d5fdc$export$affdea4146de9cf5() {
    var creators = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).creators;
    var _a;
    var cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$ca04af99794d5fdc$var$asyncThunkSymbol];
    return function createSlice2(options) {
        var name = options.name, _options_reducerPath = options.reducerPath, reducerPath = _options_reducerPath === void 0 ? name : _options_reducerPath;
        if (!name) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(11));
        var reducers = (typeof options.reducers === "function" ? options.reducers($ca04af99794d5fdc$var$buildReducerCreators()) : options.reducers) || {};
        var reducerNames = Object.keys(reducers);
        var context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        var contextMethods = {
            addCase: function(typeOrActionCreator, reducer2) {
                var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher: function(matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction: function(name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer: function(name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach(function(reducerName) {
            var reducerDefinition = reducers[reducerName];
            var reducerDetails = {
                reducerName: reducerName,
                type: $ca04af99794d5fdc$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($ca04af99794d5fdc$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $ca04af99794d5fdc$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $ca04af99794d5fdc$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            var _ref = (0, $2nwvT._)(typeof options.extraReducers === "function" ? $ca04af99794d5fdc$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ], 3), tmp = _ref[0], extraReducers = tmp === void 0 ? {} : tmp, tmp1 = _ref[1], actionMatchers = tmp1 === void 0 ? [] : tmp1, defaultCaseReducer = _ref[2];
            var finalCaseReducers = $ca04af99794d5fdc$var$__spreadValues($ca04af99794d5fdc$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $ca04af99794d5fdc$export$473eb76d322d0290(options.initialState, function(builder) {
                for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = context.sliceMatchers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sM = _step.value;
                        builder.addMatcher(sM.matcher, sM.reducer);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = actionMatchers[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var m = _step1.value;
                        builder.addMatcher(m.matcher, m.reducer);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        var selectSelf = function(state) {
            return state;
        };
        var injectedSelectorCache = /* @__PURE__ */ new Map();
        var _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2) {
            var injected = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            function selectSlice(state) {
                var sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors() {
                var selectState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : selectSelf;
                var selectorCache = $ca04af99794d5fdc$var$getOrInsertComputed(injectedSelectorCache, injected, function() {
                    return /* @__PURE__ */ new WeakMap();
                });
                return $ca04af99794d5fdc$var$getOrInsertComputed(selectorCache, selectState, function() {
                    var _a2;
                    var map = {};
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.entries((_a2 = options.selectors) != null ? _a2 : {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $2nwvT._)(_step.value, 2), name2 = _step_value[0], selector = _step_value[1];
                            map[name2] = $ca04af99794d5fdc$var$wrapSelector(selector, selectState, getInitialState, injected);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        var slice = $ca04af99794d5fdc$var$__spreadProps($ca04af99794d5fdc$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto: function(injectable) {
                var _a2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _b = _a2, pathOpt = _b.reducerPath, config = $ca04af99794d5fdc$var$__objRest(_b, [
                    "reducerPath"
                ]);
                var newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $ca04af99794d5fdc$var$__spreadValues($ca04af99794d5fdc$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $ca04af99794d5fdc$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector.apply(void 0, [
            sliceState
        ].concat((0, $2us1u._)(args)));
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $ca04af99794d5fdc$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $ca04af99794d5fdc$export$affdea4146de9cf5();
function $ca04af99794d5fdc$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $ca04af99794d5fdc$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = function() {
        return asyncThunk;
    };
    return {
        reducer: function(caseReducer) {
            return Object.assign(// hack so the wrapping function has the same name as the original
            // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
            (0, $72osQ._)({}, caseReducer.name, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return caseReducer.apply(void 0, (0, $2us1u._)(args));
            })[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer: function(prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $ca04af99794d5fdc$var$handleNormalReducerDefinition(param, maybeReducerWithPrepare, context) {
    var type = param.type, reducerName = param.reducerName, createNotation = param.createNotation;
    var caseReducer;
    var prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$ca04af99794d5fdc$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $ca04af99794d5fdc$export$309c7a02b0b0bc62(type, prepareCallback) : $ca04af99794d5fdc$export$309c7a02b0b0bc62(type));
}
function $ca04af99794d5fdc$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $ca04af99794d5fdc$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $ca04af99794d5fdc$var$handleThunkCaseReducerDefinition(param, reducerDefinition, context, cAT) {
    var type = param.type, reducerName = param.reducerName;
    if (!cAT) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(18));
    var payloadCreator = reducerDefinition.payloadCreator, fulfilled = reducerDefinition.fulfilled, pending = reducerDefinition.pending, rejected = reducerDefinition.rejected, settled = reducerDefinition.settled, options = reducerDefinition.options;
    var thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $ca04af99794d5fdc$var$noop,
        pending: pending || $ca04af99794d5fdc$var$noop,
        rejected: rejected || $ca04af99794d5fdc$var$noop,
        settled: settled || $ca04af99794d5fdc$var$noop
    });
}
function $ca04af99794d5fdc$var$noop() {}
// src/entities/entity_state.ts
function $ca04af99794d5fdc$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $ca04af99794d5fdc$var$createInitialStateFactory(stateAdapter) {
    function getInitialState() {
        var additionalState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, entities = arguments.length > 1 ? arguments[1] : void 0;
        var state = Object.assign($ca04af99794d5fdc$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $ca04af99794d5fdc$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var tmp = options.createSelector, createSelector2 = tmp === void 0 ? $ca04af99794d5fdc$export$a5d3c27355e35910 : tmp;
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = createSelector2(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = createSelector2(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $ca04af99794d5fdc$var$isDraftTyped = (0, $kK8g8.isDraft);
function $ca04af99794d5fdc$var$createSingleArgumentStateOperator(mutator) {
    var operator = $ca04af99794d5fdc$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $ca04af99794d5fdc$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $ca04af99794d5fdc$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($ca04af99794d5fdc$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $kK8g8.produce)(state, runMutator);
    };
}
function $ca04af99794d5fdc$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $ca04af99794d5fdc$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $ca04af99794d5fdc$var$getCurrent(value) {
    return (0, $kK8g8.isDraft)(value) ? (0, $kK8g8.current)(value) : value;
}
function $ca04af99794d5fdc$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
    var existingIdsArray = $ca04af99794d5fdc$var$getCurrent(state.ids);
    var existingIds = new Set(existingIdsArray);
    var added = [];
    var updated = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entity = _step.value;
            var id = $ca04af99794d5fdc$var$selectIdValue(entity, selectId);
            if (existingIds.has(id)) updated.push({
                id: id,
                changes: entity
            });
            else added.push(entity);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $ca04af99794d5fdc$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $ca04af99794d5fdc$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                addOneMutably(entity, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function setOneMutably(entity, state) {
        var key = $ca04af99794d5fdc$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                setOneMutably(entity, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        var updated = Object.assign({}, original3, update.changes);
        var newKey = $ca04af99794d5fdc$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $ca04af99794d5fdc$var$__spreadValues($ca04af99794d5fdc$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map(function(e) {
                return $ca04af99794d5fdc$var$selectIdValue(e, selectId);
            });
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _splitAddedUpdatedEntities = (0, $2nwvT._)($ca04af99794d5fdc$var$splitAddedUpdatedEntities(newEntities, selectId, state), 2), added = _splitAddedUpdatedEntities[0], updated = _splitAddedUpdatedEntities[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $ca04af99794d5fdc$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $ca04af99794d5fdc$var$createStateOperator(addOneMutably),
        addMany: $ca04af99794d5fdc$var$createStateOperator(addManyMutably),
        setOne: $ca04af99794d5fdc$var$createStateOperator(setOneMutably),
        setMany: $ca04af99794d5fdc$var$createStateOperator(setManyMutably),
        setAll: $ca04af99794d5fdc$var$createStateOperator(setAllMutably),
        updateOne: $ca04af99794d5fdc$var$createStateOperator(updateOneMutably),
        updateMany: $ca04af99794d5fdc$var$createStateOperator(updateManyMutably),
        upsertOne: $ca04af99794d5fdc$var$createStateOperator(upsertOneMutably),
        upsertMany: $ca04af99794d5fdc$var$createStateOperator(upsertManyMutably),
        removeOne: $ca04af99794d5fdc$var$createStateOperator(removeOneMutably),
        removeMany: $ca04af99794d5fdc$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $ca04af99794d5fdc$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    var lowIndex = 0;
    var highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        var middleIndex = lowIndex + highIndex >>> 1;
        var currentItem = sortedItems[middleIndex];
        var res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $ca04af99794d5fdc$var$insert(sortedItems, item, comparisonFunction) {
    var insertAtIndex = $ca04af99794d5fdc$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $ca04af99794d5fdc$var$createSortedStateAdapter(selectId, comparer) {
    var _createUnsortedStateAdapter = $ca04af99794d5fdc$var$createUnsortedStateAdapter(selectId), removeOne = _createUnsortedStateAdapter.removeOne, removeMany = _createUnsortedStateAdapter.removeMany, removeAll = _createUnsortedStateAdapter.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
        var existingKeys = new Set(existingIds != null ? existingIds : $ca04af99794d5fdc$var$getCurrent(state.ids));
        var models = newEntities.filter(function(model) {
            return !existingKeys.has($ca04af99794d5fdc$var$selectIdValue(model, selectId));
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var item = _step.value;
                    delete state.entities[selectId(item)];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $ca04af99794d5fdc$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        var replacedIds = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = updates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var update = _step.value;
                var entity = state.entities[update.id];
                if (!entity) continue;
                appliedUpdates = true;
                Object.assign(entity, update.changes);
                var newId = selectId(entity);
                if (update.id !== newId) {
                    replacedIds = true;
                    delete state.entities[update.id];
                    var oldIndex = state.ids.indexOf(update.id);
                    state.ids[oldIndex] = newId;
                    state.entities[newId] = entity;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _splitAddedUpdatedEntities = (0, $2nwvT._)($ca04af99794d5fdc$var$splitAddedUpdatedEntities(newEntities, selectId, state), 3), added = _splitAddedUpdatedEntities[0], updated = _splitAddedUpdatedEntities[1], existingIdsArray = _splitAddedUpdatedEntities[2];
        if (updated.length) updateManyMutably(updated, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    var mergeFunction = function(state, addedItems, appliedUpdates, replacedIds) {
        var currentEntities = $ca04af99794d5fdc$var$getCurrent(state.entities);
        var currentIds = $ca04af99794d5fdc$var$getCurrent(state.ids);
        var stateEntities = state.entities;
        var ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        var sortedEntities = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = ids[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var id = _step.value;
                var entity = currentEntities[id];
                if (entity) sortedEntities.push(entity);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var wasPreviouslyEmpty = sortedEntities.length === 0;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = addedItems[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var item = _step1.value;
                stateEntities[selectId(item)] = item;
                if (!wasPreviouslyEmpty) $ca04af99794d5fdc$var$insert(sortedEntities, item, comparer);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        var newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $ca04af99794d5fdc$var$createStateOperator(addOneMutably),
        updateOne: $ca04af99794d5fdc$var$createStateOperator(updateOneMutably),
        upsertOne: $ca04af99794d5fdc$var$createStateOperator(upsertOneMutably),
        setOne: $ca04af99794d5fdc$var$createStateOperator(setOneMutably),
        setMany: $ca04af99794d5fdc$var$createStateOperator(setManyMutably),
        setAll: $ca04af99794d5fdc$var$createStateOperator(setAllMutably),
        addMany: $ca04af99794d5fdc$var$createStateOperator(addManyMutably),
        updateMany: $ca04af99794d5fdc$var$createStateOperator(updateManyMutably),
        upsertMany: $ca04af99794d5fdc$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $ca04af99794d5fdc$export$abcf4037b41e0df() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var __spreadValues1 = $ca04af99794d5fdc$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = __spreadValues1.selectId, sortComparer = __spreadValues1.sortComparer;
    var stateAdapter = sortComparer ? $ca04af99794d5fdc$var$createSortedStateAdapter(selectId, sortComparer) : $ca04af99794d5fdc$var$createUnsortedStateAdapter(selectId);
    var stateFactory = $ca04af99794d5fdc$var$createInitialStateFactory(stateAdapter);
    var selectorsFactory = $ca04af99794d5fdc$var$createSelectorsFactory();
    return $ca04af99794d5fdc$var$__spreadValues($ca04af99794d5fdc$var$__spreadValues($ca04af99794d5fdc$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $ca04af99794d5fdc$var$task = "task";
var $ca04af99794d5fdc$var$listener = "listener";
var $ca04af99794d5fdc$var$completed = "completed";
var $ca04af99794d5fdc$var$cancelled = "cancelled";
var $ca04af99794d5fdc$var$taskCancelled = "task-".concat($ca04af99794d5fdc$var$cancelled);
var $ca04af99794d5fdc$var$taskCompleted = "task-".concat($ca04af99794d5fdc$var$completed);
var $ca04af99794d5fdc$var$listenerCancelled = "".concat($ca04af99794d5fdc$var$listener, "-").concat($ca04af99794d5fdc$var$cancelled);
var $ca04af99794d5fdc$var$listenerCompleted = "".concat($ca04af99794d5fdc$var$listener, "-").concat($ca04af99794d5fdc$var$completed);
var $ca04af99794d5fdc$export$cb1bdac908fed7f = function TaskAbortError(code) {
    "use strict";
    (0, $grujF._)(this, TaskAbortError);
    this.code = code;
    $ca04af99794d5fdc$var$__publicField(this, "name", "TaskAbortError");
    $ca04af99794d5fdc$var$__publicField(this, "message");
    this.message = "".concat($ca04af99794d5fdc$var$task, " ").concat($ca04af99794d5fdc$var$cancelled, " (reason: ").concat(code, ")");
};
// src/listenerMiddleware/utils.ts
var $ca04af99794d5fdc$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError($ca04af99794d5fdc$export$378fa86b259c0280(32));
};
var $ca04af99794d5fdc$var$noop2 = function() {};
var $ca04af99794d5fdc$var$catchRejection = function(promise) {
    var onError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $ca04af99794d5fdc$var$noop2;
    promise.catch(onError);
    return promise;
};
var $ca04af99794d5fdc$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $ca04af99794d5fdc$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $ca04af99794d5fdc$var$validateActive = function(signal) {
    if (signal.aborted) {
        var reason = signal.reason;
        throw new $ca04af99794d5fdc$export$cb1bdac908fed7f(reason);
    }
};
function $ca04af99794d5fdc$var$raceWithSignal(signal, promise) {
    var cleanup = $ca04af99794d5fdc$var$noop2;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $ca04af99794d5fdc$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $ca04af99794d5fdc$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $ca04af99794d5fdc$var$noop2;
    });
}
var $ca04af99794d5fdc$var$runTask = function(task2, cleanUp) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
        var value, error;
        return (0, $fRv9I.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        Promise.resolve()
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        task2()
                    ];
                case 2:
                    value = _state.sent();
                    return [
                        2,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        {
                            status: error instanceof $ca04af99794d5fdc$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $ca04af99794d5fdc$var$createPause = function(signal) {
    return function(promise) {
        return $ca04af99794d5fdc$var$catchRejection($ca04af99794d5fdc$var$raceWithSignal(signal, promise).then(function(output) {
            $ca04af99794d5fdc$var$validateActive(signal);
            return output;
        }));
    };
};
var $ca04af99794d5fdc$var$createDelay = function(signal) {
    var pause = $ca04af99794d5fdc$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $ca04af99794d5fdc$var$assign = Object.assign;
var $ca04af99794d5fdc$var$INTERNAL_NIL_TOKEN = {};
var $ca04af99794d5fdc$var$alm = "listenerMiddleware";
var $ca04af99794d5fdc$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $ca04af99794d5fdc$var$addAbortSignalListener(parentAbortSignal, function() {
            return $ca04af99794d5fdc$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $ca04af99794d5fdc$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $ca04af99794d5fdc$var$runTask(function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
                var result2;
                return (0, $fRv9I.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            $ca04af99794d5fdc$var$validateActive(parentAbortSignal);
                            $ca04af99794d5fdc$var$validateActive(childAbortController.signal);
                            return [
                                4,
                                taskExecutor({
                                    pause: $ca04af99794d5fdc$var$createPause(childAbortController.signal),
                                    delay: $ca04af99794d5fdc$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _state.sent();
                            $ca04af99794d5fdc$var$validateActive(childAbortController.signal);
                            return [
                                2,
                                result2
                            ];
                    }
                });
            })();
        }, function() {
            return $ca04af99794d5fdc$var$abortControllerWithReason(childAbortController, $ca04af99794d5fdc$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($ca04af99794d5fdc$var$noop2));
        return {
            result: $ca04af99794d5fdc$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $ca04af99794d5fdc$var$abortControllerWithReason(childAbortController, $ca04af99794d5fdc$var$taskCancelled);
            }
        };
    };
};
var $ca04af99794d5fdc$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var unsubscribe, tuplePromise, promises, output;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $ca04af99794d5fdc$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            $ca04af99794d5fdc$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _state.sent();
                        $ca04af99794d5fdc$var$validateActive(signal);
                        return [
                            2,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return function(predicate, timeout) {
        return $ca04af99794d5fdc$var$catchRejection(take(predicate, timeout));
    };
};
var $ca04af99794d5fdc$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $ca04af99794d5fdc$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(21));
    $ca04af99794d5fdc$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $ca04af99794d5fdc$var$createListenerEntry = /* @__PURE__ */ $ca04af99794d5fdc$var$assign(function(options) {
    var _getListenerEntryPropsFrom = $ca04af99794d5fdc$var$getListenerEntryPropsFrom(options), type = _getListenerEntryPropsFrom.type, predicate = _getListenerEntryPropsFrom.predicate, effect = _getListenerEntryPropsFrom.effect;
    var entry = {
        id: $ca04af99794d5fdc$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: function() {
            throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: function() {
        return $ca04af99794d5fdc$var$createListenerEntry;
    }
});
var $ca04af99794d5fdc$var$findListenerEntry = function(listenerMap, options) {
    var _getListenerEntryPropsFrom = $ca04af99794d5fdc$var$getListenerEntryPropsFrom(options), type = _getListenerEntryPropsFrom.type, effect = _getListenerEntryPropsFrom.effect, predicate = _getListenerEntryPropsFrom.predicate;
    return Array.from(listenerMap.values()).find(function(entry) {
        var matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $ca04af99794d5fdc$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $ca04af99794d5fdc$var$abortControllerWithReason(controller, $ca04af99794d5fdc$var$listenerCancelled);
    });
};
var $ca04af99794d5fdc$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($ca04af99794d5fdc$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $ca04af99794d5fdc$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $ca04af99794d5fdc$export$f03a6b845d3fb58b = /* @__PURE__ */ $ca04af99794d5fdc$var$assign(/* @__PURE__ */ $ca04af99794d5fdc$export$309c7a02b0b0bc62("".concat($ca04af99794d5fdc$var$alm, "/add")), {
    withTypes: function() {
        return $ca04af99794d5fdc$export$f03a6b845d3fb58b;
    }
});
var $ca04af99794d5fdc$export$b1b8022855fb2b71 = /* @__PURE__ */ $ca04af99794d5fdc$export$309c7a02b0b0bc62("".concat($ca04af99794d5fdc$var$alm, "/removeAll"));
var $ca04af99794d5fdc$export$b03e9483f936dccb = /* @__PURE__ */ $ca04af99794d5fdc$var$assign(/* @__PURE__ */ $ca04af99794d5fdc$export$309c7a02b0b0bc62("".concat($ca04af99794d5fdc$var$alm, "/remove")), {
    withTypes: function() {
        return $ca04af99794d5fdc$export$b03e9483f936dccb;
    }
});
var $ca04af99794d5fdc$var$defaultErrorHandler = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _console;
    (_console = console).error.apply(_console, [
        "".concat($ca04af99794d5fdc$var$alm, "/error")
    ].concat((0, $2us1u._)(args)));
};
var $ca04af99794d5fdc$export$1228acebbbcb485b = function() {
    var middlewareOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var listenerMap = /* @__PURE__ */ new Map();
    var extra = middlewareOptions.extra, _middlewareOptions_onError = middlewareOptions.onError, onError = _middlewareOptions_onError === void 0 ? $ca04af99794d5fdc$var$defaultErrorHandler : _middlewareOptions_onError;
    $ca04af99794d5fdc$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $ca04af99794d5fdc$var$cancelActiveListeners(entry);
        };
    };
    var startListening = function(options) {
        var _a;
        var entry = (_a = $ca04af99794d5fdc$var$findListenerEntry(listenerMap, options)) != null ? _a : $ca04af99794d5fdc$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $ca04af99794d5fdc$var$assign(startListening, {
        withTypes: function() {
            return startListening;
        }
    });
    var stopListening = function(options) {
        var entry = $ca04af99794d5fdc$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $ca04af99794d5fdc$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $ca04af99794d5fdc$var$assign(stopListening, {
        withTypes: function() {
            return stopListening;
        }
    });
    var notifyListener = function(entry, action, api, getOriginalState) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $g3gsR._)(function() {
            var internalTaskController, take, autoJoinPromises, listenerError;
            return (0, $fRv9I.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $ca04af99794d5fdc$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4,
                            Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
                            $ca04af99794d5fdc$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $ca04af99794d5fdc$var$createDelay(internalTaskController.signal),
                                pause: $ca04af99794d5fdc$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $ca04af99794d5fdc$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $ca04af99794d5fdc$var$abortControllerWithReason(controller, $ca04af99794d5fdc$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                },
                                cancel: function() {
                                    $ca04af99794d5fdc$var$abortControllerWithReason(internalTaskController, $ca04af99794d5fdc$var$listenerCancelled);
                                    entry.pending.delete(internalTaskController);
                                },
                                throwIfCancelled: function() {
                                    $ca04af99794d5fdc$var$validateActive(internalTaskController.signal);
                                }
                            })))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 3:
                        listenerError = _state.sent();
                        if (!(listenerError instanceof $ca04af99794d5fdc$export$cb1bdac908fed7f)) $ca04af99794d5fdc$var$safelyNotifyError(onError, listenerError, {
                            raisedBy: "effect"
                        });
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            Promise.all(autoJoinPromises)
                        ];
                    case 5:
                        _state.sent();
                        $ca04af99794d5fdc$var$abortControllerWithReason(internalTaskController, $ca04af99794d5fdc$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var clearListenerMiddleware = $ca04af99794d5fdc$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!(0, $20ec22595b3da151$export$b956e38827fca970)(action)) return next(action);
                if ($ca04af99794d5fdc$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($ca04af99794d5fdc$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($ca04af99794d5fdc$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $ca04af99794d5fdc$var$INTERNAL_NIL_TOKEN) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(23));
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = listenerEntries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var entry = _step.value;
                                var runListener = false;
                                try {
                                    runListener = entry.predicate(action, currentState, originalState);
                                } catch (predicateError) {
                                    runListener = false;
                                    $ca04af99794d5fdc$var$safelyNotifyError(onError, predicateError, {
                                        raisedBy: "predicate"
                                    });
                                }
                                if (!runListener) continue;
                                notifyListener(entry, action, api, getOriginalState);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } finally{
                    originalState = $ca04af99794d5fdc$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $ca04af99794d5fdc$var$createMiddlewareEntry = function(middleware) {
    return {
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    };
};
var $ca04af99794d5fdc$var$matchInstance = function(instanceId) {
    return function(action) {
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
};
var $ca04af99794d5fdc$export$4bb1606a79445586 = function() {
    var instanceId = $ca04af99794d5fdc$export$ac4959f4f1338dfc();
    var middlewareMap = /* @__PURE__ */ new Map();
    var withMiddleware = Object.assign($ca04af99794d5fdc$export$309c7a02b0b0bc62("dynamicMiddleware/add", function() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
            middlewares[_key] = arguments[_key];
        }
        return {
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        };
    }), {
        withTypes: function() {
            return withMiddleware;
        }
    });
    var addMiddleware = Object.assign(function addMiddleware2() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
            middlewares[_key] = arguments[_key];
        }
        middlewares.forEach(function(middleware2) {
            $ca04af99794d5fdc$var$getOrInsertComputed(middlewareMap, middleware2, $ca04af99794d5fdc$var$createMiddlewareEntry);
        });
    }, {
        withTypes: function() {
            return addMiddleware;
        }
    });
    var getFinalMiddleware = function(api) {
        var appliedMiddleware = Array.from(middlewareMap.values()).map(function(entry) {
            return $ca04af99794d5fdc$var$getOrInsertComputed(entry.applied, api, entry.middleware);
        });
        return (0, $20ec22595b3da151$export$f672e0b6f7222cd7).apply(void 0, (0, $2us1u._)(appliedMiddleware));
    };
    var isWithMiddleware = $ca04af99794d5fdc$export$9dd1fb32974da385(withMiddleware, $ca04af99794d5fdc$var$matchInstance(instanceId));
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (isWithMiddleware(action)) {
                    addMiddleware.apply(void 0, (0, $2us1u._)(action.payload));
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
        };
    };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $ca04af99794d5fdc$var$isSliceLike = function(maybeSliceLike) {
    return "reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
};
var $ca04af99794d5fdc$var$getReducers = function(slices) {
    return slices.flatMap(function(sliceOrMap) {
        return $ca04af99794d5fdc$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap);
    });
};
var $ca04af99794d5fdc$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $ca04af99794d5fdc$var$isStateProxy = function(value) {
    return !!value && !!value[$ca04af99794d5fdc$var$ORIGINAL_STATE];
};
var $ca04af99794d5fdc$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $ca04af99794d5fdc$var$createStateProxy = function(state, reducerMap) {
    return $ca04af99794d5fdc$var$getOrInsertComputed($ca04af99794d5fdc$var$stateProxyMap, state, function() {
        return new Proxy(state, {
            get: function(target, prop, receiver) {
                if (prop === $ca04af99794d5fdc$var$ORIGINAL_STATE) return target;
                var result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    var reducer = reducerMap[prop.toString()];
                    if (reducer) {
                        var reducerResult = reducer(void 0, {
                            type: $ca04af99794d5fdc$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(24));
                        return reducerResult;
                    }
                }
                return result;
            }
        });
    });
};
var $ca04af99794d5fdc$var$original = function(state) {
    if (!$ca04af99794d5fdc$var$isStateProxy(state)) throw new Error($ca04af99794d5fdc$export$378fa86b259c0280(25));
    return state[$ca04af99794d5fdc$var$ORIGINAL_STATE];
};
var $ca04af99794d5fdc$var$noopReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return state;
};
function $ca04af99794d5fdc$export$a3734c7614660b9() {
    for(var _len = arguments.length, slices = new Array(_len), _key = 0; _key < _len; _key++){
        slices[_key] = arguments[_key];
    }
    var reducerMap = Object.fromEntries($ca04af99794d5fdc$var$getReducers(slices));
    var getReducer = function() {
        return Object.keys(reducerMap).length ? (0, $20ec22595b3da151$export$66e4520cdb265d18)(reducerMap) : $ca04af99794d5fdc$var$noopReducer;
    };
    var reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = function() {
        return combinedReducer;
    };
    var inject = function(slice) {
        var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var reducerPath = slice.reducerPath, reducerToInject = slice.reducer;
        var currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    var selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            return selectorFn.apply(void 0, [
                $ca04af99794d5fdc$var$createStateProxy(selectState ? selectState.apply(void 0, [
                    state
                ].concat((0, $2us1u._)(args))) : state, reducerMap)
            ].concat((0, $2us1u._)(args)));
        };
    }, {
        original: $ca04af99794d5fdc$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $ca04af99794d5fdc$export$378fa86b259c0280(code) {
    return "Minified Redux Toolkit error #".concat(code, "; visit https://redux-toolkit.js.org/Errors?code=").concat(code, " for the full message or use the non-minified dev environment for full errors. ");
}


var $5f6a65239c5f7383$var$cartSlice = (0, $ca04af99794d5fdc$export$4d8d9bd83c24ae8b)({
    name: 'cart',
    initialState: {
        items: []
    },
    reducers: {
        addItem: function(state, action) {
            state.items.push(action.payload);
        },
        removeItem: function(state) {
            state.items.pop();
        },
        clearCart: function(state) {
            state.items.length = 0;
        }
    }
});
var $5f6a65239c5f7383$var$_cartSlice_actions = $5f6a65239c5f7383$var$cartSlice.actions;
var $5f6a65239c5f7383$export$fb9705de59d96855 = $5f6a65239c5f7383$var$_cartSlice_actions.addItem, $5f6a65239c5f7383$export$fe2d9b4e03920b4c = $5f6a65239c5f7383$var$_cartSlice_actions.removeItem, $5f6a65239c5f7383$export$810121176e3e3671 = $5f6a65239c5f7383$var$_cartSlice_actions.clearCart;
var $5f6a65239c5f7383$export$2e2bcd8739ae039 = $5f6a65239c5f7383$var$cartSlice.reducer;


var $981f1ca9fd215ae3$var$ItemList = function(param) {
    var items = param.items;
    var dispatch = (0, $d7d37dc522b09008$export$8ad76b76a4c905f8)();
    var handleAddItem = function(item) {
        dispatch((0, $5f6a65239c5f7383$export$fb9705de59d96855)(item));
    };
    return /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
        className: "divide-y divide-gray-200",
        children: items.map(function(item) {
            return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "flex flex-col sm:flex-row justify-between gap-4 py-4",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                        className: "sm:w-9/12",
                        children: [
                            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                                className: "flex justify-between sm:justify-start sm:gap-2 font-medium text-gray-800",
                                children: [
                                    /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                                        children: item.card.info.name
                                    }),
                                    /*#__PURE__*/ (0, $iD4WH.jsxs)("span", {
                                        children: [
                                            "\u20B9",
                                            item.card.info.price ? item.card.info.price / 100 : item.card.info.defaultPrice / 100
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iD4WH.jsx)("p", {
                                className: "text-sm text-gray-500 mt-1",
                                children: item.card.info.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                        className: "sm:w-3/12 flex items-center justify-end",
                        children: /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                            className: "px-5 py-2 bg-green-500 text-white rounded-lg shadow hover:bg-green-600 transition",
                            onClick: function() {
                                return handleAddItem(item);
                            },
                            children: "Add +"
                        })
                    })
                ]
            }, item.card.info.id);
        })
    });
};
var $981f1ca9fd215ae3$export$2e2bcd8739ae039 = $981f1ca9fd215ae3$var$ItemList;


var $a6945e307908f5ca$var$RestaurantCategory = function(param) {
    var data = param.data, setshowIndex = param.setshowIndex, ShowItems = param.ShowItems;
    var handleClick = function() {
        setshowIndex();
    };
    return /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
            className: "max-w-3xl mx-auto my-4 bg-white rounded-xl shadow-md",
            children: [
                /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                    className: "flex justify-between items-center px-5 py-4 cursor-pointer hover:bg-gray-50 transition",
                    onClick: handleClick,
                    children: [
                        /*#__PURE__*/ (0, $iD4WH.jsxs)("span", {
                            className: "font-semibold text-lg text-gray-800",
                            children: [
                                data.title,
                                " (",
                                data.itemCards.length,
                                ")"
                            ]
                        }),
                        /*#__PURE__*/ (0, $iD4WH.jsx)("span", {
                            className: "text-xl",
                            children: ShowItems ? "\u2B06\uFE0F" : "\u2B07\uFE0F"
                        })
                    ]
                }),
                ShowItems && /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                    className: "px-4 pb-4",
                    children: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $981f1ca9fd215ae3$export$2e2bcd8739ae039), {
                        items: data.itemCards
                    })
                })
            ]
        })
    });
};
var $a6945e307908f5ca$export$2e2bcd8739ae039 = $a6945e307908f5ca$var$RestaurantCategory;



var $dQFEZ = parcelRequire("dQFEZ");
var $f09132227c615720$var$RestaurantMenu = function() {
    var _resInfo_cards__card_card, _resInfo_cards__card, _resInfo_cards, _resInfo_cards__groupedCard_cardGroupMap_REGULAR, _resInfo_cards__groupedCard_cardGroupMap, _resInfo_cards__groupedCard, _resInfo_cards_, _resInfo_cards1;
    var resId = (0, $8c3ad80f8a436e0f$export$99eaa27ddbbb95ef)().resId;
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)(null), 2), showIndex = _useState[0], setshowIndex = _useState[1];
    var dummy = "Dummy Data";
    var resInfo = (0, $dd0108b4f6c17030$export$2e2bcd8739ae039)(resId);
    if (resInfo === null) return /*#__PURE__*/ (0, $iD4WH.jsx)((0, $aa723e6d45ed0f27$export$2e2bcd8739ae039), {});
    var name = resInfo === null || resInfo === void 0 ? void 0 : (_resInfo_cards = resInfo.cards) === null || _resInfo_cards === void 0 ? void 0 : (_resInfo_cards__card = _resInfo_cards[2].card) === null || _resInfo_cards__card === void 0 ? void 0 : (_resInfo_cards__card_card = _resInfo_cards__card.card) === null || _resInfo_cards__card_card === void 0 ? void 0 : _resInfo_cards__card_card.info.name;
    var categories = resInfo === null || resInfo === void 0 ? void 0 : (_resInfo_cards1 = resInfo.cards) === null || _resInfo_cards1 === void 0 ? void 0 : (_resInfo_cards_ = _resInfo_cards1[4]) === null || _resInfo_cards_ === void 0 ? void 0 : (_resInfo_cards__groupedCard = _resInfo_cards_.groupedCard) === null || _resInfo_cards__groupedCard === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap = _resInfo_cards__groupedCard.cardGroupMap) === null || _resInfo_cards__groupedCard_cardGroupMap === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap_REGULAR = _resInfo_cards__groupedCard_cardGroupMap.REGULAR) === null || _resInfo_cards__groupedCard_cardGroupMap_REGULAR === void 0 ? void 0 : _resInfo_cards__groupedCard_cardGroupMap_REGULAR.cards.filter(function(c) {
        var _c_card_card, _c_card;
        return ((_c_card = c.card) === null || _c_card === void 0 ? void 0 : (_c_card_card = _c_card.card) === null || _c_card_card === void 0 ? void 0 : _c_card_card["@type"]) === "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory";
    });
    return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
        className: "max-w-5xl mx-auto px-4 py-6",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "text-center mb-8",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsx)("h1", {
                        className: "font-bold text-3xl mb-2",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("h2", {
                        className: "text-gray-500 text-lg",
                        children: "Menu"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                className: "space-y-4",
                children: categories === null || categories === void 0 ? void 0 : categories.map(function(category, index) {
                    var _category_card, _category_card1;
                    return /*#__PURE__*/ (0, $iD4WH.jsx)((0, $a6945e307908f5ca$export$2e2bcd8739ae039), {
                        data: category === null || category === void 0 ? void 0 : (_category_card = category.card) === null || _category_card === void 0 ? void 0 : _category_card.card,
                        ShowItems: index === showIndex,
                        setshowIndex: function() {
                            return setshowIndex(index);
                        },
                        dummy: dummy
                    }, category === null || category === void 0 ? void 0 : (_category_card1 = category.card) === null || _category_card1 === void 0 ? void 0 : _category_card1.card.title);
                })
            })
        ]
    });
};
var $f09132227c615720$export$2e2bcd8739ae039 = $f09132227c615720$var$RestaurantMenu;



var $iD4WH = parcelRequire("iD4WH");



var $599ff7157a6c84bb$var$Cart = function() {
    var cartItems = (0, $d7d37dc522b09008$export$2105062e25df4afe)(function(store) {
        return store.cart.items;
    });
    var dispatch = (0, $d7d37dc522b09008$export$8ad76b76a4c905f8)();
    var handleClearCart = function() {
        dispatch((0, $5f6a65239c5f7383$export$810121176e3e3671)());
    };
    return /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
        className: "max-w-5xl mx-auto px-4 py-8 text-center",
        children: [
            /*#__PURE__*/ (0, $iD4WH.jsx)("h1", {
                className: "text-3xl font-bold mb-6",
                children: "Your Cart"
            }),
            /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "bg-white shadow-lg rounded-xl p-6",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                        className: "flex justify-center mb-4",
                        children: /*#__PURE__*/ (0, $iD4WH.jsx)("button", {
                            className: "px-6 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition",
                            onClick: handleClearCart,
                            children: "Clear Cart"
                        })
                    }),
                    (cartItems === null || cartItems === void 0 ? void 0 : cartItems.length) === 0 && /*#__PURE__*/ (0, $iD4WH.jsx)("h1", {
                        className: "text-gray-500 text-lg mt-6",
                        children: "Cart is empty. Add items to continue!"
                    }),
                    /*#__PURE__*/ (0, $iD4WH.jsx)("div", {
                        className: "mt-6",
                        children: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $981f1ca9fd215ae3$export$2e2bcd8739ae039), {
                            items: cartItems
                        })
                    })
                ]
            })
        ]
    });
};
var $599ff7157a6c84bb$export$2e2bcd8739ae039 = $599ff7157a6c84bb$var$Cart;





var $d14ec3e9b7d44903$var$appStore = (0, $ca04af99794d5fdc$export$7d8a5b498da695ac)({
    reducer: {
        cart: (0, $5f6a65239c5f7383$export$2e2bcd8739ae039)
    }
});
var $d14ec3e9b7d44903$export$2e2bcd8739ae039 = $d14ec3e9b7d44903$var$appStore;



var $be4aacfa9ee5643d$var$Grocery = /*#__PURE__*/ (0, $dQFEZ.lazy)(function() {
    return (parcelRequire("5gfhY"));
}); // Fixed path here too
var $be4aacfa9ee5643d$var$AppLayout = function() {
    var _useState = (0, $2nwvT._)((0, $dQFEZ.useState)(), 2), userName = _useState[0], setUserName = _useState[1];
    //authentication
    (0, $dQFEZ.useEffect)(function() {
        // Make an API call and send username and password
        var data = {
            name: "Navneet rajput"
        };
        setUserName(data.name);
    }, []);
    return /*#__PURE__*/ (0, $iD4WH.jsx)((0, $d7d37dc522b09008$export$2881499e37b75b9a), {
        store: (0, $d14ec3e9b7d44903$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $d868f44da76e6f1f$export$2e2bcd8739ae039).Provider, {
            value: {
                loggedInUser: userName,
                setUserName: setUserName
            },
            children: /*#__PURE__*/ (0, $iD4WH.jsxs)("div", {
                className: "app",
                children: [
                    /*#__PURE__*/ (0, $iD4WH.jsx)((0, $b31165b6a74e9de9$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $iD4WH.jsx)((0, $8c3ad80f8a436e0f$export$910ae8079b2c2852), {})
                ]
            })
        })
    });
};
var $be4aacfa9ee5643d$var$appRoute = (0, $fc41d09ddc03e3ec$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $iD4WH.jsx)($be4aacfa9ee5643d$var$AppLayout, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $df1724acf1d1a14f$export$2e2bcd8739ae039), {})
            },
            {
                path: "/contact",
                element: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $b8195d93c2c9d902$export$2e2bcd8739ae039), {})
            },
            {
                path: "/about",
                element: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $3a22b9b2156a6d0c$export$2e2bcd8739ae039), {})
            },
            {
                path: "/grocery",
                element: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $dQFEZ.Suspense), {
                    fallback: /*#__PURE__*/ (0, $iD4WH.jsx)("h1", {
                        children: "Loading...."
                    }),
                    children: /*#__PURE__*/ (0, $iD4WH.jsx)($be4aacfa9ee5643d$var$Grocery, {})
                })
            },
            {
                path: "/cart",
                element: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $599ff7157a6c84bb$export$2e2bcd8739ae039), {})
            },
            {
                path: "/restaurant/:resId",
                element: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $f09132227c615720$export$2e2bcd8739ae039), {})
            }
        ],
        errorElement: /*#__PURE__*/ (0, $iD4WH.jsx)((0, $3ad99775c31f630e$export$2e2bcd8739ae039), {})
    }
]);
var $be4aacfa9ee5643d$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($8dbfa3fee6dc40a7$exports))).createRoot(document.getElementById("root"));
$be4aacfa9ee5643d$var$root.render(/*#__PURE__*/ (0, $iD4WH.jsx)((0, $fc41d09ddc03e3ec$export$323e4fc2fa4753fb), {
    router: $be4aacfa9ee5643d$var$appRoute
}));

})();
//# sourceMappingURL=client.057c78fd.js.map
